import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { toWords } from "number-to-words";
import KaldanHeader from "../../InvoiveHeaders/kaldanHeader.png";
import KevaliHeader from "../../InvoiveHeaders/KevaliHeader.png";
import ArchanaHeader from "../../InvoiveHeaders/archanaHeader.png";
//import icons
import MailIcon from "../../InvoiveHeaders/icons/mailIcon.webp";
import InstaIcon from "../../InvoiveHeaders/icons/instaIcon.avif";
import WebIcon from "../../InvoiveHeaders/icons/websiteicon.jpg";
import PhoneIcon from "../../InvoiveHeaders/icons/phoneicon.jpg";
import LandlineIcon from "../../InvoiveHeaders/icons/landlineicon.png";
import { adminLoggedIn } from "./../../redux/action/Actions";
import { Icon } from "@iconify/react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  PDFViewer,
  pdf,
  Image,
} from "@react-pdf/renderer";

export const generateBillPDF = async  (
  invoiceItems,
  csData,
  invoiceformate,
  mainitem,
  adminLoggedIn = {},
  isSmallScreen = false,
 
  //  einvoiceAndWayBill="",
) => {
  console.log("invoiceformate ", invoiceformate);
  console.log("customer ", csData);
  console.log("adminLoggedIn ", mainitem);
  console.log(isSmallScreen);
  


  // generateinvoicepdfMundlik(invoiceItems, csData, mainitem);

  // generateinvoicepdf6(invoiceItems, csData, mainitem);

  // generateinvoicepdf8(invoiceItems, csData, mainitem);

  // generateinvoicepdf10(invoiceItems, csData, mainitem);

  // generateinvoicepdf6(invoiceItems, csData, mainitem);

  if (invoiceformate === 2) {
    generateinvoicepdf2(invoiceItems, csData, mainitem);
    return;
  } else if (invoiceformate === 3) {
    generateinvoicepdf3(invoiceItems, csData, mainitem);
    return;
  } else if (invoiceformate === 4) {
    generateinvoicepdf4(invoiceItems, csData, mainitem);
    return;
  } else if (invoiceformate === 5) {
    // generateinvoicepdf5(invoiceItems, csData, mainitem);
    return;
  } else if(invoiceformate == 1){
    console.log("checking our --- local PDF ")
    irnEwayBill(
      invoiceItems,
      csData,
      mainitem,
      adminLoggedIn,
      einvoiceAndWayBill
    );
    return;
  } else if(invoiceformate == 2000){
    //saurabh tester
    let urdPurchase = 0;
    invoiceItems?.map((item) => {
      if (item?.BillType == "purchase") {
        urdPurchase += 1;
      }
    });
    if (invoiceItems?.length == urdPurchase) {
      GeneratePurchaseInvoiceMundlik(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
    }
    if (urdPurchase && invoiceItems?.length > urdPurchase) {
      generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);
      GeneratePurchaseInvoiceMundlik(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
    }
    if (!urdPurchase) {
      generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);
    }
    generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);
    // generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);


    handleGenerateInvoiceMundlik(invoiceItems, csData, mainitem, adminLoggedIn, urdPurchase)



    return;
  }else if (invoiceformate == 1000) {
    console.log("shhh");

    console.log(mainitem);

    // const isUrdBill = mainitem.InvoiceItem.some(
    //   (item) =>
    //     item.CategoryName === "OLD GOLD" || item.CategoryName === "OLD SILVER"
    // );

    // console.log(isUrdBill);

    // if (isUrdBill) {
    //   console.log("here");

    //   generateMundlikUrdBill(invoiceItems, csData, mainitem, adminLoggedIn);
    // }
    // console.log("there");
    // generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);

   


    let urdPurchase = 0;
    invoiceItems?.map((item) => {
      if (item?.BillType == "purchase") {
        urdPurchase += 1;
      }
    });
    console.log(invoiceItems?.length)
    console.log(urdPurchase)


    handleGenerateInvoiceMundlik(invoiceItems, csData, mainitem, adminLoggedIn, urdPurchase)



    // if (invoiceItems?.length == urdPurchase) {
    //   // GeneratePurchaseInvoiceMundlik(
    //   //   invoiceItems,
    //   //   csData,
    //   //   mainitem,
    //   //   adminLoggedIn
    //   // );
    //   console.log('muu');
      
    //   generateMundlikUrdBill(invoiceItems, csData, mainitem, adminLoggedIn);
    // }
    // if (urdPurchase && invoiceItems?.length > urdPurchase) {
      
    //   handleGenerateInvoice(invoiceItems, csData, mainitem, adminLoggedIn, urdPurchase)
     
    
    // }
    // if (!urdPurchase) {
    //   generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);
    // }

    return;

    
  } else if (invoiceformate === 6) {
    // generateinvoicepdf6(invoiceItems, csData, mainitem, adminLoggedIn);
    GenerateInvoiceKevaliNew(invoiceItems, csData, mainitem, adminLoggedIn);
    return;
  }
  
   else if (invoiceformate == 7) {
    //for Mundlik
    let urdPurchase = 0;
    invoiceItems?.map((item) => {
      if (item?.BillType == "purchase") {
        urdPurchase += 1;
      }
    });


    // if (invoiceItems?.length == urdPurchase) {
    //   GeneratePurchaseInvoiceMundlik(
    //     invoiceItems,
    //     csData,
    //     mainitem,
    //     adminLoggedIn
    //   );
    // }
    // if (urdPurchase && invoiceItems?.length > urdPurchase) {
    //   generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);
    //   GeneratePurchaseInvoiceMundlik(
    //     invoiceItems,
    //     csData,
    //     mainitem,
    //     adminLoggedIn
    //   );
    // }
    // if (!urdPurchase) {
    //   generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);
    // }
    // generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);
    // // generateinvoicepdfMundlik(invoiceItems, csData, mainitem, adminLoggedIn);


    handleGenerateInvoiceMundlik(invoiceItems, csData, mainitem, adminLoggedIn, urdPurchase);



    return;
  } else if (invoiceformate === 8) {
    generateinvoicepdf8(invoiceItems, csData, mainitem);
    // generateinvoicepdf8(invoiceItems, csData, mainitem);
    return;
  } else if (invoiceformate == 10) {

    let urdPurchase = 0;
    invoiceItems?.map((item) => {
      if (item?.BillType == "purchase") {
        urdPurchase += 1;
      }
    });

    
    //generateinvoicepdfArchana2(invoiceItems, csData, mainitem, adminLoggedIn);
    handleGenerateInvoiceArchana(invoiceItems, csData, mainitem, adminLoggedIn, urdPurchase)

    return;
  } else if (invoiceformate === 11) {
    generateinvoicepdf8(invoiceItems, csData, mainitem);
    return;
  } else if (invoiceformate === 12) {
    generateBSPInvoice(invoiceItems, csData, mainitem, adminLoggedIn);
    return;
  } else if (invoiceformate == 17) {
    // for kaldan
    // generateKaldanInvoice(invoiceItems, csData, mainitem, adminLoggedIn);
    kaldanInvoiceNew(invoiceItems, csData, mainitem, adminLoggedIn);
  } else if (invoiceformate == 20) {
    // for ashtalaxmi
    generateAshtalaxmiInvoice55(invoiceItems, csData, mainitem, adminLoggedIn);
  } else if (invoiceformate == 100) {
    // for ashtalaxmi
    generateAshtalaxmiInvoice55(invoiceItems, csData, mainitem, adminLoggedIn);
  } else if (invoiceformate == 21) {
    // console.log(isSmallScreen);

    let urdPurchase = 0;
    invoiceItems?.map((item) => {
      if (item?.BillType == "purchase") {
        urdPurchase += 1;
      }
    });




    if (isSmallScreen) {
      ThreeInch(invoiceItems, csData, mainitem, adminLoggedIn);
    } else {
      generateinvoicepdfHeera2(invoiceItems, csData, mainitem, adminLoggedIn);
    }
    //for heera jewellers
  } else if (invoiceformate == 24) {
    console.log("parumal >>");
    GenerateInvoiceParumal(invoiceItems, csData, mainitem, adminLoggedIn);
  } else if (invoiceformate == 25) {
    console.log("mehta >>");
    generateinvoicepdfMehta(invoiceItems, csData, mainitem, adminLoggedIn);
  } else if (invoiceformate == 26) {
    console.log("mehta >>");
    generateinvoicepdfHeera2(invoiceItems, csData, mainitem, adminLoggedIn);
  }
};








const handleGenerateInvoiceMundlik = async (
  invoiceItems,
  csData,
  mainitem,
  adminLoggedIn,
  urdPurchase
) => {
  const hasOnlyURD =
    invoiceItems?.length === urdPurchase && urdPurchase > 0;
  const hasBoth = urdPurchase && invoiceItems?.length > urdPurchase;
  const hasOnlyGold = !urdPurchase;

  console.log(mainitem)
  

  try {
    if (hasOnlyURD) {
      // CASE 1: Only URD (OLD GOLD/OLD SILVER)
      const urdWindow = window.open('', '_blank');
      if (!urdWindow) {
        alert('Popup blocked for URD Invoice');
        return;
      }

      urdWindow.document.write('<p>Generating URD Invoice...</p>');

      const urdInvoiceDoc = await generateMundlikUrdBill(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
      const urdBlob = await pdf(urdInvoiceDoc).toBlob();
      const urdUrl = URL.createObjectURL(urdBlob);

      urdWindow.document.body.innerHTML = ''; // clear loading message
      urdWindow.document.write(
        `<iframe width="100%" height="100%" src="${urdUrl}"></iframe>`
      );
    } else if (hasBoth) {
      // CASE 2: Both GOLD and URD

      const goldWindow = window.open('', '_blank');
      const urdWindow = window.open('', '_blank');

      if (!goldWindow || !urdWindow) {
        alert('Popup blocked for one or both invoices');
        return;
      }

      goldWindow.document.write('<p>Generating Gold Invoice...</p>');
      urdWindow.document.write('<p>Generating URD Invoice...</p>');

      console.log(invoiceItems);
      

      // Generate Gold PDF
      const goldDoc = generateinvoicepdfMundlik(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
      const goldBlob = goldDoc.output('blob');
      const goldUrl = URL.createObjectURL(goldBlob);

      goldWindow.document.body.innerHTML = '';
      goldWindow.document.write(
        `<iframe width="100%" height="100%" src="${goldUrl}"></iframe>`
      );

      // Generate URD PDF
      const urdDoc = await generateMundlikUrdBill(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
      const urdBlob = await pdf(urdDoc).toBlob();
      const urdUrl = URL.createObjectURL(urdBlob);

      urdWindow.document.body.innerHTML = '';
      urdWindow.document.write(
        `<iframe width="100%" height="100%" src="${urdUrl}"></iframe>`
      );
    } else if (hasOnlyGold) {
      // CASE 3: Only GOLD
      const goldWindow = window.open('', '_blank');
      if (!goldWindow) {
        alert('Popup blocked for Gold Invoice');
        return;
      }

     

      const goldDoc = generateinvoicepdfMundlik(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );

      console.log(invoiceItems, 'invoiceItems');
      
      const goldBlob = goldDoc.output('blob');
      const goldUrl = URL.createObjectURL(goldBlob);

      goldWindow.document.body.innerHTML = '';
      goldWindow.document.write(
        `<iframe width="100%" height="100%" src="${goldUrl}"></iframe>`
      );
    }
  } catch (error) {
    console.error('Error generating invoice:', error);
  }
};

const handleGenerateInvoiceArchana = async (
  invoiceItems,
  csData,
  mainitem,
  adminLoggedIn,
  urdPurchase
) => {
  const hasOnlyURD =
    invoiceItems?.length === urdPurchase && urdPurchase > 0;
  const hasBoth = urdPurchase && invoiceItems?.length > urdPurchase;
  const hasOnlyGold = !urdPurchase;

  try {
    if (hasOnlyURD) {
      // CASE 1: Only URD (OLD GOLD/OLD SILVER)
      const urdWindow = window.open('', '_blank');
      if (!urdWindow) {
        alert('Popup blocked for URD Invoice');
        return;
      }

      urdWindow.document.write('<p>Generating URD Invoice...</p>');

      const urdInvoiceDoc = await generateMundlikUrdBill(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
      const urdBlob = await pdf(urdInvoiceDoc).toBlob();
      const urdUrl = URL.createObjectURL(urdBlob);

      urdWindow.document.body.innerHTML = ''; // clear loading message
      urdWindow.document.write(
        `<iframe width="100%" height="100%" src="${urdUrl}"></iframe>`
      );
    } else if (hasBoth) {
      // CASE 2: Both GOLD and URD

      const goldWindow = window.open('', '_blank');
      const urdWindow = window.open('', '_blank');

      if (!goldWindow || !urdWindow) {
        alert('Popup blocked for one or both invoices');
        return;
      }

      goldWindow.document.write('<p>Generating Gold Invoice...</p>');
      urdWindow.document.write('<p>Generating URD Invoice...</p>');

      // Generate Gold PDF
      const goldDoc = generateinvoicepdfArchana2(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
      const goldBlob = goldDoc.output('blob');
      const goldUrl = URL.createObjectURL(goldBlob);

      goldWindow.document.body.innerHTML = '';
      goldWindow.document.write(
        `<iframe width="100%" height="100%" src="${goldUrl}"></iframe>`
      );

      // Generate URD PDF
      const urdDoc = await generateMundlikUrdBill(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
      const urdBlob = await pdf(urdDoc).toBlob();
      const urdUrl = URL.createObjectURL(urdBlob);

      urdWindow.document.body.innerHTML = '';
      urdWindow.document.write(
        `<iframe width="100%" height="100%" src="${urdUrl}"></iframe>`
      );
    } else if (hasOnlyGold) {
      // CASE 3: Only GOLD
      const goldWindow = window.open('', '_blank');
      if (!goldWindow) {
        alert('Popup blocked for Gold Invoice');
        return;
      }

      goldWindow.document.write('<p>Generating Gold Invoice...</p>');

      const goldDoc = generateinvoicepdfArchana2(
        invoiceItems,
        csData,
        mainitem,
        adminLoggedIn
      );
      const goldBlob = goldDoc.output('blob');
      const goldUrl = URL.createObjectURL(goldBlob);

      goldWindow.document.body.innerHTML = '';
      goldWindow.document.write(
        `<iframe width="100%" height="100%" src="${goldUrl}"></iframe>`
      );
    }
  } catch (error) {
    console.error('Error generating invoice:', error);
  }
};


const GenerateInvoiceParumal = async (
  items,
  customer,
  mainitem,
  adminLoggedIn
) => {
  const generateInvoiceParumalStyles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
      fontFamily: "Helvetica",
      marginTop: 10,
    },
    headerImg: {
      height: 150,
    },
    section: {
      display: "flex",
      flexDirection: "row",
      // marginBottom: 10,
      border: "1px solid #000",
      // justifyContent: "space-between",
      padding: 10,
    },
    Innersection: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
    },
    Innersection2: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      paddingLeft: "100px",
    },
    header: {
      textAlign: "center",
      fontSize: 13,
      fontWeight: "bold",
      marginBottom: 10,
      textDecoration: "underline",
    },
    table: {
      display: "table",
      width: "100%",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "black",
      borderBottomWidth: 0,
      minHeight: 250,
    },
    row: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderBottomColor: "black",
      breakInside: "avoid", // Ensures row does not break mid-way
    },
    Trow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderTopWidth: 1,
      borderBottomColor: "black",
      breakInside: "avoid", // Ensures row does not break mid-way
    },
    // Ensures each section starts on a new page if needed
    pageBreak: {
      break: "before",
    },
    rowL: {
      flexDirection: "row",
      borderBottomWidth: 0,
      borderBottomColor: "black",
    },

    cell: {
      flex: 1,
      padding: 5,
      textAlign: "center",
      borderRightWidth: 1,
      borderRightColor: "black",
      fontSize: 7,
    },
    cellL: {
      flex: 1,
      padding: 5,
      textAlign: "center",
      borderRightWidth: 0,
      borderRightColor: "black",
      fontSize: 7,
    },
    footer: {
      // marginTop: 10,
      paddingTop: 10,
      borderTopWidth: 1,
      borderTopColor: "black",
      width: "30%",
      marginLeft: "70%",
      border: "1px solid #000",
      padding: 5,
    },

    footerText: {
      fontSize: 10,
    },

    signature: {
      fontSize: 10,
      // textAlign: "right",
      fontStyle: "italic",
      marginTop: 10,
      width: "75%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },

    summaryTable: {
      display: "flex",

      marginBottom: 10,
    },

    summaryRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      borderBottomWidth: 0.5, // Light separator between rows
      borderBottomColor: "gray",
      paddingVertical: 3,
    },

    summaryLabel: {
      fontSize: 9,
      textAlign: "left",
      width: "80%",
    },

    summaryValue: {
      fontSize: 9,
      textAlign: "right",
      width: "20%",
      marginRight: "20px",
    },

    underlineRow: {
      borderBottomWidth: 1, // Darker and thicker underline for R.O Discount
      borderBottomColor: "black",
    },

    netAmountRow: {
      fontWeight: "bold",
      fontSize: 12,
    },

    topText: {
      marginBottom: 10,
      fontWeight: "bold",
    },
    topTextValue: {
      marginBottom: 10,
      fontWeight: "normal",
    },
    bankSection: {
      display: "flex",
      flexDirection: "row",
      marginTop: 30,
    },
    bankSection1: {
      display: "flex",
      flexDirection: "column",
      width: "35%",
    },
    bankSection2: {
      display: "flex",
      flexDirection: "column",
      width: "35%",
    },

    bankText: {
      fontSize: 9,
      fontWeight: "bold",
      marginBottom: 3,
    },
  });

  const { GST, TotalNetAmount } = mainitem;

  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  const igst = +(GST || 0);

  const tableColumns = [
    { label: "ITEMS", width: "28%" },
    { label: "HSN", width: "7%" },
    { label: "PURITY", width: "7%" },
    { label: "GR. WT.", width: "7%" },
    { label: "STONE WT.", width: "7%" },
    { label: "NET WT.", width: "7%" },
    { label: "ST. AMT.", width: "7%" },
    { label: "Rate/10gm", width: "7%" },
    { label: "MAKING AMT", width: "8%" },
    { label: "AMOUNT", width: "15%" },
  ];

  // ✅ Calculate Totals
  const totalGrossWt = items.reduce(
    (sum, item) => sum + (parseFloat(item.GrossWt) || 0),
    0
  );
  const totalStoneWt = items.reduce(
    (sum, item) => sum + (parseFloat(item.TotalStoneWeight) || 0),
    0
  );
  const totalNetWt = items.reduce(
    (sum, item) => sum + (parseFloat(item.NetWt) || 0),
    0
  );
  const totalAmount = items.reduce(
    (sum, item) => sum + (parseFloat(item.TotalItemAmount) || 0),
    0
  );

  const totalGst = items.reduce(
    (sum, item) => sum + (parseFloat(item.GST) || 0),
    0
  );

  console.log(totalAmount, totalGst, mainitem?.Offer, mainitem?.CourierCharge);

  const MyDocument = (
    <Document>
      <Page size="A4" style={[generateInvoiceParumalStyles.page]}>
        <View style={[generateInvoiceParumalStyles.headerImg]}></View>
        <Text style={generateInvoiceParumalStyles.header}>TAX INVOICE</Text>

        <View style={generateInvoiceParumalStyles.section}>
          <View style={generateInvoiceParumalStyles.Innersection}>
            <Text style={generateInvoiceParumalStyles.topText}>
              Name:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.FirstName || ""}
              </Text>
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Mobile No:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.Mobile || ""}
              </Text>{" "}
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Address:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {`${customer?.CurrAddStreet || ""} ${customer?.City || ""} ${
                  customer?.CurrAddState || ""
                } ${customer?.Country || ""} ${
                  customer?.CurrAddPincode || ""
                }`.trim()}
              </Text>
            </Text>
          </View>
          <View style={generateInvoiceParumalStyles.Innersection2}>
            <Text style={generateInvoiceParumalStyles.topText}>
              Invoice No:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {mainitem?.InvoiceNo || ""}
              </Text>{" "}
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Date:
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {" "}
                {mainitem?.InvoiceDate || ""}
              </Text>
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Buyer's GST:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.GstNo || ""}
              </Text>
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Buyer's PAN:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.PanNo || ""}
              </Text>
            </Text>
          </View>
        </View>

        <View style={generateInvoiceParumalStyles.table}>
          <View style={[generateInvoiceParumalStyles.row]} wrap={false}>
            {tableColumns.map((column, index) => (
              <Text
                key={index}
                style={[
                  index == 9
                    ? generateInvoiceParumalStyles.cellL
                    : generateInvoiceParumalStyles.cell,
                  { flex: column.width },
                ]}
              >
                {column.label}
              </Text>
            ))}
          </View>
          <View>
            {items?.map((item, index) => (
              <View style={generateInvoiceParumalStyles.row} key={index}>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.28 }]}
                >
                  {item?.ProductName}
                </Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
                >
                  {item?.HSNCode}
                </Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
                >
                  {item?.Purity}
                </Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
                >
                  {item?.GrossWt}
                </Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
                >
                  {item?.TotalStoneWeight}
                </Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
                >
                  {item?.NetWt}
                </Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
                >
                  {item?.TotalStoneAmount}
                </Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
                >
                  {item?.MetalRate * 10}
                </Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.08 }]}
                >
                  {item?.MakingPerGram}
                </Text>
                <Text
                  style={[
                    generateInvoiceParumalStyles.cellL,
                    { flex: 0.15, borderBottomWidth: 0 },
                  ]}
                >
                  {item?.TotalItemAmount}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* ✅ Total Row at the Bottom */}
        <View
          style={[
            generateInvoiceParumalStyles.Trow,
            { borderLeft: "1px solid #000" },
          ]}
        >
          <Text
            style={[
              generateInvoiceParumalStyles.cell,
              { flex: 0.28, fontSize: 9 },
            ]}
          >
            Total
          </Text>
          <Text
            style={[
              generateInvoiceParumalStyles.cell,
              { flex: 0.07, fontSize: 9 },
            ]}
          ></Text>
          <Text
            style={[
              generateInvoiceParumalStyles.cell,
              { flex: 0.07, fontSize: 9 },
            ]}
          ></Text>
          <Text
            style={[
              generateInvoiceParumalStyles.cell,
              { flex: 0.07, fontWeight: "bold", fontSize: 9 },
            ]}
          >
            {totalGrossWt.toFixed(2)}
          </Text>
          <Text
            style={[
              generateInvoiceParumalStyles.cell,
              { flex: 0.07, fontWeight: "bold", fontSize: 9 },
            ]}
          >
            {totalStoneWt.toFixed(2)}
          </Text>
          <Text
            style={[
              generateInvoiceParumalStyles.cell,
              { flex: 0.07, fontWeight: "bold", fontSize: 9 },
            ]}
          >
            {totalNetWt.toFixed(2)}
          </Text>
          <Text
            style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
          ></Text>
          <Text
            style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
          ></Text>
          <Text
            style={[generateInvoiceParumalStyles.cell, { flex: 0.08 }]}
          ></Text>
          <Text
            style={[
              generateInvoiceParumalStyles.cell,
              { flex: 0.15, fontWeight: "bold", fontSize: 9 },
            ]}
          >
            {totalAmount.toFixed(2)}
          </Text>
        </View>

        {/* //summary */}
        <View style={generateInvoiceParumalStyles.footer}>
          <View style={generateInvoiceParumalStyles.summaryTable}>
            <View style={generateInvoiceParumalStyles.summaryRow}>
              <Text style={generateInvoiceParumalStyles.summaryLabel}>
                CGST 1.5%
              </Text>
              <Text style={generateInvoiceParumalStyles.summaryValue}>
                {adminLoggedIn?.Clients?.State ==
                mainitem?.Customer?.CurrAddState
                  ? Number((totalAmount / 100) * 1.5).toFixed(3)
                  : ""}
              </Text>
            </View>

            <View style={generateInvoiceParumalStyles.summaryRow}>
              <Text style={generateInvoiceParumalStyles.summaryLabel}>
                SGST 1.5%
              </Text>
              <Text style={generateInvoiceParumalStyles.summaryValue}>
                {adminLoggedIn?.Clients?.State ==
                mainitem?.Customer?.CurrAddState
                  ? Number((totalAmount / 100) * 1.5).toFixed(3)
                  : ""}
              </Text>
            </View>

            <View style={generateInvoiceParumalStyles.summaryRow}>
              <Text style={generateInvoiceParumalStyles.summaryLabel}>
                IGST 3%
              </Text>
              <Text style={generateInvoiceParumalStyles.summaryValue}>
                {adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
                  ? Number((totalAmount / 100) * 3).toFixed(3)
                  : ""}
              </Text>
            </View>

            <View
              style={[
                generateInvoiceParumalStyles.summaryRow,
                generateInvoiceParumalStyles.underlineRow,
              ]}
            >
              <Text style={generateInvoiceParumalStyles.summaryLabel}>
                R.O DISCOUNT
              </Text>
              <Text style={generateInvoiceParumalStyles.summaryValue}>
                {Number(mainitem?.Offer).toFixed(2) || "0.00"}
              </Text>
            </View>

            <View
              style={[
                generateInvoiceParumalStyles.summaryRow,
                generateInvoiceParumalStyles.netAmountRow,
              ]}
            >
              <Text style={generateInvoiceParumalStyles.summaryLabel}>
                NET AMOUNT
              </Text>
              <Text style={[generateInvoiceParumalStyles.summaryValue]}>
                {(
                  (Number(totalAmount) || 0) +
                  (Number(GST) || 0) -
                  (Number(mainitem?.Offer) || 0) +
                  (Number(mainitem?.CourierCharge) || 0)
                ).toFixed(2)}
              </Text>
            </View>
          </View>
        </View>

        {/* <View style={[generateInvoiceParumalStyles.signature]}>
          <View>
            <Text
              style={[
                generateInvoiceParumalStyles.signature,
                { fontWeight: "bold" },
              ]}
            >
              Purchaser Sign: ..............................
            </Text>
          </View>
          <View>
            <Text style={generateInvoiceParumalStyles.signature}>
              <Text style={{ fontWeight: "bold" }}>For: PARUMAL JEWELLERS</Text>
            </Text>
          </View>
        </View>    */}

        {/* <View style={generateInvoiceParumalStyles.bankSection}>
          <View style={generateInvoiceParumalStyles.bankSection1}>
            <Text style={[generateInvoiceParumalStyles.bankText]}>
              Bank Name:
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {" "}
                SBI
              </Text>
            </Text>
            <Text style={generateInvoiceParumalStyles.bankText}>
              Acc No:
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {" "}
                38037981455
              </Text>
            </Text>
            <Text style={generateInvoiceParumalStyles.bankText}>
              IFSC Code:
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {" "}
                SBIN 0050701
              </Text>
            </Text>
          </View>
          <View style={generateInvoiceParumalStyles.bankSection2}>
            <Text style={generateInvoiceParumalStyles.bankText}>
              Cash/Cheque/Balance: (Subject to realization of the Cheque)
            </Text>
            <Text style={generateInvoiceParumalStyles.bankText}>
              {" "}
              Note: 1. Goods once sold will not be taken back or exchanged
            </Text>

            <Text style={generateInvoiceParumalStyles.bankText}>
              {" "}
              2.Subject to Jabalpur Jurisdiction
            </Text>
          </View>
        </View> */}
      </Page>
    </Document>
  );

  // Generate the PDF blob
  const pdfBlob = await pdf(MyDocument).toBlob();

  // Create a Blob URL
  const pdfUrl = URL.createObjectURL(pdfBlob);

  // Open in a new window
  window.open(pdfUrl, "_blank");
};
const GenerateInvoiceKevaliNew = async (
  items,
  customer,
  mainitem,
  adminLoggedIn
) => {
  const generateInvoiceParumalStyles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
      fontFamily: "Helvetica",
      marginTop: 10,
    },
    headerTop: {
      display: "flex",
      flexDirection: "row", // ✅ Ensures horizontal placement
      justifyContent: "space-between", // ✅ Distributes left and right sections
      alignItems: "center", // ✅ Aligns items in the center vertically
      // width: "100%",
      padding: 10, // ✅ Adds some spacing for better appearance
    },

    headerInLeft: {
      width: "60%", // ✅ Takes half of the header width
      display: "flex",
      justifyContent: "flex-start", // ✅ Aligns image to the left
    },

    headerInRight: {
      width: "30%", // ✅ Takes half of the header width
      display: "flex",
      flexDirection: "column",
      justifyContent: "center", // ✅ Centers text vertically
      alignItems: "flex-end", // ✅ Aligns text to the right
      gap: 5,
    },

    section: {
      display: "flex",
      flexDirection: "row",
      // marginBottom: 10,
      border: "1px solid #000",
      borderColor: "#ededed",
      // justifyContent: "space-between",
      padding: 10,
    },
    Innersection: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
    },
    Innersection2: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      paddingLeft: "100px",
    },
    header: {
      textAlign: "center",
      fontSize: 13,
      fontWeight: "bold",
      marginBottom: 10,
      textDecoration: "underline",
    },
    table: {
      display: "table",
      width: "100%",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ededed",
      borderBottomWidth: 0,
      minHeight: 250,
      borderBottom: 1,
      borderBottomColor: "#ededed",
    },
    row: {
      flexDirection: "row",
      // borderBottomWidth: 1,
      // borderBottomColor: "black",
      breakInside: "avoid", // Ensures row does not break mid-way
    },
    Trow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderTopWidth: 1,
      borderBottomColor: "black",
      breakInside: "avoid", // Ensures row does not break mid-way
    },
    // Ensures each section starts on a new page if needed
    pageBreak: {
      break: "before",
    },
    rowL: {
      flexDirection: "row",
      borderBottomWidth: 0,
      borderBottomColor: "black",
    },

    cell: {
      flex: 1,
      padding: 5,
      textAlign: "center",
      borderRightWidth: 1,
      borderRightColor: "#ededed",
      fontSize: 8,
    },
    cellL: {
      flex: 1,
      padding: 5,
      textAlign: "center",
      borderRightWidth: 0,
      borderRightColor: "black",
      fontSize: 7,
    },
    footer: {
      // marginTop: 10,
      paddingTop: 5,

      flexDirection: "row",
      width: "100%",
      // marginLeft: "70%",

      marginTop: 10,
      justifyContent: "space-between",
    },
    footerRight: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      width: "40%",
    },

    footerText: {
      fontSize: 10,
    },

    signature: {
      fontSize: 10,
      // textAlign: "right",
      fontStyle: "italic",
      marginTop: 10,
      width: "75%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    tableRight: {
      display: "flex",
      width: "40%",

      marginBottom: 10,
    },

    summaryTable: {
      display: "flex",
      width: "100%",
      border: "1px solid #000",
      padding: 10,
      borderColor: "#ededed",
    },

    summaryRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      borderBottomWidth: 0.5, // Light separator between rows
      borderBottomColor: "gray",
      paddingVertical: 3,
    },

    summaryLabel: {
      fontSize: 9,
      // textAlign: "left",
    },

    summaryValue: {
      fontSize: 9,
      textAlign: "right",
      width: "20%",
      marginRight: "30px",
    },

    underlineRow: {
      borderBottomWidth: 1, // Darker and thicker underline for R.O Discount
      borderBottomColor: "black",
    },

    netAmountRow: {
      fontWeight: "bold",
      fontSize: 12,
    },

    topText: {
      marginBottom: 10,
      fontWeight: "bold",
    },
    topTextValue: {
      marginBottom: 10,
      fontWeight: "normal",
    },
    bankSection: {
      display: "flex",
      flexDirection: "row",
      marginTop: 30,
    },
    bankSection1: {
      display: "flex",
      flexDirection: "column",
      width: "35%",
    },
    bankSection2: {
      display: "flex",
      flexDirection: "column",
      width: "35%",
    },

    bankText: {
      fontSize: 9,
      fontWeight: "bold",
      marginBottom: 3,
    },
    footer2: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      marginTop: 20,
    },
    footer2box: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
      marginBottom: 10,
    },
    iconContainer: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 10,
    },
    icon: {
      width: 20,
      height: 20,
      marginRight: 10,
    },
  });

  const { GST, TotalNetAmount } = mainitem;

  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  const igst = +(GST || 0);

  const tableColumns = [
    { label: "Sr No", width: 0.08 }, // 8%
    { label: "Product Details", width: 0.4 }, // 40%
    { label: "HSN Code", width: 0.12 }, // 12%
    { label: "Purity", width: 0.1 }, // 10%
    { label: "Quantity", width: 0.15 }, // 15%
    { label: "Total Amount", width: 0.15 }, // 15%
  ];

  // ✅ Calculate Totals
  const totalGrossWt = items.reduce(
    (sum, item) => sum + (parseFloat(item.GrossWt) || 0),
    0
  );
  const totalStoneWt = items.reduce(
    (sum, item) => sum + (parseFloat(item.TotalStoneWeight) || 0),
    0
  );
  const totalNetWt = items.reduce(
    (sum, item) => sum + (parseFloat(item.NetWt) || 0),
    0
  );
  const totalQty = items.reduce(
    (sum, item) => sum + (parseFloat(item.Quantity) || 0),
    0
  );
  const totalAmount = items.reduce(
    (sum, item) => sum + (parseFloat(item.MRP || item.TotalItemAmount) || 0),
    0
  );

  console.log(items);

  const getPaymentAmount = (mode) => {
    const amount = mainitem?.Payments?.find(
      (payment) => payment.PaymentModeType === mode
    )?.Amount;
    return amount ? parseFloat(amount).toFixed(3) : "";
  };

  const cashPayment = getPaymentAmount("Cash");
  const rtgsPayment = getPaymentAmount("RTGS");
  const chequePayment = getPaymentAmount("Cheque");
  const cardPayment = getPaymentAmount("Card");
  const upiPayment = getPaymentAmount("UPI");

  const MyDocument = (
    <Document>
      <Page size="A4" style={[generateInvoiceParumalStyles.page]}>
        <View style={generateInvoiceParumalStyles.headerTop}>
          <View style={generateInvoiceParumalStyles.headerInLeft}>
            <Image src={KevaliHeader} style={{ width: 250, height: 80 }} />
          </View>

          <View style={generateInvoiceParumalStyles.headerInRight}>
            <Text>A Brand By</Text>
            <Text>Mewar Jewellery House Pvt. Ltd</Text>
            <Text style={{ fontWeight: "bold", fontSize: 14 }}>
              TAX INVOICE
            </Text>
            <Text style={generateInvoiceParumalStyles.topTextValue}>
              GST No: {adminLoggedIn?.Clients?.GSTNo || ""}
            </Text>
          </View>
        </View>

        <View style={generateInvoiceParumalStyles.section}>
          <View style={generateInvoiceParumalStyles.Innersection}>
            <Text style={generateInvoiceParumalStyles.topText}>
              Name:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.FirstName || ""}
              </Text>
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Mobile No:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.Mobile || ""}
              </Text>{" "}
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Address:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {`${customer?.CurrAddStreet || ""} ${customer?.City || ""} ${
                  customer?.CurrAddState || ""
                } ${customer?.Country || ""} ${
                  customer?.CurrAddPincode || ""
                }`.trim()}
              </Text>
            </Text>
          </View>
          <View style={[generateInvoiceParumalStyles.Innersection2]}>
            {/* <Text style={generateInvoiceParumalStyles.topText}>
              GSTIN:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {adminLoggedIn?.Clients?.GSTNo || ""}
              </Text>
            </Text> */}
            <Text style={generateInvoiceParumalStyles.topText}>
              Invoice No:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {mainitem?.InvoiceNo || ""}
              </Text>{" "}
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Date:
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {" "}
                {mainitem?.InvoiceDate || ""}
              </Text>
            </Text>

            {/* <Text style={generateInvoiceParumalStyles.topText}>
              Buyer's PAN:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.PanNo || ""}
              </Text>
            </Text> */}
          </View>
        </View>

        <View style={generateInvoiceParumalStyles.table}>
          <View style={[generateInvoiceParumalStyles.row]} wrap={false}>
            {tableColumns.map((column, index) => (
              <View
                key={index}
                style={[
                  generateInvoiceParumalStyles.cell,
                  {
                    flex: column.width,
                    borderRightWidth: index === tableColumns.length - 1 ? 0 : 1, // No border on last column
                    alignItems: "center",
                    justifyContent: "center",
                    borderBottom: 1,
                    borderBottomColor: "#ededed",
                  },
                ]}
              >
                <Text
                  style={{
                    fontSize: 8,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {column.label}
                </Text>
              </View>
            ))}
          </View>

          <View>
            {items?.map((item, index) => (
              <View style={generateInvoiceParumalStyles.row} key={index}>
                {/* Sr No */}
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.08 }]}
                >
                  {index + 1}
                </Text>

                {/* Product Name */}
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.4 }]}
                >
                  {item?.ProductName}
                </Text>

                {/* HSN Code */}
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.12 }]}
                >
                  {item?.HSNCode}
                </Text>

                {/* Purity */}
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.1 }]}
                >
                  {item?.Purity}
                </Text>

                {/* Gross Weight */}
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.15 }]}
                >
                  {item?.Quantity}
                </Text>

                {/* Total Stone Weight */}
                <Text
                  style={[
                    generateInvoiceParumalStyles.cell,
                    { flex: 0.15, borderRightWidth: 0 },
                  ]}
                >
                  {item?.TotalItemAmount}
                </Text>
              </View>
            ))}
          </View>
          {/* Add empty rows to extend vertical borders */}
          {Array.from({ length: Math.max(0, 10 - items.length) }).map(
            (_, i) => (
              <View
                style={[generateInvoiceParumalStyles.row, { flexGrow: 1 }]}
                key={`empty-${i}`}
              >
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.08 }]}
                ></Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.4 }]}
                ></Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.12 }]}
                ></Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.1 }]}
                ></Text>
                <Text
                  style={[generateInvoiceParumalStyles.cell, { flex: 0.15 }]}
                ></Text>
                <Text
                  style={[
                    generateInvoiceParumalStyles.cell,
                    { flex: 0.15, borderRightWidth: 0 },
                  ]}
                ></Text>
              </View>
            )
          )}
        </View>

        {/* //summary */}
        <View style={generateInvoiceParumalStyles.footer}>
          <View style={generateInvoiceParumalStyles.footerRight}>
            <View>
              <View
                style={{
                  borderWidth: 1,
                  borderColor: "#ededed",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {/* Left Section: "Payment Mode" */}
                <View style={{ flex: 1, padding: 5 }}>
                  <Text style={{ fontSize: 8, fontWeight: "bold" }}>Cash</Text>
                </View>

                {/* Vertical Divider */}
                <View
                  style={{
                    borderLeftWidth: 1,
                    borderColor: "#ededed",
                    height: "100%",
                  }}
                />

                {/* Right Section: "Cash" */}
                <View style={{ flex: 1, padding: 5 }}>
                  <Text
                    style={{ fontSize: 8, fontWeight: "bold", marginLeft: 5 }}
                  >
                    {cashPayment}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  borderWidth: 1,
                  borderColor: "#000",
                  flexDirection: "row",
                  alignItems: "center",
                  borderColor: "#ededed",
                }}
              >
                {/* Left Section: "Payment Mode" */}
                <View style={{ flex: 1, padding: 5 }}>
                  <Text style={{ fontSize: 8, fontWeight: "bold" }}>Card</Text>
                </View>

                {/* Vertical Divider */}
                <View
                  style={{
                    borderLeftWidth: 1,
                    borderColor: "#ededed",
                    height: "100%",
                  }}
                />

                {/* Right Section: "Cash" */}
                <View style={{ flex: 1, padding: 5 }}>
                  <Text
                    style={{ fontSize: 8, fontWeight: "bold", marginLeft: 5 }}
                  >
                    {cardPayment}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  borderWidth: 1,
                  borderColor: "#000",
                  flexDirection: "row",
                  alignItems: "center",
                  borderColor: "#ededed",
                }}
              >
                {/* Left Section: "Payment Mode" */}
                <View style={{ flex: 1, padding: 5 }}>
                  <Text style={{ fontSize: 8, fontWeight: "bold" }}>UPI</Text>
                </View>

                {/* Vertical Divider */}
                <View
                  style={{
                    borderLeftWidth: 1,
                    borderColor: "#ededed",
                    height: "100%",
                  }}
                />

                {/* Right Section: "Cash" */}
                <View style={{ flex: 1, padding: 5 }}>
                  <Text
                    style={{ fontSize: 8, fontWeight: "bold", marginLeft: 5 }}
                  >
                    {upiPayment}
                  </Text>
                </View>
              </View>
            </View>

            <Text
              style={{ fontSize: "15px", color: "#f53101", marginTop: "40px" }}
            >
              Thank You For Your Business!
            </Text>
            <Text style={{ fontSize: "13px" }}>God Bless, Keep Buying.</Text>
            <Text
              style={{
                fontSize: "9px",
                fontStyle: "italic",
                marginTop: "40px",
              }}
            >
              Declaration:
            </Text>
            <Text style={{ fontSize: "9px", fontStyle: "italic" }}>
              I declare that this invoice shows the actual price of the goods
              described and that all particulars are true and correct. I
              received ornament in good condition.
            </Text>
          </View>
          <View style={generateInvoiceParumalStyles.tableRight}>
            <View style={generateInvoiceParumalStyles.summaryTable}>
              <View style={generateInvoiceParumalStyles.summaryRow}>
                <Text style={generateInvoiceParumalStyles.summaryLabel}>
                  Taxable Amount
                </Text>
                <Text style={generateInvoiceParumalStyles.summaryValue}>
                  {Number(totalAmount).toFixed(2)}
                </Text>
              </View>

              <View style={generateInvoiceParumalStyles.summaryRow}>
                <Text style={generateInvoiceParumalStyles.summaryLabel}>
                  CGST 1.5%
                </Text>
                <Text style={generateInvoiceParumalStyles.summaryValue}>
                  {adminLoggedIn?.Clients?.State ==
                  mainitem?.Customer?.CurrAddState
                    ? Number((totalAmount / 100) * 1.5).toFixed(2)
                    : ""}
                </Text>
              </View>

              <View style={generateInvoiceParumalStyles.summaryRow}>
                <Text style={generateInvoiceParumalStyles.summaryLabel}>
                  SGST 1.5%
                </Text>
                <Text style={generateInvoiceParumalStyles.summaryValue}>
                  {adminLoggedIn?.Clients?.State ==
                  mainitem?.Customer?.CurrAddState
                    ? Number((totalAmount / 100) * 1.5).toFixed(3)
                    : ""}
                </Text>
              </View>

              <View style={generateInvoiceParumalStyles.summaryRow}>
                <Text style={generateInvoiceParumalStyles.summaryLabel}>
                  IGST 3%
                </Text>
                <Text style={generateInvoiceParumalStyles.summaryValue}>
                  {adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
                    ? Number((totalAmount / 100) * 3).toFixed(3)
                    : ""}
                </Text>
              </View>

              <View
                style={[
                  generateInvoiceParumalStyles.summaryRow,
                  generateInvoiceParumalStyles.underlineRow,
                ]}
              >
                <Text style={generateInvoiceParumalStyles.summaryLabel}>
                  R.O DISCOUNT
                </Text>
                <Text style={generateInvoiceParumalStyles.summaryValue}>
                  {Number(mainitem?.Offer).toFixed(2) || "0.00"}
                </Text>
              </View>

              <View
                style={[
                  generateInvoiceParumalStyles.summaryRow,
                  generateInvoiceParumalStyles.netAmountRow,
                ]}
              >
                <Text style={generateInvoiceParumalStyles.summaryLabel}>
                  NET AMOUNT
                </Text>
                <Text style={[generateInvoiceParumalStyles.summaryValue]}>
                  {(
                    (Number(totalAmount) || 0) +
                    (Number(GST) || 0) -
                    (Number(mainitem?.Offer) || 0) +
                    (Number(mainitem?.CourierCharge) || 0)
                  ).toFixed(2)}
                </Text>
              </View>
            </View>
            <Text
              style={{
                fontSize: "10px",
                marginTop: "120px",
                marginLeft: "47px",
                fontWeight: "bold",
              }}
            >
              For: Mewar Jewellery House Pvt. Ltd.{" "}
            </Text>
          </View>
        </View>

        <View style={generateInvoiceParumalStyles.footer2}>
          <View
            style={[
              generateInvoiceParumalStyles.footer2box,
              { borderBottomWidth: 1, borderBottomColor: "#e8e8e8" },
            ]}
          >
            <Text
              style={{ fontSize: "10px", fontWeight: "600", marginBottom: 5 }}
            >
              Customer Signature
            </Text>
            <Text
              style={{ fontSize: "10px", fontWeight: "600", marginBottom: 5 }}
            >
              Authorised Signatory
            </Text>
          </View>
          <View style={[generateInvoiceParumalStyles.footer2box]}>
            <View>
              <Text style={{ fontSize: "10px" }}>
                1st Floor, 1/1, 2nd Cross, Vasanthappa Thota,
              </Text>
              <Text style={{ fontSize: "10px" }}>
                Ganganagar, Bangalore- 560032.
              </Text>
            </View>
            <View style={{ gap: 3 }}>
              <Text style={{ fontSize: "10px" }}>
                jewels@kevali.in || @kevali.in || www.kevali.in
              </Text>
              <Text style={{ fontSize: "10px" }}>
                Phone: +91 6366607409 / 9845351098
              </Text>
              <Text style={{ fontSize: "10px" }}>
                Landline: 080-23333409 / 41515409
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );

  // Generate the PDF blob
  const pdfBlob = await pdf(MyDocument).toBlob();

  // Create a Blob URL
  const pdfUrl = URL.createObjectURL(pdfBlob);

  // Open in a new window
  window.open(pdfUrl, "_blank");
};

function generateBSPInvoice(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.width; // Get the page width

  const startx = 2;
  const starty = 54.5;
  const boxTopMargin = starty + 10; // Top margin for the box
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 40;

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;
  const cgst = (GST || 0) / 2;
  const sgst = (GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // doc.setFont("sanserif", "bold");
  // doc.setFontSize(16);
  // doc.setTextColor(0, 0, 0);
  // doc.text("GOLD SALE", 90, 43);

  const pan = customer?.PanNo || "NA";
  const adhar = customer?.AadharNo || "NA";
  const mobile = customer?.Mobile || "NA";
  const address = customer?.CurrAddStreet || "NA";
  const town = customer?.CurrAddTown || "";
  const city = customer?.City || "";
  const CurrAddPincode = customer?.CurrAddPincode || "";
  const PanNo = customer?.PanNo || "";
  const GSTIN = customer?.GSTIN || "";

  // First column data
  const add = [
    `${customer?.CurrAddStreet || ""}`,
    `${customer?.City || ""}`,
    `${customer?.CurrAddState || ""}`,
    `${customer?.Country || ""}`,
    `${customer?.CurrAddPincode || ""}`,
  ]?.join(",");
  const firstColumn = [
    {
      label: "Billing Name And Address      : ",
      value: `BILLING NAME AND ADDRESS`,
    },
    { label: "Name      : ", value: `${customer?.FirstName?.toUpperCase()}` },
    {
      label: "Address   : ",
      value: add,
    },
    // { label: "Mobile    : ", value: `${mobile}` },
    // { label: "Pan/Adhar : ", value: `${pan} / ${adhar}` },
  ];

  // Second column data
  const secondColumn = [
    { label: "BILL NO           ", value: `${InvoiceNo}` },
    { label: "Date                    ", value: `${InvoiceDate}` },
    { label: "PAN                    ", value: PanNo || "" },
    { label: "GSTIN No          ", value: GSTIN || "" },
    { label: "STATE CODE   ", value: "" },
  ];

  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height of 40
  // Draw content inside the box
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(
    "BSP GOLD & DIAMOND",
    boxPadding + boxWidth / 2 - 35,
    boxTopMargin - 3
  ); // Centered "GOLD SALE" text

  // Set Font for content
  // doc.setFontSize(12);
  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  // Draw first column data
  let columnY = boxTopMargin + 8;
  firstColumn.forEach((item) => {
    doc.text(`${item.value}`, boxPadding + 2, columnY);
    columnY += 6;
  });

  // Draw second column data
  columnY = boxTopMargin + 8;
  secondColumn?.forEach((item) => {
    doc.text(
      `${item.label}${item.value}`,
      boxPadding + boxWidth / 2 + 25,
      columnY
    );
    columnY += 6;
  });
  const rowHeight = 10; // Height of each row
  const headerHeight = 20; // Height for the header
  const paddingHeight = 20;

  //main tbale
  // Now creating the attached table box for items
  const tableStartY = starty + boxHeight + 10; // Start below the first box
  let tableHeight = headerHeight + items?.length * rowHeight + paddingHeight;

  doc.rect(boxPadding, tableStartY, boxWidth, tableHeight); // Draw the outer box for the table
  // doc.rect(boxPadding, 275, boxWidth, 10);
  // Column widths and labels
  const columnWidths = {
    Sr: 12,
    "Item Name": 35.18,
    Pcs: 12,
    // "Total Wt": 16.18,
    // Packing: 12,
    "Gross Wt": 12.18,
    "Stone Wt": 12,
    // 'RB Wt': 11,
    // 'EM Wt': 11,
    // 'NR Wt': 11,
    // 'AD Wt': 11,
    // 'CLR Wt': 11,
    // 'MOTI Wt': 10,
    // 'BDS Wt': 11,
    "Net Wt": 12,
    Fine: 12,
    Wastage: 12,
    "Rate/Gm": 12,
    "Stone Amt": 12,
    // Tounch: 12,
    Hallmark: 12,
    Amout: 13,
    // Metal: 12,
  };

  const columnArray = [
    "Sr",
    "Item Name",
    "Pcs",
    // "Total Wt",
    // "Packing",
    "Gross Wt",
    "Stone Wt",
    // 'RB Wt',
    // 'EM Wt',
    // 'NR Wt',
    // 'AD Wt',
    // 'CLR Wt',
    // 'MOTI Wt',
    // 'BDS Wt',
    "Net Wt",
    "Fine",
    "Wastage",
    // 'Tounch',
    "Rate/Gm",
    "Stone Amt",
    "Hallmark",
    "Amount",
    // "Metal"
  ];

  // Table Headers
  let startX = boxPadding + 2; // Starting X position for table
  let headerY = tableStartY + 7; // Starting Y position for the headers

  doc.setFontSize(5);
  doc.setFont("helvetica", "normal");
  columnArray.forEach((col, index) => {
    doc.text(col, startX, headerY);

    startX += columnWidths[col]; // Move X based on column width
  });

  // Draw vertical lines separating columns
  let columnX = boxPadding; // startx + 2;
  columnArray.forEach((col) => {
    doc.line(columnX, tableStartY, columnX, tableStartY + tableHeight); // Draw vertical lines
    columnX += columnWidths[col];
  });

  // Draw the right border for the table
  doc.line(boxPadding, tableStartY, boxPadding, tableStartY + tableHeight);
  doc.line(
    boxPadding,
    tableStartY + 10,
    boxPadding + boxWidth,
    tableStartY + 10
  );

  const pageHeight = doc.internal.pageSize.height; // Get the height of the page

  let rowStartY = tableStartY + headerHeight;
  let stoneCharge = 0;
  let FineWastageWtTotal = 0;
  let NetWtTotal = 0;
  let GrossWtTotal = 0;
  let TagTotal = 0;
  let GrossTagTotal = 0;
  let PcsTotal = 0;
  let HallmarkAmountTotal = 0;
  let RBWt = 0;
  let RBRate = "";
  let EMWt = 0;
  let EMRate = "";
  let NRWt = 0;
  let NRRate = "";
  let ADWt = 0;
  let ADRate = "";
  let CLRWt = 0;
  let CLRRate = "";
  let MOTIWt = 0;
  let MOTIRate = 0;
  let BDSWt = 0;
  let BDSRate = 0;
  items?.forEach((item, itemIndex) => {
    stoneCharge += +(item?.TotalStoneAmount || 0);
    FineWastageWtTotal += +(item?.FineWastageWt || 0);
    NetWtTotal += +(item?.NetWt || 0);
    GrossTagTotal += +(item?.TotalWt || 0);
    TagTotal += +(item?.PackingWeight || 0);
    GrossWtTotal += +(item?.GrossWt || 0);
    HallmarkAmountTotal += +(item?.HallmarkAmount || 0);

    if (rowStartY + rowHeight > pageHeight - 10) {
      // 20 is bottom margin
      doc.addPage(); // Add a new page

      rowStartY = 0; // Reset Y position for the new page
      // Optionally, re-render the header on the new page
      let startX = boxPadding + 2;
      columnArray.forEach((col, index) => {
        // doc.text(col, startX, rowStartY); // Render header
        startX += columnWidths[col];
      });
      rowStartY += headerHeight; // Move Y position after header
    }

    let startX = boxPadding + 2; // Reset startX for each new row

    let StonePcs = 0;
    let itemRBWt = 0;
    let itemEMWt = 0;
    let itemNRWt = 0;
    let itemADWt = 0;
    let ItemCLRWt = 0;
    let ItemMOTIWt = 0;
    let ItemBDSWt = 0;
    if (item?.Stones?.length) {
      item?.Stones?.map((sitem) => {
        StonePcs += +(sitem?.StonePieces || 0);
        if (sitem?.StoneName == "RUBY") {
          itemRBWt += +(sitem?.StoneWeight || 0);
          RBWt += +(sitem?.StoneWeight || 0);
          RBRate = sitem?.StoneRate;
        }
        if (sitem?.StoneName == "EMERALD") {
          itemEMWt += +(sitem?.StoneWeight || 0);
          EMWt += +(sitem?.StoneWeight || 0);
          EMRate = sitem?.StoneRate;
        }
        if (sitem?.StoneName == "NR") {
          itemNRWt += +(sitem?.StoneWeight || 0);
          NRWt += +(sitem?.StoneWeight || 0);
          NRRate = sitem?.StoneRate;
        }
        if (sitem?.StoneName == "AD") {
          itemADWt += +(sitem?.StoneWeight || 0);
          ADWt += +(sitem?.StoneWeight || 0);
          ADRate = sitem?.StoneRate;
        }
        if (sitem?.StoneName == "CLR") {
          ItemCLRWt += +(sitem?.StoneWeight || 0);
          CLRWt += +(sitem?.StoneWeight || 0);
          CLRRate = sitem?.StoneRate;
        }
        if (sitem?.StoneName == "MOTI") {
          ItemMOTIWt += +(sitem?.StoneWeight || 0);
          MOTIWt += +(sitem?.StoneWeight || 0);
          MOTIRate += +(sitem?.StoneRate || 0);
        }
        if (sitem?.StoneName == "BDS") {
          ItemBDSWt += +(sitem?.StoneWeight || 0);
          BDSWt += +(sitem?.StoneWeight || 0);
          BDSRate += +(sitem?.StoneRate || 0);
        }
      });
    }
    PcsTotal += +(StonePcs || 0);

    const itemData = [
      itemIndex + 1,
      item?.ProductName || "",
      +(StonePcs || 0),
      // (+(item?.TotalWt || 0))?.toFixed(3),
      // (+(item?.PackingWeight || 0))?.toFixed(3),
      (+(item?.GrossWt || 0))?.toFixed(3),
      (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      // (+(itemRBWt || 0))?.toFixed(3),
      // (+(itemEMWt || 0))?.toFixed(3),
      // (+(itemNRWt || 0))?.toFixed(3),
      // (+(itemADWt || 0))?.toFixed(3),
      // (+(ItemCLRWt || 0))?.toFixed(3),
      // (+(ItemMOTIWt || 0))?.toFixed(3),
      // (+(ItemMOTIWt || 0))?.toFixed(3),
      // item.Purity,
      // "1",
      // item.GrossWt,
      // item.TotalStoneWeight,
      (+(item?.NetWt || 0))?.toFixed(3),
      ((+(item?.NetWt || 0) * (item?.FinePercentage || 0)) / 100)?.toFixed(3),
      ((+(item?.NetWt || 0) * (item?.MakingPercentage || 0)) / 100)?.toFixed(3),
      // item?.FinePercentage + ' + ' + item?.MakingPercentage || 0,
      (+(item?.MetalRate || 0))?.toFixed(3),
      (+(item?.StoneAmount || 0))?.toFixed(3),
      (+(item?.HallmarkAmount || 0))?.toFixed(3),
      // item.TotalStoneAmount,
      // item.MetalRate,
      // item.MakingPercentage,
      (+(item?.MRP
        ? item?.MRP
        : item?.TotalItemAmount
        ? item?.TotalItemAmount
        : 0))?.toFixed(3),
      // (+(item?.FineWastageWt || 0))?.toFixed(3)
    ];

    // (+(item?.MRP ? item?.MRP : item?.TotalItemAmount ? item?.TotalItemAmount : 0))?.toFixed(3),

    // Render each column's data for the current row
    itemData?.forEach((data, index) => {
      doc.text(`${data}`, startX, rowStartY);
      startX += columnWidths[columnArray[index]]; // Move to the next column
    });
    rowStartY += rowHeight; // Move to the next row
  });

  doc.setFont("Helvetica", "normal");

  // totalStoneAmtData.forEach((data, index) => {
  //   doc.text(`${data}`, startXXXX, rowStartY + 16);
  //   startXXXX += columnWidths[columnArray[index]]; // Move to the next column
  // });

  if (rowStartY + 70 > pageHeight - 10) {
    // 70 is the approximate height needed for additional content
    doc.addPage(); // Add a new page
    rowStartY = 10; // Reset Y position for the new page
  }
  let metal = 0;
  let metalToCash = 0;
  let cashToMetal = 0;
  let cash = 0;
  let card = 0;
  let upi = 0;
  let cheque = 0;
  let rtgs = 0;

  mainitem?.Payments?.forEach((item) => {
    if (item?.PaymentModeType == "Cash") {
      cash += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Card") {
      card += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "UPI") {
      upi += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Cheque") {
      cheque += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "RTGS") {
      rtgs += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Metal to Cash") {
      metalToCash += +(item?.GoldAmount || item?.SilverAmount || 0);
    }
    if (item?.PaymentModeType == "Metal") {
      metal += +(item?.OldGoldGrossWt || item?.OldSilverGrossWt || 0);
    }
    if (item?.PaymentModeType == "Cash to Metal") {
      cashToMetal += +(item?.OldGoldGrossWt || item?.OldSilverGrossWt || 0);
    }
  });

  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(10);
  doc.text(
    `Payable Amount          ${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    )?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 25
  );

  doc.setFont("Helvetica", "normal");
  doc.setFontSize(8);

  doc.text(
    `Cash                                       ${cash?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 37
  );
  doc.text(
    `Card                                        ${card?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 42
  );
  doc.text(
    `UPI                                          ${upi?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 47
  );
  doc.text(
    `Cheque                                   ${cheque?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 52
  );
  doc.text(
    `RTGS                                      ${rtgs?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 57
  );
  doc.text(
    `Metal to Cash                          ${metalToCash?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 62
  );
  doc.text(
    `Cash to Metal                          ${cashToMetal?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 67
  );
  doc.text(
    `Metal                                       ${metal?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 72
  );
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(10);

  doc.text(
    `Balance Amount          ${(+(mainitem?.BalanceAmount || 0))?.toFixed(3)}`,
    boxPadding + 4,
    rowStartY + 80
  );

  // // Draw the "Cash" label cell
  doc.setFont("Helvetica", "normal");
  doc.setFontSize(7);
  doc.text(
    `Purchase Amt          ${(+(mainitem?.TotalNetAmount || 0))?.toFixed(3)}`,
    boxPadding + 162,
    rowStartY + 25
  );

  doc.text(
    `Total GST                ${(+(mainitem?.TotalGSTAmount || 0))?.toFixed(
      3
    )}`,
    boxPadding + 162,
    rowStartY + 29
  );
  doc.text(
    `Courier Charge        ${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
    boxPadding + 162,
    rowStartY + 33
  );
  doc.text(
    `TDS                         ${(+(mainitem?.TDS || 0))?.toFixed(3)}`,
    boxPadding + 162,
    rowStartY + 37
  );

  doc.text(
    `Discount (-)              ${(+(mainitem?.Offer || 0))?.toFixed(3)}`,
    boxPadding + 162,
    rowStartY + 41
  );

  // doc.text(`Gold Value               ${"0.00"}`, boxPadding + 162,rowStartY+45  );
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(7);
  doc.text(
    `Payable Amt           ${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    )?.toFixed(3)}`,
    boxPadding + 162,
    rowStartY + 49
  );
  doc.setFont("Helvetica", "normal");

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}
function generateinvoicepdf13(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  console.log(mainitem);
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.width; // Get the page width

  const startx = 2;
  const starty = 54.5;
  const boxTopMargin = starty + 10; // Top margin for the box
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 40;

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;
  const cgst = (GST || 0) / 2;
  const sgst = (GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // doc.setFont("sanserif", "bold");
  // doc.setFontSize(16);
  // doc.setTextColor(0, 0, 0);
  // doc.text("GOLD SALE", 90, 43);

  const pan = customer.PanNo || "NA";
  const adhar = customer.AadharNo || "NA";
  const mobile = customer.Mobile || "NA";
  const address = customer.CurrAddStreet || "NA";
  const town = customer?.CurrAddTown || "";
  const city = customer?.City || "";
  const CurrAddPincode = customer?.CurrAddPincode || "";
  const PanNo = customer?.PanNo || "";
  const GSTIN = customer?.GSTIN || "";

  // First column data
  const firstColumn = [
    {
      label: "Billing Name And Address      : ",
      value: `BILLING NAME AND ADDRESS`,
    },
    { label: "Name      : ", value: `${customer?.FirstName?.toUpperCase()}` },
    {
      label: "Address   : ",
      value: `${address?.toUpperCase()}${town && `, ${town}`}${
        CurrAddPincode && ` - ${CurrAddPincode}`
      }`,
    },
    // { label: "Mobile    : ", value: `${mobile}` },
    // { label: "Pan/Adhar : ", value: `${pan} / ${adhar}` },
  ];

  // Second column data
  const secondColumn = [
    { label: "BILL NO           ", value: `${InvoiceNo}` },
    { label: "Date                    ", value: `${InvoiceDate}` },
    { label: "PAN                    ", value: PanNo || "" },
    { label: "GSTIN No          ", value: GSTIN || "" },
    { label: "STATE CODE   ", value: "" },
  ];

  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height of 40
  // Draw content inside the box
  doc.setFont("sanserif", "bold");
  doc.setFontSize(16);
  doc.text("KALDAN JEWELS", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3); // Centered "GOLD SALE" text

  // Set Font for content
  // doc.setFontSize(12);
  doc.setFontSize(10);
  doc.setFont("sanserif", "bold");
  // Draw first column data
  let columnY = boxTopMargin + 8;
  firstColumn.forEach((item) => {
    doc.text(`${item.value}`, boxPadding + 2, columnY);
    columnY += 6;
  });

  // Draw second column data
  columnY = boxTopMargin + 8;
  secondColumn.forEach((item) => {
    doc.text(
      `${item.label}${item.value}`,
      boxPadding + boxWidth / 2 + 25,
      columnY
    );
    columnY += 6;
  });

  //main tbale
  // Now creating the attached table box for items
  const tableStartY = starty + boxHeight + 10; // Start below the first box
  const tableHeight = 80;

  doc.rect(boxPadding, tableStartY, boxWidth, tableHeight); // Draw the outer box for the table

  // Column widths and labels
  const columnWidths = {
    "SL No": 13.18,
    Item: 66.18,
    HSN: 26.18,
    // Purity: 13.18,
    // Qty: 12.18,
    // "G wt": 15.18,
    // "Stone wt": 17.18,
    "Net wt": 20.18,
    // "St amt": 15.18,
    "Rate/gm": 24.18,
    // "Making": 21.18,
    Amount: 16.18,
  };

  const columnArray = [
    "SL No",
    "Item",
    "HSN",
    // "Purity",
    // "Qty",
    // "G wt",
    // "Stone wt",
    "Net wt",
    // "St amt",
    "Rate/gm",
    // "Making",
    "Amount",
  ];

  const arr = [
    { label: "CGST 1.5%", value: `${Number(cgst).toFixed(2)}` },
    { label: "SGST 1.5%", value: `${Number(sgst).toFixed(2)}` },
  ];
  const arr1 = [{ label: "IGST 3%", value: `${Number(GST).toFixed(2)}` }];

  const leftColumn = [
    { label: "Total", value: `${totalgross.toFixed(2)}` },
    // ()
    ...(customer?.CurrAddState?.toLowerCase() ==
    adminLoggedIn?.State?.toLowerCase()
      ? arr
      : arr1),

    // { label: "Hallmarking Amount", value: "" },
    // { label: "Purchase Amount (-)", value: `${UrdPurchaseAmt}` },
    // { label: "RO/Discount (-)", value: "" },
    { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
  ];
  console.log(leftColumn);
  const arrv1 = [`${Number(cgst).toFixed(2)}`, `${Number(sgst).toFixed(2)}`];
  const arrv2 = [`${Number(GSTNumber).toFixed(2)}`];
  // Dummy values for the right column
  const rightColumnValues = [
    `${Math.abs(totalgross.toFixed(2))}`,
    ...(customer?.CurrAddState?.toLowerCase() ==
    adminLoggedIn?.State?.toLowerCase()
      ? arrv1
      : arrv2),

    // "",
    // `${UrdPurchaseAmt}`,
    // "",
    `${(Math.abs(totalgross) + GSTNumber - UrdPurchaseAmt).toFixed(2)}`,
  ];

  console.log(rightColumnValues);

  // Table Headers
  let startX = boxPadding + 2; // Starting X position for table
  let headerY = tableStartY + 7; // Starting Y position for the headers

  doc.setFontSize(10);
  columnArray.forEach((col, index) => {
    doc.text(col, startX, headerY);

    startX += columnWidths[col]; // Move X based on column width
  });

  // Draw vertical lines separating columns
  let columnX = boxPadding; // startx + 2;
  columnArray.forEach((col) => {
    doc.line(columnX, tableStartY, columnX, tableStartY + tableHeight); // Draw vertical lines
    columnX += columnWidths[col];
  });

  // Draw the right border for the table
  doc.line(boxPadding, tableStartY, boxPadding, tableStartY + tableHeight);

  doc.line(
    boxPadding,
    tableStartY + 10,
    boxPadding + boxWidth,
    tableStartY + 10
  );

  // Render table content
  let rowStartY = headerY + 10;
  // startX = boxPadding+2;
  items.forEach((item, itemIndex) => {
    if (item.ProductName.toLowerCase() === "old gold") {
      return; // Skip to the next item
    }
    let startX = boxPadding + 2; // Reset startX for each new row

    const itemData = [
      itemIndex + 1,
      item.ProductName,
      item.HSNCode,
      // item.Purity,
      // "1",
      // item.GrossWt,
      // item.TotalStoneWeight,
      item.NetWt,
      // item.TotalStoneAmount,
      item.MetalRate,
      // item.MakingPercentage,
      item?.TotalItemAmount || item?.MRP,
    ];

    // Render each column's data for the current row
    itemData.forEach((data, index) => {
      doc.text(`${data}`, startX, rowStartY);
      startX += columnWidths[columnArray[index]]; // Move to the next column
    });

    rowStartY += 10; // Move to the next row
  });

  const startX4 = 135; // Starting X position for the table
  const startY4 = 185; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 50; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  doc.setLineWidth(0.3);
  doc.rect(startX4, startY4, tableWidth4, tableHeight4); // Outer table border

  // Draw vertical line at the center
  doc.line(verticalLineX, startY4, verticalLineX, startY4 + tableHeight4); // Vertical line splitting the table

  // Fill in the left column labels and right column dummy values
  leftColumn.forEach((row, index) => {
    const ypos = startY4 + (index + 1) * cellHeight4 - 3; // Y position for the text

    // Draw left side labels
    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(`${row.label}`, startX4 + 2, ypos);

    // Draw right side dummy values
    const rightValue = rightColumnValues[index];
    doc.setFont("sanserif", "normal");
    doc.text(`${rightValue}`, verticalLineX + 2, ypos); // Right side column values

    // Draw horizontal line after each cell
    doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3); // Horizontal line across the row
  });
  // Draw bottom border for the table

  //draw cash table
  doc.setFont("sanserif", "bold");

  // Initialize drawing positions
  const sectionX = 5; // Starting X position for the payment section
  // const sectionY = 199; // Starting Y position
  // const cellWidth = 50; // Width of each column for the payment table
  // const cellHeight = 10; // Height for each cell

  let currentX = sectionX; // To adjust X position dynamically for each payment mode

  // Set font and style for the document
  doc.setFontSize(10);
  doc.setFont("sanserif", "bold");

  // const paymentSummary = Payments.map(payment => ({
  //   mode: payment.PaymentModeType,
  //   amount: payment.Amount
  // }));

  // Starting position for drawing the payment sections
  let startY = 199; // Starting Y position for the first payment section
  const cellWidth = 50; // Width of each column for the payment table
  const cellHeight = 10; // Height of each row for the payment table
  let adminy = 190;
  // Loop through payment summary and draw each payment mode and amount
  // paymentSummary.forEach((payment, index) => {
  //   // Calculate the Y position for each payment mode based on the index
  //   const currentY = startY + index * (cellHeight + 0); // Adding 2 for spacing

  //   // Draw the payment mode label cell
  //   doc.setFontSize(10);
  //   doc.setFont("sanserif", "bold");
  //   doc.text(
  //     payment.mode,
  //     5 + cellWidth / 2 - doc.getTextWidth(payment.mode) / 2,
  //     currentY + 7 // Center text vertically
  //   ); // Center text in the first column

  //   // Draw the payment amount cell
  //   doc.text(
  //     payment.amount,
  //     5 + cellWidth + cellWidth / 2 - doc.getTextWidth(payment.amount) / 2,
  //     currentY + 2 // Center text vertically
  //   ); // Center text in the second column

  //   // Draw the outer border of the payment mode and amount cells
  //   doc.rect(5, currentY, cellWidth, cellHeight); // Border for payment mode label
  //   doc.rect(5 + cellWidth, currentY, cellWidth, cellHeight); // Border for the amount
  //   adminy = currentY;
  // });

  // Now create a second section with two columns: "Cash" and its amount
  // const cashSectionX = 5; // Starting X position for the cash section
  // const cashSectionY = 199;
  // const cashCellWidth = 50; // Width of each column for the cash table

  // // Draw the "Cash" label cell
  // doc.setFontSize(10);
  // doc.setFont("sanserif", "bold");

  // doc.text(
  //   "Cash",
  //   cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
  //   cashSectionY + 7
  // ); // Center text in the first column

  // // Draw the "Cash" amount cell
  // doc.text(
  //   "",
  //   cashSectionX +
  //   cashCellWidth +
  //   cashCellWidth / 2 -
  //   doc.getTextWidth("1000") / 2,
  //   cashSectionY + 7
  // ); // Center text in the second column

  // // Draw the outer border of the cash and amount cells
  // doc.rect(cashSectionX, cashSectionY, cashCellWidth, 10); // Border for "Cash" label
  // doc.rect(cashSectionX + cashCellWidth, cashSectionY, cashCellWidth, 10); // Border for the amount
  const startX7 = 5; // Starting X position for the table
  const startY7 = 185; // Starting Y position for the table
  const tableWidth7 = 130; // Table width
  const tableHeight7 = 50; // Table height (adjust based on number of rows)
  const cellHeight7 = 10; // Height for each cell row

  doc.setLineWidth(0.3);
  doc.rect(startX7, startY7, tableWidth7, tableHeight7);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(15);
  doc.text("Amount in words", 6, adminy);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  const amountInWords = toWords(totalgross + GSTNumber);
  doc.text(`Rupees ${amountInWords} only`, 6, 200);

  const startX5 = 5; // Starting X position for the table
  const startY5 = 235; // Starting Y position for the table
  const tableWidth5 = 200; // Table width
  const tableHeight5 = 20; // Table height (adjust based on number of rows)
  const cellHeight5 = 10; // Height for each cell row

  doc.setLineWidth(0.3);
  doc.rect(startX5, startY5, tableWidth5, tableHeight5);

  const startX6 = 5; // Starting X position for the table
  const startY6 = 255; // Starting Y position for the table
  const tableWidth6 = 200; // Table width
  const tableHeight6 = 25; // Table height (adjust based on number of rows)
  const cellHeight6 = 10; // Height for each cell row

  doc.setLineWidth(0.3);
  doc.rect(startX6, startY6, tableWidth6, tableHeight6);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`Bank Details`, 6, 240);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`Bank Name`, 40, 240);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`A/C No.`, 40, 246);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`Branch & IFS Code.`, 40, 252);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`Kotak Mahindra Bank`, 80, 240);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`9743981235`, 80, 246);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`Race Course Road & KKBK0008082`, 80, 252);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(12);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`Terms & Conditions`, 6, 260);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(7);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(`1. Our Responsibility ceases after the delivery of goods`, 6, 266);
  doc.text(
    `2. Interest @ 24% per annum will be charged for bills not paid within 15 days.`,
    6,
    270
  );
  doc.text(`3. Goods once sold will not be taken back.`, 6, 274);
  doc.text(`Subject to Banglore Jurisdiction`, 6, 278);
  // doc.setFont("sanserif", "normal");
  // doc.setFontSize(10);
  // doc.text(
  //   "note:- we declare that this invoice shows actual price of the good described ",
  //   5,
  //   240
  // );

  // doc.setFont("sanserif", "normal");
  // doc.setFontSize(10);
  // doc.text("and that all particulars are true and correct", 5, 245);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text(
    "Kundan Deep's No. 109, Second Floor, Shop No. 201, Nagarthpet, Sree Dharmarayaswamy Temple Road, Bengaluru - 560002",
    6,
    285
  );
  doc.text(
    "GST IN : 29AALCK3890N1ZM | Contact : +91 7337777733 / 080 43771414",
    6,
    290
  );

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}

function MundlikInvoice(items, customer, mainitem, adminLoggedIn) {
  console.log(mainitem);
}

function generateinvoicepdfMundlik(items, customer, mainitem, adminLoggedIn) {
  console.log("new gold invoice");

  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
    Offer,
  } = mainitem;

  console.log(items);
  console.log(mainitem);
  

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 54.5 + 10;
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 28;
  doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;

  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  const igst = +(GST || 0);

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // Set up customer details
  const address = `${customer?.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;
  // Billing information
  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(16);
  doc.text("GOLD SALE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.setFontSize(8);

  let currAddress = "";
  if (mainitem?.Customer?.CurrAddStreet) {
    currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
  }
  if (mainitem?.Customer?.CurrAddTown) {
    currAddress += mainitem?.Customer?.CurrAddTown + ", ";
  }
  if (mainitem?.Customer?.CurrAddState) {
    currAddress += mainitem?.Customer?.CurrAddState + ", ";
  }
  if (mainitem?.Customer?.City) {
    currAddress += mainitem?.Customer?.City + " ";
  }
  if (mainitem?.Customer?.CurrAddPincode) {
    currAddress += mainitem?.Customer?.CurrAddPincode + " ";
  }
  // First column data

  const add = [
    `${customer?.Area || ""}`,
    `${customer?.CurrAddStreet || ""}`,
    `${customer?.City || ""}`,
    `${customer?.CurrAddState || ""}`,

    `${customer?.CurrAddPincode || ""}`,
  ]?.join(",");

  const billingDetails = [
    `NAME                      :  ${customer?.FirstName?.toUpperCase() || ""}`,
    `ADDRESS               :  ${add || ""}`,
    `MOBILE                  :  ${customer?.Mobile || ""}`,
    `PAN/GSTNO    :  ${customer?.PanNo || customer?.GstNo || ""}`,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 6;
  });
  console.log(adminLoggedIn);

  // Second column data
  const secondColumn = [
    { label: "BILL NO        ", value: `${InvoiceNo || ""}` },
    { label: "Date               ", value: `${InvoiceDate || ""}` },
    {
      label: "GSTIN NO      ",
      value: `${adminLoggedIn?.Clients?.GSTNo || ""}`,
    },
    { label: "GSTIN Type   ", value: `${"CGST + SGST + IGST"}` },
  ];

  // Define second column starting position
  const secondColumnStartX = boxPadding + 100; // Adjust as needed
  let secondColumnStartY = boxTopMargin + 8; // Align with first column

  // Print second column data
  secondColumn.forEach(({ label, value }) => {
    doc.text(`${label}: ${value}`, secondColumnStartX + 50, secondColumnStartY);
    secondColumnStartY += 6; // Move to the next line
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    Item: 40.18,
    HSN: 15.18,
    Purity: 11,
    Qty: 8.18,
    "G wt": 13.18,
    "St wt": 14.18,
    "Net wt": 13.18,
    "St. Amt": 15.18,
    "Rate/gm": 15.18,
    "Making/gm": 20,
    // Hallmark: 15.18,
    Amount: 38.36,
  };

  const columnArray = [
    "Item",
    "HSN",
    "Purity",
    "Qty",
    "G wt",
    "St wt",
    "Net wt",
    "St. Amt",
    "Rate/gm",
    "Making/gm",
    // "Hallmark",
    "Amount",
  ];

  // Function to render table headers
  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table
    columnArray.forEach((col) => {
      doc.text(col, startX + 2, currentY + 2);
      startX += columnWidths[col];

      doc.line(5, 100, 205, 100); //horizontal line after table headers
    });

    // Draw vertical lines for headers
    startX = boxPadding;
    columnArray.forEach((col, index) => {
      // if(index == columnArray.length - 1){
      //   return
      // }
      doc.line(startX, currentY - 4, startX, currentY + rowHeight + 3); // Vertical line
      startX += columnWidths[col];
    });

    // Ensure the last vertical line extends fully
    doc.line(startX, currentY + 2, startX, currentY + rowHeight + 3);
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);

  tableStartY += 7; // Adjust for the first header row

  // Draw table and handle borders
  let rowStartY = tableStartY;

  console.log(items);
  let tableHeightUsed = 0;
  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(8);

  let urdTotalAmount = 0;
  let urdTotalNetWt = 0;
  let urdTotalGrossWt = 0;

  items?.forEach((item, index) => {
    console.log(item?.CategoryName);

    if (
      item?.CategoryName === "OLD GOLD" ||
      item?.CategoryName === "OLD SILVER"
    ) {
      return; // Skip this iteration
    }

    // if (item?.BillType == "purchase") {
    //   urdTotalAmount += +(item?.Amount || 0);
    //   urdTotalNetWt += +(item?.NetWt || 0);
    //   urdTotalGrossWt += +(item?.GrossWt || 0);
    // }

    if (rowStartY + rowHeight > pageHeight - 5) {
      // Check space at the bottom
      // Draw table border for the previous page
      const contentHeight = rowStartY - tableStartY;
      // doc.rect(boxPadding, tableStartY, boxWidth, contentHeight);
      // Add a horizontal line before adding a new page
      // doc.line(5, rowStartY, 205, rowStartY);
      tableHeightUsed += rowStartY - tableStartY;

      doc.addPage(); // Add a new page
      rowStartY = 3; // Reset Y position for the new page
      tableStartY = rowStartY; // Update table start Y for the new page

      // Draw a new table border for the new page
      renderHeaders(rowStartY - 2);
      rowStartY += 7; // Position after headers
      doc.line(5, 10, 205, 10); //horizontal line after table headers
    }

    let startX = boxPadding + 2; // Reset startX for each new row
    const itemData = [
      item?.ProductName || "",
      item?.HSNCode || "",
      item?.Purity || "",
      item?.Quantity || "",
      (+(item?.GrossWt || 0))?.toFixed(3),
      (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      (+(item?.NetWt || 0))?.toFixed(3),
      (+(item?.StoneAmount || 0))?.toFixed(3),
      (+(item?.MetalRate || 0))?.toFixed(3),
      // (+(item?.MakingPerGram || 0))?.toFixed(3),
      item?.MakingPercentage > 0
        ? `${+item.MakingPercentage}%`
        : item?.MakingPerGram > 0
        ? (+item.MakingPerGram).toFixed(3)
        : "",

      (+(item?.TotalItemAmount || 0))?.toFixed(3),
    ];

    itemData.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 8);
      startX += columnWidths[columnArray[colIndex]];
    });

    doc.setFont("Helvetica", "Normal");
    doc.setFontSize(8);
    // Draw vertical lines for table rows
    startX = boxPadding;
    columnArray.forEach((col, colIndex) => {
      doc.line(startX, rowStartY, startX, rowStartY + rowHeight); // Vertical line for each column
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        doc.line(startX - 4, rowStartY - 11, startX - 4, rowStartY + rowHeight); // Last vertical line
      }
    });

    rowStartY += rowHeight; // Move to the next row
  });

  // Store the final table height used on the last page
  tableHeightUsed += rowStartY - tableStartY;

  // Additional contents (for example, terms, conditions, signatures, etc.)
  let contentStartY = rowStartY + 10; // Start below the table

  // Draw final table border for the last page
  let finalContentHeight = rowStartY - tableStartY;

  if (contentStartY + 20 > pageHeight) {
    // Draw final table border for the last page
    finalContentHeight = rowStartY - tableStartY + 4;
  }

  if (contentStartY + 20 > pageHeight) {
    doc.addPage(); // Add a new page
    contentStartY = 10; // Reset Y on new page
  }

  //  Add horizontal line after the last row of the table
  if (rowStartY <= pageHeight - 5) {
    // Ensure horizontal line is added at the end of the table
    doc.line(5, rowStartY, 205, rowStartY);
  }

  function checkAndAddPage(currentY, sectionHeight) {
    if (currentY + sectionHeight > pageHeight - 20) {
      // Adjust to prevent cutoff
      doc.addPage();
      return 10; // Reset Y position for new page
    }
    return currentY;
  }

  // Now create a second section with two columns: "Cash" and its amount
  const cashSectionX = 5; // Starting X position for the cash section
  let summaryStartY = rowStartY; // Add spacing after the first table
  summaryStartY = checkAndAddPage(summaryStartY, 80); // Ensure it fits in the page
  let cashStartY = summaryStartY; // Place cash details below summary
  cashStartY = checkAndAddPage(cashStartY, 20); // Ensure cash details fit
  const cashCellWidth = 50; // Width of each column for the cash table

  // Draw the "Cash" label cell
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");

  let totalHallmarkAmount = items?.reduce(
    (sum, item) => sum + (Number(item?.HallmarkAmount) || 0),
    0
  );

  let urdProductName = "";

  items?.forEach((item) => {
    if (
      item?.CategoryName == "OLD GOLD" ||
      item?.CategoryName == "OLD SILVER"
    ) {
      urdTotalAmount += parseFloat(item.Amount) || 0;
      urdTotalNetWt += parseFloat(item.NetWt) || 0;
      urdTotalGrossWt += parseFloat(item.GrossWt) || 0;
      if (item?.CategoryName == "OLD GOLD") {
        urdProductName = "OLD GOLD";
      } else if (item?.CategoryName == "OLD SILVER") {
        urdProductName = "OLD SILVER";
      }
    }
  });

  console.log(urdTotalAmount);

  const leftColumn = [
    { label: "Gross Amount", value: `${totalgross.toFixed(3)}` },
    {
      label: "CGST 1.5%",
      value: `${
        adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
          ? Number(cgst).toFixed(2)
          : ""
      }`,
    },
    {
      label: "SGST 1.5%",
      value: `${
        adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
          ? Number(sgst).toFixed(2)
          : ""
      }`,
    },
    {
      label: "IGST 3%",
      value: `${
        adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
          ? Number(igst).toFixed(2)
          : ""
      } }`,
    },
    {
      label: "Total Hallmark Amount",
      value: `${totalHallmarkAmount.toFixed(2)}`,
    },
    { label: "Purchase Amount (-)", value: `${urdTotalAmount.toFixed(2)}` },
    { label: "RO/Discount (-)", value: `${mainitem?.Offer}` },
    { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
  ];

  console.log(adminLoggedIn?.State);
  console.log(mainitem?.Customer?.CurrAddState);

  // Dummy values for the right column
  const rightColumnValues = [
    `${(+(mainitem?.TotalNetAmount || 0))?.toFixed(2)}`,
    `${
      adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
        ? Number(cgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
        ? Number(sgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.Clients?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    `${(+(totalHallmarkAmount.toFixed(2) || 0))?.toFixed(3)}`,
    // `${(
    //   +(mainitem?.TotalNetAmount || 0) +
    //   +(mainitem?.GST || 0) +
    //   +(mainitem?.TDS || 0) +
    //   +(mainitem?.CourierCharge || 0)
    // )?.toFixed(3)}`,
    `${(+(urdTotalAmount || 0))?.toFixed(2)}`,
    `${mainitem?.Offer || ""}`,
    `${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0) -
      +(urdTotalAmount || 0)
    )?.toFixed(2)}`,
  ];

  // Set table starting position and dimensions
  const startX4 = 135; // Starting X position for the table
  const startY4 = 130; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  // SUMMARY TABLE
  doc.setFont("helvetica", "bold");
  doc.rect(startX4, summaryStartY, tableWidth4, tableHeight4);
  doc.line(
    verticalLineX,
    summaryStartY,
    verticalLineX,
    summaryStartY + tableHeight4
  );
  let ypos;

  // leftColumn.forEach((row, index) => {
  //   ypos = summaryStartY + (index + 1) * cellHeight4 - 3;
  //   doc.text(`${row.label}`, startX4 + 2, ypos);
  //   doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);
  //   doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
  // });

  leftColumn.forEach((row, index) => {
    ypos = summaryStartY + (index + 1) * cellHeight4 - 3;

    // Set font to bold for label
    doc.setFont("helvetica", "bold");
    doc.text(`${row.label}`, startX4 + 2, ypos);

    // Set font back to normal for value
    doc.setFont("helvetica", "normal");
    doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);

    // Draw line
    doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
  });

  // Determine the starting position below the main dynamic table
  let newTableStartY = rowStartY + 10; // Ensure proper spacing below dynamic table
  doc.setFont("helvetica", "normal");
  // New Table (Above Cash & RTGS)
  doc.rect(cashSectionX, newTableStartY, cashCellWidth * 2, 10); // Full row width

  // Sample data row
  let newTableRowStartY = newTableStartY - 10;
  doc.rect(cashSectionX, ypos - 77, cashCellWidth * 2, 10); // Row border

  doc.line(30, ypos - 77, 30, ypos - 57); // verticle lines at old gold
  doc.line(55, ypos - 77, 55, ypos - 57); // verticle lines at old gold
  doc.line(75, ypos - 77, 75, ypos - 57); // verticle lines at old gold
  // doc.line(75, 113.5, 75, 133.5);

  doc.text("ITEM", cashSectionX + 5, ypos - 70);
  doc.text("GROSS WT", cashSectionX + cashCellWidth / 2 + 5, ypos - 70);
  doc.text("NET WT", cashSectionX + cashCellWidth + 5, ypos - 70);
  doc.text(
    "AMOUNT",
    cashSectionX + cashCellWidth + cashCellWidth / 2,
    ypos - 70
  );

  doc.text(`${urdProductName}`, cashSectionX + 5, ypos - 62);
  doc.text(
    `${(+(urdTotalGrossWt || 0))?.toFixed(3)}`,
    cashSectionX + cashCellWidth / 2 + 5,
    ypos - 62
  );
  doc.text(
    `${(+(urdTotalNetWt || 0))?.toFixed(3)}`,
    cashSectionX + cashCellWidth + 5,
    ypos - 62
  );
  doc.text(
    `${(+(urdTotalAmount || 0))?.toFixed(2)}`,
    cashSectionX + cashCellWidth + cashCellWidth / 2,
    ypos - 62
  );

  // Update starting position for Cash Table
  let cashStartY2 = newTableRowStartY + 25; // Move below the new table

  const getPaymentAmount = (mode) => {
    const amount = mainitem?.Payments?.find(
      (payment) => payment.PaymentModeType === mode
    )?.Amount;
    return amount ? parseFloat(amount).toFixed(3) : "";
  };
  doc.setFont("helvetica", "bold");
  // Get amounts for each payment mode
  const cashPayment = getPaymentAmount("Cash");
  const rtgsPayment = getPaymentAmount("RTGS");
  const chequePayment = getPaymentAmount("Cheque");
  const cardPayment = getPaymentAmount("Card");

  // CASH DETAILS TABLE
  doc.setFont("helvetica", "bold");
  // doc.setFontSize(10);
  doc.text(
    "Cash",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
    ypos - 52
  );
  doc.text(
    `${cashPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2 + 45,
    ypos - 52
  );
  doc.rect(cashSectionX, ypos - 57, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 57, cashCellWidth, 10);

  // RTGS Table
  let rtgsStartY = cashStartY2 + 12; // Moving RTGS just below the Cash table
  doc.text(
    "RTGS",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 42
  );
  doc.text(
    `${rtgsPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 42
  );
  doc.rect(cashSectionX, ypos - 47, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 47, cashCellWidth, 10);

  //Cheque
  doc.text(
    "Cheque",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 32
  );
  doc.text(
    `${chequePayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 32
  );
  doc.rect(cashSectionX, ypos - 37, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 37, cashCellWidth, 10);

  //Card
  doc.text(
    "Card",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 22
  );
  doc.text(
    `${cardPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 22
  );
  doc.rect(cashSectionX, ypos - 27, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 27, cashCellWidth, 10);

  let ypos2 = ypos + 30;

  doc.text(`Terms & Conditions`, 6, ypos2 - 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(
    `note:- we declare that this invoice shows actual price of the good described and that all`,
    6,
    ypos2 - 15
  );
  doc.text(` particulars are true and correct`, 6, ypos2 - 10);

  doc.setFont("Helvetica", "Bold");

  // Ensure Footer is dynamically placed below Terms & Conditions
  let footerStartY = ypos2 + 25; // Space after Terms & Conditions

  doc.setFontSize(10);
  doc.text("Customer Sign", 10, footerStartY);

  doc.text("(Saturday Closed)", 80, footerStartY);

  doc.text("Thank You!", 85, footerStartY + 5);

  doc.text("For: Mundlik Jewellers", 160, footerStartY);

  // Generate the PDF and open it in a new window
  // const pdfData = doc.output("datauristring");
  // const newWindow = window.open();
  // newWindow.document.write(
  //   `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  // );

//   const pdfData = doc.output("blob"); // Generate a Blob instead of a data URL
// const pdfUrl = URL.createObjectURL(pdfData); // Create an object URL


// const newWindow = window.open();
// if (newWindow) {
//   const iframe = newWindow.document.createElement("iframe");
//   iframe.style.width = "100%";
//   iframe.style.height = "100%";
//   iframe.src = pdfUrl;

//   newWindow.document.body.appendChild(iframe);

  

// }

return doc;

}

const generateMundlikUrdBill = async (
  items,
  customer,
  mainitem,
  adminLoggedIn
) => {
  console.log(items);

  const styles = StyleSheet.create({
    page: {
      flexDirection: "column",
      padding: 15,
    },
    section: {
      marginTop: 70, // Leave space for the pre-printed header
    },
    row: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderBottomColor: "#000",
      paddingVertical: 5,
    },
    col: {
      fontSize: 10,
      padding: 3,
    },
    bold: {
      fontWeight: "bold",
    },
    text: {
      fontWeight: "normal",
      fontSize: "10px",
      marginBottom: "10px",
    },
    tableHeader: {
      // backgroundColor: "#f0f0f0",
    },
    rightAlign: {
      textAlign: "right",
    },
    TopBox: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
      padding: "15px",
      borderBottom: "4px",
      borderBottomColor: "#ddd",
      borderTop: "4px",
      borderTopColor: "#ddd",
    },
    TopSectionContainer: {
      width: "45%",
    },
  });

  console.log(mainitem);

  const columns = [
    { label: "SR NO.", width: "10%" },
    { label: "Particulars", width: "20%" },
    { label: "Net Wt", width: "15%" },
    { label: "Fine Wt", width: "15%" },
    { label: "Fine %", width: "10%" },
    { label: "Rate/Gm", width: "15%" },
    { label: "Amount", width: "15%", align: "right" },
  ];

  let fineWt = 0;

  items.forEach((item) => {
    if (
      item?.CategoryName == "OLD GOLD" ||
      item?.CategoryName == "OLD SILVER"
    ) {
      console.log(item?.FinePercentage, item?.NetWt);

      fineWt = ((+item?.FinePercentage || 0) * (+item?.NetWt || 0)) / 100;
    }
  });

  const filteredUrdItems = items.filter(
    (item) =>
      item.CategoryName.toLowerCase() === "old gold" ||
      item.CategoryName.toLowerCase() === "old silver"
  );

  const getPaymentAmount = (mode) => {
    const amount = mainitem?.Payments?.find(
      (payment) => payment.PaymentModeType === mode
    )?.Amount;
    return amount ? parseFloat(amount).toFixed(3) : "";
  };

  // Get amounts for each payment mode
  const cashPayment = getPaymentAmount("Cash");
  const rtgsPayment = getPaymentAmount("RTGS");
  const chequePayment = getPaymentAmount("Cheque");
  const cardPayment = getPaymentAmount("Card");

  const add = [
    `${customer?.Area || ""}`,
    `${customer?.CurrAddStreet || ""}`,
    `${customer?.City || ""}`,
    `${customer?.CurrAddState || ""}`,

    `${customer?.CurrAddPincode || ""}`,
  ]?.join(",");

  console.log(items);
  console.log(filteredUrdItems);

  const InvoicePDF = (
    <Document>
      <Page size={{ width: 842, height: 595 }} style={styles.page}>
        <View style={styles.section}>
          {/* Customer Details */}
          <View style={styles.TopBox}>
            <View style={styles.TopSectionContainer}>
              <Text style={styles.text}>
                NAME: {customer?.FirstName?.toUpperCase() || ""}
              </Text>
              <Text style={styles.text}>
                MOBILE NO: {customer?.Mobile || ""}
              </Text>
              <Text style={styles.text}>ADDRESS: {add || ""}</Text>
            </View>
            <View style={styles.TopSectionContainer}>
              <Text style={styles.text}>Purchase Bill No: </Text>
              <Text style={styles.text}>
                Date.: {mainitem?.InvoiceDate || ""}
              </Text>
            </View>
          </View>

          {/* Table Header */}
          <View style={styles.row}>
            {columns.map((col, index) => (
              <Text
                key={index}
                style={[
                  styles.col,
                  { width: col.width },
                  col.align === "right" && styles.rightAlign,
                ]}
              >
                {col.label}
              </Text>
            ))}
          </View>

          {/* Table Data */}
          {filteredUrdItems.map((item, index) => (
            <View key={index} style={styles.row}>
              <Text style={[styles.col, { width: "10%" }]}>{index + 1}</Text>
              <Text style={[styles.col, { width: "20%" }]}>
                {item.ProductName}
              </Text>
              <Text style={[styles.col, { width: "15%" }]}>{item.NetWt}</Text>
              <Text style={[styles.col, { width: "15%" }]}>{fineWt}</Text>
              <Text style={[styles.col, { width: "10%" }]}>
                {item.FinePercentage}
              </Text>
              <Text style={[styles.col, { width: "15%" }]}>
                {item.MetalRate}
              </Text>
              <Text style={[styles.col, { width: "15%" }, styles.rightAlign]}>
                {item.Amount}
              </Text>
            </View>
          ))}

          {/* Total Amount */}
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginTop: 10,
              alignItems: "flex-end",
            }}
          >
            <View
              style={[
                styles.row,
                { border: "1px solid #000", marginTop: 10, width: "25%" },
              ]}
            >
              <Text style={[styles.col, { width: "85%" }]}>Total Amount:</Text>
              <Text style={[styles.col, { width: "35%" }]}>
                {filteredUrdItems
                  .reduce((sum, item) => sum + parseFloat(item.Amount), 0)
                  .toFixed(2)}
              </Text>
            </View>
            <View
              style={[
                styles.row,
                { border: "1px solid #000", marginTop: 10, width: "25%" },
              ]}
            >
              <Text style={[styles.col, { width: "85%" }]}>RTGS</Text>
              <Text style={[styles.col, { width: "35%" }]}>{rtgsPayment}</Text>
            </View>
            <View
              style={[
                styles.row,
                { border: "1px solid #000", width: "25%", borderTop: 0 },
              ]}
            >
              <Text style={[styles.col, { width: "85%" }]}>Card</Text>
              <Text style={[styles.col, { width: "35%" }]}>{cardPayment}</Text>
            </View>
          </View>

          <View
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              fontSize: "12px",
              fontWeight: "bold",
              marginTop: "60px",
              padding: "0px 20px",
            }}
          >
            <View>
              <Text>Customer Signature</Text>
            </View>

            <View>
              <Text style={{ display: "flex", flexDirection: "column" }}>
                Saturday Closed
              </Text>
              <Text>(Thank You)</Text>
            </View>

            <View>
              <Text>For Mundlik Jewellers</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );

  // try {
  //   // Generate the PDF blob correctly
  //   const pdfBlob = await pdf(InvoicePDF).toBlob();

  //   // Create a Blob URL
  //   const pdfUrl = URL.createObjectURL(pdfBlob);

  //   // Open in a new window
  //   window.open(pdfUrl, "_blank");

    

   
  // } catch (error) {
  //   console.error("Error generating PDF:", error);
  // }

  return InvoicePDF;
};

function irnEwayBill(items, customer, mainitem, adminLoggedIn,einvoiceAndWayBill) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  console.log(items);
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 54.5 + 10;
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 28;
  doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;

  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  const igst = +(GST || 0);

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // Set up customer details
  const address = `${customer?.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;
  // Billing information
  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(16);
  doc.text("GOLD SALE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.setFontSize(8);

  let currAddress = "";
  if (mainitem?.Customer?.CurrAddStreet) {
    currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
  }
  if (mainitem?.Customer?.CurrAddTown) {
    currAddress += mainitem?.Customer?.CurrAddTown + ", ";
  }
  if (mainitem?.Customer?.CurrAddState) {
    currAddress += mainitem?.Customer?.CurrAddState + ", ";
  }
  if (mainitem?.Customer?.City) {
    currAddress += mainitem?.Customer?.City + " ";
  }
  if (mainitem?.Customer?.CurrAddPincode) {
    currAddress += mainitem?.Customer?.CurrAddPincode + " ";
  }
  // First column data

  const add = [
    `${customer?.Area || ""}`,
    `${customer?.CurrAddStreet || ""}`,
    `${customer?.City || ""}`,
    `${customer?.CurrAddState || ""}`,

    `${customer?.CurrAddPincode || ""}`,
  ]?.join(",");

  const billingDetails = [
    `NAME                      :  ${customer?.FirstName?.toUpperCase() || ""}`,
    `ADDRESS               :  ${add || ""}`,
    `MOBILE                  :  ${customer?.Mobile || ""}`,
    `PAN/GSTNO    :  ${customer?.PanNo || customer?.GstNo || ""}`,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 6;
  });
  console.log(adminLoggedIn);

  // Second column data
  const secondColumn = [
    { label: "BILL NO        ", value: `${InvoiceNo || ""}` },
    { label: "Date               ", value: `${InvoiceDate || ""}` },
    {
      label: "GSTIN NO      ",
      value: `${adminLoggedIn?.Clients?.GSTNo || ""}`,
    },
    { label: "GSTIN Type   ", value: `${"CGST + SGST + IGST"}` },
  ];

  // Define second column starting position
  const secondColumnStartX = boxPadding + 100; // Adjust as needed
  let secondColumnStartY = boxTopMargin + 8; // Align with first column

  // Print second column data
  secondColumn.forEach(({ label, value }) => {
    doc.text(`${label}: ${value}`, secondColumnStartX + 50, secondColumnStartY);
    secondColumnStartY += 6; // Move to the next line
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    Item: 40.18,
    HSN: 15.18,
    Purity: 11,
    Qty: 8.18,
    "G wt": 13.18,
    "St wt": 14.18,
    "Net wt": 13.18,
    "St. Amt": 15.18,
    "Rate/gm": 15.18,
    "Making/gm": 20,
    // Hallmark: 15.18,
    Amount: 38.36,
  };

  const columnArray = [
    "Item",
    "HSN",
    "Purity",
    "Qty",
    "G wt",
    "St wt",
    "Net wt",
    "St. Amt",
    "Rate/gm",
    "Making/gm",
    // "Hallmark",
    "Amount",
  ];

  // Function to render table headers
  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table
    columnArray.forEach((col) => {
      doc.text(col, startX + 2, currentY + 2);
      startX += columnWidths[col];

      doc.line(5, 100, 205, 100); //horizontal line after table headers
    });

    // Draw vertical lines for headers
    startX = boxPadding;
    columnArray.forEach((col, index) => {
      // if(index == columnArray.length - 1){
      //   return
      // }
      doc.line(startX, currentY - 4, startX, currentY + rowHeight + 3); // Vertical line
      startX += columnWidths[col];
    });

    // Ensure the last vertical line extends fully
    doc.line(startX, currentY + 2, startX, currentY + rowHeight + 3);
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);
  tableStartY += 7; // Adjust for the first header row

  // Draw table and handle borders
  let rowStartY = tableStartY;

  console.log(items);
  let tableHeightUsed = 0;
  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(8);
  let urdTotalAmount = 0;
  let urdTotalNetWt = 0;
  let urdTotalGrossWt = 0;
  items?.forEach((item, index) => {
    if (item?.BillType == "purchase") {
      urdTotalAmount += +(item?.Amount || 0);
      urdTotalNetWt += +(item?.NetWt || 0);
      urdTotalGrossWt += +(item?.GrossWt || 0);
    }
    if (rowStartY + rowHeight > pageHeight - 5) {
      // Check space at the bottom
      // Draw table border for the previous page
      const contentHeight = rowStartY - tableStartY;
      // doc.rect(boxPadding, tableStartY, boxWidth, contentHeight);
      // Add a horizontal line before adding a new page
      // doc.line(5, rowStartY, 205, rowStartY);
      tableHeightUsed += rowStartY - tableStartY;

      doc.addPage(); // Add a new page
      rowStartY = 3; // Reset Y position for the new page
      tableStartY = rowStartY; // Update table start Y for the new page

      // Draw a new table border for the new page
      renderHeaders(rowStartY - 2);
      rowStartY += 7; // Position after headers
      doc.line(5, 10, 205, 10); //horizontal line after table headers
    }

    let startX = boxPadding + 2; // Reset startX for each new row
    const itemData = [
      item?.ProductName || "",
      item?.HSNCode || "",
      item?.Purity === "Unknown"  ? "" : item?.Purity || "",
      item?.Quantity || "",
      (+(item?.GrossWt || 0))?.toFixed(3),
      (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      (+(item?.NetWt || 0))?.toFixed(3),
      (+(item?.StoneAmount || 0))?.toFixed(3),
      (+(item?.MetalRate || 0))?.toFixed(3),
      // (+(item?.MakingPerGram || 0))?.toFixed(3),
      item?.MakingPercentage > 0
        ? `${+item.MakingPercentage}%`
        : item?.MakingPerGram > 0
        ? (+item.MakingPerGram).toFixed(3)
        : "",

      (+(item?.TotalItemAmount || 0))?.toFixed(3),
    ];

    itemData.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 8);
      startX += columnWidths[columnArray[colIndex]];
    });

    doc.setFont("Helvetica", "Normal");
    doc.setFontSize(8);
    // Draw vertical lines for table rows
    startX = boxPadding;
    columnArray.forEach((col, colIndex) => {
      doc.line(startX, rowStartY, startX, rowStartY + rowHeight); // Vertical line for each column
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        doc.line(startX - 4, rowStartY - 11, startX - 4, rowStartY + rowHeight); // Last vertical line
      }
    });

    rowStartY += rowHeight; // Move to the next row
  });

  // Store the final table height used on the last page
  tableHeightUsed += rowStartY - tableStartY;

  // Additional contents (for example, terms, conditions, signatures, etc.)
  let contentStartY = rowStartY + 10; // Start below the table

  // Draw final table border for the last page
  let finalContentHeight = rowStartY - tableStartY;

  if (contentStartY + 20 > pageHeight) {
    // Draw final table border for the last page
    finalContentHeight = rowStartY - tableStartY + 4;
  }

  if (contentStartY + 20 > pageHeight) {
    doc.addPage(); // Add a new page
    contentStartY = 10; // Reset Y on new page
  }

  //  Add horizontal line after the last row of the table
  if (rowStartY <= pageHeight - 5) {
    // Ensure horizontal line is added at the end of the table
    doc.line(5, rowStartY, 205, rowStartY);
  }

  // apply EInvoice and Eway Bill ----------------------------------------------------

// Dynamic IRN and E-Way Bill Rows Insertion
if (einvoiceAndWayBill?.IRN || einvoiceAndWayBill?.EWayBillNumber) {

  const extraRowHeight = 10;
  const irnEwayBillStartY = rowStartY ; // Immediately after the last row of the items table

  // Horizontal lines
  doc.line(5, irnEwayBillStartY, 205, irnEwayBillStartY);
  doc.line(5, irnEwayBillStartY + extraRowHeight, 150, irnEwayBillStartY + extraRowHeight);
  doc.line(5, irnEwayBillStartY + 2 * extraRowHeight, 205, irnEwayBillStartY + 2 * extraRowHeight);

  // Vertical lines
  doc.line(5, irnEwayBillStartY, 5, irnEwayBillStartY + 2 * extraRowHeight);
  doc.line(205, irnEwayBillStartY, 205, irnEwayBillStartY + 2 * extraRowHeight);
  doc.line(150, irnEwayBillStartY, 150, irnEwayBillStartY + 2 * extraRowHeight);

  // IRN and Eway Bill texts
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  doc.text(
    `IRN No: ${einvoiceAndWayBill?.IRN || "N/A"}`,
    7,
    irnEwayBillStartY + 7
  );

  doc.text(
    `E-Way Bill No: ${einvoiceAndWayBill?.EWayBillNumber || "N/A"}`,
    7,
    irnEwayBillStartY + 17
  );

  // QR Code insertion (right section)
  const qrCodeImage = einvoiceAndWayBill?.QRCode || "";

  if (qrCodeImage) {
    doc.addImage(
      qrCodeImage,
      "PNG",
      152,
      irnEwayBillStartY + 2, // Vertically centered inside the IRN/EWayBill rows
      50,
      17
    );
  }

  // Adjust rowStartY for subsequent sections dynamically
  rowStartY += 2 * extraRowHeight ; // Adjust spacing after IRN/E-Way rows



      // EInvoice and Eway Bill ----------------------------------------------------
      // add vertical line -->
      // doc.line(
      //   110,
      //   (finalContentHeight + contentStartY +tableHeightUsed + 20),
      //   110,
      //   (finalContentHeight + tableHeightUsed +contentStartY + 40 )
      // );
}
  
  function checkAndAddPage(currentY, sectionHeight) {
    if (currentY + sectionHeight > pageHeight - 20) {
      // Adjust to prevent cutoff
      doc.addPage();
      return 10; // Reset Y position for new page
    }
    return currentY;
  }

  // Now create a second section with two columns: "Cash" and its amount
  const cashSectionX = 5; // Starting X position for the cash section
  let summaryStartY = rowStartY; // Add spacing after the first table
  summaryStartY = checkAndAddPage(summaryStartY, 80); // Ensure it fits in the page
  let cashStartY = summaryStartY; // Place cash details below summary
  cashStartY = checkAndAddPage(cashStartY, 20); // Ensure cash details fit
  const cashCellWidth = 50; // Width of each column for the cash table

  // Draw the "Cash" label cell
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");

  let totalHallmarkAmount = items.reduce(
    (sum, item) => sum + (Number(item?.HallmarkAmount) || 0),
    0
  );

  console.log(totalHallmarkAmount);

  const leftColumn = [
    { label: "Gross Amount ", value: `${totalgross.toFixed(3)}` },
    {
      label: "CGST 1.5%",
      value: `${
        adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
          ? Number(cgst).toFixed(2)
          : ""
      }`,
    },
    {
      label: "SGST 1.5%",
      value: `${
        adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
          ? Number(sgst).toFixed(2)
          : ""
      }`,
    },
    {
      label: "IGST 3%",
      value: `${
        adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
          ? Number(igst).toFixed(2)
          : ""
      } }`,
    },
    {
      label: "Total Hallmark Amount",
      value: `${totalHallmarkAmount.toFixed(2)}`,
    },
    { label: "Purchase Amount (-)", value: "" },
    { label: "RO/Discount (-)", value: "" },
    { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
  ];

  console.log(adminLoggedIn?.State);
  console.log(mainitem?.Customer?.CurrAddState);

  // Dummy values for the right column
  const rightColumnValues = [
    `${(+(mainitem?.TotalNetAmount || 0))?.toFixed(2)}`,
    `${
      adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
        ? Number(cgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
        ? Number(sgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.Clients?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    `${(+(totalHallmarkAmount.toFixed(2) || 0))?.toFixed(3)}`,
    // `${(
    //   +(mainitem?.TotalNetAmount || 0) +
    //   +(mainitem?.GST || 0) +
    //   +(mainitem?.TDS || 0) +
    //   +(mainitem?.CourierCharge || 0)
    // )?.toFixed(3)}`,
    `${(+(urdTotalAmount || 0))?.toFixed(2)}`,
    `${mainitem?.Offer || ""}`,
    `${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0) -
      +(urdTotalAmount || 0)
    )?.toFixed(2)}`,
  ];

  // Set table starting position and dimensions
  const startX4 = 135; // Starting X position for the table
  const startY4 = 130; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  // SUMMARY TABLE
  doc.setFont("helvetica", "bold");
  doc.rect(startX4, summaryStartY 
    , tableWidth4, tableHeight4);
  doc.line(
    verticalLineX,
    (summaryStartY ),
    verticalLineX,
    (summaryStartY )  + tableHeight4
  );
  let ypos;

  // leftColumn.forEach((row, index) => {
  //   ypos = summaryStartY + (index + 1) * cellHeight4 - 3;
  //   doc.text(`${row.label}`, startX4 + 2, ypos);
  //   doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);
  //   doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
  // });

  leftColumn.forEach((row, index) => {
    ypos = summaryStartY + (index + 1) * cellHeight4 - 3  ;  // need to set
    console.log(ypos)

    // Set font to bold for label
    doc.setFont("helvetica", "bold");
    doc.text(`${row.label}`, startX4 + 2, ypos);

    // Set font back to normal for value
    doc.setFont("helvetica", "normal");
    doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);

    // Draw line
    doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
  });

  // Determine the starting position below the main dynamic table
  let newTableStartY = rowStartY + 10; // Ensure proper spacing below dynamic table
  doc.setFont("helvetica", "normal");
  // New Table (Above Cash & RTGS)
  doc.rect(cashSectionX, newTableStartY, cashCellWidth * 2, 10); // Full row width

  // Sample data row
  let newTableRowStartY = newTableStartY - 10;
  doc.rect(cashSectionX, ypos - 77, cashCellWidth * 2, 10); // Row border
  //need to fix -->
  // doc.line(95, ypos - 77, 95, ypos - 77); // verticle lines at old gold
  doc.line(30, ypos - 77, 30, ypos - 57); // verticle lines at old gold
  doc.line(55, ypos - 77, 55, ypos - 57); // verticle lines at old gold
  doc.line(75, ypos - 77, 75, ypos - 57); // verticle lines at old gold
  // doc.line(75, 113.5, 75, 133.5);

  doc.text("ITEM", cashSectionX + 5, ypos - 70);
  doc.text("GROSS WT", cashSectionX + cashCellWidth / 2 + 5, ypos - 70);
  doc.text("NET WT", cashSectionX + cashCellWidth + 5, ypos - 70);
  doc.text(
    "AMOUNT",
    cashSectionX + cashCellWidth + cashCellWidth / 2,
    ypos - 70
  );

  doc.text("Old Gold", cashSectionX + 5, ypos - 62);
  doc.text(
    `${(+(urdTotalGrossWt || 0))?.toFixed(3)}`,
    cashSectionX + cashCellWidth / 2 + 5,
    ypos - 62
  );
  doc.text(
    `${(+(urdTotalNetWt || 0))?.toFixed(3)}`,
    cashSectionX + cashCellWidth + 5,
    ypos - 62
  );
  doc.text(
    `${(+(urdTotalAmount || 0))?.toFixed(2)}`,
    cashSectionX + cashCellWidth + cashCellWidth / 2,
    ypos - 62
  );

  // Update starting position for Cash Table
  let cashStartY2 = newTableRowStartY + 25; // Move below the new table

  const getPaymentAmount = (mode) => {
    const amount = mainitem?.Payments?.find(
      (payment) => payment.PaymentModeType === mode
    )?.Amount;
    return amount ? parseFloat(amount).toFixed(3) : "";
  };
  doc.setFont("helvetica", "bold");
  // Get amounts for each payment mode
  const cashPayment = getPaymentAmount("Cash");
  const rtgsPayment = getPaymentAmount("RTGS");
  const chequePayment = getPaymentAmount("Cheque");
  const cardPayment = getPaymentAmount("Card");

  // CASH DETAILS TABLE
  doc.setFont("helvetica", "bold");
  // doc.setFontSize(10);
  doc.text(
    "Cash",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
    ypos - 52
  );
  doc.text(
    `${cashPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2 + 45,
    ypos - 52
  );
  doc.rect(cashSectionX, ypos - 57, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 57, cashCellWidth, 10);

  // RTGS Table
  let rtgsStartY = cashStartY2 + 12; // Moving RTGS just below the Cash table
  doc.text(
    "RTGS",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 42
  );
  doc.text(
    `${rtgsPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 42
  );
  doc.rect(cashSectionX, ypos - 47, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 47, cashCellWidth, 10);

  //Cheque
  doc.text(
    "Cheque",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 32
  );
  doc.text(
    `${chequePayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 32
  );
  doc.rect(cashSectionX, ypos - 37, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 37, cashCellWidth, 10);

  //Card
  doc.text(
    "Card",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 22
  );
  doc.text(
    `${cardPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 22
  );
  doc.rect(cashSectionX, ypos - 27, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 27, cashCellWidth, 10);

  let ypos2 = ypos + 30;

  doc.text(`Terms & Conditions`, 6, ypos2 - 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(
    `note:- we declare that this invoice shows actual price of the good described and that all`,
    6,
    ypos2 - 15
  );
  doc.text(` particulars are true and correct`, 6, ypos2 - 10);

  doc.setFont("Helvetica", "Bold");

  // Ensure Footer is dynamically placed below Terms & Conditions
  let footerStartY = ypos2 + 25; // Space after Terms & Conditions

  doc.setFontSize(10);
  doc.text("Customer Sign", 10, footerStartY);

  doc.text("(Saturday Closed)", 80, footerStartY);

  doc.text("Thank You!", 85, footerStartY + 5);

  doc.text("For: Mundlik Jewellers", 160, footerStartY);

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}

const GeneratePurchaseInvoiceMundlik = async (
  items,
  customer,
  mainitem,
  adminLoggedIn
) => {
  const generateInvoiceParumalStyles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
      fontFamily: "Helvetica",
      marginTop: 10,
    },
    headerImg: {
      height: 170,
    },
    section: {
      display: "flex",
      flexDirection: "row",
      // marginBottom: 10,
      border: "1px solid #000",
      justifyContent: "space-between",
      padding: 10,
    },
    Innersection: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
    },
    Innersection2: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      marginLeft: "50%",
    },
    header: {
      textAlign: "center",
      fontSize: 13,
      fontWeight: "bold",
      marginBottom: 10,
      textDecoration: "underline",
    },
    table: {
      display: "table",
      width: "100%",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "black",
      borderBottomWidth: 0,
      // minHeight: 2,
    },
    row: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderBottomColor: "black",
      breakInside: "avoid", // Ensures row does not break mid-way
    },
    Trow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderTopWidth: 1,
      borderBottomColor: "black",
      breakInside: "avoid", // Ensures row does not break mid-way
    },
    // Ensures each section starts on a new page if needed
    pageBreak: {
      break: "before",
    },
    rowL: {
      flexDirection: "row",
      borderBottomWidth: 0,
      borderBottomColor: "black",
    },

    cell: {
      flex: 1,
      padding: 5,
      textAlign: "center",
      borderRightWidth: 1,
      borderRightColor: "black",
      fontSize: 7,
    },
    cellL: {
      flex: 1,
      padding: 5,
      textAlign: "center",
      borderRightWidth: 0,
      borderRightColor: "black",
      fontSize: 7,
    },
    footer: {
      // marginTop: 10,
      paddingTop: 10,
      borderTopWidth: 1,
      borderTopColor: "black",
      width: "30%",
      marginLeft: "70%",
      border: "1px solid #000",
      padding: 5,
    },

    footerText: {
      fontSize: 10,
    },

    signature: {
      fontSize: 10,
      // textAlign: "right",
      fontStyle: "italic",
      marginTop: 10,
      width: "75%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },

    summaryTable: {
      display: "flex",

      marginBottom: 10,
    },

    summaryRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      borderBottomWidth: 0.5, // Light separator between rows
      borderBottomColor: "gray",
      paddingVertical: 3,
    },

    summaryLabel: {
      fontSize: 9,
      textAlign: "left",
      width: "80%",
    },

    summaryValue: {
      fontSize: 9,
      textAlign: "right",
      width: "20%",
    },

    underlineRow: {
      borderBottomWidth: 1, // Darker and thicker underline for R.O Discount
      borderBottomColor: "black",
    },

    netAmountRow: {
      fontWeight: "bold",
      fontSize: 12,
    },

    topText: {
      marginBottom: 10,
      fontWeight: "bold",
    },
    topTextValue: {
      marginBottom: 10,
      fontWeight: "normal",
    },
    bankSection: {
      display: "flex",
      flexDirection: "row",
      marginTop: 30,
    },
    bankSection1: {
      display: "flex",
      flexDirection: "column",
      width: "35%",
    },
    bankSection2: {
      display: "flex",
      flexDirection: "column",
      width: "35%",
    },

    bankText: {
      fontSize: 9,
      fontWeight: "bold",
      marginBottom: 3,
    },
  });
  const tableColumns = [
    { label: "SR NO.", width: "7%" },
    { label: "PARTICULARS", width: "45%" },
    { label: "PRODUCT WT", width: "12%" },
    { label: "FINE WT", width: "12%" },
    { label: "QTY", width: "12%" },
    { label: "AMOUNT", width: "12%" },
  ];

  const totalAmount = items.reduce(
    (sum, item) => sum + +(item?.Amount || 0),
    0
  );

  const MyDocument = (
    <Document>
      <Page size="A4" style={[generateInvoiceParumalStyles.page]}>
        <View style={[generateInvoiceParumalStyles.headerImg]}></View>
        <Text style={generateInvoiceParumalStyles.header}>
          PURCHASE RECEIPT
        </Text>

        <View style={generateInvoiceParumalStyles.section}>
          <View style={generateInvoiceParumalStyles.Innersection}>
            <Text style={generateInvoiceParumalStyles.topText}>
              Name:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.FirstName || ""}
              </Text>
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Mobile No:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {customer?.Mobile || ""}
              </Text>{" "}
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Address:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {`${customer?.CurrAddStreet || ""} ${customer?.City || ""} ${
                  customer?.CurrAddState || ""
                } ${customer?.Country || ""} ${
                  customer?.CurrAddPincode || ""
                }`.trim()}
              </Text>
            </Text>
          </View>
          <View style={generateInvoiceParumalStyles.Innersection2}>
            <Text style={generateInvoiceParumalStyles.topText}>
              Purchase Bill No:{" "}
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {mainitem?.InvoiceNo || ""}
              </Text>{" "}
            </Text>
            <Text style={generateInvoiceParumalStyles.topText}>
              Date:
              <Text style={generateInvoiceParumalStyles.topTextValue}>
                {" "}
                {mainitem?.InvoiceDate || ""}
              </Text>
            </Text>
          </View>
        </View>

        <View style={generateInvoiceParumalStyles.table}>
          <View style={[generateInvoiceParumalStyles.row]} wrap={false}>
            {tableColumns.map((column, index) => (
              <Text
                key={index}
                style={[
                  index == 9
                    ? generateInvoiceParumalStyles.cellL
                    : generateInvoiceParumalStyles.cell,
                  { flex: column.width },
                ]}
              >
                {column.label}
              </Text>
            ))}
          </View>
          <View>
            {items
              ?.filter((item) => item?.BillType == "purchase")
              ?.map((item, index) => (
                <View style={generateInvoiceParumalStyles.row} key={index}>
                  <Text
                    style={[generateInvoiceParumalStyles.cell, { flex: 0.07 }]}
                  >
                    {index + 1}
                  </Text>
                  <Text
                    style={[generateInvoiceParumalStyles.cell, { flex: 0.45 }]}
                  >
                    {item?.CategoryName} - {item?.ProductName}
                  </Text>

                  <Text
                    style={[generateInvoiceParumalStyles.cell, { flex: 0.12 }]}
                  >
                    {item?.TotalWt}
                  </Text>
                  <Text
                    style={[generateInvoiceParumalStyles.cell, { flex: 0.12 }]}
                  >
                    {((item?.NetWt || 0) * (item?.FinePercentage || 0)) / 100}
                  </Text>
                  <Text
                    style={[generateInvoiceParumalStyles.cell, { flex: 0.12 }]}
                  >
                    {item?.Quantity}
                  </Text>

                  <Text
                    style={[generateInvoiceParumalStyles.cell, { flex: 0.12 }]}
                  >
                    {item?.Amount}
                  </Text>
                </View>
              ))}
          </View>
        </View>

        {/* ✅ Total Row at the Bottom */}

        <View style={generateInvoiceParumalStyles.footer}>
          <View style={generateInvoiceParumalStyles.summaryTable}>
            <View
              style={[
                generateInvoiceParumalStyles.summaryRow,
                generateInvoiceParumalStyles.netAmountRow,
              ]}
            >
              <Text style={generateInvoiceParumalStyles.summaryLabel}>
                TOTAL AMOUNT
              </Text>
              <Text style={generateInvoiceParumalStyles.summaryValue}>
                {totalAmount?.toFixed(2) || "0.00"}
              </Text>
            </View>
            <View
              style={[
                generateInvoiceParumalStyles.summaryRow,
                generateInvoiceParumalStyles.netAmountRow,
              ]}
            >
              <Text style={generateInvoiceParumalStyles.summaryLabel}>
                {"CASH (DEBITED)"}
              </Text>
              <Text style={generateInvoiceParumalStyles.summaryValue}>
                {mainitem?.NetAmount || "0.00"}
              </Text>
            </View>
          </View>
        </View>

        <View style={[generateInvoiceParumalStyles.signature]}>
          <View>
            <Text
              style={[
                generateInvoiceParumalStyles.signature,
                { fontWeight: "bold" },
              ]}
            >
              Customer Sign: ..............................
            </Text>
          </View>
          <View>
            <Text style={generateInvoiceParumalStyles.signature}>
              <Text style={{ fontWeight: "bold" }}>For: MUNDLIK JEWELLERS</Text>
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );

  // Generate the PDF blob
  const pdfBlob = await pdf(MyDocument).toBlob();

  // Create a Blob URL
  const pdfUrl = URL.createObjectURL(pdfBlob);

  // Open in a new window
  window.open(pdfUrl, "_blank");
};

function CreditNote(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  console.log(items);
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 54.5 + 10;
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 28;
  doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;

  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  const igst = +(GST || 0);

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // Set up customer details
  const address = `${customer?.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;
  // Billing information
  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(16);
  doc.text("GOLD SALE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.setFontSize(8);

  let currAddress = "";
  if (mainitem?.Customer?.CurrAddStreet) {
    currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
  }
  if (mainitem?.Customer?.CurrAddTown) {
    currAddress += mainitem?.Customer?.CurrAddTown + ", ";
  }
  if (mainitem?.Customer?.CurrAddState) {
    currAddress += mainitem?.Customer?.CurrAddState + ", ";
  }
  if (mainitem?.Customer?.City) {
    currAddress += mainitem?.Customer?.City + " ";
  }
  if (mainitem?.Customer?.CurrAddPincode) {
    currAddress += mainitem?.Customer?.CurrAddPincode + " ";
  }
  // First column data

  const add = [
    `${customer?.Area || ""}`,
    `${customer?.CurrAddStreet || ""}`,
    `${customer?.City || ""}`,
    `${customer?.CurrAddState || ""}`,

    `${customer?.CurrAddPincode || ""}`,
  ]?.join(",");

  const billingDetails = [
    `NAME                      :  ${customer?.FirstName?.toUpperCase() || ""}`,
    `ADDRESS               :  ${add || ""}`,
    `MOBILE                  :  ${customer?.Mobile || ""}`,
    `PAN/GSTNO    :  ${customer?.PanNo || customer?.GstNo || ""}`,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 6;
  });
  console.log(adminLoggedIn);

  // Second column data
  const secondColumn = [
    { label: "BILL NO        ", value: `${InvoiceNo || ""}` },
    { label: "Date               ", value: `${InvoiceDate || ""}` },
    {
      label: "GSTIN NO      ",
      value: `${adminLoggedIn?.Clients?.GSTNo || ""}`,
    },
    { label: "GSTIN Type   ", value: `${"CGST + SGST + IGST"}` },
  ];

  // Define second column starting position
  const secondColumnStartX = boxPadding + 100; // Adjust as needed
  let secondColumnStartY = boxTopMargin + 8; // Align with first column

  // Print second column data
  secondColumn.forEach(({ label, value }) => {
    doc.text(`${label}: ${value}`, secondColumnStartX + 50, secondColumnStartY);
    secondColumnStartY += 6; // Move to the next line
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    Item: 40.18,
    HSN: 15.18,
    Purity: 11,
    Qty: 8.18,
    "G wt": 13.18,
    "St wt": 14.18,
    "Net wt": 13.18,
    "St. Amt": 15.18,
    "Rate/gm": 15.18,
    "Making/gm": 20,
    // Hallmark: 15.18,
    Amount: 38.36,
  };

  const columnArray = [
    "Item",
    "HSN",
    "Purity",
    "Qty",
    "G wt",
    "St wt",
    "Net wt",
    "St. Amt",
    "Rate/gm",
    "Making/gm",
    // "Hallmark",
    "Amount",
  ];

  // Function to render table headers
  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table
    columnArray.forEach((col) => {
      doc.text(col, startX + 2, currentY + 2);
      startX += columnWidths[col];

      doc.line(5, 100, 205, 100); //horizontal line after table headers
    });

    // Draw vertical lines for headers
    startX = boxPadding;
    columnArray.forEach((col, index) => {
      // if(index == columnArray.length - 1){
      //   return
      // }
      doc.line(startX, currentY - 4, startX, currentY + rowHeight + 3); // Vertical line
      startX += columnWidths[col];
    });

    // Ensure the last vertical line extends fully
    doc.line(startX, currentY + 2, startX, currentY + rowHeight + 3);
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);

  tableStartY += 7; // Adjust for the first header row

  // Draw table and handle borders
  let rowStartY = tableStartY;

  console.log(items);
  let tableHeightUsed = 0;
  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(8);
  let urdTotalAmount = 0;
  let urdTotalNetWt = 0;
  let urdTotalGrossWt = 0;

  items?.forEach((item, index) => {
    if (item?.BillType == "purchase") {
      urdTotalAmount += +(item?.Amount || 0);
      urdTotalNetWt += +(item?.NetWt || 0);
      urdTotalGrossWt += +(item?.GrossWt || 0);
    }
    if (rowStartY + rowHeight > pageHeight - 5) {
      // Check space at the bottom
      // Draw table border for the previous page
      const contentHeight = rowStartY - tableStartY;
      // doc.rect(boxPadding, tableStartY, boxWidth, contentHeight);
      // Add a horizontal line before adding a new page
      // doc.line(5, rowStartY, 205, rowStartY);
      tableHeightUsed += rowStartY - tableStartY;

      doc.addPage(); // Add a new page
      rowStartY = 3; // Reset Y position for the new page
      tableStartY = rowStartY; // Update table start Y for the new page

      // Draw a new table border for the new page
      renderHeaders(rowStartY - 2);
      rowStartY += 7; // Position after headers
      doc.line(5, 10, 205, 10); //horizontal line after table headers
    }

    let startX = boxPadding + 2; // Reset startX for each new row
    const itemData = [
      item?.ProductName || "",
      item?.HSNCode || "",
      item?.Purity || "",
      item?.Quantity || "",
      (+(item?.GrossWt || 0))?.toFixed(3),
      (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      (+(item?.NetWt || 0))?.toFixed(3),
      (+(item?.StoneAmount || 0))?.toFixed(3),
      (+(item?.MetalRate || 0))?.toFixed(3),
      // (+(item?.MakingPerGram || 0))?.toFixed(3),
      item?.MakingPercentage > 0
        ? `${+item.MakingPercentage}%`
        : item?.MakingPerGram > 0
        ? (+item.MakingPerGram).toFixed(3)
        : "",

      (+(item?.MRP || item?.TotalItemAmount || 0))?.toFixed(3),
    ];

    itemData.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 8);
      startX += columnWidths[columnArray[colIndex]];
    });

    doc.setFont("Helvetica", "Normal");
    doc.setFontSize(8);
    // Draw vertical lines for table rows
    startX = boxPadding;
    columnArray.forEach((col, colIndex) => {
      doc.line(startX, rowStartY, startX, rowStartY + rowHeight); // Vertical line for each column
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        doc.line(startX - 4, rowStartY - 11, startX - 4, rowStartY + rowHeight); // Last vertical line
      }
    });

    rowStartY += rowHeight; // Move to the next row
  });

  // Store the final table height used on the last page
  tableHeightUsed += rowStartY - tableStartY;

  // Additional contents (for example, terms, conditions, signatures, etc.)
  let contentStartY = rowStartY + 10; // Start below the table

  // Draw final table border for the last page
  let finalContentHeight = rowStartY - tableStartY;

  if (contentStartY + 20 > pageHeight) {
    // Draw final table border for the last page
    finalContentHeight = rowStartY - tableStartY + 4;
  }

  if (contentStartY + 20 > pageHeight) {
    doc.addPage(); // Add a new page
    contentStartY = 10; // Reset Y on new page
  }

  //  Add horizontal line after the last row of the table
  if (rowStartY <= pageHeight - 5) {
    // Ensure horizontal line is added at the end of the table
    doc.line(5, rowStartY, 205, rowStartY);
  }

  function checkAndAddPage(currentY, sectionHeight) {
    if (currentY + sectionHeight > pageHeight - 20) {
      // Adjust to prevent cutoff
      doc.addPage();
      return 10; // Reset Y position for new page
    }
    return currentY;
  }

  // Now create a second section with two columns: "Cash" and its amount
  const cashSectionX = 5; // Starting X position for the cash section
  let summaryStartY = rowStartY; // Add spacing after the first table
  summaryStartY = checkAndAddPage(summaryStartY, 80); // Ensure it fits in the page
  let cashStartY = summaryStartY; // Place cash details below summary
  cashStartY = checkAndAddPage(cashStartY, 20); // Ensure cash details fit
  const cashCellWidth = 50; // Width of each column for the cash table

  // Draw the "Cash" label cell
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");

  let totalHallmarkAmount = items.reduce(
    (sum, item) => sum + (Number(item?.HallmarkAmount) || 0),
    0
  );

  doc.line(30, 113.5, 30, 133.5);
  doc.line(75, 113.5, 75, 133.5);

  console.log(totalHallmarkAmount);

  const leftColumn = [
    { label: "Gross Amount", value: `${totalgross.toFixed(3)}` },
    {
      label: "CGST 1.5%",
      value: `${
        adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
          ? Number(cgst).toFixed(2)
          : ""
      }`,
    },
    {
      label: "SGST 1.5%",
      value: `${
        adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
          ? Number(sgst).toFixed(2)
          : ""
      }`,
    },
    {
      label: "IGST 3%",
      value: `${
        adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
          ? Number(igst).toFixed(2)
          : ""
      } }`,
    },
    {
      label: "Total Hallmark Amount",
      value: `${totalHallmarkAmount.toFixed(2)}`,
    },
    { label: "Purchase Amount (-)", value: "" },
    { label: "RO/Discount (-)", value: "" },
    { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
  ];

  console.log(adminLoggedIn?.State);
  console.log(mainitem?.Customer?.CurrAddState);

  // Dummy values for the right column
  const rightColumnValues = [
    `${(+(mainitem?.TotalNetAmount || 0))?.toFixed(2)}`,
    `${
      adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
        ? Number(cgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.Clients?.State == mainitem?.Customer?.CurrAddState
        ? Number(sgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.Clients?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    `${(+(totalHallmarkAmount.toFixed(2) || 0))?.toFixed(3)}`,
    // `${(
    //   +(mainitem?.TotalNetAmount || 0) +
    //   +(mainitem?.GST || 0) +
    //   +(mainitem?.TDS || 0) +
    //   +(mainitem?.CourierCharge || 0)
    // )?.toFixed(3)}`,
    `${(+(urdTotalAmount || 0))?.toFixed(2)}`,
    `${mainitem?.Offer || ""}`,
    `${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0) -
      +(urdTotalAmount || 0)
    )?.toFixed(2)}`,
  ];

  // Set table starting position and dimensions
  const startX4 = 135; // Starting X position for the table
  const startY4 = 130; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  // SUMMARY TABLE
  doc.setFont("helvetica", "bold");
  doc.rect(startX4, summaryStartY, tableWidth4, tableHeight4);
  doc.line(
    verticalLineX,
    summaryStartY,
    verticalLineX,
    summaryStartY + tableHeight4
  );
  let ypos;

  // leftColumn.forEach((row, index) => {
  //   ypos = summaryStartY + (index + 1) * cellHeight4 - 3;
  //   doc.text(`${row.label}`, startX4 + 2, ypos);
  //   doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);
  //   doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
  // });

  leftColumn.forEach((row, index) => {
    ypos = summaryStartY + (index + 1) * cellHeight4 - 3;

    // Set font to bold for label
    doc.setFont("helvetica", "bold");
    doc.text(`${row.label}`, startX4 + 2, ypos);

    // Set font back to normal for value
    doc.setFont("helvetica", "normal");
    doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);

    // Draw line
    doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
  });

  // Determine the starting position below the main dynamic table
  let newTableStartY = rowStartY + 10; // Ensure proper spacing below dynamic table
  doc.setFont("helvetica", "normal");
  // New Table (Above Cash & RTGS)
  doc.rect(cashSectionX, newTableStartY, cashCellWidth * 2, 10); // Full row width
  doc.line(
    cashSectionX + cashCellWidth,
    newTableStartY,
    cashSectionX + cashCellWidth,
    newTableStartY + 10
  ); // Middle vertical line

  // Sample data row
  let newTableRowStartY = newTableStartY - 10;
  doc.rect(cashSectionX, ypos - 77, cashCellWidth * 2, 10); // Row border
  doc.line(
    cashSectionX + cashCellWidth,
    newTableRowStartY,
    cashSectionX + cashCellWidth,
    newTableRowStartY + 10
  ); // Middle vertical

  doc.text("ITEM", cashSectionX + 5, ypos - 70);
  doc.text("GROSS WT", cashSectionX + cashCellWidth / 2 + 5, ypos - 70);
  doc.text("NET WT", cashSectionX + cashCellWidth + 5, ypos - 70);
  doc.text(
    "AMOUNT",
    cashSectionX + cashCellWidth + cashCellWidth / 2,
    ypos - 70
  );

  doc.text("Old Gold", cashSectionX + 5, ypos - 62);
  doc.text(
    `${(+(urdTotalGrossWt || 0))?.toFixed(3)}`,
    cashSectionX + cashCellWidth / 2 + 5,
    ypos - 62
  );
  doc.text(
    `${(+(urdTotalNetWt || 0))?.toFixed(3)}`,
    cashSectionX + cashCellWidth + 5,
    ypos - 62
  );
  doc.text(
    `${(+(urdTotalAmount || 0))?.toFixed(2)}`,
    cashSectionX + cashCellWidth + cashCellWidth / 2,
    ypos - 62
  );

  // Update starting position for Cash Table
  let cashStartY2 = newTableRowStartY + 25; // Move below the new table

  const getPaymentAmount = (mode) => {
    const amount = mainitem?.Payments?.find(
      (payment) => payment.PaymentModeType === mode
    )?.Amount;
    return amount ? parseFloat(amount).toFixed(3) : "";
  };
  doc.setFont("helvetica", "bold");
  // Get amounts for each payment mode
  const cashPayment = getPaymentAmount("Cash");
  const rtgsPayment = getPaymentAmount("RTGS");
  const chequePayment = getPaymentAmount("Cheque");
  const cardPayment = getPaymentAmount("Card");

  // CASH DETAILS TABLE
  doc.setFont("helvetica", "bold");
  // doc.setFontSize(10);
  doc.text(
    "Cash",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
    ypos - 52
  );
  doc.text(
    `${cashPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2 + 45,
    ypos - 52
  );
  doc.rect(cashSectionX, ypos - 57, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 57, cashCellWidth, 10);

  // RTGS Table
  let rtgsStartY = cashStartY2 + 12; // Moving RTGS just below the Cash table
  doc.text(
    "RTGS",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 42
  );
  doc.text(
    `${rtgsPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 42
  );
  doc.rect(cashSectionX, ypos - 47, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 47, cashCellWidth, 10);

  //Cheque
  doc.text(
    "Cheque",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 32
  );
  doc.text(
    `${chequePayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 32
  );
  doc.rect(cashSectionX, ypos - 37, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 37, cashCellWidth, 10);

  //Card
  doc.text(
    "Card",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 22
  );
  doc.text(
    `${cardPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 22
  );
  doc.rect(cashSectionX, ypos - 27, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 27, cashCellWidth, 10);

  let ypos2 = ypos + 30;

  doc.text(`Terms & Conditions`, 6, ypos2 - 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(
    `note:- we declare that this invoice shows actual price of the good described and that all`,
    6,
    ypos2 - 15
  );
  doc.text(` particulars are true and correct`, 6, ypos2 - 10);

  doc.setFont("Helvetica", "Bold");

  // Ensure Footer is dynamically placed below Terms & Conditions
  let footerStartY = ypos2 + 25; // Space after Terms & Conditions

  doc.text("Customer Sign", 6, footerStartY);

  doc.text("(Saturday Closed)", 80, footerStartY);

  doc.text("Thank You!", 85, footerStartY + 5);

  doc.text("For: Mundlik Jewellers", 180, footerStartY);

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}
function GeneratePurchase(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 42.5 + 10;
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 28;
  doc.setFontSize(16);
  doc.text("Purchase", 90, 50);
  doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;

  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // Set up customer details
  const address = `${customer?.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;
  // Billing information
  doc.setLineWidth(0.3);
  // doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(16);
  // doc.text("GOLD SALE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.setFontSize(8);

  let currAddress = "";
  if (mainitem?.Customer?.CurrAddStreet) {
    currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
  }
  if (mainitem?.Customer?.CurrAddTown) {
    currAddress += mainitem?.Customer?.CurrAddTown + ", ";
  }
  if (mainitem?.Customer?.CurrAddState) {
    currAddress += mainitem?.Customer?.CurrAddState + ", ";
  }
  if (mainitem?.Customer?.CurrAddPincode) {
    currAddress += mainitem?.Customer?.CurrAddPincode + " ";
  }

  const billingDetails = [
    `NAME                      :   FR - 53`,
    `Invoice No               : `,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 6;
  });

  // Second column data
  const secondColumn = [
    { label: "Date               ", value: "" },
    { label: "Lot NO        ", value: "" },
  ];

  // Define second column starting position
  const secondColumnStartX = boxPadding + 100; // Adjust as needed
  let secondColumnStartY = boxTopMargin + 8; // Align with first column

  // Print second column data
  secondColumn.forEach(({ label, value }) => {
    doc.text(`${label}: ${value}`, secondColumnStartX + 50, secondColumnStartY);
    secondColumnStartY += 6; // Move to the next line
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    "Sr No": 13.18,
    SKU: 20.18,
    Testing: 23,
    "G wt": 28.18,
    "St wt": 28.18,
    "S Pcs": 28.18,
    "Tag Wt": 28.18,
    Pair: 35,
  };

  const columnArray = [
    "Sr No",
    "SKU",
    "Testing",
    "G wt",
    "St wt",
    "S Pcs",
    "Tag Wt",
    "Pair",
  ];

  // Function to render table headers
  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table
    columnArray.forEach((col) => {
      doc.text(col, startX + 2, currentY + 2);
      startX += columnWidths[col];
    });

    // Draw vertical lines for headers
    startX = boxPadding;
    columnArray.forEach((col, index) => {
      // if(index == columnArray.length - 1){
      //   return
      // }
      doc.line(startX, currentY - 4, startX, currentY + rowHeight + 3); // Vertical line
      startX += columnWidths[col];
    });

    // Ensure the last vertical line extends fully
    doc.line(startX, currentY + 2, startX, currentY + rowHeight + 3);
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);

  tableStartY += 7; // Adjust for the first header row

  doc.line(5, 68.5, 205, 68.5);
  doc.line(5, 76.5, 205, 76.5);
  // Draw table and handle borders
  let rowStartY = tableStartY;

  let tableHeightUsed = 0;
  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(8);
  items?.forEach((item, index) => {
    if (rowStartY + rowHeight > pageHeight - 5) {
      const contentHeight = rowStartY - tableStartY;

      tableHeightUsed += rowStartY - tableStartY;

      doc.addPage(); // Add a new page
      rowStartY = 3; // Reset Y position for the new page
      tableStartY = rowStartY; // Update table start Y for the new page

      // Draw a new table border for the new page
      renderHeaders(rowStartY - 2);
      rowStartY += 7; // Position after headers
      // doc.line(5, 10, 205, 10); //horizontal line after table headers
    }

    let startX = boxPadding + 2; // Reset startX for each new row
    const itemData = [
      item?.ProductName || "",
      item?.HSNCode || "",
      item?.Purity || "",
      item?.Quantity || "",
      (+(item?.GrossWt || 0))?.toFixed(3),
      (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      (+(item?.NetWt || 0))?.toFixed(3),
      (+(item?.StoneAmount || 0))?.toFixed(3),
      // (+(item?.MetalRate || 0))?.toFixed(3),
      // (+(item?.MakingPerGram || 0))?.toFixed(3),
      // (+(item?.HallmarkAmount || 0))?.toFixed(3),
      // (+(item?.MRP || item?.TotalItemAmount || 0))?.toFixed(3),
    ];

    itemData.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 8);
      startX += columnWidths[columnArray[colIndex]];
    });

    doc.setFont("Helvetica", "Normal");
    doc.setFontSize(8);
    // Draw vertical lines for table rows
    startX = boxPadding;
    columnArray.forEach((col, colIndex) => {
      doc.line(startX, rowStartY, startX, rowStartY + rowHeight + 10); // Vertical line for each column
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        doc.line(
          startX - 4,
          rowStartY - 11,
          startX - 4,
          rowStartY + rowHeight + 10
        ); // Last vertical line
      }
    });

    rowStartY += rowHeight; // Move to the next row
  });

  // Store the final table height used on the last page
  tableHeightUsed += rowStartY - tableStartY;

  // Additional contents (for example, terms, conditions, signatures, etc.)
  let contentStartY = rowStartY + 10; // Start below the table

  // Draw final table border for the last page
  let finalContentHeight = rowStartY - tableStartY;

  if (contentStartY + 20 > pageHeight) {
    // Draw final table border for the last page
    finalContentHeight = rowStartY - tableStartY + 4;
  }

  if (contentStartY + 20 > pageHeight) {
    doc.addPage(); // Add a new page
    contentStartY = 10; // Reset Y on new page
  }

  if (rowStartY <= pageHeight - 5) {
    doc.line(5, rowStartY, 205, rowStartY);
  }

  function checkAndAddPage(currentY, sectionHeight) {
    if (currentY + sectionHeight > pageHeight - 20) {
      // Adjust to prevent cutoff
      doc.addPage();
      return 10; // Reset Y position for new page
    }
    return currentY;
  }

  const cashSectionX = 5; // Starting X position for the cash section
  let summaryStartY = rowStartY; // Add spacing after the first table
  summaryStartY = checkAndAddPage(summaryStartY, 80); // Ensure it fits in the page
  let cashStartY = summaryStartY; // Place cash details below summary
  cashStartY = checkAndAddPage(cashStartY, 20); // Ensure cash details fit
  const cashCellWidth = 50; // Width of each column for the cash table

  // Draw the "Cash" label cell
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");

  const leftColumn = [
    { label: "Gross Amount", value: `${totalgross.toFixed(3)}` },
    { label: "CGST 1.5%", value: `${Number(cgst).toFixed(2)}` },
    { label: "SGST 1.5%", value: `${Number(sgst).toFixed(2)}` },
    { label: "IGST 3%", value: `${GSTNumber.toFixed(2)}` },
    // { label: 'Courier', value: '' },
    { label: "Purchase Amount (-)", value: `${UrdPurchaseAmt}` },
    { label: "RO/Discount (-)", value: "" },
    { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
  ];

  console.log(adminLoggedIn);
  // Dummy values for the right column
  const rightColumnValues = [
    `${mainitem?.TotalNetAmount}`,
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? Number(cgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? Number(sgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    // `${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
    `${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0)
    )?.toFixed(3)}`,
    `${mainitem?.Offer || ""}`,
    `${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    )?.toFixed(3)}`,
  ];

  // Set table starting position and dimensions
  const startX4 = 135; // Starting X position for the table
  const startY4 = 130; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  let ypos;

  let newTableStartY = rowStartY + 10; // Ensure proper spacing below dynamic table
  doc.setFont("helvetica", "normal");

  let newTableRowStartY = newTableStartY - 10;

  let cashStartY2 = newTableRowStartY + 25; // Move below the new table

  let rtgsStartY = cashStartY2 + 12;

  // Calculate total values
  let totalGrossWt = items.reduce(
    (sum, item) => sum + +(item?.GrossWt || 0),
    0
  );
  let totalStoneWt = items.reduce(
    (sum, item) => sum + +(item?.TotalStoneWeight || 0),
    0
  );
  let totalStonePcs = items.reduce((sum, item) => sum + +(item?.S_Pcs || 0), 0);
  let totalTagWt = items.reduce((sum, item) => sum + +(item?.NetWt || 0), 0);
  let totalPair = items.reduce(
    (sum, item) => sum + +(item?.StoneAmount || 0),
    0
  );

  // Position the total row below the last item
  let totalRowY = rowStartY;

  // Ensure we don't run off the page
  if (totalRowY + rowHeight > pageHeight - 5) {
    doc.addPage();
    totalRowY = 10;
    renderHeaders(totalRowY - 2); // Re-render table headers
    totalRowY += 7;
  }

  // **Draw the Total Row**
  let startX = boxPadding + 2;
  const totalData = [
    "Total", // "Sr No" column
    "", // SKU
    "", // Testing
    totalGrossWt.toFixed(3), // G wt
    totalStoneWt.toFixed(3), // St wt
    totalStonePcs.toFixed(3), // S Pcs
    totalTagWt.toFixed(3), // Tag Wt
    totalPair.toFixed(3), // Pair
  ];

  // **Draw the rectangle covering the total row**
  doc.rect(5, totalRowY, 200, rowHeight); // X, Y, Width, Height

  // Print Total Row Data
  totalData.forEach((data, colIndex) => {
    doc.setFont("Helvetica", "Bold");
    doc.text(`${data}`, startX, totalRowY + 8);
    startX += columnWidths[columnArray[colIndex]];
  });

  // Draw bottom border for total row
  doc.line(5, totalRowY + rowHeight, 205, totalRowY + rowHeight);

  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}

function generateinvoicepdfArchana2(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  console.log(mainitem);

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 54.5 + 10;
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 28;

  const imageWidth = 220; // Adjust width as needed
  const imageHeight = 54.5; // Adjust height as needed
  const imageX = (pageWidth - imageWidth) / 2;
  let yPosition = 0; // Initial Y position
  const imageY = yPosition; // Position at the top

  doc.addImage(ArchanaHeader, "PNG", imageX, imageY, imageWidth, imageHeight);

  doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;
  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // Set up customer details
  const address = `${customer?.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;
  // Billing information
  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(16);
  // doc.text("SALE INVOICE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.text(
    `${
      mainitem?.InvoiceItem?.[0]?.CategoryName?.toUpperCase() == "GOLD"
        ? "GOLD SALE INVOICE"
        : mainitem?.InvoiceItem?.[0]?.CategoryName?.toUpperCase() == "SILVER"
        ? "SILVER SALE INVOICE"
        : "SALE INVOICE"
    }`,
    boxPadding + boxWidth / 2 - 20,
    boxTopMargin - 3
  );
  doc.setFontSize(8);

  let currAddress = "";
  if (mainitem?.Customer?.CurrAddStreet) {
    currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
  }
  if (mainitem?.Customer?.CurrAddTown) {
    currAddress += mainitem?.Customer?.CurrAddTown + ", ";
  }
  if (mainitem?.Customer?.CurrAddState) {
    currAddress += mainitem?.Customer?.CurrAddState + ", ";
  }
  if (mainitem?.Customer?.CurrAddPincode) {
    currAddress += mainitem?.Customer?.CurrAddPincode + " ";
  }

  const billingDetails = [
    `NAME                      :  ${customer?.FirstName?.toUpperCase() || ""}`,
    `ADDRESS               :  ${currAddress || ""}`,
    `MOBILE                  :  ${customer?.Mobile || ""}`,
    `PAN/ADHAR NO    :  ${customer?.PanNo || customer?.AadharNo || ""}`,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 6;
  });

  // Second column data
  const secondColumn = [
    { label: "BILL NO        ", value: `${InvoiceNo || ""}` },
    { label: "Date               ", value: `${InvoiceDate || ""}` },
    {
      label: "GSTIN NO      ",
      value: `${adminLoggedIn?.Clients?.GSTNo || ""}`,
    },

    { label: "GSTIN Type   ", value: `${"CGST + SGST + IGST"}` },
  ];

  // Define second column starting position
  const secondColumnStartX = boxPadding + 100; // Adjust as needed
  let secondColumnStartY = boxTopMargin + 8; // Align with first column

  // Print second column data
  secondColumn.forEach(({ label, value }) => {
    doc.text(`${label}: ${value}`, secondColumnStartX + 50, secondColumnStartY);
    secondColumnStartY += 6; // Move to the next line
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    Item: 40.18,
    HSN: 15.18,
    Purity: 11,
    Qty: 8.18,
    "G wt": 13.18,
    "St wt": 12.18,
    "Net wt": 13.18,
    "St. Amt": 15.18,
    "Rate/gm": 15.18,
    "Making/gm": 20.18,
    Hallmark: 15.18,
    Amount: 25.18,
  };

  const columnArray = [
    "Item",
    "HSN",
    "Purity",
    "Qty",
    "G wt",
    "St wt",
    "Net wt",
    "St. Amt",
    "Rate/gm",
    "Making/gm",
    "Hallmark",
    "Amount",
  ];

  // Function to render table headers
  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table
    columnArray.forEach((col) => {
      doc.text(col, startX + 2, currentY + 2);
      startX += columnWidths[col];

      doc.line(5, 100, 205, 100); //horizontal line after table headers
    });

    // Draw vertical lines for headers
    startX = boxPadding;
    columnArray.forEach((col, index) => {
      // if(index == columnArray.length - 1){
      //   return
      // }
      doc.line(startX, currentY - 4, startX, currentY + rowHeight + 3); // Vertical line
      startX += columnWidths[col];
    });

    // Ensure the last vertical line extends fully
    doc.line(startX, currentY + 2, startX, currentY + rowHeight + 3);
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);

  tableStartY += 7; // Adjust for the first header row

  // Draw table and handle borders
  let rowStartY = tableStartY;

  let tableHeightUsed = 0;
  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(8);
  items?.forEach((item, index) => {
    if (
      item?.CategoryName === "OLD GOLD" ||
      item?.CategoryName === "OLD SILVER"
    ) {
      return; // Skip this iteration
    }
    if (rowStartY + rowHeight > pageHeight - 5) {
      // Check space at the bottom
      // Draw table border for the previous page
      const contentHeight = rowStartY - tableStartY;
      // doc.rect(boxPadding, tableStartY, boxWidth, contentHeight);
      // Add a horizontal line before adding a new page
      // doc.line(5, rowStartY, 205, rowStartY);
      tableHeightUsed += rowStartY - tableStartY;

      doc.addPage(); // Add a new page
      rowStartY = 3; // Reset Y position for the new page
      tableStartY = rowStartY; // Update table start Y for the new page

      // Draw a new table border for the new page
      renderHeaders(rowStartY - 2);
      rowStartY += 7; // Position after headers
      doc.line(5, 10, 205, 10); //horizontal line after table headers
    }

    let startX = boxPadding + 2; // Reset startX for each new row
    const itemData = [
      item?.ProductName || "",
      item?.HSNCode || "",
      item?.Purity || "",
      item?.Quantity || "",
      (+(item?.GrossWt || 0))?.toFixed(3),
      (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      (+(item?.NetWt || 0))?.toFixed(3),
      (+(item?.StoneAmount || 0))?.toFixed(3),
      (+(item?.MetalRate || 0))?.toFixed(3),
      (+(item?.MakingPerGram || 0))?.toFixed(3),
      (+(item?.HallmarkAmount || 0))?.toFixed(3),
      (+(item?.MRP || item?.TotalItemAmount || 0))?.toFixed(3),
    ];

    itemData.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 8);
      startX += columnWidths[columnArray[colIndex]];
    });

    doc.setFont("Helvetica", "Normal");
    doc.setFontSize(8);
    // Draw vertical lines for table rows
    startX = boxPadding;
    columnArray.forEach((col, colIndex) => {
      doc.line(startX, rowStartY, startX, rowStartY + rowHeight); // Vertical line for each column
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        doc.line(startX - 4, rowStartY - 11, startX - 4, rowStartY + rowHeight); // Last vertical line
      }
    });

    rowStartY += rowHeight; // Move to the next row
  });

  // Store the final table height used on the last page
  tableHeightUsed += rowStartY - tableStartY;

  // Additional contents (for example, terms, conditions, signatures, etc.)
  let contentStartY = rowStartY + 10; // Start below the table

  // Draw final table border for the last page
  let finalContentHeight = rowStartY - tableStartY;

  if (contentStartY + 20 > pageHeight) {
    // Draw final table border for the last page
    finalContentHeight = rowStartY - tableStartY + 4;
  }

  if (contentStartY + 20 > pageHeight) {
    doc.addPage(); // Add a new page
    contentStartY = 10; // Reset Y on new page
  }

  //  Add horizontal line after the last row of the table
  if (rowStartY <= pageHeight - 5) {
    // Ensure horizontal line is added at the end of the table
    doc.line(5, rowStartY, 205, rowStartY);
  }

  function checkAndAddPage(currentY, sectionHeight) {
    if (currentY + sectionHeight > pageHeight - 20) {
      // Adjust to prevent cutoff
      doc.addPage();
      return 10; // Reset Y position for new page
    }
    return currentY;
  }

  // Now create a second section with two columns: "Cash" and its amount
  const cashSectionX = 5; // Starting X position for the cash section
  let summaryStartY = rowStartY; // Add spacing after the first table
  summaryStartY = checkAndAddPage(summaryStartY, 80); // Ensure it fits in the page
  let cashStartY = summaryStartY; // Place cash details below summary
  cashStartY = checkAndAddPage(cashStartY, 20); // Ensure cash details fit
  const cashCellWidth = 50; // Width of each column for the cash table

  // Draw the "Cash" label cell
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");

  const leftColumn = [
    { label: "Gross Amount", value: `${totalgross.toFixed(3)}` },
    { label: "CGST 1.5%", value: `${Number(cgst).toFixed(2)}` },
    { label: "SGST 1.5%", value: `${Number(sgst).toFixed(2)}` },
    { label: "IGST 3%", value: `${GSTNumber.toFixed(2)}` },
    // { label: 'Courier', value: '' },
    { label: "Purchase Amount (-)", value: `${UrdPurchaseAmt}` },
    { label: "RO/Discount (-)", value: "" },
    { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
  ];

  console.log(adminLoggedIn);
  // Dummy values for the right column
  const rightColumnValues = [
    `${mainitem?.TotalNetAmount}`,
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? Number(cgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? Number(sgst).toFixed(2)
        : ""
    }`,
    `${
      adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    // `${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
    "",
    `${mainitem?.Offer || ""}`,
    `${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    )?.toFixed(3)}`,
  ];

  // Set table starting position and dimensions
  const startX4 = 135; // Starting X position for the table
  const startY4 = 130; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  // SUMMARY TABLE
  doc.rect(startX4, summaryStartY + 2, tableWidth4, tableHeight4);
  doc.line(
    verticalLineX,
    summaryStartY + 2,
    verticalLineX,
    summaryStartY + tableHeight4 + 2
  );
  let ypos;
  leftColumn.forEach((row, index) => {
    ypos = summaryStartY + 2 + (index + 1) * cellHeight4 - 3;
    doc.text(`${row.label}`, startX4 + 2, ypos);
    doc.text(`${rightColumnValues[index]}`, verticalLineX + 2, ypos);
    doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3);
  });

  // Determine the starting position below the main dynamic table
  let newTableStartY = rowStartY + 10; // Ensure proper spacing below dynamic table
  doc.setFont("helvetica", "normal");
  // New Table (Above Cash & RTGS)

  doc.line(
    cashSectionX + cashCellWidth,
    newTableStartY,
    cashSectionX + cashCellWidth,
    newTableStartY + 10
  ); // Middle vertical line

  // Sample data row
  let newTableRowStartY = newTableStartY - 10;

  doc.rect(cashSectionX, ypos - 66, cashCellWidth * 2, 10); // Row border
  doc.rect(cashSectionX, newTableStartY + 3, cashCellWidth * 2, 10); // Full row width

  doc.line(
    cashSectionX + cashCellWidth,
    newTableRowStartY + 3,
    cashSectionX + cashCellWidth,
    newTableRowStartY + 23
  ); // Middle vertical

  doc.text("ITEM", cashSectionX + 5, ypos - 62);
  doc.text("GROSS WT", cashSectionX + cashCellWidth / 2 + 5, ypos - 62);
  doc.text("NET WT", cashSectionX + cashCellWidth + 5, ypos - 62);
  doc.text(
    "AMOUNT",
    cashSectionX + cashCellWidth + cashCellWidth / 2,
    ypos - 62
  );

  doc.text("Old Gold", cashSectionX + 5, ypos - 50);
  doc.text("", cashSectionX + cashCellWidth / 2 + 5, ypos - 50);
  doc.text("", cashSectionX + cashCellWidth + 5, ypos - 50);
  doc.text("", cashSectionX + cashCellWidth + cashCellWidth / 2, ypos - 50);

  // Update starting position for Cash Table
  let cashStartY2 = newTableRowStartY + 25; // Move below the new table

  const getPaymentAmount = (mode) => {
    const amount = mainitem?.Payments?.find(
      (payment) => payment.PaymentModeType === mode
    )?.Amount;
    return amount ? parseFloat(amount).toFixed(3) : "";
  };

  // Get amounts for each payment mode
  const cashPayment = getPaymentAmount("Cash");
  const rtgsPayment = getPaymentAmount("RTGS");
  const upiPayment = getPaymentAmount("UPI");

  // CASH DETAILS TABLE

  doc.text(
    "Cash",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
    ypos - 40
  );
  doc.text(
    `${cashPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2 + 45,
    ypos - 40
  );

  doc.rect(cashSectionX, ypos - 46, cashCellWidth, 10); //cash box boder
  doc.rect(cashSectionX + cashCellWidth, ypos - 46, cashCellWidth, 10); //cash box boder

  // RTGS Table
  let rtgsStartY = cashStartY2 + 12; // Moving RTGS just below the Cash table
  doc.text(
    "RTGS",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 30
  );
  doc.text(
    `${rtgsPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 30
  );
  doc.rect(cashSectionX, ypos - 36, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 36, cashCellWidth, 10);

  //UPI
  doc.text(
    "UPI",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2,
    ypos - 20
  );
  doc.text(
    `${upiPayment}`,
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("RTGS") / 2 + 45,
    ypos - 20
  );
  doc.rect(cashSectionX, ypos - 26, cashCellWidth, 10);
  doc.rect(cashSectionX + cashCellWidth, ypos - 26, cashCellWidth, 10);

  let ypos2 = ypos + 30;

  doc.text(`Terms & Conditions`, 6, ypos2 - 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  // const amountInWords = toWords((totalgross + GSTNumber));
  doc.text(
    `note:- we declare that this invoice shows actual price of the good described and that all`,
    6,
    ypos2 - 15
  );
  doc.text(` particulars are true and correct`, 6, ypos2 - 10);

  // Ensure Footer is dynamically placed below Terms & Conditions
  let footerStartY = ypos2 + 25; // Space after Terms & Conditions

  doc.text("Customer Sign", 6, footerStartY);

  doc.text("(Saturday Closed)", 80, footerStartY);

  doc.text("Thank You!", 85, footerStartY + 5);

  doc.text("Customer Sign", 180, footerStartY);

  // // Generate the PDF and open it in a new window
  // const pdfData = doc.output("datauristring");
  // const newWindow = window.open();
  // newWindow.document.write(
  //   `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  // );

  return doc;
}

function generateinvoicepdfHeera(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [210, 145],
  });

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 30;
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 80;
  // doc.line(0, 30, 210, 30); // Draw a horizontal line

  doc.line(5, 58, 205, 58); // Draw a horizontal line

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;
  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // Set up customer details
  const address = `${customer?.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;
  // Billing information
  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(16);
  // doc.text('GOLD SALE', boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.setFontSize(8);

  let currAddress = "";
  if (mainitem?.Customer?.CurrAddStreet) {
    currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
  }
  if (mainitem?.Customer?.CurrAddTown) {
    currAddress += mainitem?.Customer?.CurrAddTown + ", ";
  }
  if (mainitem?.Customer?.CurrAddState) {
    currAddress += mainitem?.Customer?.CurrAddState + ", ";
  }
  if (mainitem?.Customer?.CurrAddPincode) {
    currAddress += mainitem?.Customer?.CurrAddPincode + " ";
  }

  console.log(customer);

  const billingDetails = [
    `NAME                      :  ${customer?.FirstName?.toUpperCase() || ""}`,
    `MOBILE                  :  ${customer?.Mobile || ""}`,
    `ADDRESS               :  ${currAddress || ""}`,
    // `PAN/ADHAR NO    :  ${customer?.PanNo || customer?.AadharNo || ""}`,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 8;
  });

  // Second column data
  const secondColumn = [
    { label: "Invoice No        ", value: `${InvoiceNo || ""}` },
    { label: "Date               ", value: `${InvoiceDate || ""}` },
    {
      label: "PAN/GST No      ",
      value: `${mainitem?.Customer?.GstNo || mainitem?.Customer?.PanNo || ""}`,
    },
    // { label: 'GSTIN Type   ', value: `${"CGST + SGST + IGST"}` },
  ];

  // Define second column starting position
  const secondColumnStartX = boxPadding + 100; // Adjust as needed
  let secondColumnStartY = boxTopMargin + 8; // Align with first column

  // Print second column data
  secondColumn.forEach(({ label, value }) => {
    doc.text(`${label}: ${value}`, secondColumnStartX + 50, secondColumnStartY);
    secondColumnStartY += 8; // Move to the next line
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    Item: 65.18,
    HSN: 17.18,
    "G wt": 17,
    "St wt": 17,
    "Net wt": 18,

    "Wastage %": 18.18,
    "Rate/Gm": 18.18,
    Amount: 33.18,
  };

  const columnArray = [
    "Item",
    "HSN",
    "G wt",
    "St wt",
    "Net wt",

    "Wastage %",
    "Rate/Gm",
    "Amount",
  ];

  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table

    columnArray.forEach((col, colIndex) => {
      if (typeof columnWidths[col] !== "number") {
        console.error(`Invalid column width for ${col}: ${columnWidths[col]}`);
        return; // Skip if column width is invalid
      }

      doc.text(String(col), startX + 2, currentY + 2);
      // doc.line(startX, currentY - 4, startX, currentY + 5);
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        // doc.line(startX, currentY, startX, currentY + 5);
      }
    });
    // doc.line(5, currentY - 5 , 205, currentY - 5);
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);

  tableStartY += 1; // Adjust for the first header row

  // Draw table and handle borders
  let rowStartY = tableStartY;

  let tableHeightUsed = 100;
  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(8);

  console.log("dde", items);

  items?.forEach((item, index) => {
    if (rowStartY + rowHeight > pageHeight - 5) {
      doc.addPage(); // Ensure a new page is added if space runs out
      rowStartY = 30; // Reset to a new page start position
      renderHeaders(rowStartY); // Redraw headers on new page
      rowStartY += 2; // Adjust spacing
    }

    let startX = boxPadding + 2; // Reset X for new row
    const itemData = [
      item?.ProductName || "",
      item?.HSNCode || "",
      (+(item?.GrossWt || 0))?.toFixed(3),
      (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      (+(item?.NetWt || 0))?.toFixed(3),
      +(item?.MakingPercentage || 0), // Wastage
      (+(item?.MetalRate || 0))?.toFixed(3),
      (+(item?.MRP || item?.TotalItemAmount || 0))?.toFixed(3),
    ];

    itemData.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 8);
      startX += columnWidths[columnArray[colIndex]];
    });

    rowStartY += rowHeight; // ✅ Move to the next row correctly
  });

  //verticle lines
  doc.line(70, 58, 70, 110);
  doc.line(87.18, 58, 87.18, 110);
  doc.line(104.18, 58, 104.18, 110);
  doc.line(121.18, 58, 121.18, 110);
  doc.line(139.18, 58, 139.18, 110);
  doc.line(157.36, 58, 157.36, 110);
  doc.line(175.54, 58, 175.54, 110);

  //all totals
  doc.setFont("Helvetica", "bold");
  doc.text("Total", 30, boxHeight + 26);

  // Calculate total MRP

  // Calculate total values for required fields

  const totalGrossWt = items?.reduce(
    (sum, item) => sum + Number(item?.GrossWt || 0),
    0
  );

  const totalStoneWeight = items?.reduce(
    (sum, item) => sum + Number(item?.TotalStoneWeight || 0),
    0
  );
  const totalNetWt = items?.reduce(
    (sum, item) => sum + Number(item?.NetWt || 0),
    0
  );
  const totalMakingPercentage = items?.reduce(
    (sum, item) => sum + Number(item?.MakingPercentage || 0),
    0
  );
  const totalRatePerGram = items?.reduce(
    (sum, item) => sum + Number(item?.MetalRate || 0),
    0
  );
  const totalMRP = items?.reduce(
    (sum, item) => sum + Number(item?.MRP || item?.TotalItemAmount || 0),
    0
  );
  const totalHSNCode = items?.reduce(
    (sum, item) => sum + Number(item?.HSNCode || 0),
    0
  );

  // Format all total values to 3 decimal places
  const totalGrossWtString = totalGrossWt.toFixed(3);
  const totalStoneWeightString = totalStoneWeight.toFixed(3);
  const totalNetWtString = totalNetWt.toFixed(3);
  const totalMakingPercentageString = totalMakingPercentage.toFixed();
  const totalRatePerGramString = totalRatePerGram.toFixed(3);
  const totalMRPString = totalMRP.toFixed(3);
  const totalMrpString = totalMRP.toFixed(3);
  const totalHsnString = totalHSNCode.toFixed(3);

  doc.text(totalMrpString ? totalMrpString : 0, 180, boxHeight + 26);

  doc.text(totalHsnString ? totalHsnString : 0, 73, boxHeight + 26);

  doc.text(totalGrossWtString ? totalGrossWtString : 0, 90, boxHeight + 26);

  doc.text(
    totalStoneWeightString ? totalStoneWeightString : 0,
    106,
    boxHeight + 26
  );

  doc.text(totalNetWtString ? totalNetWtString : 0, 126, boxHeight + 26);

  doc.text(
    totalMakingPercentageString ? totalMakingPercentageString : 0,
    143,
    boxHeight + 26
  );

  doc.text(
    totalRatePerGramString ? totalRatePerGramString : 0,
    160,
    boxHeight + 26
  );

  //horizontal line at last for total
  doc.line(5, 102, 205, 102);

  doc.setFont("Helvetica", "Normal");

  // ✨ **Add GST Table (Right-Aligned) Below Main Table**
  const gstTableX = 155; // Right-aligned position
  const gstTableY = boxHeight + 30; // Below the item table
  const gstTableWidth = 50;
  const gstTableHeight = 18; // Increased height to accommodate the Net Amount row

  // CGST & SGST Amount Calculation
  const gstAmount = (TotalAmount * (GST / 100)) / 2;
  const netAmount = +(totalMrpString || 0) + +(cgst || 0) + +(sgst || 0); // Total Amount + GST

  console.log(cgst, sgst);

  // GST Table Box
  doc.rect(
    gstTableX + 2.5,
    gstTableY + 2,
    gstTableWidth - 2.2,
    gstTableHeight + 7
  ); // Box for GST table

  // **Table Rows**
  doc.line(
    gstTableX + 2.2,
    gstTableY + 8,
    gstTableX + gstTableWidth,
    gstTableY + 8
  ); // Line between CGST & SGST rows
  doc.line(
    gstTableX + 2.2,
    gstTableY + 14,
    gstTableX + gstTableWidth,
    gstTableY + 14
  ); // Line for Net Amount row
  doc.line(
    gstTableX + 2.2,
    gstTableY + 20,
    gstTableX + gstTableWidth,
    gstTableY + 20
  ); // Line for Net Amount row
  doc.line(
    gstTableX + 20.5,
    gstTableY + 2,
    gstTableX + 20.5,
    gstTableY + 9 + gstTableHeight
  ); // Vertical line between Label & Amount

  // **GST Labels**
  doc.text(`CGST 1.5% : `, gstTableX + 4, gstTableY + 6);
  // doc.text(`${Number(cgst).toFixed(2)}`, gstTableX + 3, gstTableY + 4);
  doc.text(`SGST 1.5%:`, gstTableX + 4, gstTableY + 12);
  doc.text(`GST 3%:`, gstTableX + 4, gstTableY + 18);
  // doc.text(` ${Number(sgst).toFixed(2)}` , gstTableX + 3, gstTableY + 10);
  doc.text(`Net Amount:`, gstTableX + 4, gstTableY + 24); // New row for Net Amount

  doc.setFont("Helvetica", "Normal");
  // **GST Amounts**
  const cgstAmt = +(GST || 0) / 2;
  const sgstAmt = +(GST || 0) / 2;
  const totalNetAmount = `${(
    +(mainitem?.TotalNetAmount || 0) +
    +(mainitem?.GST || 0) +
    +(mainitem?.TDS || 0) +
    +(mainitem?.CourierCharge || 0) -
    +(mainitem?.Offer || 0)
  )?.toFixed(3)}`;
  doc.text(
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? cgstAmt.toFixed(2)
        : ""
    }`,
    gstTableX + 23,
    gstTableY + 6
  );
  doc.text(
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? sgstAmt.toFixed(2)
        : ""
    }`,
    gstTableX + 23,
    gstTableY + 12
  );
  doc.text(
    `${
      adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    gstTableX + 23,
    gstTableY + 18
  );

  doc.text(`${totalNetAmount}`, gstTableX + 22, gstTableY + 24); // New row for Net Amount

  // // Store the final table height used on the last page
  // // tableHeightUsed += rowStartY - tableStartY;

  // // Additional contents (for example, terms, conditions, signatures, etc.)
  // let contentStartY = rowStartY + 10; // Start below the table

  // // Draw final table border for the last page
  // let finalContentHeight = rowStartY - tableStartY;

  // if (contentStartY + 20 > pageHeight) {
  //   // Draw final table border for the last page
  //   finalContentHeight = rowStartY - tableStartY + 4;
  // }

  // console.log(adminLoggedIn);

  // // Set table starting position and dimensions
  // const startX4 = 135; // Starting X position for the table
  // const startY4 = 130; // Starting Y position for the table
  // const tableWidth4 = 70; // Table width
  // const tableHeight4 = 80; // Table height (adjust based on number of rows)
  // const cellHeight4 = 10; // Height for each cell row
  // const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  // // SUMMARY TABLE
  doc.text(
    `GST No : ${adminLoggedIn?.Clients?.GSTNo || ""}`,
    6,
    boxHeight + 37
  );
  // `${adminLoggedIn?.Clients?.GSTNo || ""}`,
  doc.text("Customer Sign", 6, boxHeight + 60);

  // doc.text("(Saturday Closed)", 80, boxHeight + 80);

  doc.text("Heera Gold Palace", 130, boxHeight + 60);

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}

function ThreeInch(items, customer, mainitem, adminLoggedIn, mode) {
  console.log(mode);

  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  // Base document height
  let baseHeight = 50; // Initial height for headers, customer details, etc.

  // Calculate height dynamically based on items (each item takes ~25mm)
  let itemHeight = mainitem.InvoiceItem.length * 100;

  // Add bottom padding (extra space at the bottom of the receipt)
  let bottomPadding = 20;

  // Final total height calculation
  let totalHeight = baseHeight + itemHeight + bottomPadding;

  // Set minimum and maximum height constraints
  totalHeight = Math.max(120, totalHeight); // Ensure at least 120mm height
  totalHeight = Math.min(320, totalHeight); // Prevent excessive height

  // Set document width (76.2mm) and dynamic height
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [76.2, totalHeight], // Dynamically set height
  });

  let y = 5;
  let x = 5;

  console.log(adminLoggedIn);

  // Store Header
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text(`Heera Gold Palace`, x, y);
  y += 6;
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(`No 236 Paper Mills Road Perambur Chennai`, x, y);
  y += 5;
  doc.text(`GST: ${adminLoggedIn?.Clients?.GSTNo || ""}`, x, y);
  y += 5;
  doc.text("Phone: 8904833916", x, y);
  y += 5;
  doc.text("Website: https://hgpperambur.com", x, y);
  y += 8;

  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(`${customer?.FirstName || ""}`, x, y);
  y += 5;
  doc.text(`${customer?.CurrAddStreet || ""}, ${customer?.City || ""}`, x, y);
  y += 5;
  doc.text(`GST: ${customer?.GstNo || ""}`, x, y);
  y += 5;
  doc.text(`Mobile: ${customer?.Mobile || ""}`, x, y);

  console.log(mainitem.InvoiceItem);
  y += 8;
  doc.setFont("helvetica", "bold");

  doc.text("Item Details", x, y);
  y += 5;

  let totalItemAmount = 0;

  // Invoice Items Data
  mainitem.InvoiceItem.forEach((item) => {
    doc.setFont("helvetica", "bold");

    y += 5;
    doc.text("Item", x, y);
    doc.text("HSN", x + 32, y);
    doc.text("Peices", x + 50, y);
    doc.text("Gr Wt", x, y + 10);
    doc.text("Stone Wt", x + 32, y + 10);
    doc.text("Net Wt", x + 50, y + 10);
    doc.text("Rate/Gm", x, y + 20);
    doc.text("Wastage", x + 32, y + 20);
    doc.text("Stone Amt", x + 50, y + 20);
    doc.text("Item Amt", x + 50, y + 30);

    y += 5;
    doc.setFont("helvetica", "normal");

    let itemAmount = +(item?.MRP || item?.TotalItemAmount || 0); // Get item amount

    totalItemAmount += itemAmount; // Accumulate the total item amount

    console.log(totalItemAmount);

    doc.text(item?.ProductName?.toString() || "0", x, y);
    doc.text(item?.HSNCode?.toString() || "0", x + 32, y);
    doc.text(item?.Quantity?.toString() || "0", x + 50, y);
    doc.text(item?.GrossWt?.toString() || "0", x, y + 10);
    doc.text(item?.TotalStoneWeight?.toString() || "0", x + 32, y + 10);
    doc.text(item?.NetWt?.toString() || "0", x + 50, y + 10);
    doc.text(item?.MetalRate?.toString() || "0", x, y + 20);
    doc.text(item?.MakingPercentage?.toString() || "0", x + 32, y + 20);
    doc.text(item?.StoneAmount?.toString() || "0", x + 50, y + 20);
    doc.text(
      (+(item?.MRP || item?.TotalItemAmount || 0))?.toFixed(3),
      x + 50,
      y + 30
    );

    y += 40; // Increase spacing for next row
  });

  y += 5;

  // **GST Amounts**
  const cgstAmt =
    +(mainitem?.GST && mainitem?.GST != "NaN" ? mainitem?.GST : 0) / 2;
  const sgstAmt =
    +(mainitem?.GST && mainitem?.GST != "NaN" ? mainitem?.GST : 0) / 2;

  const totalNetAmount = `${(
    +(mainitem?.TotalNetAmount || 0) +
    +(mainitem?.GST && mainitem?.GST != "NaN" ? mainitem?.GST : 0) +
    +(mainitem?.TDS || 0) +
    +(mainitem?.CourierCharge || 0) -
    +(mainitem?.Offer || 0)
  )?.toFixed(3)}`;

  doc.text(
    `Total Item Amount: ${(+(totalItemAmount || 0)).toFixed(3)}`,
    x + 22,
    y
  );
  doc.text(
    `IGST 3%: ${
      adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    x + 35,
    y + 5
  );
  doc.text(
    `CGST 1.5%: ${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? (+(cgstAmt || 0)).toFixed(2)
        : ""
    }`,
    x + 32,
    y + 10
  );
  doc.text(
    `SGST 1.5%: ${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? (+(sgstAmt || 0)).toFixed(2)
        : ""
    }`,
    x + 32,
    y + 15
  );

  // y += 20; // Extra space before the bottom section

  // **Final Total**
  doc.setFont("helvetica", "bold");
  doc.text(`Total Net Amount: ${totalNetAmount || 0}`, x + 22, y + 22);

  y += 40; // Bottom padding

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}

function generateinvoicepdfHeera2(
  items,
  customer,
  mainitem,
  adminLoggedIn,
  mode
) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [210, 145],
  });

 console.log(mainitem);
 
  

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 25;
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 80;
  // doc.line(0, 30, 210, 30); // Draw a horizontal line

  doc.line(5, 52, 205, 52); // Draw a horizontal line

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;
  const cgst = +(GST || 0) / 2;
  const sgst = +(GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // Set up customer details
  const address = `${customer?.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;
  // Billing information
  doc.setLineWidth(0.3);
  // doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight + 5); // Create a box with the calculated width and height
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(16);
  // doc.text('GOLD SALE', boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.setFontSize(8);

  let currAddress = "";
  if (mainitem?.Customer?.CurrAddStreet) {
    currAddress += mainitem?.Customer?.CurrAddStreet + ", ";
  }
  if (mainitem?.Customer?.CurrAddTown) {
    currAddress += mainitem?.Customer?.CurrAddTown + ", ";
  }
  if (mainitem?.Customer?.CurrAddState) {
    currAddress += mainitem?.Customer?.CurrAddState + ", ";
  }
  if (mainitem?.Customer?.CurrAddPincode) {
    currAddress += mainitem?.Customer?.CurrAddPincode + " ";
  }

  console.log(customer);

  const billingDetails = [
    `NAME                      :  ${customer?.FirstName?.toUpperCase() || ""}`,
    `MOBILE                  :  ${customer?.Mobile || ""}`,
    `ADDRESS               :  ${currAddress || ""}`,
    // `PAN/ADHAR NO    :  ${customer?.PanNo || customer?.AadharNo || ""}`,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 8;
  });

  // Second column data
  const secondColumn = [
    { label: "Invoice No        ", value: `${InvoiceNo || ""}` },
    { label: "Date               ", value: `${InvoiceDate || ""}` },
    {
      label: "PAN/GST No      ",
      value: `${mainitem?.Customer?.GstNo || mainitem?.Customer?.PanNo || ""}`,
    },
    // { label: 'GSTIN Type   ', value: `${"CGST + SGST + IGST"}` },
  ];

  // Define second column starting position
  const secondColumnStartX = boxPadding + 100; // Adjust as needed
  let secondColumnStartY = boxTopMargin + 8; // Align with first column

  // Print second column data
  secondColumn.forEach(({ label, value }) => {
    doc.text(`${label}: ${value}`, secondColumnStartX + 50, secondColumnStartY);
    secondColumnStartY += 8; // Move to the next line
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    Item: 65.18,
    HSN: 17.18,
    "G wt": 17,
    "St wt": 17,
    "Net wt": 18,

    "Wastage %": 18.18,
    "Rate/Gm": 18.18,
    Amount: 33.18,
  };

  const columnArray = [
    "Item",
    "HSN",
    "G wt",
    "St wt",
    "Net wt",

    "Wastage %",
    "Rate/Gm",
    "Amount",
  ];

  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table

    columnArray.forEach((col, colIndex) => {
      if (typeof columnWidths[col] !== "number") {
        console.error(`Invalid column width for ${col}: ${columnWidths[col]}`);
        return; // Skip if column width is invalid
      }

      doc.text(String(col), startX + 2, currentY);
      // doc.line(startX - 1, currentY - 5, startX - 1, currentY + 5);
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        // doc.line(startX, currentY, startX, currentY + 5);
      }
    });
    // doc.line(5, currentY - 5 , 205, currentY - 5);
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);

  tableStartY += 1; // Adjust for the first header row

  // Draw table and handle borders
  let rowStartY = tableStartY;

  let tableHeightUsed = 100;
  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(8);

  console.log("dde", items);

  items?.forEach((item, index) => {
    if (rowStartY + rowHeight > pageHeight - 5) {
      doc.addPage(); // Ensure a new page is added if space runs out
      rowStartY = 30; // Reset to a new page start position
      renderHeaders(rowStartY); // Redraw headers on new page
      rowStartY += 2; // Adjust spacing
    }

    let startX = boxPadding + 2; // Reset X for new row
    const itemData = [
      item?.ProductName || "",
      item?.HSNCode || "",
      (+(item?.GrossWt || 0))?.toFixed(3),
      (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      (+(item?.NetWt || 0))?.toFixed(3),
      +(item?.MakingPercentage || 0), // Wastage
      (+(item?.MetalRate || 0))?.toFixed(3),
      (+(item?.TotalItemAmount || 0))?.toFixed(3),
    ];

    itemData.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 5);
      startX += columnWidths[columnArray[colIndex]];
    });

    rowStartY += rowHeight - 3; // ✅ Move to the next row correctly
  });

  //verticle lines
  doc.line(5, 52, 5, 110);
  doc.line(70, 52, 70, 110);
  doc.line(87.18, 52, 87.18, 110);
  doc.line(104.18, 52, 104.18, 110);
  doc.line(121.18, 52, 121.18, 110);
  doc.line(139.18, 52, 139.18, 110);
  doc.line(157.36, 52, 157.36, 110);
  doc.line(175.54, 52, 175.54, 110);
  doc.line(205.5, 52, 205.5, 110);

  doc.line(5, 60, 205, 60); //after header horizontal line

  doc.line(5, 110, 205, 110); //last horizontal line

  //all totals
  doc.setFont("Helvetica", "bold");
  doc.text("Total", 30, boxHeight + 26);

  // Calculate total MRP

  // Calculate total values for required fields

  const totalGrossWt = items?.reduce(
    (sum, item) => sum + Number(item?.GrossWt || 0),
    0
  );

  const totalStoneWeight = items?.reduce(
    (sum, item) => sum + Number(item?.TotalStoneWeight || 0),
    0
  );
  const totalNetWt = items?.reduce(
    (sum, item) => sum + Number(item?.NetWt || 0),
    0
  );
  const totalMakingPercentage = items?.reduce(
    (sum, item) => sum + Number(item?.MakingPercentage || 0),
    0
  );
  const totalRatePerGram = items?.reduce(
    (sum, item) => sum + Number(item?.MetalRate || 0),
    0
  );
  const totalMRP = items?.reduce(
    (sum, item) => sum + Number(item?.TotalItemAmount || 0),
    0
  );
  const totalHSNCode = items?.reduce(
    (sum, item) => sum + Number(item?.HSNCode || 0),
    0
  );

  // Format all total values to 3 decimal places
  const totalGrossWtString = (+(totalGrossWt || 0)).toFixed(3);
  const totalStoneWeightString = (+(totalStoneWeight || 0)).toFixed(3);
  const totalNetWtString = (+(totalNetWt || 0)).toFixed(3);
  const totalMakingPercentageString = (+(totalMakingPercentage || 0)).toFixed();
  const totalRatePerGramString = (+(totalRatePerGram || 0)).toFixed(3);
  const totalMRPString = (+(totalMRP || 0)).toFixed(3);
  const totalMrpString = (+(totalMRP || 0)).toFixed(3);
  const totalHsnString = (+(totalHSNCode || 0)).toFixed(3);

  doc.text(totalMrpString ? totalMrpString : 0, 180, boxHeight + 26);

  // doc.text(totalHsnString ? totalHsnString : 0, 73, boxHeight + 26);

  doc.text(totalGrossWtString ? totalGrossWtString : 0, 90, boxHeight + 26);

  doc.text(
    totalStoneWeightString ? totalStoneWeightString : 0,
    106,
    boxHeight + 26
  );

  doc.text(totalNetWtString ? totalNetWtString : 0, 126, boxHeight + 26);

  // doc.text(
  //   totalMakingPercentageString ? totalMakingPercentageString : 0,
  //   143,
  //   boxHeight + 26
  // );

  doc.text(
    totalRatePerGramString ? totalRatePerGramString : 0,
    160,
    boxHeight + 26
  );

  //horizontal line at last for total
  doc.line(5, 102, 205, 102);

  doc.setFont("Helvetica", "Normal");

  //mode of payment
  const getPaymentAmount = (mode) => {
    const amount = mainitem?.Payments?.find(
      (payment) => payment.PaymentModeType === mode
    )?.Amount;
    return amount ? parseFloat(amount).toFixed(3) : "";
  };

  const cashPayment = getPaymentAmount("Cash");
  const rtgsPayment = getPaymentAmount("RTGS");
  const chequePayment = getPaymentAmount("Cheque");
  const cardPayment = getPaymentAmount("Card");
  const upiPayment = getPaymentAmount("UPI");

  const paymentModeX = 140;

  const paymentModeY = boxHeight + 45; // Below the item table

  doc.rect(paymentModeX - 80, paymentModeY - 14, 45, 10);
  doc.setFont("Helvetica", "bold");
  doc.text(
    `Balance Amount: ${Number(mainitem?.BalanceAmount).toFixed(2) || "0.00"}`,
    paymentModeX - 75,
    paymentModeY - 10
  );

  doc.rect(paymentModeX - 30, paymentModeY - 14, 45, 20);
  doc.setFont("Helvetica", "bold");
  doc.text(`Cash: ${cashPayment}`, paymentModeX - 18, paymentModeY - 10);
  doc.text(`Card: ${cardPayment}`, paymentModeX - 18, paymentModeY - 5);
  doc.text(`UPI: ${upiPayment}`, paymentModeX - 18, paymentModeY);
  doc.text(
    `Discount: ${Number(mainitem?.Offer).toFixed(2) || "0.00"}`,
    paymentModeX - 18,
    paymentModeY + 5
  );

  // ✨ **Add GST Table (Right-Aligned) Below Main Table**
  const gstTableX = 155; // Right-aligned position
  const gstTableY = boxHeight + 30; // Below the item table
  const gstTableWidth = 50;
  const gstTableHeight = 18; // Increased height to accommodate the Net Amount row

  // CGST & SGST Amount Calculation
  const gstAmount = (TotalAmount * (GST / 100)) / 2;
  const netAmount = +(totalMrpString || 0) + +(cgst || 0) + +(sgst || 0); // Total Amount + GST

  console.log(cgst, sgst);

  // GST Table Box
  doc.rect(gstTableX + 2.5, gstTableY, gstTableWidth - 2.2, gstTableHeight + 7); // Box for GST table

  // **Table Rows**
  doc.line(
    gstTableX + 2.2,
    gstTableY + 8,
    gstTableX + gstTableWidth,
    gstTableY + 8
  ); // Line between CGST & SGST rows
  doc.line(
    gstTableX + 2.2,
    gstTableY + 14,
    gstTableX + gstTableWidth,
    gstTableY + 14
  ); // Line for Net Amount row
  doc.line(
    gstTableX + 2.2,
    gstTableY + 20,
    gstTableX + gstTableWidth,
    gstTableY + 20
  ); // Line for Net Amount row
  doc.line(
    gstTableX + 20.5,
    gstTableY,
    gstTableX + 20.5,
    gstTableY + 9 + gstTableHeight - 2
  ); // Vertical line between Label & Amount

  // **GST Labels**
  doc.text(`CGST 1.5%: `, gstTableX + 4, gstTableY + 5);
  // doc.text(`${Number(cgst).toFixed(2)}`, gstTableX + 3, gstTableY + 4);
  doc.text(`SGST 1.5%:`, gstTableX + 4, gstTableY + 12);
  doc.text(`IGST 3%:`, gstTableX + 4, gstTableY + 18);
  // doc.text(` ${Number(sgst).toFixed(2)}` , gstTableX + 3, gstTableY + 10);
  doc.text(`Net Amount:`, gstTableX + 4, gstTableY + 24); // New row for Net Amount

  doc.setFont("Helvetica", "Normal");
  // **GST Amounts**
  const cgstAmt =
    +(mainitem?.GST && mainitem?.GST != "NaN" ? mainitem?.GST : 0) / 2;
  const sgstAmt =
    +(mainitem?.GST && mainitem?.GST != "NaN" ? mainitem?.GST : 0) / 2;

  const totalNetAmount = `${(
    +(mainitem?.TotalNetAmount || 0) +
    +(mainitem?.GST && mainitem?.GST != "NaN" ? mainitem?.GST : 0) +
    +(mainitem?.TDS || 0) +
    +(mainitem?.CourierCharge || 0) -
    +(mainitem?.Offer || 0)
  )?.toFixed(3)}`;

  doc.text(
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? (+(cgstAmt || 0)).toFixed(2)
        : ""
    }`,
    gstTableX + 23,
    gstTableY + 6
  );
  doc.text(
    `${
      adminLoggedIn?.State == mainitem?.Customer?.CurrAddState
        ? (+(sgstAmt || 0)).toFixed(2)
        : ""
    }`,
    gstTableX + 23,
    gstTableY + 12
  );
  doc.text(
    `${
      adminLoggedIn?.State != mainitem?.Customer?.CurrAddState
        ? (+(GST || 0)).toFixed(2)
        : ""
    }`,
    gstTableX + 23,
    gstTableY + 18
  );

  doc.text(
    `${(+(totalNetAmount || 0))?.toFixed(3)}`,
    gstTableX + 22,
    gstTableY + 24
  ); // New row for Net Amount

  // // Store the final table height used on the last page
  // // tableHeightUsed += rowStartY - tableStartY;

  // // Additional contents (for example, terms, conditions, signatures, etc.)
  // let contentStartY = rowStartY + 10; // Start below the table

  // // Draw final table border for the last page
  // let finalContentHeight = rowStartY - tableStartY;

  // if (contentStartY + 20 > pageHeight) {
  //   // Draw final table border for the last page
  //   finalContentHeight = rowStartY - tableStartY + 4;
  // }

  // console.log(adminLoggedIn);

  // // Set table starting position and dimensions
  // const startX4 = 135; // Starting X position for the table
  // const startY4 = 130; // Starting Y position for the table
  // const tableWidth4 = 70; // Table width
  // const tableHeight4 = 80; // Table height (adjust based on number of rows)
  // const cellHeight4 = 10; // Height for each cell row
  // const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  // // SUMMARY TABLE
  doc.text(
    `GST No : ${adminLoggedIn?.Clients?.GSTNo || ""}`,
    6,
    boxHeight + 37
  );
  // `${adminLoggedIn?.Clients?.GSTNo || ""}`,
  doc.text("Customer Sign", 6, boxHeight + 55);

  // doc.text("(Saturday Closed)", 80, boxHeight + 80);

  doc.text("Heera Gold Palace", 130, boxHeight + 55);

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}

const generateInvoicePdfArchana = async (items, customer, mainitem) => {
  console.log("checking items", items);
  console.log("checking customer", customer);

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  console.log("mainitem", mainitem);

  const dummyData = generateDummyData();
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const marginTop = 80;
  const marginBottom = 40;
  const rowHeight = 10; // Initial row height
  const tableHeight = 100; // Fixed table height
  let currentY = marginTop;
  const invoicex = pageWidth - 60;
  const invoicey = 60;
  const customerx = pageWidth - 200;
  const customery = 60;
  const fotertotalx = pageWidth - 70;
  const fotertotaly = 180;

  const despx = pageWidth - 70;
  const despy = 250;

  const invoicenumber = `${mainitem.InvoiceNo}`;
  const invoicedate = `${mainitem.InvoiceDate}`;
  const firstname = `${customer.FirstName}`;
  const lastname = `${customer.LastName}`;
  const mobile = `${customer.Mobile}`;
  const address = `${customer.CurrAddStreet} ${customer.CurrAddTown} ${customer.CurrAddState}`;

  console.log("checkpagewidth  ", pageWidth);

  // Define the column positions
  const columnPositions = {
    sr: pageWidth - 200,
    productDetails: pageWidth - 190,
    hsnCode: pageWidth - 150,
    purity: pageWidth - 140,
    gross: pageWidth - 128,
    stone: pageWidth - 110,
    stoneCast: pageWidth - 90,
    discount: pageWidth - 70,
    va: pageWidth - 50,
    amount: pageWidth - 40,
  };

  // Draw the table structure dynamically
  const drawTableStructure = () => {
    // Vertical Lines (for column separators)
    // doc.line(10, marginTop, 10, marginTop + tableHeight); // Left border
    Object.values(columnPositions).forEach((pos) => {
      doc.line(pos, marginTop, pos, marginTop + tableHeight); // Column separators
    });
    doc.line(
      pageWidth - 10,
      marginTop,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Right border
  };

  const drawTableHeader = () => {
    doc.setFontSize(9);
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header top line
    currentY += 5;

    // Draw the header text
    doc.text("Sr.", columnPositions.sr + 2, currentY);
    doc.text("Product Details", columnPositions.productDetails + 2, currentY);
    // doc.text('Pcs', columnPositions.pcs+2, currentY);
    doc.text("HSN", columnPositions.hsnCode + 2, currentY);
    doc.text("Purity", columnPositions.purity + 2, currentY);
    doc.text("Gross", columnPositions.gross + 2, currentY);
    doc.text("Stone", columnPositions.stone + 2, currentY);
    doc.text("Stone Cast", columnPositions.stoneCast + 2, currentY);
    doc.text("Discount", columnPositions.discount + 2, currentY);
    doc.text("VA", columnPositions.va + 2, currentY);
    doc.text("Total Amt", columnPositions.amount + 2, currentY);

    currentY += 5;
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header bottom line
    currentY += 5;

    doc.line(
      columnPositions.sr,
      marginTop + tableHeight,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Table header top line
  };

  const totalAmount = Number(mainitem.TotalAmount) || 0;
  const gstAmount = Number(mainitem.GST) || 0;
  const receivedAmount = Number(mainitem.ReceivedAmount) || 0;

  const totalPrice = mainitem.InvoiceItem.reduce((sum, item) => {
    // Parse the price to a float and add to the sum
    return sum + parseFloat(item.Price);
  }, 0);

  const discountPrice = totalPrice - totalAmount;

  console.log("discountPrice", discountPrice);

  // Calculate CGST, SGST, total invoice amount, and balance amount
  const cgst = (totalAmount * 1.5) / 100; // CGST @1.5%
  const total = totalAmount + gstAmount; // Total Invoice Amount
  const bal = total - receivedAmount; // Balance Amount

  console.log("totalAmount", totalAmount);

  console.log("receivedAmount", receivedAmount);

  const AmtWithoutDiscount = totalAmount - receivedAmount;

  console.log("AmtWithoutDiscount", AmtWithoutDiscount);

  // Format amounts to two decimal places for better precision
  const formatAmount = (amount) => amount.toFixed(2);

  const drawFooter = () => {
    // // Discount Amount
    // doc.text(
    //   `Discount Amount : ${formatAmount(discountPrice)}`,
    //   fotertotalx,
    //   fotertotaly + 10
    // );

    // Taxable Amount
    doc.text(
      `Taxable Amount : ${formatAmount(totalAmount)}`,
      fotertotalx,
      fotertotaly + 15
    );

    // CGST and SGST (assuming both are calculated similarly)
    doc.text(
      `CGST @ 1.5% : ${formatAmount(cgst)}`,
      fotertotalx,
      fotertotaly + 20
    );
    doc.text(
      `SGST @ 1.5% : ${formatAmount(cgst)}`,
      fotertotalx,
      fotertotaly + 25
    );

    // IGST (3% assumed)
    // doc.text(
    //   `IGST @ 3% : ${formatAmount(gstAmount)}`,
    //   fotertotalx,
    //   fotertotaly + 25
    // );

    // Total Invoice Amount
    doc.text(
      `Total Invoice Amount : ${formatAmount(total)}`,
      fotertotalx,
      fotertotaly + 30
    );

    // Amount Received
    doc.text(
      `Amount Received : ${formatAmount(receivedAmount)}`,
      fotertotalx,
      fotertotaly + 35
    );

    // Balance Amount (Handle negative balance if any)
    const balanceText =
      bal >= 0 ? formatAmount(bal) : `-${formatAmount(Math.abs(bal))}`;
    doc.text(`Balance Amount : ${balanceText}`, fotertotalx, fotertotaly + 40);

    const thankYouText = "Thank You For Your Business, God Bless Keep Buying";
    doc.setFontSize(10);

    // Calculate the text width to center it
    const textWidth = doc.getTextWidth(thankYouText);
    const centerX = (pageWidth - textWidth) / 3; // Calculate the x position for center alignment

    // Draw the centered text
    doc.text(thankYouText, centerX, fotertotaly + 50);
    doc.setFontSize(9);
    doc.text("Declaration :", customerx, fotertotaly + 55);
    const declarationText =
      "I declare that this invoice shows the actual price of the goods described and that all particulars are true and correct. I received ornament in good condition";
    const splitText = doc.splitTextToSize(declarationText, 80); // Adjust 180 to the width you want
    doc.setFontSize(9);
    doc.text(splitText, customerx, fotertotaly + 60);

    doc.setFontSize(9);
    doc.text("For Archana Jewellery", fotertotalx, fotertotaly + 60);

    doc.text("Authorised Signature", fotertotalx, fotertotaly + 86);
    doc.text("Customer Signatory", customerx, fotertotaly + 86);

    doc.line(customerx, fotertotaly + 90, fotertotalx + 60, fotertotaly + 90);

    const ctext = "Shop no 2-10-30/1, shabazar, mahabubnagar, 509001";
    const splitText1 = doc.splitTextToSize(ctext, 80); // Adjust 180 to the width you want
    doc.text(splitText1, customerx, fotertotaly + 95);
    const stext = "Contact Us : 9440389832";
    const s1text = "";
    const s2text = "";
    const splitText2 = doc.splitTextToSize(stext, 80); // Adjust 180 to the width you want
    doc.text(stext, fotertotalx - 6, fotertotaly + 95);
    doc.text(s1text, fotertotalx - 6, fotertotaly + 100);
    doc.text(s2text, fotertotalx - 6, fotertotaly + 105);
  };

  const drawTableRows = () => {
    const pageContentHeight = pageHeight - marginTop - marginBottom; // Height available for content
    items.forEach((item, index) => {
      // Determine text lines and adjust currentY for each row
      const productDetailsLines = doc.splitTextToSize(
        item.ProductName,
        columnPositions.amount - columnPositions.productDetails - 5
      ); // Adjust width as needed
      const rowCount = Math.max(
        productDetailsLines.length,
        1 // To ensure there's at least one row
      );
      const currentRowHeight = rowCount * rowHeight; // Height for this row
      // Check if adding this row will exceed page height
      if (currentY + currentRowHeight > pageContentHeight) {
        doc.addPage(); // Add a new page if needed
        currentY = marginTop; // Reset currentY
        drawTableHeader(); // Redraw the header on the new page
        drawTableStructure(); // Redraw the table structure on the new page
      }

      // Draw row data
      doc.text(`${index + 1}`, columnPositions.sr + 2, currentY);
      productDetailsLines.forEach((line, lineIndex) => {
        doc.text(
          line,
          columnPositions.productDetails + 2,
          currentY + lineIndex * rowHeight
        );
      });
      doc.text(item.HSNCode, columnPositions.hsnCode + 2, currentY);
      doc.text(item.Purity || "NA", columnPositions.purity + 2, currentY);
      doc.text(item.GrossWt || "NA", columnPositions.gross + 2, currentY);
      doc.text(item.StoneWeight || "NA", columnPositions.stone + 2, currentY);
      doc.text(item.stoneCast || "NA", columnPositions.stoneCast + 2, currentY);
      doc.text(item.discount || "NA", columnPositions.discount + 2, currentY);
      doc.text(item.va || "NA", columnPositions.va + 2, currentY);
      doc.text(
        item.TotalItemAmount || item.totalAmount || item.MRP,
        columnPositions.amount + 2,
        currentY
      );

      // Update currentY
      currentY += currentRowHeight; // Increase based on row height
    });
  };

  // const drawTableRows = () => {
  //   items.forEach((item, index) => {
  //     // Determine text lines and adjust currentY for each row
  //     const productDetailsLines = doc.splitTextToSize(
  //       item.ProductName,
  //       columnPositions.amount - columnPositions.productDetails - 5
  //     ); // Adjust width as needed
  //     const rowCount = Math.max(
  //       productDetailsLines.length,
  //       1 // To ensure there's at least one row
  //     );

  //     if (currentY + (rowCount + rowHeight) > pageHeight - marginBottom) {
  //       doc.addPage(); // Add a new page if needed
  //       currentY = marginTop;
  //       drawTableHeader();
  //       drawTableStructure();
  //     }

  //     // Draw row data
  //     doc.text(`${index + 1}`, columnPositions.sr + 2, currentY);
  //     productDetailsLines.forEach((line, lineIndex) => {
  //       doc.text(
  //         line,
  //         columnPositions.productDetails + 2,
  //         currentY + lineIndex * rowHeight
  //       );
  //     });
  //     // doc.text(item.Quantity || '1', columnPositions.pcs+2, currentY);
  //     doc.text('7113', columnPositions.hsnCode + 2, currentY);
  //     doc.text(item.Purity || 'NA', columnPositions.purity + 2, currentY);
  //     // doc.text( item.Price || "NA", columnPositions.price + 2, currentY);
  //     doc.text(item.GrossWt || 'NA', columnPositions.gross + 2, currentY);
  //     doc.text(item.StoneWeight || 'NA', columnPositions.stone+2, currentY);
  //     doc.text(item.stoneCast || 'NA', columnPositions.stoneCast + 2, currentY);
  //     doc.text(item.discount || 'NA', columnPositions.discount + 2, currentY);
  //     doc.text(item.va || 'NA', columnPositions.va + 2, currentY);
  //     doc.text(item.MRP || 'NA', columnPositions.amount + 2, currentY);

  //     // Update currentY based on the row count
  //     currentY += rowCount * rowHeight; // Adjust currentY based on the number of lines
  //   });
  // };

  const getImageBase64 = (imagePath) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imagePath; // This path should point to the public folder image
      img.crossOrigin = "Anonymous"; // Ensure CORS issues don't block loading
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/jpeg"); // Convert to Base64
        resolve(dataURL);
      };
      img.onerror = (err) => reject(err);
    });
  };

  try {
    // Get the Base64 string of the image
    const imageBase64 = await getImageBase64("/images/pdfimages/10.png"); // Adjust path accordingly

    // Add the image to the PDF at specified coordinates (x, y, width, height)
    // const x = (pageWidth - 40) / 2;

    // doc.addImage(imageBase64, 'JPEG', x, 2, 40, 40);
    const imageWidth = 55;
    const imageX = (pageWidth - imageWidth) / 2; // Center horizontally
    const imageY = 3; // Adjust the y-coordinate as needed

    // Add the image to the PDF
    doc.addImage(imageBase64, "JPEG", imageX, imageY, imageWidth, 45);
  } catch (error) {
    console.error("Error loading image:", error);
  }

  const text = "TAX INVOICE";
  const textWidth = doc.getTextWidth(text); // Get the width of the text
  const textX = (pageWidth - textWidth) / 2; // Center horizontally
  const textY = 56; // Adjust the Y position as needed (below the image)

  // Add centered "TAX INVOICE" text
  doc.text(text, textX, textY);

  // Start generating the PDF
  // doc.text("TAX INVOICE", 90, 49);
  doc.setFontSize(10);
  doc.text("GSTIN :- 29AASCM4571D1Z2", invoicex, invoicey);
  doc.text("Invoice No :-", invoicex, invoicey + 5);
  doc.text(invoicenumber, invoicex + 20, invoicey + 5);
  // doc.text("Date :-", invoicex, invoicey + 5);
  doc.text(`Date :- ${invoicedate}`, invoicex, invoicey + 9);

  doc.text("Invoice To", customerx, customery);

  doc.text(
    `Customer Name : ${firstname} ${lastname}`,
    customerx,
    customery + 5
  );
  // doc.text(``, customerx + 28, customery + 5);
  doc.text(`Mobile No     : ${mobile}`, customerx, customery + 10);
  // doc.text(``, customerx + 28, customery + 10);
  doc.text(`Address       : ${address}`, customerx, customery + 15);
  // doc.text(``, customerx + 28, customery + 15);

  drawTableHeader();
  drawTableStructure();
  drawTableRows();

  function checkAndAddPage(currentY, sectionHeight) {
    if (currentY + sectionHeight > pageHeight - 20) {
      // Adjust to prevent cutoff
      doc.addPage();
      return 10; // Reset Y position for new page
    }
    return currentY;
  }
  const drawBankDetails = () => {
    const boxPadding = 10;
    const boxHeight = 28;
    const boxWidth = 80; // Box width with padding

    // Positioning for the bank details box
    let bankDetailsY = pageHeight - boxHeight - 80; // Add some spacing from the last table row

    // // Check if there's enough space for the bank details box
    // if (bankDetailsY + boxHeight + 20 > pageHeight - marginBottom) {
    //   doc.addPage();
    //   bankDetailsY = marginTop + 5; // Reset to the top margin of the new page
    // }
    // Ensure it's always on the last page
    if (currentY > bankDetailsY) {
      doc.addPage();
      bankDetailsY = pageHeight - boxHeight - 80; // Reset position for new page
    }

    // Draw the bank details box
    doc.rect(boxPadding, bankDetailsY, boxWidth, boxHeight);
    doc.setFontSize(8);
    doc.text("Bank Details", boxPadding + 2, bankDetailsY + 5);
    doc.text("Bank Name: ", boxPadding + 2, bankDetailsY + 10);
    doc.text("AC/NO: ", boxPadding + 2, bankDetailsY + 15);
    doc.text("Branch: ", boxPadding + 2, bankDetailsY + 20);
    doc.text("IFSC: ", boxPadding + 2, bankDetailsY + 25);
  };

  const currentYAfterTable = currentY; // Save the current Y position after the table

  drawBankDetails(currentYAfterTable); // Add the bank details box
  // Add the footer to the last page
  drawFooter();

  // Open the PDF
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

// function generateAshtalaxmiInvoice23(items, customer, mainitem, adminLoggedIn) {

//   console.log('log>>');

//   const {
//     InvoiceNo,
//     InvoiceDate,
//     ProductName,
//     HSNCode,
//     Purity,
//     Qty,
//     GrossWt,
//     StoneWt,
//     NetWt,
//     StoneAmount,
//     MakingPerGram,
//     TotalAmount,
//     UrdPurchaseAmt,
//     Payments,
//     PaymentMode,
//     GST,
//   } = mainitem;

//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: "a4",
//   });

//   const pageWidth = doc.internal.pageSize.width; // Get the page width

//   const startx = 2;
//   const starty = 54.5;
//   const boxTopMargin = starty + 10; // Top margin for the box
//   const boxPadding = 5; // Padding on both sides
//   const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
//   const boxHeight = 40;

//   const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

//   const totalgross = urdPurchasePositive - UrdPurchaseAmt;
//   const cgst = (GST || 0) / 2;
//   const sgst = (GST || 0) / 2;

//   // const sGstFx = sGst.toFixed(2)
//   const totalAmountNumber = Number(TotalAmount);
//   const GSTNumber = Number(GST);

//   doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

//   // doc.setFont("sanserif", "bold");
//   // doc.setFontSize(16);
//   // doc.setTextColor(0, 0, 0);
//   // doc.text("GOLD SALE", 90, 43);

//   const pan = customer?.PanNo || "NA";
//   const adhar = customer?.AadharNo || "NA";
//   const mobile = customer?.Mobile || "NA";
//   const address = customer?.CurrAddStreet || "NA";
//   const town = customer?.CurrAddTown || "";
//   const city = customer?.City || "";
//   const CurrAddPincode = customer?.CurrAddPincode || "";
//   const PanNo = customer?.PanNo || "";
//   const GSTIN = customer?.GSTIN || "";

//   // First column data
//   const firstColumn = [
//     {
//       label: "Billing Name And Address      : ",
//       value: `BILLING NAME AND ADDRESS`,
//     },
//     { label: "Name      : ", value: `${customer?.FirstName?.toUpperCase()}` },
//     {
//       label: "Address   : ",
//       value: `${address?.toUpperCase()}${town && `, ${town}`}${
//         CurrAddPincode && ` - ${CurrAddPincode}`
//       }`,
//     },
//     // { label: "Mobile    : ", value: `${mobile}` },
//     // { label: "Pan/Adhar : ", value: `${pan} / ${adhar}` },
//   ];

//   // Second column data
//   const secondColumn = [
//     { label: "BILL NO           ", value: `${InvoiceNo}` },
//     { label: "Date                    ", value: `${InvoiceDate}` },
//     { label: "PAN                    ", value: PanNo || "" },
//     { label: "GSTIN No          ", value: GSTIN || "" },
//     { label: "STATE CODE   ", value: "" },
//   ];

//   doc.setLineWidth(0.3);
//   doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height of 40
//   // Draw content inside the box
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(16);
//   doc.text(
//     "ASHTALAXMI JEWELS",
//     boxPadding + boxWidth / 2 - 35,
//     boxTopMargin - 3
//   ); // Centered "GOLD SALE" text

//   // Set Font for content
//   // doc.setFontSize(12);
//   doc.setFontSize(8);
//   doc.setFont("helvetica", "bold");
//   // Draw first column data
//   let columnY = boxTopMargin + 8;

//   firstColumn.forEach((item) => {
//     doc.text(`${item.value}`, boxPadding + 2, columnY);
//     columnY += 6;
//   });

//   // Draw second column data
//   columnY = boxTopMargin + 8;
//   secondColumn.forEach((item) => {
//     doc.text(
//       `${item.label}${item.value}`,
//       boxPadding + boxWidth / 2 + 25,
//       columnY
//     );
//     columnY += 6;
//   });
//   const rowHeight = 10; // Height of each row
//   const headerHeight = 20; // Height for the header
//   const paddingHeight = 20;

//   //main tbale
//   // Now creating the attached table box for items
//   const tableStartY = starty + boxHeight + 10; // Start below the first box
//   let tableHeight = headerHeight + items?.length * rowHeight + paddingHeight;

//   // doc.rect(boxPadding, tableStartY, boxWidth, tableHeight); // Draw the outer box for the table
//   // doc.rect(boxPadding, 275, boxWidth, 10);
//   // Column widths and labels
//   const stnNames = [];
//   items?.map((item, index) => {
//     item?.Stones?.forEach((sitem, sindex) => {
//       if (!stnNames?.includes(sitem?.StoneName)) {
//         stnNames?.push(sitem?.StoneName);
//       }
//     });
//   });

//   doc.rect(boxPadding, tableStartY, boxWidth, tableHeight + 20); // Draw the outer box for the table
//   console.log(stnNames);
//   let result1 = {}
//   stnNames?.map((item)=>{
//     result1[item] = 12
//   })
//   let result2 = { "Net Wt": 12,
//     Tounch: 12,
//     "Fine Wt": 12,
//     "S. Amt": 13}

//   const columnWidths = {
//     Sr: 6,
//     "Item Name": 30.18,
//     "Item Code": 12.18,
//     Pcs: 8,

//     "Gross Wt": 10.18,
//     ...result1,
//     ...result2

//   };

//   let names2 = [ "Net Wt",
//     "Tounch",
//     "Fine Wt",
//     "S. Amt",]

//   const columnArray = [
//     "Sr",
//     "Item Name",
//     "Item Code",
//     "Pcs",

//     "Gross Wt",
//    ...stnNames,
//    ...names2

//   ];

//   const arr = [
//     { label: "CGST 1.5%", value: `${Number(cgst || 0).toFixed(2)}` },
//     { label: "SGST 1.5%", value: `${Number(sgst || 0).toFixed(2)}` },
//   ];
//   const arr1 = [{ label: "IGST 3%", value: `${Number(GST || 0).toFixed(2)}` }];

//   const arrv1 = [
//     `${Number(cgst || 0).toFixed(2)}`,
//     `${Number(sgst || 0).toFixed(2)}`,
//   ];
//   const arrv2 = [`${Number(GSTNumber || 0).toFixed(2)}`];
//   // Dummy values for the right column

//   // Table Headers
//   let startX = boxPadding + 2; // Starting X position for table
//   let headerY = tableStartY + 7; // Starting Y position for the headers
//   let rowStartY = tableStartY + headerHeight;
//   let startA = boxPadding + 2; // Starting X position for table
//   let headerB = tableStartY + 7;
//   doc.setFontSize(5);
//   doc.setFont("helvetica", "normal");
//   columnArray.forEach((col, index) => {
//     doc.text(col, startX, headerY);

//     startX += columnWidths[col]; // Move X based on column width
//   });

//   const pageHeight = doc.internal.pageSize.height; // Get the height of the page
//   let currentY = tableStartY;
//   // Draw vertical lines separating columns
//   let columnX = boxPadding; // startx + 2;
//   columnArray.forEach((col, colIndex) => {
//      doc.line(columnX, tableStartY, columnX, tableStartY + tableHeight + 20); // Draw vertical lines
//     columnX += columnWidths[col];

//   });

//   // Draw the last vertical line to close the right border of the table
// doc.line(columnX + 84.5, tableStartY  , columnX + 84.5, tableStartY  + tableHeight + 20)

// doc.line(boxPadding,tableStartY + tableHeight + 20, boxPadding + boxWidth,tableStartY + tableHeight + 20); // Draw horizontal line after last row

// doc.line(boxPadding, tableStartY + tableHeight, boxPadding + boxWidth, tableStartY + tableHeight);

//   // Draw the right border for the table
//   doc.line(boxPadding, tableStartY, boxPadding, tableStartY + tableHeight);
//   doc.line(
//     boxPadding,
//     tableStartY + 10,
//     boxPadding + boxWidth,
//     tableStartY + 10
//   );
//   // Render table content
//   // let rowStartY = headerY + 10;
//   // startX = boxPadding+2;

//   let totalQuantity = 0;
//   let totalGrossWt = 0;
//   let totalNetWt = 0;
//   let totalFineWastageWt = 0;
//   let totalItemAmount = 0;

//   let stoneCharge = 0;
//   let FineWastageWtTotal = 0;
//   let NetWtTotal = 0;
//   let GrossWtTotal = 0;
//   let TagTotal = 0;
//   let GrossTagTotal = 0;
//   let PcsTotal = 0;
//   let HallmarkAmountTotal = 0;

//   let RBWt = 0;
//   let RBRate = "";
//   let EMWt = 0;
//   let EMRate = "";
//   let NRWt = 0;
//   let NRRate = "";
//   let ADWt = 0;
//   let ADRate = "";
//   let CLRWt = 0;
//   let CLRRate = "";
//   let MOTIWt = 0;
//   let MOTIRate = 0;
//   let BDSWt = 0;
//   let BDSRate = 0;
//   const stoneTotalObj = {};
//   const stoneTotalRateObj = {};

//   const bottomMargin = 10; // Space to leave at the bottom
//   const topMargin = 10; // Space for headers

// let currentY2 = tableStartY + headerHeight; // Start position for rows
// let lastRowY = currentY2; // Track last printed row for vertical lines
// let pageCount = 1; // Track pages

//   items.forEach((item, itemIndex) => {
//     stoneCharge += +(item?.TotalStoneAmount || 0);
//     FineWastageWtTotal += +(item?.FineWastageWt || 0);
//     NetWtTotal += +(item?.NetWt || 0);
//     GrossTagTotal += +(item?.TotalWt || 0);
//     TagTotal += +(item?.PackingWeight || 0);
//     GrossWtTotal += +(item?.GrossWt || 0);
//     HallmarkAmountTotal += +(item?.HallmarkAmount || 0);

//     const rowHeight = 10; // Height of each row
//     const availableSpace = pageHeight - currentY2 - bottomMargin;

//     // If not enough space for the row, create a new page
//     if (rowHeight > availableSpace) {
//         if (pageCount === 2) {
//             // drawVerticalLines(lastRowY, true); // Draw vertical lines (including last one)
//             // drawHorizontalLine(lastRowY); // Draw horizontal line after last row
//         }

//         doc.addPage(); // Create new page
//         currentY2 = topMargin; // Reset Y position
//         pageCount++; // Increase page count

//         // Re-render table headers on the new page
//         let startX = boxPadding + 2;
//         columnArray.forEach((col) => {
//             doc.text(col, startX, currentY2 + 7);
//             startX += columnWidths[col];
//         });

//         currentY2 += headerHeight; // Move below headers
//         lastRowY = currentY2; // Reset lastRowY for new page
//     }

//     let startX = boxPadding + 2;
//     let StonePcs = `${+(item?.Pieces || 0)}`;

//     const stoneObj = {};
//     const stoneRateObj = {};

//     if (item?.Stones?.length) {
//       item?.Stones?.map((sitem) => {

//         if (stoneObj[sitem.StoneName]) {
//           stoneObj[sitem.StoneName] += parseFloat((+(sitem?.StoneWeight || 0))?.toFixed(3));
//         } else {
//           stoneObj[sitem.StoneName] = parseFloat((+(sitem?.StoneWeight || 0))?.toFixed(3))
//         }

//         if (!stoneRateObj[sitem.StoneName]) {
//           stoneRateObj[sitem.StoneName] = parseFloat((+(sitem?.StoneRateKarate || 0))?.toFixed(3));
//         }

//       });
//     }

//     Object.keys(stoneObj)?.map((item)=>{
//       if(stoneTotalObj[item]){
//         stoneTotalObj[item] += +(stoneObj[item] || 0)
//       }else{
//         stoneTotalObj[item] = +(stoneObj[item] || 0)
//       }
//     })
//     Object?.keys(stoneRateObj)?.map((item)=>{
//       if(!stoneTotalRateObj[item]){
//         stoneTotalRateObj[item] = +(stoneRateObj[item] || 0)
//       }
//     })

//     // Object.keys(stoneRateObj).forEach((name) => {
//     //     stoneTotalRateObj[name] = (stoneTotalRateObj[name] || 0) + stoneRateObj[name];
//     // });

//     PcsTotal += +(StonePcs || 0);
//     let nameArr = [
//       `${item?.ItemCode ? `${item?.ItemCode}` : ""}`,
//       `${item?.CategoryName ? `${item?.CategoryName}` : ""}`,
//       `${item?.ProductName ? `${item?.ProductName}` : ""}`,
//       `${item?.DesignName ? `${item?.DesignName}` : ""}`,
//       `${item?.Purity ? `${item?.Purity}` : ""}`,
//     ].join(",");
//     let arrResult = stnNames.map((name) => (+(stoneObj[name] || 0)).toFixed(3));
//     let arrResult2 = [
//         `${(+(item?.NetWt || 0)).toFixed(3)}`,
//         `${item?.FinePercentage + " + " + item?.MakingPercentage || 0}`,
//         `${(+(item?.FineWastageWt || 0)).toFixed(3)}`,
//         `${(+(item?.TotalStoneAmount || 0)).toFixed(3)}`
//     ];

//     const itemData = [
//         itemIndex + 1,
//         `${(nameArr || "")?.substring(0, 20)}...`,
//         `${item?.ItemCode || ""}`,
//         +(StonePcs || 0),
//         (+(item?.GrossWt || 0)).toFixed(3),
//         ...arrResult,
//         ...arrResult2
//     ];

//     itemData.forEach((data, index) => {
//         doc.text(`${data}`, startX, currentY2);
//         startX += columnWidths[columnArray[index]];
//     });

//     lastRowY = currentY2; // Update last row position
//     currentY2 += rowHeight; // Move to the next row

// });

// console.log(tableStartY, tableHeight , pageHeight, currentY2, pageCount);

// if(pageCount == 1){
//   currentY2 += 20;
// }

// if(pageCount > 1){
//   let columnX2 = 5; // startx + 2;
//   columnArray.forEach((col, colIndex) => {
//     doc.line(columnX2, 1, columnX2, currentY2 + 20 ); // Draw vertical lines
//    columnX2 += columnWidths[col];

//  });

//  // Draw the last vertical line to close the right border of the table
// doc.line(columnX2 + 84.5, 1  , columnX2  + 84.5, currentY2 + 20)

// doc.line(boxPadding, currentY2, boxPadding + boxWidth, currentY2 ); // Draw horizontal line after last row

// doc.line(boxPadding, currentY2 + 20, boxPadding + boxWidth, currentY2 + 20 ); // Draw horizontal line after total row

// }

//   console.log(stoneTotalObj);
//   doc.setFont("Helvetica", "normal");
//   let startXX = boxPadding + 2;

//   let totalData2 = [`${(+(NetWtTotal || 0))?.toFixed(3)}`,"",`${(+(FineWastageWtTotal || 0))?.toFixed(3)}`,`${(+(stoneCharge || 0))?.toFixed(3)}`]
//   let totalData1 = stnNames?.map((item)=>{return (+(stoneTotalObj[item] || 0))?.toFixed(3)})

//   const totalsData = [
//     "", // Empty for index column
//     "Total", // "Total" label in ProductName column
//     "",
//     +(PcsTotal || 0),

//     (+(GrossWtTotal || 0))?.toFixed(3),
//     ...totalData1,
//     ...totalData2
//   ];

//   totalsData.forEach((data, index) => {
//     doc.text(`${data}`, startXX, currentY2 + 10);
//     startXX += columnWidths[columnArray[index]];
//   });

//   doc.setFont("Helvetica", "normal");
//   let startXXX = boxPadding + 2;

//   console.log(stoneTotalRateObj)
//   let totalData3 = stnNames?.map((item)=>{return (+(stoneTotalRateObj[item] || 0))?.toFixed(3)})

//   const totalStoneRateData = [
//     "",
//     "Stn Rate",
//     "",
//     "",
//     "",

//     ...totalData3

//   ];
//   totalStoneRateData.forEach((data, index) => {
//     doc.text(`${data}`, startXXX, currentY2 + 13);
//     startXXX += columnWidths[columnArray[index]];
//   });

//   doc.setFont("Helvetica", "Bold");
//   let startXXXX = boxPadding + 2;
//   const totalData4 = stnNames?.map((item)=>{return ((+(stoneTotalRateObj[item] || 0)) * (+(stoneTotalObj[item] || 0)))?.toFixed(3) })
//   const totalStoneAmtData = [
//     "",
//     "Stn Amt",
//     "",
//     "",
//     "",

//     ...totalData4

//   ];
//   totalStoneAmtData.forEach((data, index) => {
//     doc.text(`${data}`, startXXXX, currentY2 + 16);
//     startXXXX += columnWidths[columnArray[index]];
//   });

//   // if (rowStartY + 70 > pageHeight - 10) {

//   //   doc.addPage();
//   //   rowStartY = 10;
//   // }

//   doc.setFont("Helvetica", "normal");
//   doc.setFontSize(7);
//  doc.rect(boxWidth - 45, currentY2 + 20, boxWidth / 4, 47)
//   doc.text(
//     `Stone Charg            ${(+(stoneCharge || 0))?.toFixed(3)}`,
//     boxPadding + 162,
//     currentY2 + 25
//   );
//   doc.text(
//     `Huid Charg              ${(+(HallmarkAmountTotal || 0))?.toFixed(3)}`,
//     boxPadding + 162,
//     currentY2 + 31
//   );
//   doc.text(
//     `Courier Charg          ${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
//     boxPadding + 162,
//     currentY2 + 37
//   );
//   doc.text(
//     `GST                         ${(+(mainitem?.TotalGSTAmount || 0))?.toFixed(
//       3
//     )}`,
//     boxPadding + 162,
//     currentY2 + 43
//   );
//   doc.text(
//     `TDS Amount            ${(+(mainitem?.TDS || 0))?.toFixed(3)}`,
//     boxPadding + 162,
//     currentY2 + 51
//   );
//   // doc.text(`Gold Value               ${"0.00"}`, boxPadding + 162,rowStartY+45  );
//   doc.setFont("Helvetica", "Bold");
//   doc.setFontSize(7);
//   doc.text(
//     `Payable Amt           ${(+(
//       +(stoneCharge || 0) +
//         +(HallmarkAmountTotal || 0) +
//         +(mainitem?.CourierCharge || 0) +
//         +(mainitem?.TotalGSTAmount || 0) || 0
//     ))?.toFixed(3)}`,
//     boxPadding + 162,
//     currentY2 + 57
//   );
//   doc.setFont("Helvetica", "normal");
//   doc.setFontSize(7);
//   doc.text(
//     `Net Balance             ${(+(
//       +(stoneCharge || 0) +
//         +(HallmarkAmountTotal || 0) +
//         +(mainitem?.CourierCharge || 0) +
//         +(mainitem?.TotalGSTAmount || 0) || 0
//     ))?.toFixed(3)}`,
//     boxPadding + 162,
//     currentY2 + 63
//   );

//   // Generate the PDF and open it in a new window
//   const pdfData = doc?.output("datauristring");
//   const newWindow = window?.open();
//   newWindow?.document?.write(
//     `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
//   );
// }

function generateAshtalaxmiInvoice55(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.width; // Get the page width

  const startx = 2;
  const starty = 54.5;
  const boxTopMargin = starty + 10; // Top margin for the box
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 40;

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;
  const cgst = (GST || 0) / 2;
  const sgst = (GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // doc.setFont("sanserif", "bold");
  // doc.setFontSize(16);
  // doc.setTextColor(0, 0, 0);
  // doc.text("GOLD SALE", 90, 43);

  const pan = customer?.PanNo || "NA";
  const adhar = customer?.AadharNo || "NA";
  const mobile = customer?.Mobile || "NA";
  const address = customer?.CurrAddStreet || "NA";
  const town = customer?.CurrAddTown || "";
  const city = customer?.City || "";
  const CurrAddPincode = customer?.CurrAddPincode || "";
  const PanNo = customer?.PanNo || "";
  const GSTIN = customer?.GSTIN || "";
  console.log();
  // First column data
  const firstColumn = [
    {
      label: "Billing Name       ",
      value: `:  ${customer?.FirstName?.toUpperCase()}`,
    },
    {
      label: "Billing Address  ",
      value: `:  ${address?.toUpperCase()}${town && `, ${town}`}${
        CurrAddPincode && ` - ${CurrAddPincode}`
      }`,
    },
    // { label: "Name      : ", value: `${customer?.FirstName?.toUpperCase()}` },
    // {
    //   label: "Address   : ",
    //   value: `${address?.toUpperCase()}${town && `, ${town}`}${
    //     CurrAddPincode && ` - ${CurrAddPincode}`
    //   }`,
    // },
    // { label: "Mobile    : ", value: `${mobile}` },
    // { label: "Pan/Adhar : ", value: `${pan} / ${adhar}` },
  ];

  // Second column data
  const secondColumn = [
    { label: "BILL NO           ", value: `:  ${InvoiceNo}` },
    { label: "Date                  ", value: `:  ${InvoiceDate}` },
    { label: "PAN                  ", value: `:  ${PanNo || ""}` },
    { label: "GSTIN No         ", value: `:  ${GSTIN || ""}` },
    { label: "STATE CODE   ", value: ":  " },
  ];

  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height of 40
  // Draw content inside the box
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(
    "ASHTALAXMI JEWELS",
    boxPadding + boxWidth / 2 - 35,
    boxTopMargin - 3
  ); // Centered "GOLD SALE" text

  // Set Font for content
  // doc.setFontSize(12);
  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  // Draw first column data
  let columnY = boxTopMargin + 8;

  firstColumn.forEach((item) => {
    doc.text(`${item.label}${item.value}`, boxPadding + 5, columnY);
    columnY += 6;
  });

  // Draw second column data
  columnY = boxTopMargin + 8;
  secondColumn.forEach((item) => {
    doc.text(
      `${item.label}${item.value}`,
      boxPadding + boxWidth / 2 + 25,
      columnY
    );
    columnY += 6;
  });
  const rowHeight = 10; // Height of each row
  const headerHeight = 20; // Height for the header
  const paddingHeight = 20;

  //main tbale
  // Now creating the attached table box for items
  const tableStartY = starty + boxHeight + 10; // Start below the first box
  let tableHeight = headerHeight + items?.length * rowHeight + paddingHeight;

  // doc.rect(boxPadding, tableStartY, boxWidth, tableHeight); // Draw the outer box for the table
  // doc.rect(boxPadding, 275, boxWidth, 10);
  // Column widths and labels
  const stnNames = [];
  items?.map((item, index) => {
    item?.Stones?.forEach((sitem, sindex) => {
      const trimmedName = (sitem?.StoneName || "")?.substring(0, 9);
      if (!stnNames?.includes(sitem?.StoneName)) {
        stnNames?.push(sitem?.StoneName);
      }
    });
  });

  doc.rect(boxPadding, tableStartY, boxWidth, tableHeight + 20); // Draw the outer box for the table
  console.log(stnNames);
  let result1 = {};
  stnNames?.map((item) => {
    result1[item] = 12;
  });
  let result2 = { "Net Wt": 12, Tounch: 12, "Fine Wt": 12, "S. Amt": 13 };

  const columnWidths = {
    Sr: 6,
    "Item Name": 30.18,
    "Item Code": 12.18,
    Pcs: 8,

    "Gross Wt": 10.18,
    ...result1,
    ...result2,
  };

  let names2 = ["Net Wt", "Tounch", "Fine Wt", "S. Amt"];

  const columnArray = [
    "Sr",
    "Item Name",
    "Item Code",
    "Pcs",

    "Gross Wt",
    ...stnNames,
    ...names2,
  ];

  const arr = [
    { label: "CGST 1.5%", value: `${Number(cgst || 0).toFixed(2)}` },
    { label: "SGST 1.5%", value: `${Number(sgst || 0).toFixed(2)}` },
  ];
  const arr1 = [{ label: "IGST 3%", value: `${Number(GST || 0).toFixed(2)}` }];

  const arrv1 = [
    `${Number(cgst || 0).toFixed(2)}`,
    `${Number(sgst || 0).toFixed(2)}`,
  ];
  const arrv2 = [`${Number(GSTNumber || 0).toFixed(2)}`];
  // Dummy values for the right column

  // Table Headers
  let startX = boxPadding + 2; // Starting X position for table
  let headerY = tableStartY + 7; // Starting Y position for the headers
  let rowStartY = tableStartY + headerHeight;
  let startA = boxPadding + 2; // Starting X position for table
  let headerB = tableStartY + 7;
  doc.setFontSize(5);
  doc.setFont("helvetica", "normal");
  columnArray.forEach((col, index) => {
    doc.text(col?.substring(0, 10), startX, headerY);

    startX += columnWidths[col]; // Move X based on column width
  });

  const pageHeight = doc.internal.pageSize.height; // Get the height of the page
  let currentY = tableStartY;
  // Draw vertical lines separating columns
  let columnX = boxPadding; // startx + 2;
  columnArray.forEach((col, colIndex) => {
    doc.line(columnX, tableStartY, columnX, tableStartY + tableHeight + 20); // Draw vertical lines
    columnX += columnWidths[col];
  });

  // Draw the last vertical line to close the right border of the table
  doc.line(
    columnX + 84.5,
    tableStartY,
    columnX + 84.5,
    tableStartY + tableHeight + 20
  );

  doc.line(
    boxPadding,
    tableStartY + tableHeight + 20,
    boxPadding + boxWidth,
    tableStartY + tableHeight + 20
  ); // Draw horizontal line after last row

  doc.line(
    boxPadding,
    tableStartY + tableHeight,
    boxPadding + boxWidth,
    tableStartY + tableHeight
  );

  // Draw the right border for the table
  doc.line(boxPadding, tableStartY, boxPadding, tableStartY + tableHeight);
  doc.line(
    boxPadding,
    tableStartY + 10,
    boxPadding + boxWidth,
    tableStartY + 10
  );
  // Render table content
  // let rowStartY = headerY + 10;
  // startX = boxPadding+2;

  let totalQuantity = 0;
  let totalGrossWt = 0;
  let totalNetWt = 0;
  let totalFineWastageWt = 0;
  let totalItemAmount = 0;

  let stoneCharge = 0;
  let FineWastageWtTotal = 0;
  let NetWtTotal = 0;
  let GrossWtTotal = 0;
  let TagTotal = 0;
  let GrossTagTotal = 0;
  let PcsTotal = 0;
  let HallmarkAmountTotal = 0;

  let RBWt = 0;
  let RBRate = "";
  let EMWt = 0;
  let EMRate = "";
  let NRWt = 0;
  let NRRate = "";
  let ADWt = 0;
  let ADRate = "";
  let CLRWt = 0;
  let CLRRate = "";
  let MOTIWt = 0;
  let MOTIRate = 0;
  let BDSWt = 0;
  let BDSRate = 0;
  const stoneTotalObj = {};
  const stoneTotalRateObj = {};

  const bottomMargin = 10; // Space to leave at the bottom
  const topMargin = 10; // Space for headers

  let currentY2 = tableStartY + headerHeight; // Start position for rows
  let lastRowY = currentY2; // Track last printed row for vertical lines
  let pageCount = 1; // Track pages

  items.forEach((item, itemIndex) => {
    stoneCharge += +(item?.TotalStoneAmount || 0);
    FineWastageWtTotal += +(item?.FineWastageWt || 0);
    NetWtTotal += +(item?.NetWt || 0);
    GrossTagTotal += +(item?.TotalWt || 0);
    TagTotal += +(item?.PackingWeight || 0);
    GrossWtTotal += +(item?.GrossWt || 0);
    HallmarkAmountTotal += +(item?.HallmarkAmount || 0);

    const rowHeight = 10; // Height of each row
    const availableSpace = pageHeight - currentY2 - bottomMargin;

    // If not enough space for the row, create a new page
    if (rowHeight > availableSpace) {
      if (pageCount === 2) {
        // drawVerticalLines(lastRowY, true); // Draw vertical lines (including last one)
        // drawHorizontalLine(lastRowY); // Draw horizontal line after last row
      }

      doc.addPage(); // Create new page
      currentY2 = topMargin; // Reset Y position
      pageCount++; // Increase page count

      // Re-render table headers on the new page
      let startX = boxPadding + 2;
      columnArray.forEach((col) => {
        doc.text(col, startX, currentY2 + 7);
        startX += columnWidths[col];
      });

      currentY2 += headerHeight; // Move below headers
      lastRowY = currentY2; // Reset lastRowY for new page
    }

    let startX = boxPadding + 2;
    let StonePcs = `${+(item?.Pieces || 0)}`;

    const stoneObj = {};
    const stoneRateObj = {};

    if (item?.Stones?.length) {
      item?.Stones?.map((sitem) => {
        if (stoneObj[sitem.StoneName]) {
          stoneObj[sitem.StoneName] += parseFloat(
            (+(sitem?.StoneWeight || 0))?.toFixed(3)
          );
        } else {
          stoneObj[sitem.StoneName] = parseFloat(
            (+(sitem?.StoneWeight || 0))?.toFixed(3)
          );
        }

        if (!stoneRateObj[sitem.StoneName]) {
          stoneRateObj[sitem.StoneName] = parseFloat(
            (+(sitem?.StoneRateKarate || 0))?.toFixed(3)
          );
        }
      });
    }

    Object.keys(stoneObj)?.map((item) => {
      if (stoneTotalObj[item]) {
        stoneTotalObj[item] += +(stoneObj[item] || 0);
      } else {
        stoneTotalObj[item] = +(stoneObj[item] || 0);
      }
    });
    Object?.keys(stoneRateObj)?.map((item) => {
      if (!stoneTotalRateObj[item]) {
        stoneTotalRateObj[item] = +(stoneRateObj[item] || 0);
      }
    });
    console.log(stoneRateObj);

    // Object.keys(stoneRateObj).forEach((name) => {
    //     stoneTotalRateObj[name] = (stoneTotalRateObj[name] || 0) + stoneRateObj[name];
    // });

    PcsTotal += +(StonePcs || 0);
    let nameArr = [
      `${item?.ItemCode ? `${item?.ItemCode}` : ""}`,
      `${item?.CategoryName ? `${item?.CategoryName}` : ""}`,
      `${item?.ProductName ? `${item?.ProductName}` : ""}`,
      `${item?.DesignName ? `${item?.DesignName}` : ""}`,
      `${item?.Purity ? `${item?.Purity}` : ""}`,
    ].join(",");
    let arrResult = stnNames.map((name) => (+(stoneObj[name] || 0)).toFixed(3));
    let arrResult2 = [
      `${(+(item?.NetWt || 0)).toFixed(3)}`,
      `${
        +(item?.FinePercentage || 0) && +(item?.MakingPercentage || 0)
          ? +(item?.FinePercentage || 0) +
            " + " +
            +(item?.MakingPercentage || 0)
          : +(item?.FinePercentage || 0)
          ? +(item?.FinePercentage || 0)
          : +(item?.MakingPercentage || 0)
          ? +(item?.MakingPercentage || 0)
          : 0
      }`,
      `${(+(item?.FineWastageWt || 0)).toFixed(3)}`,
      `${(+(item?.TotalStoneAmount || 0)).toFixed(3)}`,
    ];

    const itemData = [
      itemIndex + 1,
      `${(nameArr || "")?.substring(0, 20)}...`,
      `${item?.ItemCode || ""}`,
      +(StonePcs || 0),
      (+(item?.GrossWt || 0)).toFixed(3),
      ...arrResult,
      ...arrResult2,
    ];

    itemData.forEach((data, index) => {
      doc.text(`${data}`, startX, currentY2);
      startX += columnWidths[columnArray[index]];
    });

    lastRowY = currentY2; // Update last row position
    currentY2 += rowHeight; // Move to the next row
  });

  if (pageCount == 1) {
    currentY2 += 20;
  }

  if (pageCount > 1) {
    let columnX2 = 5; // startx + 2;
    columnArray.forEach((col, colIndex) => {
      doc.line(columnX2, 1, columnX2, currentY2 + 20); // Draw vertical lines
      columnX2 += columnWidths[col];
    });

    // Draw the last vertical line to close the right border of the table
    doc.line(columnX2 + 84.5, 1, columnX2 + 84.5, currentY2 + 20);

    doc.line(boxPadding, currentY2, boxPadding + boxWidth, currentY2); // Draw horizontal line after last row

    doc.line(boxPadding, currentY2 + 20, boxPadding + boxWidth, currentY2 + 20); // Draw horizontal line after total row
  }

  console.log(stoneTotalObj);
  doc.setFont("Helvetica", "normal");
  let startXX = boxPadding + 2;

  let totalData2 = [
    `${(+(NetWtTotal || 0))?.toFixed(3)}`,
    "",
    `${(+(FineWastageWtTotal || 0))?.toFixed(3)}`,
    `${(+(stoneCharge || 0))?.toFixed(3)}`,
  ];
  let totalData1 = stnNames?.map((item) => {
    return (+(stoneTotalObj[item] || 0))?.toFixed(3);
  });

  const totalsData = [
    "", // Empty for index column
    "Total", // "Total" label in ProductName column
    "",
    +(PcsTotal || 0),

    (+(GrossWtTotal || 0))?.toFixed(3),
    ...totalData1,
    ...totalData2,
  ];

  totalsData.forEach((data, index) => {
    doc.text(`${data}`, startXX, currentY2 + 10);
    startXX += columnWidths[columnArray[index]];
  });

  doc.setFont("Helvetica", "normal");
  let startXXX = boxPadding + 2;

  console.log(stoneTotalRateObj);
  console.log(stnNames);
  let totalData3 = stnNames?.map((item) => {
    return (+(stoneTotalRateObj[item] || 0))?.toFixed(3);
  });

  console.log(totalData3);
  const totalStoneRateData = ["", "Stn Rate", "", "", "", ...totalData3];
  totalStoneRateData.forEach((data, index) => {
    doc.text(`${data}`, startXXX, currentY2 + 13);
    startXXX += columnWidths[columnArray[index]];
  });

  doc.setFont("Helvetica", "Bold");
  let startXXXX = boxPadding + 2;
  const totalData4 = stnNames?.map((item) => {
    return (
      +(stoneTotalRateObj[item] || 0) * +(stoneTotalObj[item] || 0)
    )?.toFixed(3);
  });
  const totalStoneAmtData = ["", "Stn Amt", "", "", "", ...totalData4];
  totalStoneAmtData.forEach((data, index) => {
    doc.text(`${data}`, startXXXX, currentY2 + 16);
    startXXXX += columnWidths[columnArray[index]];
  });

  // if (rowStartY + 70 > pageHeight - 10) {

  //   doc.addPage();
  //   rowStartY = 10;
  // }

  doc.setFont("Helvetica", "normal");
  doc.setFontSize(7);
  doc.rect(boxWidth - 45, currentY2 + 20, boxWidth / 4, 47);

  let metal = 0;
  let metalToCash = 0;
  let cashToMetal = 0;
  let cash = 0;
  let card = 0;
  let upi = 0;
  let cheque = 0;
  let rtgs = 0;
  mainitem?.Payments?.forEach((item) => {
    if (item?.PaymentModeType == "Cash") {
      cash += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Card") {
      card += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "UPI") {
      upi += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Cheque") {
      cheque += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "RTGS") {
      rtgs += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Metal to Cash") {
      metalToCash += +(item?.GoldAmount || item?.SilverAmount || 0);
    }
    if (item?.PaymentModeType == "Metal") {
      metal += +(item?.OldGoldGrossWt || item?.OldSilverGrossWt || 0);
    }
    if (item?.PaymentModeType == "Cash to Metal") {
      cashToMetal += +(item?.OldGoldGrossWt || item?.OldSilverGrossWt || 0);
    }
  });
  doc.rect(boxPadding, currentY2 + 20, boxWidth / 4, 47);

  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(7);
  doc.text(
    `Payable Amount             ${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || mainitem?.Discount || 0)
    )?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 25
  );

  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(7);
  doc.text(
    `Cash                                     ${(cash || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 30
  );
  doc.text(
    `Card                                      ${(card || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 35
  );
  doc.text(
    `UPI                                        ${(upi || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 40
  );
  doc.text(
    `Cheque                                  ${(cheque || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 45
  );
  doc.text(
    `RTGS                                    ${(rtgs || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 50
  );
  doc.text(
    `Metal to Cash                        ${(metalToCash || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 55
  );

  doc.text(
    `Cash to Metal                        ${(cashToMetal || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 60
  );
  doc.text(
    `Metal                                     ${(metal || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 65
  );

  doc.text(
    `Stone Charg            ${(+(stoneCharge || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 25
  );
  doc.text(
    `Huid Charg              ${(+(HallmarkAmountTotal || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 31
  );
  doc.text(
    `Courier Charg          ${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 37
  );
  doc.text(
    `GST                         ${(+(mainitem?.TotalGSTAmount || 0))?.toFixed(
      3
    )}`,
    boxPadding + 162,
    currentY2 + 43
  );
  doc.text(
    `TDS Amount            ${(+(mainitem?.TDS || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 51
  );
  // doc.text(`Gold Value               ${"0.00"}`, boxPadding + 162,rowStartY+45  );
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(7);
  console.log(stoneCharge);
  console.log(HallmarkAmountTotal);
  console.log(mainitem?.CourierCharge);
  console.log(mainitem?.TotalGSTAmount);
  console.log(mainitem?.TotalAmount);
  doc.text(
    `Payable Amt         ${(+(
      (
        +(stoneCharge || 0) +
        +(HallmarkAmountTotal || 0) +
        +(mainitem?.CourierCharge || 0) +
        +(mainitem?.TotalGSTAmount || 0) - +(mainitem?.Offer || mainitem?.Discount || 0)
      )

      // +(mainitem?.TotalAmount || 0) || 0
    ))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 57
  );
  doc.setFont("Helvetica", "normal");
  doc.setFontSize(7);
  doc.text(
    `Net Balance           ${(+(mainitem?.BalanceAmount || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 63
  );

  // Generate the PDF and open it in a new window
  const pdfData = doc?.output("datauristring");
  const newWindow = window?.open();
  newWindow?.document?.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}
function generateinvoicepdfMehta(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.width; // Get the page width

  const startx = 2;
  const starty = 54.5;
  const boxTopMargin = starty + 10; // Top margin for the box
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 40;

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;
  const cgst = (GST || 0) / 2;
  const sgst = (GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // doc.setFont("sanserif", "bold");
  // doc.setFontSize(16);
  // doc.setTextColor(0, 0, 0);
  // doc.text("GOLD SALE", 90, 43);

  const pan = customer?.PanNo || "NA";
  const adhar = customer?.AadharNo || "NA";
  const mobile = customer?.Mobile || "NA";
  const address = customer?.CurrAddStreet || "NA";
  const town = customer?.CurrAddTown || "";
  const city = customer?.City || "";
  const CurrAddPincode = customer?.CurrAddPincode || "";
  const PanNo = customer?.PanNo || "";
  const GSTIN = customer?.GSTIN || "";
  console.log();
  // First column data
  const firstColumn = [
    {
      label: "Billing Name       ",
      value: `:  ${customer?.FirstName?.toUpperCase()}`,
    },
    {
      label: "Billing Address  ",
      value: `:  ${address?.toUpperCase()}${town && `, ${town}`}${
        CurrAddPincode && ` - ${CurrAddPincode}`
      }`,
    },
    // { label: "Name      : ", value: `${customer?.FirstName?.toUpperCase()}` },
    // {
    //   label: "Address   : ",
    //   value: `${address?.toUpperCase()}${town && `, ${town}`}${
    //     CurrAddPincode && ` - ${CurrAddPincode}`
    //   }`,
    // },
    // { label: "Mobile    : ", value: `${mobile}` },
    // { label: "Pan/Adhar : ", value: `${pan} / ${adhar}` },
  ];

  // Second column data
  const secondColumn = [
    { label: "BILL NO           ", value: `:  ${InvoiceNo}` },
    { label: "Date                  ", value: `:  ${InvoiceDate}` },
    { label: "PAN                  ", value: `:  ${PanNo || ""}` },
    { label: "GSTIN No         ", value: `:  ${GSTIN || ""}` },
    { label: "STATE CODE   ", value: ":  " },
  ];

  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height of 40
  // Draw content inside the box
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(
    "VIKRAM MEHTA DESIGN STUDIO PVT LTD",
    boxPadding + boxWidth / 2 - 55,
    boxTopMargin - 3
  ); // Centered "GOLD SALE" text

  // Set Font for content
  // doc.setFontSize(12);
  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  // Draw first column data
  let columnY = boxTopMargin + 8;

  firstColumn.forEach((item) => {
    doc.text(`${item.label}${item.value}`, boxPadding + 5, columnY);
    columnY += 6;
  });

  // Draw second column data
  columnY = boxTopMargin + 8;
  secondColumn.forEach((item) => {
    doc.text(
      `${item.label}${item.value}`,
      boxPadding + boxWidth / 2 + 25,
      columnY
    );
    columnY += 6;
  });
  const rowHeight = 10; // Height of each row
  const headerHeight = 20; // Height for the header
  const paddingHeight = 20;

  //main tbale
  // Now creating the attached table box for items
  const tableStartY = starty + boxHeight + 10; // Start below the first box
  let tableHeight = headerHeight + items?.length * rowHeight + paddingHeight;

  // doc.rect(boxPadding, tableStartY, boxWidth, tableHeight); // Draw the outer box for the table
  // doc.rect(boxPadding, 275, boxWidth, 10);
  // Column widths and labels
  const stnNames = [];
  items?.map((item, index) => {
    item?.Stones?.forEach((sitem, sindex) => {
      const trimmedName = (sitem?.StoneName || "")?.substring(0, 9);
      if (!stnNames?.includes(sitem?.StoneName)) {
        stnNames?.push(sitem?.StoneName);
      }
    });
  });

  doc.rect(boxPadding, tableStartY, boxWidth, tableHeight + 20); // Draw the outer box for the table
  console.log(stnNames);
  let result1 = {};
  stnNames?.map((item) => {
    result1[item] = 12;
  });
  let result2 = { "Net Wt": 12, Tounch: 12, "Fine Wt": 12, "S. Amt": 13 };

  const columnWidths = {
    Sr: 6,
    "Item Name": 30.18,
    "Item Code": 12.18,
    Pcs: 8,

    "Gross Wt": 10.18,
    ...result1,
    ...result2,
  };

  let names2 = ["Net Wt", "Tounch", "Fine Wt", "S. Amt"];

  const columnArray = [
    "Sr",
    "Item Name",
    "Item Code",
    "Pcs",

    "Gross Wt",
    ...stnNames,
    ...names2,
  ];

  const arr = [
    { label: "CGST 1.5%", value: `${Number(cgst || 0).toFixed(2)}` },
    { label: "SGST 1.5%", value: `${Number(sgst || 0).toFixed(2)}` },
  ];
  const arr1 = [{ label: "IGST 3%", value: `${Number(GST || 0).toFixed(2)}` }];

  const arrv1 = [
    `${Number(cgst || 0).toFixed(2)}`,
    `${Number(sgst || 0).toFixed(2)}`,
  ];
  const arrv2 = [`${Number(GSTNumber || 0).toFixed(2)}`];
  // Dummy values for the right column

  // Table Headers
  let startX = boxPadding + 2; // Starting X position for table
  let headerY = tableStartY + 7; // Starting Y position for the headers
  let rowStartY = tableStartY + headerHeight;
  let startA = boxPadding + 2; // Starting X position for table
  let headerB = tableStartY + 7;
  doc.setFontSize(5);
  doc.setFont("helvetica", "normal");
  columnArray.forEach((col, index) => {
    doc.text(col?.substring(0, 10), startX, headerY);

    startX += columnWidths[col]; // Move X based on column width
  });

  const pageHeight = doc.internal.pageSize.height; // Get the height of the page
  let currentY = tableStartY;
  // Draw vertical lines separating columns
  let columnX = boxPadding; // startx + 2;
  columnArray.forEach((col, colIndex) => {
    doc.line(columnX, tableStartY, columnX, tableStartY + tableHeight + 20); // Draw vertical lines
    columnX += columnWidths[col];
  });

  // Draw the last vertical line to close the right border of the table
  doc.line(
    columnX + 84.5,
    tableStartY,
    columnX + 84.5,
    tableStartY + tableHeight + 20
  );

  doc.line(
    boxPadding,
    tableStartY + tableHeight + 20,
    boxPadding + boxWidth,
    tableStartY + tableHeight + 20
  ); // Draw horizontal line after last row

  doc.line(
    boxPadding,
    tableStartY + tableHeight,
    boxPadding + boxWidth,
    tableStartY + tableHeight
  );

  // Draw the right border for the table
  doc.line(boxPadding, tableStartY, boxPadding, tableStartY + tableHeight);
  doc.line(
    boxPadding,
    tableStartY + 10,
    boxPadding + boxWidth,
    tableStartY + 10
  );
  // Render table content
  // let rowStartY = headerY + 10;
  // startX = boxPadding+2;

  let totalQuantity = 0;
  let totalGrossWt = 0;
  let totalNetWt = 0;
  let totalFineWastageWt = 0;
  let totalItemAmount = 0;

  let stoneCharge = 0;
  let FineWastageWtTotal = 0;
  let NetWtTotal = 0;
  let GrossWtTotal = 0;
  let TagTotal = 0;
  let GrossTagTotal = 0;
  let PcsTotal = 0;
  let HallmarkAmountTotal = 0;

  let RBWt = 0;
  let RBRate = "";
  let EMWt = 0;
  let EMRate = "";
  let NRWt = 0;
  let NRRate = "";
  let ADWt = 0;
  let ADRate = "";
  let CLRWt = 0;
  let CLRRate = "";
  let MOTIWt = 0;
  let MOTIRate = 0;
  let BDSWt = 0;
  let BDSRate = 0;
  const stoneTotalObj = {};
  const stoneTotalRateObj = {};

  const bottomMargin = 10; // Space to leave at the bottom
  const topMargin = 10; // Space for headers

  let currentY2 = tableStartY + headerHeight; // Start position for rows
  let lastRowY = currentY2; // Track last printed row for vertical lines
  let pageCount = 1; // Track pages

  items.forEach((item, itemIndex) => {
    stoneCharge += +(item?.TotalStoneAmount || 0);
    FineWastageWtTotal += +(item?.FineWastageWt || 0);
    NetWtTotal += +(item?.NetWt || 0);
    GrossTagTotal += +(item?.TotalWt || 0);
    TagTotal += +(item?.PackingWeight || 0);
    GrossWtTotal += +(item?.GrossWt || 0);
    HallmarkAmountTotal += +(item?.HallmarkAmount || 0);

    const rowHeight = 10; // Height of each row
    const availableSpace = pageHeight - currentY2 - bottomMargin;

    // If not enough space for the row, create a new page
    if (rowHeight > availableSpace) {
      if (pageCount === 2) {
        // drawVerticalLines(lastRowY, true); // Draw vertical lines (including last one)
        // drawHorizontalLine(lastRowY); // Draw horizontal line after last row
      }

      doc.addPage(); // Create new page
      currentY2 = topMargin; // Reset Y position
      pageCount++; // Increase page count

      // Re-render table headers on the new page
      let startX = boxPadding + 2;
      columnArray.forEach((col) => {
        doc.text(col, startX, currentY2 + 7);
        startX += columnWidths[col];
      });

      currentY2 += headerHeight; // Move below headers
      lastRowY = currentY2; // Reset lastRowY for new page
    }

    let startX = boxPadding + 2;
    let StonePcs = `${+(item?.Pieces || 0)}`;

    const stoneObj = {};
    const stoneRateObj = {};

    if (item?.Stones?.length) {
      item?.Stones?.map((sitem) => {
        if (stoneObj[sitem.StoneName]) {
          stoneObj[sitem.StoneName] += parseFloat(
            (+(sitem?.StoneWeight || 0))?.toFixed(3)
          );
        } else {
          stoneObj[sitem.StoneName] = parseFloat(
            (+(sitem?.StoneWeight || 0))?.toFixed(3)
          );
        }

        if (!stoneRateObj[sitem.StoneName]) {
          stoneRateObj[sitem.StoneName] = parseFloat(
            (+(sitem?.StoneRateKarate || 0))?.toFixed(3)
          );
        }
      });
    }

    Object.keys(stoneObj)?.map((item) => {
      if (stoneTotalObj[item]) {
        stoneTotalObj[item] += +(stoneObj[item] || 0);
      } else {
        stoneTotalObj[item] = +(stoneObj[item] || 0);
      }
    });
    Object?.keys(stoneRateObj)?.map((item) => {
      if (!stoneTotalRateObj[item]) {
        stoneTotalRateObj[item] = +(stoneRateObj[item] || 0);
      }
    });
    console.log(stoneRateObj);

    // Object.keys(stoneRateObj).forEach((name) => {
    //     stoneTotalRateObj[name] = (stoneTotalRateObj[name] || 0) + stoneRateObj[name];
    // });

    PcsTotal += +(StonePcs || 0);
    let nameArr = [
      `${item?.ItemCode ? `${item?.ItemCode}` : ""}`,
      `${item?.CategoryName ? `${item?.CategoryName}` : ""}`,
      `${item?.ProductName ? `${item?.ProductName}` : ""}`,
      `${item?.DesignName ? `${item?.DesignName}` : ""}`,
      `${item?.Purity ? `${item?.Purity}` : ""}`,
    ].join(",");
    let arrResult = stnNames.map((name) => (+(stoneObj[name] || 0)).toFixed(3));
    let arrResult2 = [
      `${(+(item?.NetWt || 0)).toFixed(3)}`,
      `${
        +(item?.FinePercentage || 0) && +(item?.MakingPercentage || 0)
          ? +(item?.FinePercentage || 0) +
            " + " +
            +(item?.MakingPercentage || 0)
          : +(item?.FinePercentage || 0)
          ? +(item?.FinePercentage || 0)
          : +(item?.MakingPercentage || 0)
          ? +(item?.MakingPercentage || 0)
          : 0
      }`,
      `${(+(item?.FineWastageWt || 0)).toFixed(3)}`,
      `${(+(item?.TotalStoneAmount || 0)).toFixed(3)}`,
    ];

    const itemData = [
      itemIndex + 1,
      `${(nameArr || "")?.substring(0, 20)}...`,
      `${item?.ItemCode || ""}`,
      +(StonePcs || 0),
      (+(item?.GrossWt || 0)).toFixed(3),
      ...arrResult,
      ...arrResult2,
    ];

    itemData.forEach((data, index) => {
      doc.text(`${data}`, startX, currentY2);
      startX += columnWidths[columnArray[index]];
    });

    lastRowY = currentY2; // Update last row position
    currentY2 += rowHeight; // Move to the next row
  });

  if (pageCount == 1) {
    currentY2 += 20;
  }

  if (pageCount > 1) {
    let columnX2 = 5; // startx + 2;
    columnArray.forEach((col, colIndex) => {
      doc.line(columnX2, 1, columnX2, currentY2 + 20); // Draw vertical lines
      columnX2 += columnWidths[col];
    });

    // Draw the last vertical line to close the right border of the table
    doc.line(columnX2 + 84.5, 1, columnX2 + 84.5, currentY2 + 20);

    doc.line(boxPadding, currentY2, boxPadding + boxWidth, currentY2); // Draw horizontal line after last row

    doc.line(boxPadding, currentY2 + 20, boxPadding + boxWidth, currentY2 + 20); // Draw horizontal line after total row
  }

  console.log(stoneTotalObj);
  doc.setFont("Helvetica", "normal");
  let startXX = boxPadding + 2;

  let totalData2 = [
    `${(+(NetWtTotal || 0))?.toFixed(3)}`,
    "",
    `${(+(FineWastageWtTotal || 0))?.toFixed(3)}`,
    `${(+(stoneCharge || 0))?.toFixed(3)}`,
  ];
  let totalData1 = stnNames?.map((item) => {
    return (+(stoneTotalObj[item] || 0))?.toFixed(3);
  });

  const totalsData = [
    "", // Empty for index column
    "Total", // "Total" label in ProductName column
    "",
    +(PcsTotal || 0),

    (+(GrossWtTotal || 0))?.toFixed(3),
    ...totalData1,
    ...totalData2,
  ];

  totalsData.forEach((data, index) => {
    doc.text(`${data}`, startXX, currentY2 + 10);
    startXX += columnWidths[columnArray[index]];
  });

  doc.setFont("Helvetica", "normal");
  let startXXX = boxPadding + 2;

  console.log(stoneTotalRateObj);
  console.log(stnNames);
  let totalData3 = stnNames?.map((item) => {
    return (+(stoneTotalRateObj[item] || 0))?.toFixed(3);
  });

  console.log(totalData3);
  const totalStoneRateData = ["", "Stn Rate", "", "", "", ...totalData3];
  totalStoneRateData.forEach((data, index) => {
    doc.text(`${data}`, startXXX, currentY2 + 13);
    startXXX += columnWidths[columnArray[index]];
  });

  doc.setFont("Helvetica", "Bold");
  let startXXXX = boxPadding + 2;
  const totalData4 = stnNames?.map((item) => {
    return (
      +(stoneTotalRateObj[item] || 0) * +(stoneTotalObj[item] || 0)
    )?.toFixed(3);
  });
  const totalStoneAmtData = ["", "Stn Amt", "", "", "", ...totalData4];
  totalStoneAmtData.forEach((data, index) => {
    doc.text(`${data}`, startXXXX, currentY2 + 16);
    startXXXX += columnWidths[columnArray[index]];
  });

  // if (rowStartY + 70 > pageHeight - 10) {

  //   doc.addPage();
  //   rowStartY = 10;
  // }

  doc.setFont("Helvetica", "normal");
  doc.setFontSize(7);
  doc.rect(boxWidth - 45, currentY2 + 20, boxWidth / 4, 47);

  let metal = 0;
  let metalToCash = 0;
  let cashToMetal = 0;
  let cash = 0;
  let card = 0;
  let upi = 0;
  let cheque = 0;
  let rtgs = 0;
  mainitem?.Payments?.forEach((item) => {
    if (item?.PaymentModeType == "Cash") {
      cash += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Card") {
      card += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "UPI") {
      upi += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Cheque") {
      cheque += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "RTGS") {
      rtgs += +(item?.Amount || 0);
    }
    if (item?.PaymentModeType == "Metal to Cash") {
      metalToCash += +(item?.GoldAmount || item?.SilverAmount || 0);
    }
    if (item?.PaymentModeType == "Metal") {
      metal += +(item?.OldGoldGrossWt || item?.OldSilverGrossWt || 0);
    }
    if (item?.PaymentModeType == "Cash to Metal") {
      cashToMetal += +(item?.OldGoldGrossWt || item?.OldSilverGrossWt || 0);
    }
  });
  doc.rect(boxPadding, currentY2 + 20, boxWidth / 4, 47);

  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(7);
  doc.text(
    `Payable Amount             ${(
      +(mainitem?.TotalNetAmount || 0) +
      +(mainitem?.GST || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    )?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 25
  );

  doc.setFont("Helvetica", "Normal");
  doc.setFontSize(7);
  doc.text(
    `Cash                                     ${(cash || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 30
  );
  doc.text(
    `Card                                      ${(card || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 35
  );
  doc.text(
    `UPI                                        ${(upi || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 40
  );
  doc.text(
    `Cheque                                  ${(cheque || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 45
  );
  doc.text(
    `RTGS                                    ${(rtgs || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 50
  );
  doc.text(
    `Metal to Cash                        ${(metalToCash || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 55
  );

  doc.text(
    `Cash to Metal                        ${(cashToMetal || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 60
  );
  doc.text(
    `Metal                                     ${(metal || 0)?.toFixed(3)}`,
    boxPadding + 2,
    currentY2 + 65
  );

  doc.text(
    `Stone Charg            ${(+(stoneCharge || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 25
  );
  doc.text(
    `Huid Charg              ${(+(HallmarkAmountTotal || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 31
  );
  doc.text(
    `Courier Charg          ${(+(mainitem?.CourierCharge || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 37
  );
  doc.text(
    `GST                         ${(+(mainitem?.TotalGSTAmount || 0))?.toFixed(
      3
    )}`,
    boxPadding + 162,
    currentY2 + 43
  );
  doc.text(
    `TDS Amount            ${(+(mainitem?.TDS || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 51
  );
  // doc.text(`Gold Value               ${"0.00"}`, boxPadding + 162,rowStartY+45  );
  doc.setFont("Helvetica", "Bold");
  doc.setFontSize(7);
  console.log(stoneCharge);
  console.log(HallmarkAmountTotal);
  console.log(mainitem?.CourierCharge);
  console.log(mainitem?.TotalGSTAmount);
  console.log(mainitem?.TotalAmount);
  doc.text(
    `Payable Amt         ${(+(
      (
        +(stoneCharge || 0) +
        +(HallmarkAmountTotal || 0) +
        +(mainitem?.CourierCharge || 0) +
        +(mainitem?.TotalGSTAmount || 0)
      )

      // +(mainitem?.TotalAmount || 0) || 0
    ))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 57
  );
  doc.setFont("Helvetica", "normal");
  doc.setFontSize(7);
  doc.text(
    `Net Balance           ${(+(mainitem?.BalanceAmount || 0))?.toFixed(3)}`,
    boxPadding + 162,
    currentY2 + 63
  );

  // Generate the PDF and open it in a new window
  const pdfData = doc?.output("datauristring");
  const newWindow = window?.open();
  newWindow?.document?.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}

function generateKaldanInvoice(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 54.5 + 10; // Top margin for the box
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 40;

  doc.line(0, 54.5, 210, 54.5); // Draw a horizontal line

  // Set up customer details
  const address = `${customer.CurrAddStreet || "NA"}, ${
    customer?.CurrAddTown || ""
  }, ${customer?.CurrAddPincode || ""}`;

  // Billing information
  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height
  doc.setFont("sanserif", "bold");
  doc.setFontSize(16);
  doc.text("KALDAN JEWELS", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3);
  doc.setFontSize(10);

  const billingDetails = [
    `Billing Name And Address: ${customer?.FirstName?.toUpperCase()} ${address.toUpperCase()}`,
    `Bill No: ${InvoiceNo}`,
    `Date: ${InvoiceDate}`,
    `PAN: ${customer?.PanNo || "NA"}`,
    `GSTIN No: ${customer?.GSTIN || "NA"}`,
  ];

  let startY = boxTopMargin + 8;
  billingDetails.forEach((detail) => {
    doc.text(detail, boxPadding + 2, startY);
    startY += 6;
  });

  const rowHeight = 10; // Height per item row
  let tableStartY = startY; // Start of the table

  const columnWidths = {
    "SL No": 13.18,
    Item: 66.18,
    HSN: 26.18,
    "Net wt": 20.18,
    "Rate/gm": 24.18,
    Amount: 50.18,
  };

  const columnArray = ["SL No", "Item", "HSN", "Net wt", "Rate/gm", "Amount"];

  // Function to render table headers
  function renderHeaders(currentY) {
    let startX = boxPadding; // Starting X position for table
    columnArray.forEach((col) => {
      doc.text(col, startX + 2, currentY + 8);
      startX += columnWidths[col];

      doc.line(5, 112, 205, 112); //horizontal line after table headers
    });

    // Draw vertical lines for headers
    startX = boxPadding;
    columnArray.forEach((col, index) => {
      // if(index == columnArray.length - 1){
      //   return
      // }
      doc.line(startX, currentY + 2, startX, currentY + rowHeight + 3); // Vertical line
      startX += columnWidths[col];
      // if (index === columnArray.length - 1) {
      //   doc.line(startX, currentY +2  , startX, currentY + rowHeight + 3); // Last vertical line
      // }
    });
  }

  // Ensure headers on the first page
  renderHeaders(tableStartY);
  tableStartY += 7; // Adjust for the first header row

  // Draw table and handle borders
  let rowStartY = tableStartY;

  let tableHeightUsed = 0;
  items.forEach((item, index) => {
    if (rowStartY + rowHeight > pageHeight - 5) {
      // Check space at the bottom
      // Draw table border for the previous page
      const contentHeight = rowStartY - tableStartY;
      // doc.rect(boxPadding, tableStartY, boxWidth, contentHeight);
      // Add a horizontal line before adding a new page
      // doc.line(5, rowStartY, 205, rowStartY);
      tableHeightUsed += rowStartY - tableStartY;

      doc.addPage(); // Add a new page
      rowStartY = 3; // Reset Y position for the new page
      tableStartY = rowStartY; // Update table start Y for the new page

      // Draw a new table border for the new page
      renderHeaders(rowStartY - 2);
      rowStartY += 7; // Position after headers
      doc.line(5, 10, 205, 10); //horizontal line after table headers
    }

    let startX = boxPadding + 2; // Reset startX for each new row
    const itemData = [
      index + 1,
      item.ProductName,
      item.HSNCode,
      item.NetWt,
      item.MetalRate,
      item.TotalItemAmount || item.MRP,
    ];

    itemData.forEach((data, colIndex) => {
      doc.text(`${data}`, startX, rowStartY + 8);
      startX += columnWidths[columnArray[colIndex]];
    });

    // Draw vertical lines for table rows
    startX = boxPadding;
    columnArray.forEach((col, colIndex) => {
      doc.line(startX, rowStartY, startX, rowStartY + rowHeight); // Vertical line for each column
      startX += columnWidths[col];
      if (colIndex === columnArray.length - 1) {
        doc.line(startX, rowStartY - 5, startX, rowStartY + rowHeight); // Last vertical line
      }
    });

    rowStartY += rowHeight; // Move to the next row
  });

  // Store the final table height used on the last page
  tableHeightUsed += rowStartY - tableStartY;

  // Additional contents (for example, terms, conditions, signatures, etc.)
  let contentStartY = rowStartY + 10; // Start below the table

  // Draw final table border for the last page
  let finalContentHeight = rowStartY - tableStartY;

  if (contentStartY + 20 > pageHeight) {
    // Draw final table border for the last page
    finalContentHeight = rowStartY - tableStartY + 4;
  }

  if (contentStartY + 20 > pageHeight) {
    doc.addPage(); // Add a new page
    contentStartY = 10; // Reset Y on new page
  }

  //  doc.rect(boxPadding, tableStartY, boxWidth, finalContentHeight + 5);

  console.log("tableStartY ->", tableStartY);

  //  doc.line(5, tableHeightUsed, 205, tableHeightUsed); //horizontal line after table last row

  // Add horizontal line after the last row of the table
  if (rowStartY <= pageHeight - 5) {
    // Ensure horizontal line is added at the end of the table
    doc.line(5, rowStartY, 205, rowStartY);
  }

  function checkAndAddPage(currentY, sectionHeight) {
    if (currentY + sectionHeight > pageHeight - 20) {
      // Adjust to prevent cutoff
      doc.addPage();
      return 10; // Reset Y position for new page
    }
    return currentY;
  }

  // Draw the amount in words section
  rowStartY = checkAndAddPage(rowStartY, 25);
  const boxPadding2 = 5;
  const boxWidth2 = pageWidth - 2 * boxPadding2;
  const boxHeight2 = 25;

  doc.rect(boxPadding2, rowStartY, boxWidth2 - 60, boxHeight2);
  doc.setFontSize(10);
  doc.text("Amount in words", boxPadding2 + 2, rowStartY + 5);
  //  doc.text(toWords(mainitem?.TotalNetAmount) , boxPadding2 + 2, rowStartY + 10);
  // Convert amount to words and format properly
  let words = toWords(
    `${
      +(mainitem?.TotalAmount || 0) +
      +(mainitem?.TotalGSTAmount || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    }`
  )
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()); // Capitalize first letter of each word

  words.push("Only"); // Append "Only" at the end

  let finalText = words.join(" "); // Join words back into a single line

  // Add text to PDF
  doc.text(finalText, boxPadding2 + 2, rowStartY + 10);

  // Draw the total, IGST, and net amount table
  rowStartY = checkAndAddPage(rowStartY, 25);
  const summaryTableX2 = pageWidth - 60;
  const summaryTableY2 = rowStartY;
  const summaryTableWidth2 = 55;
  const summaryTableHeight2 = 25;

  doc.rect(
    summaryTableX2,
    summaryTableY2,
    summaryTableWidth2,
    summaryTableHeight2
  );
  doc.line(
    summaryTableX2,
    summaryTableY2 + 8,
    summaryTableX2 + summaryTableWidth2,
    summaryTableY2 + 8
  );
  doc.line(
    summaryTableX2,
    summaryTableY2 + 16,
    summaryTableX2 + summaryTableWidth2,
    summaryTableY2 + 16
  );

  doc.text("Total", summaryTableX2 + 2, summaryTableY2 + 5);
  doc.text(`${mainitem?.TotalAmount}`, summaryTableX2 + 40, summaryTableY2 + 5);
  doc.text("IGST 3%", summaryTableX2 + 2, summaryTableY2 + 13);
  doc.text(
    `${mainitem?.TotalGSTAmount}`,
    summaryTableX2 + 40,
    summaryTableY2 + 13
  );
  doc.text("Net Amt", summaryTableX2 + 2, summaryTableY2 + 21);
  doc.text(
    `${
      +(mainitem?.TotalAmount || 0) +
      +(mainitem?.TotalGSTAmount || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    }`,
    summaryTableX2 + 40,
    summaryTableY2 + 21
  );

  // Draw the bank details section
  rowStartY = checkAndAddPage(rowStartY + 25, 30);
  doc.rect(boxPadding2, rowStartY, boxWidth2, 30);
  doc.setFontSize(10);
  doc.text("Bank Details", boxPadding2 + 2, rowStartY + 5);
  doc.text("Bank Name: Kotak Mahindra Bank", boxPadding2 + 2, rowStartY + 10);
  doc.text("AC/NO: 97632815103", boxPadding2 + 2, rowStartY + 15);
  doc.text("Branch: South Shivaji Nagar", boxPadding2 + 2, rowStartY + 20);
  doc.text("IFSC: KBID0008280", boxPadding2 + 2, rowStartY + 25);

  // Draw the terms and conditions section
  rowStartY = checkAndAddPage(rowStartY + 35, 30);
  doc.rect(boxPadding2, rowStartY, boxWidth2, 30);
  doc.setFontSize(10);
  doc.text("Terms & Conditions", boxPadding2 + 2, rowStartY + 5);
  doc.setFontSize(6);
  doc.setFont("helvetica", "normal"); // Set font family and weight (normal)
  doc.text(
    "1) Our Responsibility ceases after delivery of goods",
    boxPadding2 + 2,
    rowStartY + 10
  );
  doc.text(
    "2) Intes of @24% per annum will be charged for  bills not paid within 15 days.",
    boxPadding2 + 2,
    rowStartY + 15
  );

  doc.text(
    "3) Goods once sold will not be taken back",
    boxPadding2 + 2,
    rowStartY + 20
  );
  doc.text(
    "4) Subjected to Bangalore Jurisdiction.",
    boxPadding2 + 2,
    rowStartY + 25
  );

  // Draw the footer section
  rowStartY = checkAndAddPage(rowStartY + 35, 20);
  doc.setFontSize(7);
  doc.setFont("helvetica", "bold");
  doc.text(
    "Kandan Deeps No. 109, Second Floor, Shop No. 201, Nagarthpet, Sree Dharmarayaswamy Temple Road, Bengaluru - 560002",
    boxPadding2 + 2,
    rowStartY + 1
  );

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}

function kaldanInvoiceNew(items, customer, mainitem, adminLoggedIn) {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  console.log(mainitem);

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  const boxTopMargin = 54.5 + 10; // Top margin for the box
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 40;

  const imageWidth = 80; // Adjust width as needed
  const imageHeight = 30; // Adjust height as needed
  const imageX = (pageWidth - imageWidth) / 2;
  let yPosition = 18; // Initial Y position
  const imageY = yPosition; // Position at the top

  doc.addImage(KaldanHeader, "PNG", imageX, imageY, imageWidth, imageHeight);

  doc.line(5, 50, 205, 50);

  console.log(mainitem);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Dear, ${mainitem?.Customer.FirstName}`, 10, 60);
  doc.text(`Date : ${mainitem?.InvoiceDate}`, 170, 60);
  doc.text("I hope this message finds you well.", 10, 67);
  doc.text(
    "Please find attached the estimation, as requested. The breakdown includes all the relevant details, ",
    10,
    80
  );
  doc.text(
    "and we believe this will give you a clear picture of the scope and costs involved. ",
    10,
    85
  );
  doc.text(
    "If you have any questions or would like to discuss any part of the estimation, please don't hesitate to ",
    10,
    95
  );
  doc.text("reach out. I'm happy to provide further clarification.", 10, 100);
  doc.text("Looking forward to hearing from you.", 10, 110);
  doc.text("Best regards.", 10, 120);

  const pageWidth3 = doc.internal.pageSize.getWidth();
  const pageHeight3 = doc.internal.pageSize.getHeight();
  const margin3 = 10;
  const startY3 = 130;
  const rowHeight3 = 10;
  const colWidths3 = [40, 18, 18, 28, 23, 28, 35]; // Adjusted for given table

  // Define table columns
  const columns3 = [
    "Particulars",
    "Weight",
    "Rate/gm",
    "Amt",
    "VA/gm",
    "Amt",
    "Total",
  ];

  // Draw table header
  let x3 = margin3;
  let y3 = startY3;

  doc.setFont("helvetica", "bold");
  // doc.text("ESTIMATE", pageWidth3 / 2 - 10, y3 - 5);
  doc.setFont("helvetica", "normal");

  // columns3.forEach((col, index) => {
  //   doc.rect(x3, y3, colWidths3[index], rowHeight3); // Draw header cell
  //   doc.text(col, x3 + 2, y3 + 7);
  //   x3 += colWidths3[index];
  // });

  // Draw table rows dynamically
  y3 += rowHeight3;
  doc.setFont("helvetica", "normal");

  // console.log('items oo', items);

  console.log("mainitem", mainitem);

  // items.forEach((item) => {
  //   x3 = margin3;
  //   const rowData3 = [
  //     item?.ProductName || "",
  //     item?.NetWt ? item?.NetWt?.toString() : "",
  //     item?.MetalRate ? item?.MetalRate?.toString() : "",
  //     (+(item?.NetWt || 0) * +(item?.MetalRate || 0))?.toString(),
  //     item?.MakingPerGram ? item?.MakingPerGram?.toString() : "",
  //     `${(+(item?.MakingPerGram || 0) * +(item?.NetWt || 0) || 0)?.toFixed(3)}`,
  //     item?.MRP
  //       ? item?.MRP?.toString()
  //       : item?.TotalItemAmount
  //       ? item?.TotalItemAmount?.toString()
  //       : "",
  //   ];

  //   rowData3.forEach((data, index) => {
  //     doc.rect(x3, y3, colWidths3[index], rowHeight3); // Draw row cell
  //     doc.text(data, x3 + 2, y3 + 7);
  //     x3 += colWidths3[index];
  //   });
  //   y3 += rowHeight3;

  //   // Check if the next row will exceed the page height
  //   if (y3 + rowHeight3 > pageHeight3 - margin3) {
  //     doc.addPage();
  //     y3 = margin3;
  //     x3 = margin3;
  //     columns3.forEach((col, index) => {
  //       doc.rect(x3, y3, colWidths3[index], rowHeight3);
  //       doc.text(col, x3 + 2, y3 + 7);
  //       x3 += colWidths3[index];
  //     });
  //     y3 += rowHeight3;
  //   }
  // });

  // Ensure there's enough space for bank details

  const bankDetailsHeight = 30; // Height required for bank details
  if (y3 + bankDetailsHeight > pageHeight3 - margin3) {
    doc.addPage();
    y3 = margin3;
  }

  // // Add new page before the table
  // doc.addPage();

  // // Add logo and message at the top
  // const imageWidth2 = 80;
  // const imageHeight2 = 30;
  // const imageX2 = (pageWidth - imageWidth) / 2;
  // const imageY2 = 10;
  // doc.addImage(
  //   KaldanHeader,
  //   "PNG",
  //   imageX2,
  //   imageY2,
  //   imageWidth2,
  //   imageHeight2
  // );
  // doc.setFontSize(14);
  // doc.text("MSG", pageWidth / 2 - 30, imageY2 + imageHeight2 + 10, {
  //   align: "center",
  // });

  // doc.line(5, 40, 205, 40);

  // Table Headers
  let startY = 130;
  const colWidths = [15, 25, 35, 20, 20, 25, 25, 25];
  const columns = [
    "Sl No",
    "Design Code",
    "Design Picture",
    "Nt wt",
    "Gr Wt",
    "Rate/gm",
    "VA/Gm",
    "Amount",
  ];
  let x = 10;

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");

  columns.forEach((col, index) => {
    doc.rect(x, startY, colWidths[index], 10);
    doc.text(col, x + 2, startY + 7);
    x += colWidths[index];
  });

  startY += 10;

  console.log(items);
  console.log(mainitem);

  doc.setFont("helvetica", "normal");
  // Table Data
  items.forEach((item, rowIndex) => {
    x = 10;
    const rowData = [
      (rowIndex + 1).toString(),
      item?.ItemCode || "",
      "[IMG]", // Placeholder for Design Picture
      item?.NetWt ? item?.NetWt?.toString() : "",
      item?.GrossWt ? item?.GrossWt?.toString() : "",
      item?.MetalRate ? item?.MetalRate?.toString() : "",
      item?.MakingPerGram ? item?.MakingPerGram?.toString() : "",
      item?.MRP
        ? item?.MRP?.toString()
        : item?.TotalItemAmount
        ? item?.TotalItemAmount
        : "",
    ];

    rowData.forEach((data, index) => {
      doc.rect(x, startY, colWidths[index], 10);
      doc.text(data, x + 2, startY + 7);
      x += colWidths[index];
    });
    startY += 10;

    if (startY + 20 > pageHeight) {
      doc.addPage();
      startY = 20;
    }
  });

  let y4 = +y3 + 40;
  // Draw the bank details section

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("Bank Details", margin3 + 2, startY + 30);
  doc.setFont("helvetica", "normal");
  doc.text("Bank Name: Kotak Mahindra Bank", margin3 + 2, startY + 35);
  doc.text("IFSC Code: KKBK0008082", margin3 + 140, startY + 35);
  doc.text("Acc No: 97439 81235", margin3 + 2, startY + 40);
  doc.text("Branch: Race Course Road", margin3 + 140, startY + 40);

  // Bottom Section (Aligned with table width)
  // startY ;
  doc.setFontSize(10);

  doc.rect(10, startY, pageWidth - 20, 10);
  doc.text("GST @3%", 165, startY + 7);
  doc.text(
    mainitem?.TotalGSTAmount?.toString() || 0,
    pageWidth - 26,
    startY + 7
  );

  startY += 10;
  doc.rect(10, startY, pageWidth - 20, 10);
  doc.text("Total", 170, startY + 7);
  // doc.text(mainitem.TotalAmount.toString(), pageWidth - 23, startY + 7);
  doc.text(
    `${(
      +(mainitem?.TotalAmount || 0) +
      +(mainitem?.TotalGSTAmount || 0) +
      +(mainitem?.TDS || 0) +
      +(mainitem?.CourierCharge || 0) -
      +(mainitem?.Offer || 0)
    )?.toFixed(3)}`,
    pageWidth - 28,
    startY + 7
  );

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
}
//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: "a4",
//   });

//   // GSTIN & Invoice Header
//   doc.setFontSize(10);
//   doc.text("GSTIN: 24AYPB4952C1ZA", 160, 10);
//   doc.setFontSize(14);
//   doc.text("TAX INVOICE", 90, 20);

//   // Invoice Details
//   doc.setFontSize(10);
//   doc.text("Invoice No.: 95", 14, 30);
//   doc.text("Invoice Dt.: 21-Feb-2020", 14, 35);
//   doc.text("Invoice Time: 10:40:24AM", 14, 40);
//   doc.text("Place of Supply: Gujarat", 150, 30);
//   doc.text("Terms of Delivery:", 150, 35);

//   // Customer Information
//   doc.text("Invoice To:", 14, 50);
//   doc.text("Rohit Mishra", 14, 55);
//   doc.text("Address Line No. 1, Address Line No. 2, Vadodara", 14, 60);
//   doc.text("State: Gujarat", 14, 65);
//   doc.text("Mobile No.: 9898098980", 150, 60);
//   doc.text("PAN No.: AKQPQ5486N", 150, 65);

//   // Draw Table Headers
//   doc.setFontSize(10);
//   doc.text("Sr.", 14, 80);
//   doc.text("Product Details", 24, 80);
//   doc.text("Pcs", 54, 80); // Adjusted width
//   doc.text("Purity", 64, 80);
//   doc.text("Gross Wt", 84, 80); // Adjusted for text width
//   doc.text("Net Wt", 104, 80); // Adjusted for text width
//   doc.text("Rate / gm", 124, 80); // Adjusted for text width
//   doc.text("Amount", 144, 80);
//   doc.text("Labour Rate", 164, 80); // Adjusted for header width
//   doc.text("Labour Amt", 184, 80); // Adjusted for header width
//   doc.text("Total", 204, 80);

//   // Draw Table Borders
//   doc.line(10, 85, 200, 85); // Top line
//   doc.line(10, 90, 200, 90); // Table header bottom line

//   // Draw Column Separators
//   doc.line(10, 85, 10, 150); // Left border, extended for half-page height
//   doc.line(20, 85, 20, 150); // After Sr
//   doc.line(50, 85, 50, 150); // After Product Details
//   doc.line(60, 85, 60, 150); // After Pcs
//   doc.line(80, 85, 80, 150); // After Purity
//   doc.line(100, 85, 100, 150); // After Gross Wt
//   doc.line(120, 85, 120, 150); // After Net Wt
//   doc.line(140, 85, 140, 150); // After Rate / gm
//   doc.line(160, 85, 160, 150); // After Amount
//   doc.line(180, 85, 180, 150); // After Labour Rate
//   doc.line(200, 85, 200, 150); // After Labour Amt
//   doc.line(210, 85, 210, 150); // Right border, extended for half-page height

//   // Insert Product Row
//   doc.text("1", 14, 95);
//   doc.text("Gold Ring", 24, 95);
//   doc.text("1", 54, 95);
//   doc.text("22K", 64, 95);
//   doc.text("11.35", 84, 95);
//   doc.text("10.67", 104, 95);
//   doc.text("3980", 124, 95);
//   doc.text("42466.60", 144, 95);
//   doc.text("500.00", 164, 95);
//   doc.text("5335.00", 184, 95);
//   doc.text("47801.60", 204, 95);

//   // Draw Row Bottom Line
//   doc.line(10, 100, 200, 100); // Row bottom line

//   // Summary Section
//   doc.text("HSN/SAC: 7108", 14, 110);
//   doc.text("Taxable Amount: 47801.60", 14, 115);
//   doc.text("CGST @ 1.50%: 717.02", 14, 120);
//   doc.text("SGST @ 1.50%: 717.02", 14, 125);
//   doc.text("IGST: 0.00", 14, 130);
//   doc.text("Round Off: 0.36", 14, 135);

//   // Total Amount
//   doc.setFontSize(12);
//   doc.text("Grand Total: 49236.00", 160, 135);

//   // Footer
//   doc.setFontSize(10);
//   doc.text("Rupees Forty Nine Thousand Two Hundred Thirty Six Only", 14, 145);
//   doc.text("For Manan Softwares", 160, 155);
//   doc.text("Authorised Signatory", 160, 160);

//   // Save the PDF
//   // doc.save("invoice.pdf");

//   const pdfData = doc.output("datauristring");
//   const newWindow = window.open();
//   newWindow.document.write(
//     `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
//   );
// };

const generateDummyData = () => {
  const stonesNames = [
    "stone1",
    "stone2",
    "stone3",
    "stone4",
    "stone5",
    "stone6",
    "stone7",
    "stone8",
  ];

  // Helper function to generate random stones array
  const generateRandomStones = () => {
    const numberOfStones = Math.floor(Math.random() * (8 - 3 + 1)) + 3; // Random number between 3 and 8
    const shuffledStones = stonesNames
      .sort(() => 0.5 - Math.random())
      .slice(0, numberOfStones);

    return shuffledStones.map((stone) => ({
      stonename: stone,
      stoneweight: (Math.random() * (5 - 1) + 1).toFixed(2), // Random stone weight between 1 and 5
    }));
  };

  const dummyData = [];

  for (let i = 1; i <= 20; i++) {
    dummyData.push({
      sno: i,
      design: `Design ${i}`,
      productdetail: `Product ${i}`,
      grosswt: (Math.random() * (100 - 50) + 50).toFixed(2), // Random gross weight between 50 and 100
      Stones: generateRandomStones(),
      netwt: (Math.random() * (90 - 40) + 40).toFixed(2), // Random net weight between 40 and 90
    });
  }

  return dummyData;
};

const generateinvoicepdf3old1 = async (items1, customer, mainitem) => {
  const items = generateDummyData();
  console.log("checking original items ", items1);
  console.log("checking items", items);
  console.log("checking customer", customer);

  const doc = new jsPDF({
    orientation: "landscape", // Change orientation to landscape
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const marginTop = 15;

  let tableHeight = 170; // Fixed table height
  let currentY = marginTop;

  // Check for maximum stones, handling empty stones array
  const maxStones = Math.max(0, ...items.map((item) => item.Stones.length));

  console.log("chek maxstones ", maxStones);

  doc.setFontSize(12);
  doc.setFont("sanserif", "bold");
  doc.text("Customer Name: ", 10, 10);

  // Adjusted column positions for a landscape layout and wider stones columns
  const columnPositions = {
    sr: 10, // Start from 10mm
    Design: 20,
    productDetails: 40,
    Gwt: 75,
    stones: 95, // Widen the "stones" column
    nwt: 178,
    stoneamt: 198, // Widen the "stoneamt" column
  };

  // Draw the table structure dynamically
  const drawTableStructure = () => {
    Object.values(columnPositions).forEach((pos) => {
      doc.line(pos, marginTop, pos, marginTop + tableHeight); // Column separators
    });
    doc.line(
      pageWidth - 10,
      marginTop,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Right border
  };

  const stoneWeightSpace = columnPositions.nwt - columnPositions.stones;
  const stoneAmountSpace = pageWidth - columnPositions.stoneamt - 10;

  // Dynamic cell width for stones, ensuring we don't divide by zero
  const stoneWeightCellWidth = maxStones > 0 ? stoneWeightSpace / maxStones : 0;
  const stoneAmountCellWidth = maxStones > 0 ? stoneAmountSpace / maxStones : 0;

  const drawTableHeader = () => {
    doc.setFontSize(10);
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header top line
    currentY += 5;

    // Draw the header text
    doc.text("Sr", columnPositions.sr + 2, currentY);
    doc.text("Design", columnPositions.Design + 2, currentY);
    doc.text("Product Details", columnPositions.productDetails + 2, currentY);
    doc.text("G Wt", columnPositions.Gwt + 2, currentY);
    doc.text("Stones Wt", columnPositions.stones + 2, currentY); // Adjusted position for Stones Wt
    doc.text("N Wt", columnPositions.nwt + 2, currentY);
    doc.text("Stones Amount", columnPositions.stoneamt + 2, currentY); // Adjusted position for Stones Amount

    currentY += 1;
    doc.line(columnPositions.sr, currentY + 5, pageWidth - 10, currentY + 5); // Table header bottom line

    // Print dynamic stone names for "Stones Wt" sub-columns
    for (let i = 0; i < maxStones; i++) {
      const stoneWeightX = columnPositions.stones + i * stoneWeightCellWidth;
      doc.line(
        stoneWeightX,
        currentY + 5,
        stoneWeightX,
        marginTop + tableHeight
      );
    }

    // Print dynamic stone names for "Stones Amount" sub-columns
    for (let i = 0; i < maxStones; i++) {
      const stoneAmountX = columnPositions.stoneamt + i * stoneAmountCellWidth;
      doc.line(
        stoneAmountX,
        currentY + 5,
        stoneAmountX,
        marginTop + tableHeight
      );
    }

    // Print dynamic stone names for "Stones Wt" and "Stones Amount" sub-columns
    items.forEach((item) => {
      for (let i = 0; i < item.Stones.length; i++) {
        const stoneName = item.Stones[i].stonename.slice(0, 3); // Get the stone name from the item data

        // Position stone names under "Stones Wt" column
        const stoneWeightX = columnPositions.stones + i * stoneWeightCellWidth;
        doc.text(stoneName, stoneWeightX + 2, currentY + 10);

        // Position stone names under "Stones Amount" column
        const stoneAmountX =
          columnPositions.stoneamt + i * stoneAmountCellWidth;
        doc.text(stoneName, stoneAmountX + 2, currentY + 10);
      }
    });

    // Final lines for the last stone sub-columns, only if there are stones
    if (maxStones > 0) {
      const finalStoneWeightX =
        columnPositions.stones + maxStones * stoneWeightCellWidth;
      const finalStoneAmountX =
        columnPositions.stoneamt + maxStones * stoneAmountCellWidth;

      console.log("maxStones:", maxStones);
      console.log("stoneWeightCellWidth:", stoneWeightCellWidth);
      console.log("finalStoneWeightX:", finalStoneWeightX);

      doc.line(
        finalStoneWeightX,
        currentY,
        finalStoneWeightX,
        marginTop + tableHeight
      );
      doc.line(
        finalStoneAmountX,
        currentY,
        finalStoneAmountX,
        marginTop + tableHeight
      );
    }

    currentY += 10;
    doc.line(columnPositions.sr, currentY + 5, pageWidth - 10, currentY + 5); // Table header bottom line
    currentY += 5;

    doc.line(
      columnPositions.sr,
      marginTop + tableHeight,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Bottom line
  };

  const drawTableRow = (item, rowIndex) => {
    const rowHeight = 10;
    const startY = currentY + 10;

    // Print row number (Sr)
    doc.text(`${rowIndex + 1}`, columnPositions.sr + 2, startY);

    // Print Design (assuming the item has a design property)
    doc.text(item.design || "", columnPositions.Design + 2, startY);

    // Print Product Details
    doc.text(
      item.productdetail || "",
      columnPositions.productDetails + 2,
      startY
    );

    // Print G Wt (Gross Weight)
    doc.text(item.grosswt || "0.00", columnPositions.Gwt + 2, startY);

    // Print Stones Wt (for each stone in item), handle empty stones array
    item.Stones.forEach((stone, index) => {
      const stoneWeightX =
        columnPositions.stones + index * stoneWeightCellWidth;
      doc.text(stone.stoneweight || "0.00", stoneWeightX + 2, startY);
    });

    // Print N Wt (Net Weight)
    doc.text(item.netwt || "0.00", columnPositions.nwt + 2, startY);

    // Print Stones Amount (for each stone in item), handle empty stones array
    item.Stones.forEach((stone, index) => {
      const stoneAmountX =
        columnPositions.stoneamt + index * stoneAmountCellWidth;
      doc.text(stone.stoneamount || "0.00", stoneAmountX + 2, startY);
    });

    currentY += rowHeight; // Move to the next row position
  };

  const drawTableContent = () => {
    const rowHeight = 10; // Set row height here for consistency
    const maxRowsPerPage = 14; // Maximum rows per page

    let currentPageItems = []; // To store items for the current page
    let pageIndex = 0; // To track the current page index
    let globalRowIndex = 0; // To track the overall row index (for Sr number)

    let grandTotalGrossWt = 0;
    let grandTotalNetWt = 0;
    let grandTotalStonesWt = Array(maxStones).fill(0); // Array for each stone's total weight
    let grandTotalStonesAmt = Array(maxStones).fill(0); // Array for each stone's total amount

    // Split items into groups of 7 per page
    for (let i = 0; i < items.length; i += maxRowsPerPage) {
      currentPageItems = items.slice(i, i + maxRowsPerPage); // Get 7 items for the current page

      // If it's not the first page, add a new page and re-draw header and structure
      if (pageIndex > 0) {
        doc.addPage();
        tableHeight = 180; // Adjust the table height for subsequent pages
        drawTableStructure();
        drawTableHeader();
      }

      currentPageItems.forEach((item, index) => {
        drawTableRow(item, globalRowIndex);
        globalRowIndex++; // Increment overall row index
        grandTotalGrossWt += parseFloat(item.grosswt) || 0;
        grandTotalNetWt += parseFloat(item.netwt) || 0;

        // Accumulate total stone weights and amounts
        item.Stones.forEach((stone, stoneIndex) => {
          grandTotalStonesWt[stoneIndex] += parseFloat(stone.stoneweight) || 0;
          grandTotalStonesAmt[stoneIndex] += parseFloat(stone.stoneamount) || 0;
        });
      });

      pageIndex++; // Increment page index
    }

    // Draw grand total at the end
    currentY += 10; // Leave space for total
    doc.setFontSize(12);
    doc.setFont("sanserif", "bold");
    doc.text("Grand Total", columnPositions.sr + 2, currentY);
    doc.text(grandTotalGrossWt.toFixed(2), columnPositions.Gwt + 2, currentY);
    doc.text(grandTotalNetWt.toFixed(2), columnPositions.nwt + 2, currentY);

    // Print totals for stones weights and amounts
    grandTotalStonesWt.forEach((weight, index) => {
      const stoneTotalX = columnPositions.stones + index * stoneWeightCellWidth;
      doc.text(weight.toFixed(2), stoneTotalX + 2, currentY);
    });

    grandTotalStonesAmt.forEach((amount, index) => {
      const stoneAmountTotalX =
        columnPositions.stoneamt + index * stoneAmountCellWidth;
      doc.text(amount.toFixed(2), stoneAmountTotalX + 2, currentY);
    });
  };

  drawTableStructure(); // Draw the initial table structure
  drawTableHeader(); // Draw the table header
  drawTableContent(); // Draw the table content

  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );

  // doc.save("invoice.pdf");
};

const generateinvoicepdf3 = async (items, customer, mainitem) => {
  console.log(items);
  console.log(customer);
  console.log(mainitem);
  const items1 = generateDummyData();
  console.log("checking original items ", items1);
  console.log("checking items", items);
  console.log("checking customer", customer);

  const doc = new jsPDF({
    orientation: "landscape", // Change orientation to landscape
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const marginTop = 15;

  let tableHeight = 170; // Fixed table height
  let currentY = marginTop;

  const maxStones = Math.max(...items.map((item) => item.Stones.length));

  console.log("chek maxstones ", maxStones);

  doc.setFontSize(12);
  doc.setFont("sanserif", "bold");
  doc.text(`Customer Name: ${customer.FirstName}`, 10, 10);

  // Adjusted column positions for a landscape layout and wider stones columns
  const columnPositions = {
    sr: 10, // Start from 10mm
    Design: 20,
    productDetails: 40,
    Gwt: 75,
    stones: 95, // Widen the "stones" column
    nwt: 178,
    stoneamt: 198, // Widen the "stoneamt" column
  };

  // Draw the table structure dynamically
  const drawTableStructure = () => {
    Object.values(columnPositions).forEach((pos) => {
      doc.line(pos, marginTop, pos, marginTop + tableHeight); // Column separators
    });
    doc.line(
      pageWidth - 10,
      marginTop,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Right border
  };

  const stoneWeightSpace = columnPositions.nwt - columnPositions.stones;
  const stoneAmountSpace = pageWidth - columnPositions.stoneamt - 10;

  // Dynamic cell width for stones
  const stoneWeightCellWidth = stoneWeightSpace / maxStones;
  const stoneAmountCellWidth = stoneAmountSpace / maxStones;

  const drawTableHeader = () => {
    doc.setFontSize(10);
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header top line
    currentY += 5;

    // Draw the header text
    doc.text("Sr", columnPositions.sr + 2, currentY);
    doc.text("Design", columnPositions.Design + 2, currentY);
    doc.text("Product Details", columnPositions.productDetails + 2, currentY);
    doc.text("G Wt", columnPositions.Gwt + 2, currentY);
    doc.text("Stones Wt", columnPositions.stones + 2, currentY); // Adjusted position for Stones Wt
    doc.text("N Wt", columnPositions.nwt + 2, currentY);
    doc.text("Stones Amount", columnPositions.stoneamt + 2, currentY); // Adjusted position for Stones Amount

    currentY += 1;
    doc.line(columnPositions.sr, currentY + 5, pageWidth - 10, currentY + 5); // Table header bottom line

    // Print dynamic stone names for "Stones Wt" sub-columns
    for (let i = 0; i < maxStones; i++) {
      const stoneWeightX = columnPositions.stones + i * stoneWeightCellWidth;
      doc.line(
        stoneWeightX,
        currentY + 5,
        stoneWeightX,
        marginTop + tableHeight
      );
    }

    // Print dynamic stone names for "Stones Amount" sub-columns
    for (let i = 0; i < maxStones; i++) {
      const stoneAmountX = columnPositions.stoneamt + i * stoneAmountCellWidth;
      doc.line(
        stoneAmountX,
        currentY + 5,
        stoneAmountX,
        marginTop + tableHeight
      );
    }

    // Print dynamic stone names for "Stones Wt" and "Stones Amount" sub-columns
    items.forEach((item) => {
      for (let i = 0; i < item.Stones.length; i++) {
        const stoneName = item.Stones[i].StoneName.slice(0, 3); // Get the stone name from the item data

        // Position stone names under "Stones Wt" column
        const stoneWeightX = columnPositions.stones + i * stoneWeightCellWidth;
        doc.text(stoneName, stoneWeightX + 2, currentY + 10);

        // Position stone names under "Stones Amount" column
        const stoneAmountX =
          columnPositions.stoneamt + i * stoneAmountCellWidth;
        doc.text(stoneName, stoneAmountX + 2, currentY + 10);
      }
    });
    if (maxStones > 0) {
      // // Final lines for the last stone sub-columns
      const finalStoneWeightX =
        columnPositions.stones + maxStones * stoneWeightCellWidth;
      const finalStoneAmountX =
        columnPositions.stoneamt + maxStones * stoneAmountCellWidth;

      console.log("maxStones:", maxStones);
      console.log("stoneWeightCellWidth:", stoneWeightCellWidth);
      console.log("finalStoneWeightX:", finalStoneWeightX);

      doc.line(
        finalStoneWeightX,
        currentY,
        finalStoneWeightX,
        marginTop + tableHeight
      );
      doc.line(
        finalStoneAmountX,
        currentY,
        finalStoneAmountX,
        marginTop + tableHeight
      );

      currentY += 10;
      doc.line(columnPositions.sr, currentY + 5, pageWidth - 10, currentY + 5); // Table header bottom line
      currentY += 5;

      doc.line(
        columnPositions.sr,
        marginTop + tableHeight,
        pageWidth - 10,
        marginTop + tableHeight
      ); // Bottom line
    }
  };

  const drawTableRow = (item, rowIndex) => {
    const rowHeight = 10;
    const startY = currentY + 10;

    // Print row number (Sr)
    doc.text(`${rowIndex + 1}`, columnPositions.sr + 2, startY);

    // Print Design (assuming the item has a design property)
    doc.text(item.ItemCode || "", columnPositions.Design + 2, startY);

    // Print Product Details
    doc.text(
      item.ProductName || "",
      columnPositions.productDetails + 2,
      startY
    );

    // Print G Wt (Gross Weight)
    doc.text(item.GrossWt || "0.00", columnPositions.Gwt + 2, startY);

    // Print Stones Wt (for each stone in item)
    item.Stones.forEach((stone, index) => {
      const stoneWeightX =
        columnPositions.stones + index * stoneWeightCellWidth;
      doc.text(stone.StoneWeight, stoneWeightX + 2, startY);
    });

    // Print N Wt (Net Weight)
    doc.text(item.NetWt || "0.00", columnPositions.nwt + 2, startY);

    // Print Stones Amount (for each stone in item)
    item.Stones.forEach((stone, index) => {
      const stoneAmountX =
        columnPositions.stoneamt + index * stoneAmountCellWidth;
      doc.text(stone.StoneAmount, stoneAmountX + 2, startY);
    });

    currentY += rowHeight; // Move to the next row position
  };

  const drawTableContent = () => {
    const rowHeight = 10; // Set row height here for consistency
    const maxRowsPerPage = 14; // Maximum rows per page

    let currentPageItems = []; // To store items for the current page
    let pageIndex = 0; // To track the current page index
    let globalRowIndex = 0; // To track the overall row index (for Sr number)

    let grandTotalGrossWt = 0;
    let grandTotalNetWt = 0;
    let grandTotalStonesWt = Array(maxStones).fill(0); // Array for each stone's total weight
    let grandTotalStonesAmt = Array(maxStones).fill(0); // Array for each stone's total amount

    // Split items into groups of 7 per page
    for (let i = 0; i < items.length; i += maxRowsPerPage) {
      currentPageItems = items.slice(i, i + maxRowsPerPage); // Get 7 items for the current page

      // If it's not the first page, add a new page and re-draw header and structure
      if (pageIndex > 0) {
        doc.addPage();
        tableHeight = 100;
        currentY = marginTop; // Reset Y position on new page
        drawTableHeader(); // Re-draw the header on the new page
        drawTableStructure(); // Re-draw the table structure on the new page
      }

      // Draw the rows for the current page
      currentPageItems.forEach((item, index) => {
        drawTableRow(item, globalRowIndex); // Pass the global index for Sr number
        grandTotalGrossWt += parseFloat(item.GrossWt);
        grandTotalNetWt += parseFloat(item.NetWt);

        // Add up stone weights and amounts for each item
        item.Stones.forEach((stone, index) => {
          grandTotalStonesWt[index] += parseFloat(stone.StoneWeight);
          grandTotalStonesAmt[index] += parseFloat(stone.StoneAmount); // Sum up the stone amounts
        });

        globalRowIndex++; // Increment the global index after each row
      });

      pageIndex++; // Move to the next page
    }

    // Draw the Grand Total row at the bottom
    if (currentY + rowHeight > pageHeight - 30) {
      doc.addPage();
      currentY = marginTop; // Reset Y position on new page
      drawTableHeader(); // Re-draw the header on the new page
      drawTableStructure(); // Re-draw the table structure on the new page
    }

    // Print the "Grand Total" row
    doc.setFont("sanserif", "bold");
    currentY += rowHeight;
    doc.text("Grand ", columnPositions.sr + 15, currentY);
    doc.text("Total ", columnPositions.sr + 15, currentY + 5);

    // Print Gross Total
    doc.text(grandTotalGrossWt.toFixed(2), columnPositions.Gwt + 2, currentY);

    // Print Stones Total (for each stone column)
    for (let i = 0; i < maxStones; i++) {
      const stoneWeightX = columnPositions.stones + i * stoneWeightCellWidth;
      doc.text(grandTotalStonesWt[i].toFixed(2), stoneWeightX + 2, currentY); // Stone weight total

      const stoneAmountX = columnPositions.stoneamt + i * stoneAmountCellWidth;
      doc.text(grandTotalStonesAmt[i].toFixed(2), stoneAmountX, currentY); // Stone amount total
    }

    // Print Net Total
    doc.text(grandTotalNetWt.toFixed(2), columnPositions.nwt + 3, currentY);

    currentY += rowHeight; // Move down to the next row after Grand Total

    doc.line(10, currentY - 17, 287, currentY - 17);
  };

  drawTableHeader();
  drawTableStructure();
  drawTableContent();

  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );

  // const pdfData = doc.output("dataurlnewwindow");
  // const newWindow = window.open();
  // newWindow.document.write(
  //   `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  // );
};

const generateinvoicepdf3old = async (items1, customer, mainitem) => {
  const items = generateDummyData();
  console.log(items);
  console.log("checking items", items);
  console.log("checking customer", customer);

  const doc = new jsPDF({
    orientation: "landscape", // Change orientation to landscape
    unit: "mm",
    format: "a4",
  });

  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const marginTop = 80;
  const tableHeight = 100; // Fixed table height
  let currentY = marginTop;

  const maxStones = Math.max(...items.map((item) => item.stones.length));

  console.log("chek maxstones ", maxStones);

  // Adjusted column positions for a landscape layout and wider stones columns
  const columnPositions = {
    sr: 10, // Start from 10mm
    Design: 20,
    productDetails: 40,
    Gwt: 75,
    stones: 95, // Widen the "stones" column
    nwt: 178,
    stoneamt: 198, // Widen the "stoneamt" column
  };

  // Draw the table structure dynamically
  const drawTableStructure = () => {
    Object.values(columnPositions).forEach((pos) => {
      doc.line(pos, marginTop, pos, marginTop + tableHeight); // Column separators
    });
    doc.line(
      pageWidth - 10,
      marginTop,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Right border
  };

  const stoneWeightSpace = columnPositions.nwt - columnPositions.stones;
  const stoneAmountSpace = pageWidth - columnPositions.stoneamt - 10;

  // Dynamic cell width for stones
  const stoneWeightCellWidth = stoneWeightSpace / maxStones;
  const stoneAmountCellWidth = stoneAmountSpace / maxStones;
  const drawTableHeader = () => {
    doc.setFontSize(10);
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header top line
    currentY += 5;

    // Draw the header text
    doc.text("Sr", columnPositions.sr + 2, currentY);
    doc.text("Design", columnPositions.Design + 2, currentY);
    doc.text("Product Details", columnPositions.productDetails + 2, currentY);
    doc.text("G Wt", columnPositions.Gwt + 2, currentY);
    doc.text("Stones Wt", columnPositions.stones + 2, currentY); // Adjusted position for Stones Wt
    doc.text("N Wt", columnPositions.nwt + 2, currentY);
    doc.text("Stones Amount", columnPositions.stoneamt + 2, currentY); // Adjusted position for Stones Amount

    currentY += 1;
    doc.line(columnPositions.sr, currentY + 5, pageWidth - 10, currentY + 5); // Table header bottom line

    // Print dynamic stone names for "Stones Wt" sub-columns
    for (let i = 0; i < maxStones; i++) {
      const stoneWeightX = columnPositions.stones + i * stoneWeightCellWidth;
      // doc.text(`Stone ${i + 1}`, stoneWeightX + 2, currentY); // Replace with stone names as needed
      doc.line(
        stoneWeightX,
        currentY + 5,
        stoneWeightX,
        marginTop + tableHeight
      );
    }

    // Print dynamic stone names for "Stones Amount" sub-columns
    for (let i = 0; i < maxStones; i++) {
      const stoneAmountX = columnPositions.stoneamt + i * stoneAmountCellWidth;
      // doc.text(`Stone ${i + 1}`, stoneAmountX + 2, currentY); // Replace with stone names as needed
      doc.line(
        stoneAmountX,
        currentY + 5,
        stoneAmountX,
        marginTop + tableHeight
      );
    }

    // Print dynamic stone names for "Stones Wt" and "Stones Amount" sub-columns
    items.forEach((item) => {
      for (let i = 0; i < item.stones.length; i++) {
        const stoneName = item.stones[i].stonename.slice(0, 3); // Get the stone name from the item data

        // Position stone names under "Stones Wt" column
        const stoneWeightX = columnPositions.stones + i * stoneWeightCellWidth;
        doc.text(stoneName, stoneWeightX + 2, currentY + 10);

        // Position stone names under "Stones Amount" column
        const stoneAmountX =
          columnPositions.stoneamt + i * stoneAmountCellWidth;
        doc.text(stoneName, stoneAmountX + 2, currentY + 10);
      }
    });

    // Final lines for the last stone sub-columns
    const finalStoneWeightX =
      columnPositions.stones + maxStones * stoneWeightCellWidth;
    const finalStoneAmountX =
      columnPositions.stoneamt + maxStones * stoneAmountCellWidth;

    doc.line(
      finalStoneWeightX,
      currentY,
      finalStoneWeightX,
      marginTop + tableHeight
    );
    doc.line(
      finalStoneAmountX,
      currentY,
      finalStoneAmountX,
      marginTop + tableHeight
    );

    currentY += 10;
    doc.line(columnPositions.sr, currentY + 5, pageWidth - 10, currentY + 5); // Table header bottom line
    currentY += 5;

    doc.line(
      columnPositions.sr,
      marginTop + tableHeight,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Bottom line
  };

  const drawTableRow = (item, rowIndex) => {
    const rowHeight = 10;
    const startY = currentY + 10;

    // Print row number (Sr)
    doc.text(`${rowIndex + 1}`, columnPositions.sr + 2, startY);

    // Print Design (assuming the item has a design property)
    doc.text(item.design || "", columnPositions.Design + 2, startY);

    // Print Product Details
    doc.text(
      item.productdetail || "",
      columnPositions.productDetails + 2,
      startY
    );

    // Print G Wt (Gross Weight)
    doc.text(item.grosswt || "0.00", columnPositions.Gwt + 2, startY);

    // Print Stones Wt (for each stone in item)
    item.stones.forEach((stone, index) => {
      const stoneWeightX =
        columnPositions.stones + index * stoneWeightCellWidth;
      doc.text(stone.stoneweight, stoneWeightX + 2, startY);
    });

    // Print N Wt (Net Weight)
    doc.text(item.netwt || "0.00", columnPositions.nwt + 2, startY);

    // Print Stones Amount (for each stone in item)
    item.stones.forEach((stone, index) => {
      const stoneAmountX =
        columnPositions.stoneamt + index * stoneAmountCellWidth;
      doc.text(stone.stoneweight, stoneAmountX + 2, startY);
    });

    currentY += rowHeight; // Move to the next row position
  };

  const drawTableContent = () => {
    const rowHeight = 10; // Set row height here for consistency

    items.forEach((item, index) => {
      if (currentY + rowHeight > pageHeight - 30) {
        // If current Y position + rowHeight will exceed pageHeight, add a new page
        doc.addPage();
        currentY = marginTop; // Reset Y position on new page
        drawTableHeader(); // Re-draw the header on the new page
        drawTableStructure(); // Re-draw the table structure on the new page
      }

      drawTableRow(item, index); // Draw the row after ensuring no overflow
    });
  };

  drawTableHeader();
  drawTableStructure();
  drawTableContent();

  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

const generateinvoicepdf6old = async (items, customer, mainitem) => {
  console.log("checking items", items);
  console.log("checking customer", customer);

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });
  const dummyData = generateDummyData();
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const marginTop = 80;
  const marginBottom = 40;
  const rowHeight = 10; // Initial row height
  const tableHeight = 100; // Fixed table height
  let currentY = marginTop;
  const invoicex = pageWidth - 60;
  const invoicey = 60;
  const customerx = pageWidth - 200;
  const customery = 60;
  const fotertotalx = pageWidth - 70;
  const fotertotaly = 180;

  const despx = pageWidth - 70;
  const despy = 250;

  const invoicenumber = `${mainitem.InvoiceNo}`;
  const invoicedate = `${mainitem.InvoiceDate}`;
  const firstname = `${customer.FirstName}`;
  const lastname = `${customer.LastName}`;
  const mobile = `${customer.Mobile}`;
  const address = `${customer.CurrAddStreet} ${customer.CurrAddTown} ${customer.CurrAddState}`;

  console.log("checkpagewidth  ", pageWidth);

  // Define the column positions
  const columnPositions = {
    sr: pageWidth - 200,
    productDetails: pageWidth - 185,
    // pcs: pageWidth-150,
    hsnCode: pageWidth - 125,
    purity: pageWidth - 100,
    // price: pageWidth - 90,
    qty: pageWidth - 60,
    amount: pageWidth - 40,
  };

  // Draw the table structure dynamically
  const drawTableStructure = () => {
    // Vertical Lines (for column separators)
    // doc.line(10, marginTop, 10, marginTop + tableHeight); // Left border
    Object.values(columnPositions).forEach((pos) => {
      doc.line(pos, marginTop, pos, marginTop + tableHeight); // Column separators
    });
    doc.line(
      pageWidth - 10,
      marginTop,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Right border
  };

  const drawTableHeader = () => {
    doc.setFontSize(10);
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header top line
    currentY += 5;

    // Draw the header text
    doc.text("Sr.", columnPositions.sr + 2, currentY);
    doc.text("Product Details", columnPositions.productDetails + 2, currentY);
    // doc.text('Pcs', columnPositions.pcs+2, currentY);
    doc.text("HSN Code", columnPositions.hsnCode + 2, currentY);
    doc.text("Purity", columnPositions.purity + 2, currentY);
    // doc.text('Gross Wt', columnPositions.grossWt+2, currentY);
    // doc.text('Net Wt', columnPositions.netWt+2, currentY);
    // doc.text("Metal Amt", columnPositions.price + 2, currentY);
    doc.text("Qty", columnPositions.qty + 2, currentY);
    // doc.text('Rate / gm', columnPositions.rate+2, currentY);
    doc.text("Total Amt", columnPositions.amount + 2, currentY);

    currentY += 5;
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header bottom line
    currentY += 5;

    doc.line(
      columnPositions.sr,
      marginTop + tableHeight,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Table header top line
  };

  const totalAmount = Number(mainitem.TotalAmount) || 0;
  const gstAmount = Number(mainitem.GST) || 0;
  const receivedAmount = Number(mainitem.ReceivedAmount) || 0;

  // Calculate CGST, SGST, total invoice amount, and balance amount
  const cgst = (totalAmount * 1.5) / 100; // CGST @1.5%
  const total = totalAmount + gstAmount; // Total Invoice Amount
  const bal = total - receivedAmount; // Balance Amount

  // Format amounts to two decimal places for better precision
  const formatAmount = (amount) => amount.toFixed(2);

  const drawFooter = () => {
    // Taxable Amount
    doc.text(
      `Taxable Amount : ${formatAmount(totalAmount)}`,
      fotertotalx,
      fotertotaly + 10
    );

    // CGST and SGST (assuming both are calculated similarly)
    doc.text(
      `CGST @ 1.5% : ${formatAmount(cgst)}`,
      fotertotalx,
      fotertotaly + 15
    );
    doc.text(
      `SGST @ 1.5% : ${formatAmount(cgst)}`,
      fotertotalx,
      fotertotaly + 20
    );

    // IGST (3% assumed)
    // doc.text(
    //   `IGST @ 3% : ${formatAmount(gstAmount)}`,
    //   fotertotalx,
    //   fotertotaly + 25
    // );

    // Total Invoice Amount
    doc.text(
      `Total Invoice Amount : ${formatAmount(total)}`,
      fotertotalx,
      fotertotaly + 30
    );

    // Amount Received
    doc.text(
      `Amount Received : ${formatAmount(receivedAmount)}`,
      fotertotalx,
      fotertotaly + 35
    );

    // Balance Amount (Handle negative balance if any)
    const balanceText =
      bal >= 0 ? formatAmount(bal) : `-${formatAmount(Math.abs(bal))}`;
    doc.text(`Balance Amount : ${balanceText}`, fotertotalx, fotertotaly + 40);

    const thankYouText = "Thank You For Your Business, God Bless Keep Buying";
    doc.setFontSize(13);

    // Calculate the text width to center it
    const textWidth = doc.getTextWidth(thankYouText);
    const centerX = (pageWidth - textWidth) / 2; // Calculate the x position for center alignment

    // Draw the centered text
    doc.text(thankYouText, centerX, fotertotaly + 50);
    doc.setFontSize(10);
    doc.text("Declaration :", customerx, fotertotaly + 55);
    const declarationText =
      "I declare that this invoice shows the actual price of the goods described and that all particulars are true and correct. I received ornament in good condition";
    const splitText = doc.splitTextToSize(declarationText, 80); // Adjust 180 to the width you want
    doc.setFontSize(10);
    doc.text(splitText, customerx, fotertotaly + 60);

    doc.setFontSize(10);
    doc.text(
      "For Mewar Jewellery House Pvt Ltd",
      fotertotalx,
      fotertotaly + 60
    );

    doc.text("Authorised Signature", fotertotalx, fotertotaly + 86);
    doc.text("Customer Signatory", customerx, fotertotaly + 86);

    doc.line(customerx, fotertotaly + 90, fotertotalx + 60, fotertotaly + 90);

    const ctext =
      "1st Floor, 1/1, 2nd cross Vasanthappa Thota Ganganagar Banglore-560032";
    const splitText1 = doc.splitTextToSize(ctext, 80); // Adjust 180 to the width you want
    doc.text(splitText1, customerx, fotertotaly + 95);
    const stext = "Contact Us : 080 23333409/080 41515409";
    const s1text = "Email: jewels@kevali.in";
    const s2text = "Instagram: kevali.in";
    const splitText2 = doc.splitTextToSize(stext, 80); // Adjust 180 to the width you want
    doc.text(stext, fotertotalx - 6, fotertotaly + 95);
    doc.text(s1text, fotertotalx - 6, fotertotaly + 100);
    doc.text(s2text, fotertotalx - 6, fotertotaly + 105);
  };

  const drawTableRows = () => {
    items.forEach((item, index) => {
      // Determine text lines and adjust currentY for each row
      const productDetailsLines = doc.splitTextToSize(
        item.ProductName,
        columnPositions.amount - columnPositions.productDetails - 5
      ); // Adjust width as needed
      const rowCount = Math.max(
        productDetailsLines.length,
        1 // To ensure there's at least one row
      );

      if (currentY + (rowCount + rowHeight) > pageHeight - marginBottom) {
        doc.addPage(); // Add a new page if needed
        currentY = marginTop;
        drawTableHeader();
        drawTableStructure();
      }

      // Draw row data
      doc.text(`${index + 1}`, columnPositions.sr + 2, currentY);
      productDetailsLines.forEach((line, lineIndex) => {
        doc.text(
          line,
          columnPositions.productDetails + 2,
          currentY + lineIndex * rowHeight
        );
      });
      // doc.text(item.Quantity || '1', columnPositions.pcs+2, currentY);
      doc.text("7113", columnPositions.hsnCode + 2, currentY);
      doc.text(item.Purity || "NA", columnPositions.purity + 2, currentY);
      // doc.text( item.Price || "NA", columnPositions.price + 2, currentY);
      doc.text(item.Quantity || "NA", columnPositions.qty + 2, currentY);
      doc.text(item.Price || "NA", columnPositions.amount + 2, currentY);

      // Update currentY based on the row count
      currentY += rowCount * rowHeight; // Adjust currentY based on the number of lines
    });
  };

  const getImageBase64 = (imagePath) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imagePath; // This path should point to the public folder image
      img.crossOrigin = "Anonymous"; // Ensure CORS issues don't block loading
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/jpeg"); // Convert to Base64
        resolve(dataURL);
      };
      img.onerror = (err) => reject(err);
    });
  };

  try {
    // Get the Base64 string of the image
    const imageBase64 = await getImageBase64("/images/pdfimages/7.png"); // Adjust path accordingly

    // Add the image to the PDF at specified coordinates (x, y, width, height)
    // const x = (pageWidth - 40) / 2;

    // doc.addImage(imageBase64, 'JPEG', x, 2, 40, 40);
    const imageWidth = 55;
    const imageX = (pageWidth - imageWidth) / 2; // Center horizontally
    const imageY = 3; // Adjust the y-coordinate as needed

    // Add the image to the PDF
    doc.addImage(imageBase64, "JPEG", imageX, imageY, imageWidth, 45);
  } catch (error) {
    console.error("Error loading image:", error);
  }

  const text = "TAX INVOICE";
  const textWidth = doc.getTextWidth(text); // Get the width of the text
  const textX = (pageWidth - textWidth) / 2; // Center horizontally
  const textY = 56; // Adjust the Y position as needed (below the image)

  // Add centered "TAX INVOICE" text
  doc.text(text, textX, textY);

  // Start generating the PDF
  // doc.text("TAX INVOICE", 90, 49);
  doc.setFontSize(10);
  doc.text("GSTIN :- 29AASCM4571D1Z2", invoicex, invoicey);
  doc.text("Invoice No :-", invoicex, invoicey + 5);
  doc.text(invoicenumber, invoicex + 20, invoicey + 5);
  // doc.text("Date :-", invoicex, invoicey + 5);
  doc.text(`Date :- ${invoicedate}`, invoicex, invoicey + 9);

  doc.text("Invoice To", customerx, customery);

  doc.text(
    `Customer Name : ${firstname} ${lastname}`,
    customerx,
    customery + 5
  );
  // doc.text(``, customerx + 28, customery + 5);
  doc.text(`Mobile No     : ${mobile}`, customerx, customery + 10);
  // doc.text(``, customerx + 28, customery + 10);
  doc.text(`Address       : ${address}`, customerx, customery + 15);
  // doc.text(``, customerx + 28, customery + 15);

  drawTableHeader();
  drawTableStructure();
  drawTableRows();

  // Add the footer to the last page
  drawFooter();

  // Open the PDF
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

const generateinvoicepdf7 = (items, customer, mainitem) => {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    UrdPurchaseAmt,
    Payments,
    PaymentMode,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.width; // Get the page width

  const startx = 2;
  const starty = 54.5;
  const boxTopMargin = starty + 10; // Top margin for the box
  const boxPadding = 5; // Padding on both sides
  const boxWidth = pageWidth - 2 * boxPadding; // Calculate box width with padding
  const boxHeight = 40;

  const urdPurchasePositive = Math.abs(TotalAmount); // Convert UrdPurchaseAmt to positive

  const totalgross = urdPurchasePositive - UrdPurchaseAmt;
  const cgst = (GST || 0) / 2;
  const sgst = (GST || 0) / 2;

  // const sGstFx = sGst.toFixed(2)
  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  doc.line(0, starty, 210, starty); // From (10, 50) to (200, 50)

  // doc.setFont("sanserif", "bold");
  // doc.setFontSize(16);
  // doc.setTextColor(0, 0, 0);
  // doc.text("GOLD SALE", 90, 43);

  const pan = customer.PanNo || "NA";
  const adhar = customer.AadharNo || "NA";
  const mobile = customer.Mobile || "NA";
  const address = customer.CurrAddStreet || "NA";

  // First column data
  const firstColumn = [
    { label: "Name      : ", value: `${customer.FirstName}` },
    { label: "Address   : ", value: `${address}` },
    { label: "Mobile    : ", value: `${mobile}` },
    { label: "Pan/Adhar : ", value: `${pan} / ${adhar}` },
  ];

  // Second column data
  const secondColumn = [
    { label: "Invoice No  : ", value: `${InvoiceNo}` },
    { label: "Date        : ", value: `${InvoiceDate}` },
    { label: "GSTIN No    : ", value: "27ABXPM4841M1ZS" },
    { label: "GSTIN Type  : ", value: "CGST + SGST + IGST" },
  ];

  doc.setLineWidth(0.3);
  doc.rect(boxPadding, boxTopMargin, boxWidth, boxHeight); // Create a box with the calculated width and height of 40
  // Draw content inside the box
  doc.setFont("sanserif", "bold");
  doc.setFontSize(16);
  doc.text("GOLD SALE", boxPadding + boxWidth / 2 - 20, boxTopMargin - 3); // Centered "GOLD SALE" text

  // Set Font for content
  // doc.setFontSize(12);
  doc.setFontSize(10);
  doc.setFont("sanserif", "bold");
  // Draw first column data
  let columnY = boxTopMargin + 8;
  firstColumn.forEach((item) => {
    doc.text(`${item.label}${item.value}`, boxPadding + 2, columnY);
    columnY += 6;
  });

  // Draw second column data
  columnY = boxTopMargin + 8;
  secondColumn.forEach((item) => {
    doc.text(
      `${item.label}${item.value}`,
      boxPadding + boxWidth / 2 + 25,
      columnY
    );
    columnY += 6;
  });

  //main tbale
  // Now creating the attached table box for items
  const tableStartY = starty + boxHeight + 10; // Start below the first box
  const tableHeight = 80;

  doc.rect(boxPadding, tableStartY, boxWidth, tableHeight); // Draw the outer box for the table

  // Column widths and labels
  const columnWidths = {
    Item: 36.18,
    HSN: 16.18,
    Purity: 13.18,
    Qty: 12.18,
    "G wt": 15.18,
    "Stone wt": 17.18,
    "Net wt": 15.18,
    "St amt": 15.18,
    "Rate/gm": 18.18,
    Making: 21.18,
    Amount: 20.18,
  };

  const columnArray = [
    "Item",
    "HSN",
    "Purity",
    "Qty",
    "G wt",
    "Stone wt",
    "Net wt",
    "St amt",
    "Rate/gm",
    "Making",
    "Amount",
  ];

  const leftColumn = [
    { label: "Gross Amount", value: `${totalgross.toFixed(2)}` },
    { label: "CGST 1.5%", value: `${Number(cgst).toFixed(2)}` },
    { label: "SGST 1.5%", value: `${Number(sgst).toFixed(2)}` },
    { label: "IGST 3%", value: `${GSTNumber.toFixed(2)}` },
    { label: "Hallmarking Amount", value: "" },
    { label: "Purchase Amount (-)", value: `${UrdPurchaseAmt}` },
    { label: "RO/Discount (-)", value: "" },
    { label: "Net Amount", value: `${(totalgross + GSTNumber).toFixed(2)}` },
  ];

  // Dummy values for the right column
  const rightColumnValues = [
    `${Math.abs(totalgross.toFixed(2))}`,
    `${Number(cgst).toFixed(2)}`,
    `${Number(sgst).toFixed(2)}`,
    `${GSTNumber.toFixed(2)}`,
    "",
    `${UrdPurchaseAmt}`,
    "",
    `${(Math.abs(totalgross) + GSTNumber - UrdPurchaseAmt).toFixed(2)}`,
  ];

  // Table Headers
  let startX = boxPadding + 2; // Starting X position for table
  let headerY = tableStartY + 7; // Starting Y position for the headers

  doc.setFontSize(10);
  columnArray.forEach((col) => {
    doc.text(col, startX, headerY);
    startX += columnWidths[col]; // Move X based on column width
  });

  // Draw vertical lines separating columns
  let columnX = boxPadding; // startx + 2;
  columnArray.forEach((col) => {
    doc.line(columnX, tableStartY, columnX, tableStartY + tableHeight); // Draw vertical lines
    columnX += columnWidths[col];
  });

  // Draw the right border for the table
  doc.line(boxPadding, tableStartY, boxPadding, tableStartY + tableHeight);

  doc.line(
    boxPadding,
    tableStartY + 10,
    boxPadding + boxWidth,
    tableStartY + 10
  );

  // Render table content
  let rowStartY = headerY + 10;
  // startX = boxPadding+2;
  items.forEach((item) => {
    if (item.ProductName.toLowerCase() === "old gold") {
      return; // Skip to the next item
    }
    let startX = boxPadding + 2; // Reset startX for each new row

    const itemData = [
      item.ProductName,
      item.HSNCode,
      item.Purity,
      "1",
      item.GrossWt,
      item.TotalStoneWeight,
      item.NetWt,
      item.TotalStoneAmount,
      item.MetalRate,
      item.MakingPercentage,
      item.Price,
    ];

    // Render each column's data for the current row
    itemData.forEach((data, index) => {
      doc.text(`${data}`, startX, rowStartY);
      startX += columnWidths[columnArray[index]]; // Move to the next column
    });

    rowStartY += 10; // Move to the next row
  });

  const startX4 = 135; // Starting X position for the table
  const startY4 = 185; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  doc.setLineWidth(0.3);
  doc.rect(startX4, startY4, tableWidth4, tableHeight4); // Outer table border

  // Draw vertical line at the center
  doc.line(verticalLineX, startY4, verticalLineX, startY4 + tableHeight4); // Vertical line splitting the table

  // Fill in the left column labels and right column dummy values
  leftColumn.forEach((row, index) => {
    const ypos = startY4 + (index + 1) * cellHeight4 - 3; // Y position for the text

    // Draw left side labels
    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(`${row.label}`, startX4 + 2, ypos);

    // Draw right side dummy values
    const rightValue = rightColumnValues[index];
    doc.setFont("sanserif", "normal");
    doc.text(`${rightValue}`, verticalLineX + 2, ypos); // Right side column values

    // Draw horizontal line after each cell
    doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3); // Horizontal line across the row
  });
  // Draw bottom border for the table

  //draw cash table
  doc.setFont("sanserif", "bold");

  // Initialize drawing positions
  const sectionX = 5; // Starting X position for the payment section
  // const sectionY = 199; // Starting Y position
  // const cellWidth = 50; // Width of each column for the payment table
  // const cellHeight = 10; // Height for each cell

  let currentX = sectionX; // To adjust X position dynamically for each payment mode

  // Set font and style for the document
  doc.setFontSize(10);
  doc.setFont("sanserif", "bold");

  const paymentSummary = Payments.map((payment) => ({
    mode: payment.PaymentModeType,
    amount: payment.Amount,
  }));

  // Starting position for drawing the payment sections
  let startY = 199; // Starting Y position for the first payment section
  const cellWidth = 50; // Width of each column for the payment table
  const cellHeight = 10; // Height of each row for the payment table
  let adminy = 210;
  // Loop through payment summary and draw each payment mode and amount
  paymentSummary.forEach((payment, index) => {
    // Calculate the Y position for each payment mode based on the index
    const currentY = startY + index * (cellHeight + 0); // Adding 2 for spacing

    // Draw the payment mode label cell
    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(
      payment.mode,
      5 + cellWidth / 2 - doc.getTextWidth(payment.mode) / 2,
      currentY + 7 // Center text vertically
    ); // Center text in the first column

    // Draw the payment amount cell
    doc.text(
      payment.amount,
      5 + cellWidth + cellWidth / 2 - doc.getTextWidth(payment.amount) / 2,
      currentY + 7 // Center text vertically
    ); // Center text in the second column

    // Draw the outer border of the payment mode and amount cells
    doc.rect(5, currentY, cellWidth, cellHeight); // Border for payment mode label
    doc.rect(5 + cellWidth, currentY, cellWidth, cellHeight); // Border for the amount
    adminy = currentY;
  });

  // Now create a second section with two columns: "Cash" and its amount
  // const cashSectionX = 5; // Starting X position for the cash section
  // const cashSectionY = 199;
  // const cashCellWidth = 50; // Width of each column for the cash table

  // // Draw the "Cash" label cell
  // doc.setFontSize(10);
  // doc.setFont("sanserif", "bold");

  // doc.text(
  //   "Cash",
  //   cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
  //   cashSectionY + 7
  // ); // Center text in the first column

  // // Draw the "Cash" amount cell
  // doc.text(
  //   "",
  //   cashSectionX +
  //   cashCellWidth +
  //   cashCellWidth / 2 -
  //   doc.getTextWidth("1000") / 2,
  //   cashSectionY + 7
  // ); // Center text in the second column

  // // Draw the outer border of the cash and amount cells
  // doc.rect(cashSectionX, cashSectionY, cashCellWidth, 10); // Border for "Cash" label
  // doc.rect(cashSectionX + cashCellWidth, cashSectionY, cashCellWidth, 10); // Border for the amount

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text("Billng By - Admin", 100, adminy + 15);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text(
    "note:- we declare that this invoice shows actual price of the good described ",
    5,
    240
  );

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text("and that all particulars are true and correct", 5, 245);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("Customer Sign", 10, 285);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("(Saturday Closed )", 70, 285);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("Thank You !", 70, 290);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("For Mundlik Jewellers", 150, 285);

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

const generateinvoicepdf8 = async (items, customer, mainitem) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a5",
  });

  // Set table starting position and dimensions
  const startX = 5;
  const startY = 45;
  const cellWidth = 80;
  const cellHeight = 10;

  const columnWidths = {
    "Sr No": 9,
    "Item Name": 18,
    Pcs: 9,
    "Gr + Tag": 12,
    Tag: 12,
    "Gr Wt": 12,
    "RB Wt": 12,
    "Em Wt": 12,
    "Nr Wt": 12,
    "Ad Wt": 12,
    "CLR Wt": 12,
    "Moti Wt": 12,
    "BDS Wt": 12,
    "Net Wt": 12,
    Touch: 12,
    "Fine Wt": 12,
    "S Amt": 12,
  };

  const columnArray = [
    "Sr No",
    "Item Name",
    "Pcs",
    "Gr + Tag",
    "Tag",
    "Gr Wt",
    "RB Wt",
    "Em Wt",
    "Nr Wt",
    "Ad Wt",
    "CLR Wt",
    "Moti Wt",
    "BDS Wt",
    "Net Wt",
    "Touch",
    "Fine Wt",
    "S Amt",
  ];

  const dummyData = [
    {
      "Sr No": "1",
      "Item Name": "Bangle",
      Pcs: "2",
      "Gr + Tag": "12.00",
      Tag: "5.00",
      "Gr Wt": "7.00",
      "RB Wt": "0.00",
      "Em Wt": "0.00",
      "Nr Wt": "6.00",
      "Ad Wt": "1.00",
      "CLR Wt": "0.00",
      "Moti Wt": "0.00",
      "BDS Wt": "0.00",
      "Net Wt": "7.00",
      Touch: "92%",
      "Fine Wt": "6.44",
      "S Amt": "1000.00",
    },
    {
      "Sr No": "2",
      "Item Name": "Bangle",
      Pcs: "1",
      "Gr + Tag": "20.00",
      Tag: "8.00",
      "Gr Wt": "12.00",
      "RB Wt": "0.00",
      "Em Wt": "0.00",
      "Nr Wt": "10.00",
      "Ad Wt": "2.00",
      "CLR Wt": "0.00",
      "Moti Wt": "0.00",
      "BDS Wt": "0.00",
      "Net Wt": "12.00",
      Touch: "91%",
      "Fine Wt": "10.92",
      "S Amt": "2000.00",
    },
    {
      "Sr No": "3",
      "Item Name": "CADA",
      Pcs: "1",
      "Gr + Tag": "30.00",
      Tag: "15.00",
      "Gr Wt": "15.00",
      "RB Wt": "2.00",
      "Em Wt": "1.00",
      "Nr Wt": "12.00",
      "Ad Wt": "3.00",
      "CLR Wt": "0.00",
      "Moti Wt": "1.00",
      "BDS Wt": "0.00",
      "Net Wt": "14.00",
      Touch: "90%",
      "Fine Wt": "12.60",
      "S Amt": "1500.00",
    },
    {
      "Sr No": "4",
      "Item Name": "MICRO EP",
      Pcs: "2",
      "Gr + Tag": "8.00",
      Tag: "2.00",
      "Gr Wt": "6.00",
      "RB Wt": "0.00",
      "Em Wt": "1.00",
      "Nr Wt": "4.00",
      "Ad Wt": "1.00",
      "CLR Wt": "0.00",
      "Moti Wt": "0.00",
      "BDS Wt": "0.00",
      "Net Wt": "5.00",
      Touch: "89%",
      "Fine Wt": "4.45",
      "S Amt": "800.00",
    },
    {
      "Sr No": "5",
      "Item Name": "NR BRCLET",
      Pcs: "1",
      "Gr + Tag": "25.00",
      Tag: "10.00",
      "Gr Wt": "15.00",
      "RB Wt": "0.00",
      "Em Wt": "2.00",
      "Nr Wt": "12.00",
      "Ad Wt": "3.00",
      "CLR Wt": "0.00",
      "Moti Wt": "0.00",
      "BDS Wt": "0.00",
      "Net Wt": "14.00",
      Touch: "88%",
      "Fine Wt": "12.32",
      "S Amt": "3000.00",
    },
    {
      "Sr No": "6",
      "Item Name": "NR BRCLET",
      Pcs: "1",
      "Gr + Tag": "7.00",
      Tag: "3.00",
      "Gr Wt": "4.00",
      "RB Wt": "0.00",
      "Em Wt": "0.00",
      "Nr Wt": "3.00",
      "Ad Wt": "1.00",
      "CLR Wt": "0.00",
      "Moti Wt": "0.00",
      "BDS Wt": "0.00",
      "Net Wt": "3.00",
      Touch: "95%",
      "Fine Wt": "2.85",
      "S Amt": "1200.00",
    },
    {
      "Sr No": "7",
      "Item Name": "NR BRCLET",
      Pcs: "1",
      "Gr + Tag": "5.00",
      Tag: "2.00",
      "Gr Wt": "3.00",
      "RB Wt": "1.00",
      "Em Wt": "1.00",
      "Nr Wt": "1.00",
      "Ad Wt": "0.00",
      "CLR Wt": "0.00",
      "Moti Wt": "0.00",
      "BDS Wt": "0.00",
      "Net Wt": "2.00",
      Touch: "96%",
      "Fine Wt": "1.92",
      "S Amt": "5000.00",
    },
    {
      "Sr No": "8",
      "Item Name": "NR BRCLET",
      Pcs: "1",
      "Gr + Tag": "18.00",
      Tag: "6.00",
      "Gr Wt": "12.00",
      "RB Wt": "0.00",
      "Em Wt": "2.00",
      "Nr Wt": "8.00",
      "Ad Wt": "4.00",
      "CLR Wt": "0.00",
      "Moti Wt": "0.00",
      "BDS Wt": "0.00",
      "Net Wt": "10.00",
      Touch: "89%",
      "Fine Wt": "8.90",
      "S Amt": "1800.00",
    },
  ];

  // Calculate totals for each column
  const totals = {
    Pcs: 0,
    "Gr Wt": 0,
    "RB Wt": 0,
    "Em Wt": 0,
    "Nr Wt": 0,
    "Ad Wt": 0,
    "CLR Wt": 0,
    "Moti Wt": 0,
    "Net Wt": 0,
    "Fine Wt": 0,
    "S Amt": 0,
  };

  dummyData.forEach((row) => {
    Object.keys(totals).forEach((key) => {
      const value = parseFloat(row[key]);
      if (!isNaN(value)) {
        totals[key] += value;
      }
    });
  });

  // Draw the table header and data rows
  let currentX = 2;
  const tableWidth = 200; // Total width for the table

  columnArray.forEach((title, index) => {
    const columnWidth = columnWidths[title] || 20; // Default to 20mm if not specified
    const textX = currentX + 0.5;
    const cellY = 10; // Adjusted Y position to place text within the cell

    // Draw the centered text inside the cells
    doc.setFontSize(8.5);
    doc.setFont("sanserif", "normal");
    doc.text(title.charAt(0).toUpperCase() + title.slice(1), textX, cellY); // Capitalize first letter

    // Draw the vertical line for each column
    if (index !== 0) {
      doc.line(currentX, 5, currentX, 92); // Vertical line from header to the bottom of the table
    }

    // Draw the vertical line for each column
    currentX += columnWidth;
  });

  doc.setFontSize(8.5);
  doc.setFont("sanserif", "normal");
  doc.text("Total", 15, 78);
  doc.text("Stn Rate", 15, 83);
  doc.text("Stn Amt", 15, 87);

  //footer
  doc.text("Stone Charge ", 160, 100);
  doc.text("Huid Charge ", 160, 105);
  doc.text("Courier Charge ", 160, 110);
  doc.text("GST ", 160, 115);
  doc.text("TDS Amount ", 160, 120);

  doc.text("TDS:  ", 50, 110);
  doc.text("Gold Rate: ", 50, 115);
  doc.text("Issue: ", 50, 120);
  doc.text("Reciept: ", 50, 125);

  doc.setFontSize(8.5);
  doc.setFont("sanserif", "bold");

  doc.text("Payable Amount ", 160, 125);
  doc.text("Net Balance ", 160, 130);

  // Render data rows
  const startRowY = 20;
  let rowY = startRowY;

  dummyData.forEach((row, rowIndex) => {
    let columnX = 2;

    columnArray.forEach((columnKey) => {
      let value = row[columnKey] ? row[columnKey].toString() : "";
      const columnWidth = columnWidths[columnKey] || 20;

      if (!isNaN(value)) {
        value = parseFloat(value).toFixed(2); // Apply toFixed(2) for all numeric values
      }

      doc.text(value, columnX + 0.5, rowY);
      columnX += columnWidth;
    });

    rowY += 7;
  });

  // Draw the outer table border (adjust height to fit the table content)
  doc.rect(0, 5, 210, 68); // Adjust to fit the content

  doc.line(0, 15, 210, 15);

  // Draw totals row at the bottom of the table
  let totalRowX = 2;

  columnArray.forEach((columnKey) => {
    let totalValue = totals[columnKey] ? totals[columnKey].toFixed(2) : "";
    const columnWidth = columnWidths[columnKey] || 20;

    if (totalValue) {
      doc.setFont("sanserif", "bold");
      doc.text(totalValue, totalRowX + 0.5, rowY);
      doc.line(0, 92, 210, 92);
    }

    totalRowX += columnWidth;
  });

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

const generateinvoicepdf10 = async (items, customer, mainitem) => {
  console.log("checking items", items);
  console.log("checking customer", customer);

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });
  const dummyData = generateDummyData();
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const marginTop = 80;
  const marginBottom = 40;
  const rowHeight = 10; // Initial row height
  const tableHeight = 100; // Fixed table height
  let currentY = marginTop;
  const invoicex = pageWidth - 60;
  const invoicey = 60;
  const customerx = pageWidth - 200;
  const customery = 60;
  const fotertotalx = pageWidth - 70;
  const fotertotaly = 180;

  const despx = pageWidth - 70;
  const despy = 250;

  const invoicenumber = `${mainitem.InvoiceNo}`;
  const invoicedate = `${mainitem.InvoiceDate}`;
  const firstname = `${customer.FirstName}`;
  const lastname = `${customer.LastName}`;
  const mobile = `${customer.Mobile}`;
  const address = `${customer.CurrAddStreet} ${customer.CurrAddTown} ${customer.CurrAddState}`;

  console.log("checkpagewidth  ", pageWidth);

  // Define the column positions
  const columnPositions = {
    sr: pageWidth - 205,
    productDetails: pageWidth - 192,
    // pcs: pageWidth-150,
    hsnCode: pageWidth - 155,
    purity: pageWidth - 140,
    gwt: pageWidth - 125,
    swt: pageWidth - 105,
    // gwt:pageWidth - 110,
    qty: pageWidth - 90,
    goldrate: pageWidth - 80,
    va: pageWidth - 60,
    amount: pageWidth - 40,
  };

  // Draw the table structure dynamically
  const drawTableStructure = () => {
    // Vertical Lines (for column separators)
    // doc.line(10, marginTop, 10, marginTop + tableHeight); // Left border
    Object.values(columnPositions).forEach((pos) => {
      doc.line(pos, marginTop, pos, marginTop + tableHeight); // Column separators
    });
    doc.line(
      pageWidth - 10,
      marginTop,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Right border
  };

  const drawTableHeader = () => {
    doc.setFontSize(10);
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header top line
    currentY += 5;

    // Draw the header text
    doc.text("Sr No", columnPositions.sr + 2, currentY);
    doc.text("Product Details", columnPositions.productDetails + 2, currentY);
    // doc.text('Pcs', columnPositions.pcs+2, currentY);
    doc.text("HSN", columnPositions.hsnCode + 2, currentY);
    doc.text("Purity", columnPositions.purity + 2, currentY);
    doc.text("Gross", columnPositions.gwt + 2, currentY);
    doc.text("Stone", columnPositions.swt + 2, currentY);
    // doc.text('Gross Wt', columnPositions.grossWt+2, currentY);
    // doc.text('Net Wt', columnPositions.netWt+2, currentY);
    // doc.text("Metal Amt", columnPositions.price + 2, currentY);
    doc.text("Qty", columnPositions.qty + 2, currentY);
    doc.text("Gold Rate", columnPositions.goldrate + 2, currentY);
    doc.text("VA", columnPositions.va + 2, currentY);
    doc.text("Total Amt", columnPositions.amount + 2, currentY);

    currentY += 5;
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header bottom line
    currentY += 5;

    doc.line(
      columnPositions.sr,
      marginTop + tableHeight,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Table header top line
  };

  const totalAmount = Number(mainitem.TotalAmount) || 0;
  const gstAmount = Number(mainitem.GST) || 0;
  const receivedAmount = Number(mainitem.ReceivedAmount) || 0;

  // Calculate CGST, SGST, total invoice amount, and balance amount
  const cgst = (totalAmount * 1.5) / 100; // CGST @1.5%
  const total = totalAmount + gstAmount; // Total Invoice Amount
  const bal = total - receivedAmount; // Balance Amount

  // Format amounts to two decimal places for better precision
  const formatAmount = (amount) => amount.toFixed(2);

  const drawFooter = () => {
    // Taxable Amount
    doc.text(
      `Taxable Amount : ${formatAmount(totalAmount)}`,
      fotertotalx,
      fotertotaly + 10
    );

    // CGST and SGST (assuming both are calculated similarly)
    doc.text(
      `CGST @ 1.5% : ${formatAmount(cgst)}`,
      fotertotalx,
      fotertotaly + 15
    );
    doc.text(
      `SGST @ 1.5% : ${formatAmount(cgst)}`,
      fotertotalx,
      fotertotaly + 20
    );

    // IGST (3% assumed)
    // doc.text(
    //   `IGST @ 3% : ${formatAmount(gstAmount)}`,
    //   fotertotalx,
    //   fotertotaly + 25
    // );

    // Total Invoice Amount
    doc.text(
      `Total Invoice Amount : ${formatAmount(total)}`,
      fotertotalx,
      fotertotaly + 30
    );

    // Amount Received
    doc.text(
      `Amount Received : ${formatAmount(receivedAmount)}`,
      fotertotalx,
      fotertotaly + 35
    );

    // Balance Amount (Handle negative balance if any)
    const balanceText =
      bal >= 0 ? formatAmount(bal) : `-${formatAmount(Math.abs(bal))}`;
    doc.text(`Balance Amount : ${balanceText}`, fotertotalx, fotertotaly + 40);

    const thankYouText = "Thank You For Your Business, God Bless Keep Buying";
    doc.setFontSize(15);

    // Calculate the text width to center it
    const textWidth = doc.getTextWidth(thankYouText);
    const centerX = (pageWidth - textWidth) / 2; // Calculate the x position for center alignment

    // Draw the centered text
    doc.text(thankYouText, centerX, fotertotaly + 50);
    doc.setFontSize(10);
    doc.text("Declaration :", customerx, fotertotaly + 55);
    const declarationText =
      "I declare that this invoice shows the actual price of the goods described and that all particulars are true and correct. I received ornament in good condition";
    const splitText = doc.splitTextToSize(declarationText, 80); // Adjust 180 to the width you want
    doc.setFontSize(10);
    doc.text(splitText, customerx, fotertotaly + 60);

    doc.setFontSize(10);
    doc.text("For Archana Jewellery", fotertotalx, fotertotaly + 60);

    doc.text("Authorised Signature", fotertotalx, fotertotaly + 86);
    doc.text("Customer Signatory", customerx, fotertotaly + 86);

    doc.line(customerx, fotertotaly + 90, fotertotalx + 60, fotertotaly + 90);

    const ctext = "Shop no 2-10-30/1, shabazar, mahabubnagar, 509001";
    const splitText1 = doc.splitTextToSize(ctext, 80); // Adjust 180 to the width you want
    doc.text(splitText1, customerx, fotertotaly + 95);
    const stext = "Contact Us : 9440389832";
    const s1text = "";
    const s2text = "";
    const splitText2 = doc.splitTextToSize(stext, 80); // Adjust 180 to the width you want
    doc.text(stext, fotertotalx - 6, fotertotaly + 95);
    doc.text(s1text, fotertotalx - 6, fotertotaly + 100);
    doc.text(s2text, fotertotalx - 6, fotertotaly + 105);
  };

  const drawTableRows = () => {
    items.forEach((item, index) => {
      // Determine text lines and adjust currentY for each row
      const productDetailsLines = doc.splitTextToSize(
        item.ProductName,
        columnPositions.amount - columnPositions.productDetails - 5
      ); // Adjust width as needed
      const rowCount = Math.max(
        productDetailsLines.length,
        1 // To ensure there's at least one row
      );

      if (currentY + (rowCount + rowHeight) > pageHeight - marginBottom) {
        doc.addPage(); // Add a new page if needed
        currentY = marginTop;
        drawTableHeader();
        drawTableStructure();
      }

      // Draw row data
      doc.text(`${index + 1}`, columnPositions.sr + 2, currentY);
      productDetailsLines.forEach((line, lineIndex) => {
        doc.text(
          line,
          columnPositions.productDetails + 2,
          currentY + lineIndex * rowHeight
        );
      });
      // doc.text(item.Quantity || '1', columnPositions.pcs+2, currentY);
      doc.text("7113", columnPositions.hsnCode + 2, currentY);
      doc.text(item.Purity || "NA", columnPositions.purity + 2, currentY);
      doc.text(item.GrossWt || "NA", columnPositions.gwt + 2, currentY);
      doc.text(
        item.TotalStoneWeight || "NA",
        columnPositions.swt + 2,
        currentY
      );
      // doc.text( item.Price || "NA", columnPositions.price + 2, currentY);
      doc.text(item.Quantity || "NA", columnPositions.qty + 2, currentY);
      doc.text(item.MetalRate || "NA", columnPositions.goldrate + 2, currentY);
      doc.text(item.MakingPercentage || "NA", columnPositions.va + 2, currentY);
      doc.text(item.Price || "NA", columnPositions.amount + 2, currentY);

      // Update currentY based on the row count
      currentY += rowCount * rowHeight; // Adjust currentY based on the number of lines
    });
  };

  const getImageBase64 = (imagePath) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imagePath; // This path should point to the public folder image
      img.crossOrigin = "Anonymous"; // Ensure CORS issues don't block loading
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/jpeg"); // Convert to Base64
        resolve(dataURL);
      };
      img.onerror = (err) => reject(err);
    });
  };

  try {
    // Get the Base64 string of the image
    const imageBase64 = await getImageBase64("/images/pdfimages/10.png"); // Adjust path accordingly

    // Add the image to the PDF at specified coordinates (x, y, width, height)
    // const x = (pageWidth - 40) / 2;

    // doc.addImage(imageBase64, 'JPEG', x, 2, 40, 40);
    const imageWidth = pageWidth / 2;
    const imageX = (pageWidth - imageWidth) / 2; // Center horizontally
    const imageY = 5; // Adjust the y-coordinate as needed

    // Add the image to the PDF
    // doc.addImage(imageBase64, 'JPEG', imageX, imageY, pageWidth/2, 30);

    doc.text("ARCHANA JEWELLERS", imageX, imageY);
    doc.text("SHOP NO 2-10-30/1", imageX, imageY + 5);
    doc.text("SHABAZAR", imageX, imageY + 10);
    doc.text("MAHABOOKNAGAR, 509001", imageX, imageY + 15);
    doc.text("CONTACT NO 9494709528, 9440389832", imageX, imageY + 20);
  } catch (error) {
    console.error("Error loading image:", error);
  }

  const text = "TAX INVOICE";
  const textWidth = doc.getTextWidth(text); // Get the width of the text
  const textX = (pageWidth - textWidth) / 2; // Center horizontally
  const textY = 50; // Adjust the Y position as needed (below the image)

  // Add centered "TAX INVOICE" text
  doc.text(text, textX, textY);

  // Start generating the PDF
  // doc.text("TAX INVOICE", 90, 49);
  doc.setFontSize(10);
  doc.text("GSTIN :- 36AAKFA6291P2ZQ", invoicex, invoicey);
  doc.text("Invoice No :-", invoicex, invoicey + 5);
  doc.text(invoicenumber, invoicex + 20, invoicey + 5);
  // doc.text("Date :-", invoicex, invoicey + 5);
  doc.text(`Date :- ${invoicedate}`, invoicex, invoicey + 9);

  doc.text("Invoice To", customerx, customery);

  doc.text(
    `Customer Name : ${firstname} ${lastname}`,
    customerx,
    customery + 5
  );
  // doc.text(``, customerx + 28, customery + 5);
  doc.text(`Mobile No     : ${mobile}`, customerx, customery + 10);
  // doc.text(``, customerx + 28, customery + 10);
  doc.text(`Address       : ${address}`, customerx, customery + 15);
  // doc.text(``, customerx + 28, customery + 15);

  drawTableHeader();
  drawTableStructure();
  drawTableRows();

  // Add the footer to the last page
  drawFooter();

  // Open the PDF
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

const generateinvoicepdf7old = (items, customer, mainitem) => {
  const {
    InvoiceNo,
    InvoiceDate,
    ProductName,
    HSNCode,
    Purity,
    Qty,
    GrossWt,
    StoneWt,
    NetWt,
    StoneAmount,
    MakingPerGram,
    TotalAmount,
    GST,
  } = mainitem;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  // Draw a horizontal line
  doc.line(0, 50, 210, 50); // From (10, 50) to (200, 50)

  doc.setFont("sanserif", "bold");
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text("GOLD SALE", 90, 53);

  let pan;
  let adhar;
  let mobile;
  let address;

  customer.PanNo;
  customer.AadharNo;

  if (customer.PanNo) {
    pan = customer.PanNo;
  } else {
    pan = "NA";
  }

  if (customer.AadharNo) {
    adhar = customer.AadharNo;
  } else {
    adhar = "NA";
  }

  if (customer.Mobile) {
    mobile = customer.Mobile;
  } else {
    mobile = "NA";
  }

  if (customer.CurrAddStreet) {
    address = customer.CurrAddStreet;
  } else {
    address = "NA";
  }

  // First column data
  const firstColumn = [
    { label: "Name", value: `${customer.FirstName}` },
    { label: "Address", value: `${address}` },
    { label: "Mobile", value: `${mobile}` },
    { label: "Pan/Adhar", value: `${pan} / ${adhar}` },
  ];

  // Second column data
  const secondColumn = [
    { label: "Invoice No:", value: `${InvoiceNo}` },
    { label: "Date:", value: `${InvoiceDate}` },
    { label: "GSTIN No:", value: "27ABXPM4841M1ZS" },
    { label: "GSTIN Type:", value: "CGST + SGST + IGST" },
  ];

  // Set table starting position and dimensions
  const startX = 5;
  const startY = 50.8;
  const cellWidth = 80;
  const cellHeight = 10;

  doc.setLineWidth(0.3);
  doc.rect(startX, startY, 200, 40);

  // Define custom widths for each column
  const columnWidths = {
    Item: 36.18,
    HSN: 16.18,
    Purity: 13.18,
    Qty: 12.18,
    "Gr wt": 15.18,
    "Stone wt": 17.18,
    "Net wt": 15.18,
    "St amt": 15.18,
    "Rate/gm": 18.18,
    "Making/gm": 21.18,
    Amount: 20.18,
  };

  const columnArray = [
    "Item",
    "HSN",
    "Purity",
    "Qty",
    "Gr wt",
    "Stone wt",
    "Net wt",
    "St amt",
    "Rate/gm",
    "Making/gm",
    "Amount",
  ];

  // Calculate the starting X position for each column
  let currentX = 5;
  const tableWidth = 200; // Total width for the table

  // Draw the table header and vertical lines, and center the text in each column
  columnArray.forEach((title, index) => {
    const columnWidth = columnWidths[title] || 20; // Default to 20mm if not specified

    // Calculate the position to center the text in the column
    // const textX = currentX + columnWidth / 2 - doc.getTextWidth(title) / 2;

    const textX = currentX + 1;
    const cellY = 90; // Adjusted Y position to place text within the cell

    // Draw the centered text inside the cells
    doc.setFontSize(11);
    doc.setFont("sanserif", "bold");
    doc.text(title, textX, cellY); // Centered text in the cell

    // Draw the vertical line for each column
    if (index !== 0) {
      doc.line(currentX, 85, currentX, 170); // Vertical line from header to the bottom of the table
    }

    currentX += columnWidth; // Move to the next column position
  });

  // Draw the bottom line of the header row
  doc.rect(5, 85, tableWidth, 10); // Header bottom line

  // Body (you can add data here as needed)
  firstColumn.forEach((row, index) => {
    const ypos = startY + (index + 0.7) * cellHeight;

    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(`${row.label} :`, startX + 2, ypos);
    doc.text(row.value, startX + cellWidth / 2, ypos); // Centered within the first column
  });

  secondColumn.forEach((row, index) => {
    const ypos = startY + (index + 0.7) * cellHeight;

    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(`${row.label}`, 60 + cellWidth + 2, ypos); // Left padding of 2 in the second column
    doc.text(row.value, startX + (cellWidth * 4) / 2, ypos); // Centered within the second column
  });

  // Draw the outer table border (adjust height to fit the table content)
  doc.rect(5, 85, tableWidth, 85);

  const overallStatsTable = ["Item", "Net wt", "Gross wt", "Amount"];

  let currentX2 = 5;
  const tableWidth2 = 100;

  const ColumnCount = overallStatsTable.length;
  const ColumnWidth = tableWidth2 / ColumnCount;

  // Draw the table header and vertical lines, and center the text in each column
  overallStatsTable.forEach((title, index) => {
    const textX = currentX2 + ColumnWidth / 2 - doc.getTextWidth(title) / 2;
    const cellY = startY; // Starting Y position for the table header

    // Draw the centered text inside the cells
    doc.setFontSize(10);
    doc.text(title, textX, cellY); // Centered text in the cell

    // // Draw vertical lines for the columns
    if (index !== 0) {
      doc.line(currentX2, 175, currentX2, 195); // Vertical line from header to bottom
    }

    // Move to the next column position
    currentX2 += ColumnWidth;
  });

  // Draw the outer border of the table (header + empty cells)
  doc.rect(5, 175, tableWidth2, 10 + cellHeight); // Table outer border

  // Draw the horizontal line between the header row and the empty cells for values
  doc.line(5, 177 + 10, 5 + tableWidth2, 177 + 10);

  const TableData = [
    {
      Item: `${ProductName}`,
      HSN: `${HSNCode}`,
      Purity: `${Purity}`,
      Qty: `${1}`,
      "Gr wt": `${GrossWt}`,
      "Stone wt": `${StoneWt}`,
      "Net wt": `${NetWt}`,
      "St amt": `${StoneAmount}`,
      "Rate/gm": `${0}`,
      "Making/gm": `${MakingPerGram}`,
      Amount: `${TotalAmount}`,
    },
  ];

  //draw table body
  let bodyY = 100;
  // Populate table body with items data
  items.forEach((rowData) => {
    currentX = 5;

    // Map response fields to table columns
    const row = {
      Item: rowData.ProductName || "N/A",
      HSN: rowData.HSNCode || "N/A",
      Purity: rowData.Purity || "N/A",
      Qty: "1",
      "Gr wt": rowData.GrossWt || "N/A",
      "Stone wt": rowData.TotalStoneWeight || "N/A",
      "Net wt": rowData.NetWt || "N/A",
      "St amt": rowData.TotalStoneAmount || "N/A",
      "Rate/gm": rowData.MetalRate || "N/A",
      "Making/gm": rowData.MakingPerGram || "N/A",
      Amount: rowData.TotalAmount || "N/A",
    };

    columnArray.forEach((col) => {
      const columnWidth = columnWidths[col] || 20;
      doc.setFontSize(10);
      doc.setFont("Sanserif", "normal");
      doc.text(`${row[col]}`, currentX + 1, bodyY);
      currentX += columnWidth;
    });

    bodyY += 10; // Move to the next row
  });

  //draw cash table
  doc.setFont("sanserif", "bold");

  // Now create a second section with two columns: "Cash" and its amount
  const cashSectionX = 5; // Starting X position for the cash section
  const cashSectionY = 199;
  const cashCellWidth = 50; // Width of each column for the cash table

  // Draw the "Cash" label cell
  doc.setFontSize(10);
  doc.setFont("sanserif", "bold");
  doc.text(
    "Cash",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
    cashSectionY + 7
  ); // Center text in the first column

  // Draw the "Cash" amount cell
  doc.text(
    "",
    cashSectionX +
      cashCellWidth +
      cashCellWidth / 2 -
      doc.getTextWidth("1000") / 2,
    cashSectionY + 7
  ); // Center text in the second column

  // Draw the outer border of the cash and amount cells
  doc.rect(cashSectionX, cashSectionY, cashCellWidth, 10); // Border for "Cash" label
  doc.rect(cashSectionX + cashCellWidth, cashSectionY, cashCellWidth, 10); // Border for the amount

  //detailed table

  const cGst = (GST || 0) / 2;

  const cGstFX = cGst.toFixed(2);

  const sGst = (GST || 0) / 2;

  const sGstFx = sGst.toFixed(2);

  const totalAmountNumber = Number(TotalAmount);
  const GSTNumber = Number(GST);

  // First column labels for gross amount, taxes, and discounts
  const leftColumn = [
    { label: "Gross Amount", value: `${totalAmountNumber.toFixed(2)}` },
    { label: "CGST 1.5%", value: `${Number(cGst).toFixed(2)}` },
    { label: "SGST 1.5%", value: `${Number(cGst).toFixed(2)}` },
    { label: "IGST 3%", value: `${GSTNumber.toFixed(2)}` },
    { label: "Hallmarking Amount", value: "" },
    {
      label: "Purchase Amount (-)",
      value: `${(totalAmountNumber + GSTNumber).toFixed(2)}`,
    },
    { label: "RO/Discount (-)", value: "" },
    {
      label: "Net Amount",
      value: `${(totalAmountNumber + GSTNumber).toFixed(2)}`,
    },
  ];

  // Dummy values for the right column
  const rightColumnValues = [
    `${totalAmountNumber.toFixed(2)}`,
    `${Number(cGstFX).toFixed(2)}`,
    `${Number(sGstFx).toFixed(2)}`,
    `${GSTNumber.toFixed(2)}`,
    "",
    `${(totalAmountNumber + GSTNumber).toFixed(2)}`,
    "",
    `${(totalAmountNumber + GSTNumber).toFixed(2)}`,
  ];

  // Set table starting position and dimensions
  const startX4 = 135; // Starting X position for the table
  const startY4 = 175; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  doc.setLineWidth(0.3);
  doc.rect(startX4, startY4, tableWidth4, tableHeight4); // Outer table border

  // Draw vertical line at the center
  doc.line(verticalLineX, startY4, verticalLineX, startY4 + tableHeight4); // Vertical line splitting the table

  // Fill in the left column labels and right column dummy values
  leftColumn.forEach((row, index) => {
    const ypos = startY4 + (index + 1) * cellHeight4 - 3; // Y position for the text

    // Draw left side labels
    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(`${row.label}`, startX4 + 2, ypos);

    // Draw right side dummy values
    const rightValue = rightColumnValues[index];
    doc.setFont("sanserif", "normal");
    doc.text(`${rightValue}`, verticalLineX + 2, ypos); // Right side column values

    // Draw horizontal line after each cell
    doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3); // Horizontal line across the row
  });

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text("Billng By - Admin", 100, 220);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text(
    "note:- we declare that this invoice shows actual price of the good described ",
    5,
    240
  );

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text("and that all particulars are true and correct", 5, 245);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("Customer Sign", 10, 285);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("(Saturday Closed )", 70, 285);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("Thank You !", 70, 290);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("For Mundlik Jewellers", 150, 285);

  // Generate the PDF and open it in a new window
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

const generateinvoicepdf71 = (items, customer, mainitem) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  // Draw a horizontal line
  doc.line(0, 35, 210, 35); // From (10, 50) to (200, 50)

  doc.setFont("sanserif", "bold");
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text("GOLD SALE", 90, 43);

  // First column data
  const firstColumn = [
    { label: "Name", value: "" },
    { label: "Address", value: "" },
    { label: "Mobile", value: "" },
    { label: "Pan/Adhar", value: "" },
  ];

  // Second column data
  const secondColumn = [
    { label: "Invoice No:", value: "" },
    { label: "Date:", value: "" },
    { label: "GSTIN No:", value: "" },
    { label: "GSTIN Type:", value: "" },
  ];

  // Set table starting position and dimensions
  const startX = 5;
  const startY = 45;
  const cellWidth = 80;
  const cellHeight = 10;

  doc.setLineWidth(0.3);
  doc.rect(startX, startY, 200, 40);

  // Define custom widths for each column
  const columnWidths = {
    Item: 18.18,
    HSN: 10.18,
    Purity: 15.18,
    Qty: 15.18,
    "Gr wt": 18.18,
    "Stone wt": 23.18,
    "Net wt": 18.18,
    "St amt": 18.18,
    "Rate/gm": 18.18,
    "Making/gm": 21.18,
    Amount: 24.18,
  };

  const columnArray = [
    "Item",
    "HSN",
    "Purity",
    "Qty",
    "Gr wt",
    "Stone wt",
    "Net wt",
    "St amt",
    "Rate/gm",
    "Making/gm",
    "Amount",
  ];

  // Calculate the starting X position for each column
  let currentX = 5;
  const tableWidth = 200; // Total width for the table

  // Draw the table header and vertical lines, and center the text in each column
  columnArray.forEach((title, index) => {
    const columnWidth = columnWidths[title] || 20; // Default to 20mm if not specified

    // Calculate the position to center the text in the column
    // const textX = currentX + columnWidth / 2 - doc.getTextWidth(title) / 2;

    const textX = currentX + 1;
    const cellY = 90; // Adjusted Y position to place text within the cell

    // Draw the centered text inside the cells
    doc.setFontSize(11);
    doc.setFont("sanserif", "bold");
    doc.text(title, textX, cellY); // Centered text in the cell

    // Draw the vertical line for each column
    if (index !== 0) {
      doc.line(currentX, 85, currentX, 170); // Vertical line from header to the bottom of the table
    }

    currentX += columnWidth; // Move to the next column position
  });

  // Draw the bottom line of the header row
  doc.rect(5, 85, tableWidth, 10); // Header bottom line

  // Body (you can add data here as needed)
  firstColumn.forEach((row, index) => {
    const ypos = startY + (index + 0.7) * cellHeight;

    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(`${row.label} :`, startX + 2, ypos);
    doc.text(row.value, startX + cellWidth / 2, ypos); // Centered within the first column
  });

  secondColumn.forEach((row, index) => {
    const ypos = startY + (index + 0.7) * cellHeight;

    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(`${row.label} `, 60 + cellWidth + 2, ypos); // Left padding of 2 in the second column
    doc.text(row.value, startX + (cellWidth * 4) / 2, ypos); // Centered within the second column
  });

  // Draw the outer table border (adjust height to fit the table content)
  doc.rect(5, 85, tableWidth, 85);

  const overallStatsTable = ["Item", "Net wt", "Gross wt", "Amount"];

  let currentX2 = 5;
  const tableWidth2 = 100;

  const ColumnCount = overallStatsTable.length;
  const ColumnWidth = tableWidth2 / ColumnCount;

  // Draw the table header and vertical lines, and center the text in each column
  overallStatsTable.forEach((title, index) => {
    const textX = currentX2 + ColumnWidth / 2 - doc.getTextWidth(title) / 2;
    const cellY = 180; // Starting Y position for the table header

    // Draw the centered text inside the cells
    doc.setFontSize(10);
    doc.text(title, textX, cellY); // Centered text in the cell

    // // Draw vertical lines for the columns
    if (index !== 0) {
      doc.line(currentX2, 175, currentX2, 195); // Vertical line from header to bottom
    }

    // Move to the next column position
    currentX2 += ColumnWidth;
  });

  // Draw the outer border of the table (header + empty cells)
  doc.rect(5, 175, tableWidth2, 10 + cellHeight); // Table outer border

  // Draw the horizontal line between the header row and the empty cells for values
  doc.line(5, 177 + 10, 5 + tableWidth2, 177 + 10);

  //draw cash table
  doc.setFont("sanserif", "bold");

  // Now create a second section with two columns: "Cash" and its amount
  const cashSectionX = 5; // Starting X position for the cash section
  const cashSectionY = 199;
  const cashCellWidth = 50; // Width of each column for the cash table

  // Draw the "Cash" label cell
  doc.setFontSize(10);
  doc.setFont("sanserif", "bold");
  doc.text(
    "Cash",
    cashSectionX + cashCellWidth / 2 - doc.getTextWidth("Cash") / 2,
    cashSectionY + 7
  ); // Center text in the first column

  // Draw the "Cash" amount cell
  doc.text(
    "",
    cashSectionX +
      cashCellWidth +
      cashCellWidth / 2 -
      doc.getTextWidth("1000") / 2,
    cashSectionY + 7
  ); // Center text in the second column

  // Draw the outer border of the cash and amount cells
  doc.rect(cashSectionX, cashSectionY, cashCellWidth, 10); // Border for "Cash" label
  doc.rect(cashSectionX + cashCellWidth, cashSectionY, cashCellWidth, 10); // Border for the amount

  //detailed table

  // First column labels for gross amount, taxes, and discounts
  const leftColumn = [
    { label: "Gross Amount", value: "" },
    { label: "CGST 1.5%", value: "" },
    { label: "SGST 1.5%", value: "" },
    { label: "IGST 3%", value: "" },
    { label: "Hallmarking Amount", value: "" },
    { label: "Purchase Amount (-)", value: "" },
    { label: "RO/Discount (-)", value: "" },
    { label: "Net Amount", value: "" },
  ];

  // Dummy values for the right column
  const rightColumnValues = ["", "", "", "", "", "", "", ""];

  // Set table starting position and dimensions
  const startX4 = 135; // Starting X position for the table
  const startY4 = 175; // Starting Y position for the table
  const tableWidth4 = 70; // Table width
  const tableHeight4 = 80; // Table height (adjust based on number of rows)
  const cellHeight4 = 10; // Height for each cell row
  const verticalLineX = startX4 + tableWidth4 / 2; // X position for the center vertical line

  doc.setLineWidth(0.3);
  doc.rect(startX4, startY4, tableWidth4, tableHeight4); // Outer table border

  // Draw vertical line at the center
  doc.line(verticalLineX, startY4, verticalLineX, startY4 + tableHeight4); // Vertical line splitting the table

  // Fill in the left column labels and right column dummy values
  leftColumn.forEach((row, index) => {
    const ypos = startY4 + (index + 1) * cellHeight4 - 3; // Y position for the text

    // Draw left side labels
    doc.setFontSize(10);
    doc.setFont("sanserif", "bold");
    doc.text(`${row.label}`, startX4 + 2, ypos);

    // Draw right side dummy values
    const rightValue = rightColumnValues[index];
    doc.setFont("sanserif", "normal");
    doc.text(`${rightValue}`, verticalLineX + 2, ypos); // Right side column values

    // Draw horizontal line after each cell
    doc.line(startX4, ypos + 3, startX4 + tableWidth4, ypos + 3); // Horizontal line across the row
  });

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text("Billng By - Admin", 100, 220);

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text(
    "note:- we declare that this invoice shows actual price of the good described ",
    5,
    240
  );

  doc.setFont("sanserif", "normal");
  doc.setFontSize(10);
  doc.text("and that all particulars are true and correct", 5, 245);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("Customer Sign", 10, 285);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("(Saturday Closed )", 70, 285);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("Thank You !", 70, 290);

  doc.setFont("sanserif", "bold");
  doc.setFontSize(10);
  doc.text("For Mundlik Jewellers", 150, 285);

  // Generate the PDF and open it in a new window
  // const pdfData = doc.output("datauristring");
  // const newWindow = window.open();
  // newWindow.document.write(
  //   <iframe width='100%' height='100%' src='${pdfData}'></iframe>
  // );

  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

const generateinvoicepdf12 = (items, customer) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });
  const dummyData = generateDummyData();
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const marginTop = 100;
  const marginBottom = 40;
  const rowHeight = 10; // Initial row height
  const tableHeight = 130; // Fixed table height
  let currentY = marginTop;
  const invoicex = pageWidth - 50;
  const invoicey = 60;
  const customerx = pageWidth - page;
  const customery = 60;

  console.log("checkpagewidth  ", pageWidth);

  // Define the column positions
  const columnPositions = {
    sr: pageWidth - 200,
    productDetails: pageWidth - 190,
    pcs: pageWidth - 150,
    hsnCode: pageWidth - 140,
    grossWt: pageWidth - 120,
    netWt: pageWidth - 90,
    rate: pageWidth - 60,
    amount: pageWidth - 40,
  };

  // Draw the table structure dynamically
  const drawTableStructure = () => {
    // Vertical Lines (for column separators)
    // doc.line(10, marginTop, 10, marginTop + tableHeight); // Left border
    Object.values(columnPositions).forEach((pos) => {
      doc.line(pos, marginTop, pos, marginTop + tableHeight); // Column separators
    });
    doc.line(
      pageWidth - 10,
      marginTop,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Right border
  };

  const drawTableHeader = () => {
    doc.setFontSize(10);
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header top line
    currentY += 5;

    // Draw the header text
    doc.text("Sr.", columnPositions.sr + 2, currentY);
    doc.text("Product Details", columnPositions.productDetails + 2, currentY);
    doc.text("Pcs", columnPositions.pcs + 2, currentY);
    doc.text("HSN Code", columnPositions.hsnCode + 2, currentY);
    doc.text("Gross Wt", columnPositions.grossWt + 2, currentY);
    doc.text("Net Wt", columnPositions.netWt + 2, currentY);
    doc.text("Rate / gm", columnPositions.rate + 2, currentY);
    doc.text("Amount", columnPositions.amount + 2, currentY);

    currentY += 5;
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header bottom line
    currentY += 5;

    doc.line(
      columnPositions.sr,
      marginTop + tableHeight,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Table header top line
  };

  const drawFooter = () => {
    doc.text("Taxable Amount", fotertotalx, fotertotaly + 10);
    doc.text("CGST@1.5%", fotertotalx, fotertotaly + 15);
    doc.text("SGST@1.5%", fotertotalx, fotertotaly + 20);
    doc.text("IGST@  3%", fotertotalx, fotertotaly + 25);
    doc.text("Total Invoice Amount", fotertotalx, fotertotaly + 30);
    doc.text("Amount Received", fotertotalx, fotertotaly + 35);
    doc.text("Balance Amount", fotertotalx, fotertotaly + 40);
    doc.text("Taxable Amount", 2, fotertotaly + 45);

    // doc.text('HSN/SAC: 7108', 14, currentY + 10);
    // doc.text('Taxable Amount: 47801.60', 14, currentY + 15);
    // doc.text('CGST @ 1.50%: 717.02', 14, currentY + 20);
    // doc.text('SGST @ 1.50%: 717.02', 14, currentY + 25);
    // doc.text('IGST: 0.00', 14, currentY + 30);
    // doc.text('Round Off: 0.36', 14, currentY + 35);
    // doc.setFontSize(12);
    // doc.text('Grand Total: 49236.00', 160, currentY + 35);
    // doc.setFontSize(10);
    // doc.text('For Manan Softwares', 160, currentY + 45);
    // doc.text('Authorised Signatory', 160, currentY + 50);
  };

  const drawTableRows = () => {
    items.forEach((item, index) => {
      // Determine text lines and adjust currentY for each row
      const productDetailsLines = doc.splitTextToSize(
        item.ProductName,
        columnPositions.amount - columnPositions.productDetails - 5
      ); // Adjust width as needed
      const rowCount = Math.max(
        productDetailsLines.length,
        1 // To ensure there's at least one row
      );

      if (
        currentY + rowCount * rowHeight >
        pageHeight - marginBottom - tableHeight
      ) {
        doc.addPage(); // Add a new page if needed
        currentY = marginTop;
        drawTableHeader();
        drawTableStructure();
      }

      // Draw row data
      doc.text(`${index + 1}`, columnPositions.sr + 2, currentY);
      productDetailsLines.forEach((line, lineIndex) => {
        doc.text(
          line,
          columnPositions.productDetails + 2,
          currentY + lineIndex * rowHeight
        );
      });
      doc.text(item.Quantity || "1", columnPositions.pcs + 2, currentY);
      doc.text(item.HSNCode || "0", columnPositions.hsnCode + 2, currentY);
      doc.text(item.GrossWt, columnPositions.grossWt + 2, currentY);
      doc.text(item.NetWt, columnPositions.netWt + 2, currentY);
      doc.text(item.MetalRate || "0", columnPositions.rate + 2, currentY);
      doc.text(item.TotalAmount || "0", columnPositions.amount + 2, currentY);

      // Update currentY based on the row count
      currentY += rowCount * rowHeight; // Adjust currentY based on the number of lines
    });
  };

  // Start generating the PDF
  doc.text("TAX INVOICE", 90, 50);
  doc.setFontSize(10);
  doc.text("Invoice No :-", invoicex, invoicey);
  doc.text("Date :-", invoicex, invoicey + 5);

  doc.text("Customer Name :-", customerx, customery);
  doc.text("Mobile No :-", customerx, customery + 5);
  doc.text("Address :-", customerx, customery + 5);

  drawTableHeader();
  drawTableStructure();
  drawTableRows();

  // Add the footer to the last page
  drawFooter();

  // Open the PDF
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};

const generatepdf2 = (csData, invoiceItems) => {
  const doc = new jsPDF({
    orientation: "portrait",
    format: "a4",
  });
  console.log(csData, "csData44444");
  console.log(invoiceItems, "csData44444");
  let Total = 0;
  doc.setDrawColor(0, 0, 0, 0.3);
  doc.setFontSize(12);
  doc.setFont("times");
  // if (csData?.billType === "false") {
  //   doc.text(`${csData?.orderType}`, 90, 47.5);
  // } else {
  //   doc.text(`${`billType`}`, 90, 47.5);
  // }
  doc.setFontSize(10);
  doc.line(5, 44, 205, 44);
  doc.line(5, 290, 205, 290);
  doc.line(5, 44, 5, 290);
  doc.line(205, 44, 205, 290);
  doc.line(5, 48, 205, 48);
  doc.setFont("times");

  const startY = 47.5;
  const headerY = 51;
  const maxPageHeight = doc.internal.pageSize.height - 20;
  let y = headerY;

  const renderAddress = (label, customer, y) => {
    doc.line(5, y + 22, 115, y + 22);
    doc.text(label, 6, y);
    doc.setFont("times", "bold");
    doc.text(
      `${customer.FirstName || ""} ${customer.LastName || ""}`,
      6,
      y + 4
    );
    doc.setFont("times", "normal");
    doc.text(`${customer.CurrAddStreet || "Street"}`, 6, y + 8);
    doc.text(`${customer.CurrAddTown || "Town"}`, 6, y + 12);
    doc.text(`Gst No. - ${customer.GstNo || "Gst No."}`, 6, y + 16);
    doc.text(
      `${customer.CurrAddState || ""} ${customer.CurrAddPincode || "Pan No. "}`,
      6,
      y + 20
    );
  };

  if (csData) {
    // Invoice Header
    doc.text(`${csData?.orderType || ""}`, 90, startY);

    // Consignee (Ship to)
    renderAddress("Consignee (Ship to)", csData?.Customer, y);

    doc.text(`Invoice No - ${csData?.invoiceNo || ""}`, 120, y);
    // doc.text(`Invoice Date - ${new Date(csData?.createdOn).toLocaleDateString("en-GB")}`, 120, y + 4);
    doc.text(`Invoice Date - ${csData?.InvoiceDate || ""}`, 120, y + 4);

    y += 27; // Adjust y position

    // Buyer (Bill to)
    renderAddress("Buyer (Bill to)", csData?.Customer, y);
    doc.line(115, y - 30, 115, y + 21);
  }

  doc.line(5, y + 21, 205, y + 21);
  y += 26; // Adjust y position

  // Table Header
  doc.setFontSize(9);
  doc.text("S.No", 6, y);
  doc.text("Description Of Goods", 15, y);
  doc.text("HSN", 70, y);
  doc.text("Pcs", 85, y);
  doc.text("Purity", 95, y);
  doc.text("Gross", 105, y);
  doc.text("Wt", 105, y + 3);
  doc.text("Net", 117, y);
  doc.text("Wt", 117, y + 3);
  doc.text("Other", 130, y);
  doc.text("Charges", 130, y + 3);
  doc.text("Rate", 145, y);
  doc.text("Amount", 160, y);
  doc.text("Hallmark", 175, y);
  doc.text("Charges", 175, y + 3);
  doc.text("Total", 190, y);
  doc.text("Amount", 190, y + 3);
  doc.line(5, y + 5, 205, y + 5);

  y += 10;

  // Invoice Items
  let srNo = 1;
  let totalQuantity = 0;
  let totalGrossWt = 0;
  let totalNetWt = 0;
  let totalStoneAmount = 0;
  let totalNetAmount = 0;
  let totalHallmarkCharges = 0;
  let totalProductAmount = 0;

  doc.setFontSize(8);

  invoiceItems.forEach((item) => {
    let totalAmount = 0;
    if (y + 8 > maxPageHeight) {
      doc.addPage();
      y = 10;
    }
    let OtherCharges = 0;
    let NetCharges = 0;
    let HallmarkCharges = 0;
    const productName =
      item.ProductName.length > 15
        ? `${item.ProductName.substring(0, 15)}...`
        : item.ProductName;
    doc.text(srNo.toString(), 6, y);
    doc.text(`${item.Purity || ""} ${productName || ""}`, 15, y);
    doc.text(`${item.HSNCode || "-"}`, 70, y);
    doc.text(`${item.Quantity !== "undefined" ? item.Quantity : "-"}`, 85, y);
    doc.text(`${item.Purity || "-"}`, 95, y);
    doc.text(`${item.GrossWt || "-"}`, 105, y);
    doc.text(`${item.NetWt || "-"}`, 117, y);
    if (item.MRP !== 0 && item.MRP !== "" && item.MRP !== "0") {
      doc.text(`MRP -`, 130, y);
      doc.text(`${parseFloat(item.MRP)?.toFixed(2)}`, 145, y);
      OtherCharges = Number(item.MRP);
    } else {
      doc.text(item.MetalRate ? item.MetalRate : "-", 130, y);
      doc.text(
        parseFloat(
          (parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt)
        )?.toFixed(2),
        145,
        y
      );
      OtherCharges = Number(
        (parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt)
      );
    }

    doc.text(
      parseFloat(
        parseFloat(parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt) +
          parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
          parseFloat(item.StoneAmount ? item.StoneAmount : 0)
      )?.toFixed(2),
      160,
      y
    );
    NetCharges += parseFloat(
      parseFloat(parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt) +
        parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
        parseFloat(item.StoneAmount ? item.StoneAmount : 0)
    );
    doc.text(item.HallmarkAmount ? `${item.HallmarkAmount}` : "-", 175, y);
    HallmarkCharges += parseFloat(
      item.HallmarkAmount ? item.HallmarkAmount : 0
    );
    totalAmount =
      item.MRP !== 0 && item.MRP !== "" && item.MRP !== "0"
        ? parseFloat(item.MRP ? item.MRP : 0) +
            parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
            parseFloat(item.StoneAmount ? item.StoneAmount : 0) || 0
        : parseFloat(
            parseFloat(parseFloat(item.MetalRate) / 10) *
              parseFloat(item.NetWt) +
              parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
              parseFloat(item.StoneAmount ? item.StoneAmount : 0) || 0
          );
    Total += totalAmount;
    // doc.text(`${item.StoneAmount || "-"}`, 130, y);
    // doc.text(`${item.MetalRate || "-"}`, 145, y);
    // doc.text(`${item.Amount || "-"}`, 160, y);
    // doc.text(`${item.HallmarkAmount || "-"}`, 175, y);
    doc.text(`${totalAmount || "-"}`, 190, y);

    totalQuantity +=
      parseFloat(item.Quantity !== "undefined" ? item.Quantity : 0) || 0;
    totalGrossWt += parseFloat(item.GrossWt) || 0;
    totalNetWt += parseFloat(item.NetWt) || 0;
    // totalStoneAmount += parseFloat(item.StoneAmount) || 0;
    totalStoneAmount += OtherCharges;
    // totalNetAmount += parseFloat(item.NetAmount) || 0;
    totalNetAmount += NetCharges;
    // totalHallmarkCharges += parseFloat(item.HallmarkAmount) || 0;
    totalHallmarkCharges += HallmarkCharges;
    totalProductAmount += parseFloat(totalAmount) || 0;

    srNo++;
    y += 8;
  });

  doc.line(5, y - 3, 205, y - 3);

  doc.setFont("times", "bold");
  doc.text("Total", 10, y);
  doc.text(totalQuantity.toFixed(0), 85, y);
  doc.text(totalGrossWt.toFixed(3), 105, y);
  doc.text(totalNetWt.toFixed(3), 117, y);
  doc.text(totalStoneAmount?.toFixed(2), 130, y);
  doc.text(totalNetAmount?.toFixed(2), 160, y);
  doc.text(totalHallmarkCharges?.toFixed(2), 175, y);
  doc.text(totalProductAmount?.toFixed(2), 190, y);

  y += 10;

  // Payment Modes
  if (csData?.paymentMode) {
    const paymentModes = csData?.paymentMode.split(",");
    doc.setFontSize(9);
    doc.text("Payment Mode", 10, y);
    let yPaymentModes = y + 5;
    paymentModes.forEach((paymentMode) => {
      if (yPaymentModes > maxPageHeight - 10) {
        doc.addPage();
        yPaymentModes = 5;
      }
      const [mode, amount] = paymentMode.split(":");
      doc.text(mode, 10, yPaymentModes);
      doc.text(amount, 40, yPaymentModes);
      yPaymentModes += 5;
    });
    y = yPaymentModes + 10;
  }

  // Summary
  const totalSaleAmount = invoiceItems.reduce((total, product) => {
    return total + parseFloat((parseFloat(product.Amount) * 100) / 103 || 0);
  }, 0);

  const payableGst = totalSaleAmount * 0.03;

  if (csData?.Customer.currAddState === "Maharashtra") {
    doc.text(`Sales Amount:`, 155, y);
    doc.text(`${totalSaleAmount?.toFixed(2)}`, 185, y);
    doc.text(`R.O./Discount:`, 155, y + 5);
    doc.text(`${csData?.offer || 0}`, 185, y + 5);
    doc.text(`CGST 1.5%:`, 155, y + 10);
    // doc.text(`${(payableGst / 2)?.toFixed(2)}`, 185, y + 10);
    doc.text(`${(Number(csData?.GST) / 2 || 0)?.toFixed(2)}`, 185, y + 15);
    doc.text(`SGST 1.5%:`, 155, y + 15);
    // doc.text(`${(payableGst / 2)?.toFixed(2)}`, 185, y + 15);
    doc.text(`${(Number(csData?.GST) / 2 || 0)?.toFixed(2)}`, 185, y + 15);
  } else {
    doc.text(`Sales Amount:`, 155, y);
    doc.text(`${totalSaleAmount?.toFixed(2)}`, 185, y);
    doc.text(`R.O./Discount:`, 155, y + 5);
    doc.text(`${csData?.offer || 0}`, 185, y + 5);
    doc.text(`IGST 3%:`, 155, y + 10);
    // doc.text(`${payableGst?.toFixed(2)}`, 185, y + 10);
    doc.text(`${Number(csData?.GST)?.toFixed(2)}`, 185, y + 10);
  }

  doc.text(`Purchase Amount (-):`, 155, y + 15);
  doc.text(
    `${parseFloat(csData?.UrdPurchaseAmt || 0)?.toFixed(2)}`,
    185,
    y + 15
  );
  doc.text(`Received Amount:`, 155, y + 20);
  doc.text(
    `${parseFloat(csData?.ReceivedAmount || 0)?.toFixed(2)}`,
    185,
    y + 20
  );
  doc.text(`Balance Amount:`, 155, y + 25);
  // doc.text(
  //   `${(Number(csData?.TotalAmount||0) - Number(csData?.receivedAmt||0))?.toFixed(2)}`,
  //   185,
  //   y + 25
  // );
  doc.text(`${parseFloat(csData?.BalanceAmt || 0)?.toFixed(2)}`, 185, y + 25);
  doc.text(`Total:`, 155, y + 30);
  doc.text(`${Number(csData?.TotalAmount || 0).toFixed(2)}`, 185, y + 30);

  // Footer
  // doc.setFont("times", "bold");
  // doc.setFontSize(11);
  // doc.text("for TMJ Enterprises", 155, y + 45);
  // doc.setFont("times", "normal");
  // doc.setFontSize(10);
  // doc.text("Authorised Signatory", 160, y + 55);

  let footerY = doc.internal.pageSize.height - 50;
  doc.setFontSize(9);
  // doc.text("Raja Bazar, P.O. Jatni-752050, Khordha (Odisha)", 10, footerY);
  // doc.text("Phone Number: 0674-2492089 ", 10, footerY + 4);
  // doc.text("Mobile / Whatsapp: +91 7978114496 ", 10, footerY + 8);
  // doc.text("Customer Signature", 10, footerY);
  doc.setFont("times", "bold");
  doc.line(5, footerY - 4, 205, footerY - 4);
  doc.text("Terms And Conditions :- ", 10, footerY);
  doc.setFont("times", "normal");
  doc.text(
    `Note: - No Eway Bill is required to be Generated as the Goods covered under this Invoice are Exempted as per Serial No. 4/5 to the Annexure `,
    10,
    footerY + 5
  );
  doc.text(`to Rule 138(14) of the CGST Rules.`, 10, footerY + 9);
  doc.text(
    `Consumer can get the purity of the Hallmarked Jewellery / Artifacts verified from any of the BIS recognized A & H Center`,
    10,
    footerY + 13
  );
  doc.text(
    `List of BIS recognized A & H center along with address and contact details is available on the webiste "www.bis.gov.in"`,
    10,
    footerY + 17
  );
  doc.text(`Hallmark Charges is Rs 45 Per Piece`, 10, footerY + 21);
  doc.text(
    `This Bill includes Labour Charges, Hallmark Charges, Stone/Beads/Mina and other Charges `,
    10,
    footerY + 25
  );
  doc.setFont("times", "bold");
  doc.setFontSize(10);
  doc.text(`Receivers Signature`, 10, footerY + 42);
  doc.setFont("times", "normal");
  doc.setFontSize(7);
  doc.line(5, footerY + 27, 205, footerY + 27);

  // Save PDF
  doc.save(`Invoice-${csData?.invoiceNo}.pdf`);
};

const generatepdf1 = (csData, invoiceItems) => {
  const doc = new jsPDF({
    orientation: "portrait",
    format: "a4",
  });
  console.log(csData, "csData44444");
  console.log(invoiceItems, "csData44444");
  let Total = 0;
  doc.setDrawColor(0, 0, 0, 0.3);
  doc.setFontSize(12);
  doc.setFont("times");
  // if (csData?.billType === "false") {
  //   doc.text(`${csData?.orderType}`, 90, 47.5);
  // } else {
  //   doc.text(`${`billType`}`, 90, 47.5);
  // }
  doc.setFontSize(10);
  doc.line(5, 44, 205, 44);
  doc.line(5, 290, 205, 290);
  doc.line(5, 44, 5, 290);
  doc.line(205, 44, 205, 290);
  doc.line(5, 48, 205, 48);
  doc.setFont("times");

  const startY = 47.5;
  const headerY = 51;
  const maxPageHeight = doc.internal.pageSize.height - 20;
  let y = headerY;

  const renderAddress = (label, customer, y) => {
    doc.line(5, y + 22, 115, y + 22);
    doc.text(label, 6, y);
    doc.setFont("times", "bold");
    doc.text(
      `${customer.FirstName || ""} ${customer.LastName || ""}`,
      6,
      y + 4
    );
    doc.setFont("times", "normal");
    doc.text(`${customer.CurrAddStreet || "Street"}`, 6, y + 8);
    doc.text(`${customer.CurrAddTown || "Town"}`, 6, y + 12);
    doc.text(`Gst No. - ${customer.GstNo || "Gst No."}`, 6, y + 16);
    doc.text(
      `${customer.CurrAddState || ""} ${customer.CurrAddPincode || "Pan No. "}`,
      6,
      y + 20
    );
  };

  if (csData) {
    // Invoice Header
    doc.text(`${csData?.orderType || ""}`, 90, startY);

    // Consignee (Ship to)
    renderAddress("Consignee (Ship to)", csData?.Customer, y);

    doc.text(`Invoice No - ${csData?.invoiceNo || ""}`, 120, y);
    // doc.text(`Invoice Date - ${new Date(csData?.createdOn).toLocaleDateString("en-GB")}`, 120, y + 4);
    doc.text(`Invoice Date - ${csData?.InvoiceDate || ""}`, 120, y + 4);

    y += 27; // Adjust y position

    // Buyer (Bill to)
    renderAddress("Buyer (Bill to)", csData?.Customer, y);
    doc.line(115, y - 30, 115, y + 21);
  }

  doc.line(5, y + 21, 205, y + 21);
  y += 26; // Adjust y position

  // Table Header
  doc.setFontSize(9);
  doc.text("S.No", 6, y);
  doc.text("Design", 15, y);
  doc.text("Particular", 30, y);
  doc.text("GrossWt", 70, y);
  doc.text("Pcs", 85, y);
  doc.text("Purity", 95, y);
  doc.text("Gross", 105, y);
  doc.text("Wt", 105, y + 3);
  doc.text("Net", 117, y);
  doc.text("Wt", 117, y + 3);
  doc.text("Other", 130, y);
  doc.text("Charges", 130, y + 3);
  doc.text("Rate", 145, y);
  doc.text("Amount", 160, y);
  doc.text("Hallmark", 175, y);
  doc.text("Charges", 175, y + 3);
  doc.text("Total", 190, y);
  doc.text("Amount", 190, y + 3);
  doc.line(5, y + 5, 205, y + 5);

  y += 10;

  // Invoice Items
  let srNo = 1;
  let totalQuantity = 0;
  let totalGrossWt = 0;
  let totalNetWt = 0;
  let totalStoneAmount = 0;
  let totalNetAmount = 0;
  let totalHallmarkCharges = 0;
  let totalProductAmount = 0;

  doc.setFontSize(8);

  invoiceItems.forEach((item) => {
    let totalAmount = 0;
    if (y + 8 > maxPageHeight) {
      doc.addPage();
      y = 10;
    }
    let OtherCharges = 0;
    let NetCharges = 0;
    let HallmarkCharges = 0;
    const productName =
      item.ProductName.length > 15
        ? `${item.ProductName.substring(0, 15)}...`
        : item.ProductName;
    doc.text(srNo.toString(), 6, y);
    doc.text(`${item.Purity || ""} ${productName || ""}`, 15, y);
    doc.text(`${item.HSNCode || "-"}`, 70, y);
    doc.text(`${item.Quantity !== "undefined" ? item.Quantity : "-"}`, 85, y);
    doc.text(`${item.Purity || "-"}`, 95, y);
    doc.text(`${item.GrossWt || "-"}`, 105, y);
    doc.text(`${item.NetWt || "-"}`, 117, y);
    if (item.MRP !== 0 && item.MRP !== "" && item.MRP !== "0") {
      doc.text(`MRP -`, 130, y);
      doc.text(`${parseFloat(item.MRP)?.toFixed(2)}`, 145, y);
      OtherCharges = Number(item.MRP);
    } else {
      doc.text(item.MetalRate ? item.MetalRate : "-", 130, y);
      doc.text(
        parseFloat(
          (parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt)
        )?.toFixed(2),
        145,
        y
      );
      OtherCharges = Number(
        (parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt)
      );
    }

    doc.text(
      parseFloat(
        parseFloat(parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt) +
          parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
          parseFloat(item.StoneAmount ? item.StoneAmount : 0)
      )?.toFixed(2),
      160,
      y
    );
    NetCharges += parseFloat(
      parseFloat(parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt) +
        parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
        parseFloat(item.StoneAmount ? item.StoneAmount : 0)
    );
    doc.text(item.HallmarkAmount ? `${item.HallmarkAmount}` : "-", 175, y);
    HallmarkCharges += parseFloat(
      item.HallmarkAmount ? item.HallmarkAmount : 0
    );
    totalAmount =
      item.MRP !== 0 && item.MRP !== "" && item.MRP !== "0"
        ? parseFloat(item.MRP ? item.MRP : 0) +
            parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
            parseFloat(item.StoneAmount ? item.StoneAmount : 0) || 0
        : parseFloat(
            parseFloat(parseFloat(item.MetalRate) / 10) *
              parseFloat(item.NetWt) +
              parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
              parseFloat(item.StoneAmount ? item.StoneAmount : 0) || 0
          );
    Total += totalAmount;
    // doc.text(`${item.StoneAmount || "-"}`, 130, y);
    // doc.text(`${item.MetalRate || "-"}`, 145, y);
    // doc.text(`${item.Amount || "-"}`, 160, y);
    // doc.text(`${item.HallmarkAmount || "-"}`, 175, y);
    doc.text(`${totalAmount || "-"}`, 190, y);

    totalQuantity +=
      parseFloat(item.Quantity !== "undefined" ? item.Quantity : 0) || 0;
    totalGrossWt += parseFloat(item.GrossWt) || 0;
    totalNetWt += parseFloat(item.NetWt) || 0;
    // totalStoneAmount += parseFloat(item.StoneAmount) || 0;
    totalStoneAmount += OtherCharges;
    // totalNetAmount += parseFloat(item.NetAmount) || 0;
    totalNetAmount += NetCharges;
    // totalHallmarkCharges += parseFloat(item.HallmarkAmount) || 0;
    totalHallmarkCharges += HallmarkCharges;
    totalProductAmount += parseFloat(totalAmount) || 0;

    srNo++;
    y += 8;
  });

  doc.line(5, y - 3, 205, y - 3);

  doc.setFont("times", "bold");
  doc.text("Total", 10, y);
  doc.text(totalQuantity.toFixed(0), 85, y);
  doc.text(totalGrossWt.toFixed(3), 105, y);
  doc.text(totalNetWt.toFixed(3), 117, y);
  doc.text(totalStoneAmount?.toFixed(2), 130, y);
  doc.text(totalNetAmount?.toFixed(2), 160, y);
  doc.text(totalHallmarkCharges?.toFixed(2), 175, y);
  doc.text(totalProductAmount?.toFixed(2), 190, y);

  y += 10;

  // Payment Modes
  if (csData?.paymentMode) {
    const paymentModes = csData?.paymentMode.split(",");
    doc.setFontSize(9);
    doc.text("Payment Mode", 10, y);
    let yPaymentModes = y + 5;
    paymentModes.forEach((paymentMode) => {
      if (yPaymentModes > maxPageHeight - 10) {
        doc.addPage();
        yPaymentModes = 5;
      }
      const [mode, amount] = paymentMode.split(":");
      doc.text(mode, 10, yPaymentModes);
      doc.text(amount, 40, yPaymentModes);
      yPaymentModes += 5;
    });
    y = yPaymentModes + 10;
  }

  // Summary
  const totalSaleAmount = invoiceItems.reduce((total, product) => {
    return total + parseFloat((parseFloat(product.Amount) * 100) / 103 || 0);
  }, 0);

  const payableGst = totalSaleAmount * 0.03;

  if (csData?.Customer.currAddState === "Maharashtra") {
    doc.text(`Sales Amount:`, 155, y);
    doc.text(`${totalSaleAmount?.toFixed(2)}`, 185, y);
    doc.text(`R.O./Discount:`, 155, y + 5);
    doc.text(`${csData?.offer || 0}`, 185, y + 5);
    doc.text(`CGST 1.5%:`, 155, y + 10);
    // doc.text(`${(payableGst / 2)?.toFixed(2)}`, 185, y + 10);
    doc.text(`${(Number(csData?.GST) / 2 || 0)?.toFixed(2)}`, 185, y + 15);
    doc.text(`SGST 1.5%:`, 155, y + 15);
    // doc.text(`${(payableGst / 2)?.toFixed(2)}`, 185, y + 15);
    doc.text(`${(Number(csData?.GST) / 2 || 0)?.toFixed(2)}`, 185, y + 15);
  } else {
    doc.text(`Sales Amount:`, 155, y);
    doc.text(`${totalSaleAmount?.toFixed(2)}`, 185, y);
    doc.text(`R.O./Discount:`, 155, y + 5);
    doc.text(`${csData?.offer || 0}`, 185, y + 5);
    doc.text(`IGST 3%:`, 155, y + 10);
    // doc.text(`${payableGst?.toFixed(2)}`, 185, y + 10);
    doc.text(`${Number(csData?.GST)?.toFixed(2)}`, 185, y + 10);
  }

  doc.text(`Purchase Amount (-):`, 155, y + 15);
  doc.text(
    `${parseFloat(csData?.UrdPurchaseAmt || 0)?.toFixed(2)}`,
    185,
    y + 15
  );
  doc.text(`Received Amount:`, 155, y + 20);
  doc.text(
    `${parseFloat(csData?.ReceivedAmount || 0)?.toFixed(2)}`,
    185,
    y + 20
  );
  doc.text(`Balance Amount:`, 155, y + 25);
  // doc.text(
  //   `${(Number(csData?.TotalAmount||0) - Number(csData?.receivedAmt||0))?.toFixed(2)}`,
  //   185,
  //   y + 25
  // );
  doc.text(`${parseFloat(csData?.BalanceAmt || 0)?.toFixed(2)}`, 185, y + 25);
  doc.text(`Total:`, 155, y + 30);
  doc.text(`${Number(csData?.TotalAmount || 0).toFixed(2)}`, 185, y + 30);

  // Footer
  // doc.setFont("times", "bold");
  // doc.setFontSize(11);
  // doc.text("for TMJ Enterprises", 155, y + 45);
  // doc.setFont("times", "normal");
  // doc.setFontSize(10);
  // doc.text("Authorised Signatory", 160, y + 55);

  let footerY = doc.internal.pageSize.height - 50;
  doc.setFontSize(9);
  // doc.text("Raja Bazar, P.O. Jatni-752050, Khordha (Odisha)", 10, footerY);
  // doc.text("Phone Number: 0674-2492089 ", 10, footerY + 4);
  // doc.text("Mobile / Whatsapp: +91 7978114496 ", 10, footerY + 8);
  // doc.text("Customer Signature", 10, footerY);
  doc.setFont("times", "bold");
  doc.line(5, footerY - 4, 205, footerY - 4);
  doc.text("Terms And Conditions :- ", 10, footerY);
  doc.setFont("times", "normal");
  doc.text(
    `Note: - No Eway Bill is required to be Generated as the Goods covered under this Invoice are Exempted as per Serial No. 4/5 to the Annexure `,
    10,
    footerY + 5
  );
  doc.text(`to Rule 138(14) of the CGST Rules.`, 10, footerY + 9);
  doc.text(
    `Consumer can get the purity of the Hallmarked Jewellery / Artifacts verified from any of the BIS recognized A & H Center`,
    10,
    footerY + 13
  );
  doc.text(
    `List of BIS recognized A & H center along with address and contact details is available on the webiste "www.bis.gov.in"`,
    10,
    footerY + 17
  );
  doc.text(`Hallmark Charges is Rs 45 Per Piece`, 10, footerY + 21);
  doc.text(
    `This Bill includes Labour Charges, Hallmark Charges, Stone/Beads/Mina and other Charges `,
    10,
    footerY + 25
  );
  doc.setFont("times", "bold");
  doc.setFontSize(10);
  doc.text(`Receivers Signature`, 10, footerY + 42);
  doc.setFont("times", "normal");
  doc.setFontSize(7);
  doc.line(5, footerY + 27, 205, footerY + 27);

  // Save PDF
  doc.save(`Invoice-${csData?.invoiceNo}.pdf`);
};

const generatepdf = (csData, invoiceItems) => {
  const doc = new jsPDF({
    orientation: "portrait",
    format: "a4",
  });
  console.log(csData, "csData44444");
  console.log(invoiceItems, "csData44444");
  let Total = 0;
  doc.setDrawColor(0, 0, 0, 0.3);
  doc.setFontSize(12);
  doc.setFont("times");
  // if (csData?.billType === "false") {
  //   doc.text(`${csData?.orderType}`, 90, 47.5);
  // } else {
  //   doc.text(`${`billType`}`, 90, 47.5);
  // }
  doc.setFontSize(10);
  doc.line(5, 44, 205, 44);
  doc.line(5, 290, 205, 290);
  doc.line(5, 44, 5, 290);
  doc.line(205, 44, 205, 290);
  doc.line(5, 48, 205, 48);
  doc.setFont("times");

  const startY = 47.5;
  const headerY = 51;
  const maxPageHeight = doc.internal.pageSize.height - 20;
  let y = headerY;

  const renderAddress = (label, customer, y) => {
    doc.line(5, y + 22, 115, y + 22);
    doc.text(label, 6, y);
    doc.setFont("times", "bold");
    doc.text(
      `${customer.FirstName || ""} ${customer.LastName || ""}`,
      6,
      y + 4
    );
    doc.setFont("times", "normal");
    doc.text(`${customer.CurrAddStreet || "Street"}`, 6, y + 8);
    doc.text(`${customer.CurrAddTown || "Town"}`, 6, y + 12);
    doc.text(`Gst No. - ${customer.GstNo || "Gst No."}`, 6, y + 16);
    doc.text(
      `${customer.CurrAddState || ""} ${customer.CurrAddPincode || "Pan No. "}`,
      6,
      y + 20
    );
  };

  if (csData) {
    // Invoice Header
    doc.text(`${csData?.orderType || ""}`, 90, startY);

    // Consignee (Ship to)
    renderAddress("Consignee (Ship to)", csData?.Customer, y);

    doc.text(`Invoice No - ${csData?.invoiceNo || ""}`, 120, y);
    // doc.text(`Invoice Date - ${new Date(csData?.createdOn).toLocaleDateString("en-GB")}`, 120, y + 4);
    doc.text(`Invoice Date - ${csData?.InvoiceDate || ""}`, 120, y + 4);

    y += 27; // Adjust y position

    // Buyer (Bill to)
    renderAddress("Buyer (Bill to)", csData?.Customer, y);
    doc.line(115, y - 30, 115, y + 21);
  }

  doc.line(5, y + 21, 205, y + 21);
  y += 26; // Adjust y position

  // Table Header
  doc.setFontSize(9);
  doc.text("S.No", 6, y);
  doc.text("Description Of Goods", 15, y);
  doc.text("HSN", 70, y);
  doc.text("Pcs", 85, y);
  doc.text("Purity", 95, y);
  doc.text("Gross", 105, y);
  doc.text("Wt", 105, y + 3);
  doc.text("Net", 117, y);
  doc.text("Wt", 117, y + 3);
  doc.text("Other", 130, y);
  doc.text("Charges", 130, y + 3);
  doc.text("Rate", 145, y);
  doc.text("Amount", 160, y);
  doc.text("Hallmark", 175, y);
  doc.text("Charges", 175, y + 3);
  doc.text("Total", 190, y);
  doc.text("Amount", 190, y + 3);
  doc.line(5, y + 5, 205, y + 5);

  y += 10;

  // Invoice Items
  let srNo = 1;
  let totalQuantity = 0;
  let totalGrossWt = 0;
  let totalNetWt = 0;
  let totalStoneAmount = 0;
  let totalNetAmount = 0;
  let totalHallmarkCharges = 0;
  let totalProductAmount = 0;

  doc.setFontSize(8);

  invoiceItems.forEach((item) => {
    let totalAmount = 0;
    if (y + 8 > maxPageHeight) {
      doc.addPage();
      y = 10;
    }
    let OtherCharges = 0;
    let NetCharges = 0;
    let HallmarkCharges = 0;
    const productName =
      item.ProductName.length > 15
        ? `${item.ProductName.substring(0, 15)}...`
        : item.ProductName;
    doc.text(srNo.toString(), 6, y);
    doc.text(`${item.Purity || ""} ${productName || ""}`, 15, y);
    doc.text(`${item.HSNCode || "-"}`, 70, y);
    doc.text(`${item.Quantity !== "undefined" ? item.Quantity : "-"}`, 85, y);
    doc.text(`${item.Purity || "-"}`, 95, y);
    doc.text(`${item.GrossWt || "-"}`, 105, y);
    doc.text(`${item.NetWt || "-"}`, 117, y);
    if (item.MRP !== 0 && item.MRP !== "" && item.MRP !== "0") {
      doc.text(`MRP -`, 130, y);
      doc.text(`${parseFloat(item.MRP)?.toFixed(2)}`, 145, y);
      OtherCharges = Number(item.MRP);
    } else {
      doc.text(item.MetalRate ? item.MetalRate : "-", 130, y);
      doc.text(
        parseFloat(
          (parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt)
        )?.toFixed(2),
        145,
        y
      );
      OtherCharges = Number(
        (parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt)
      );
    }

    doc.text(
      parseFloat(
        parseFloat(parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt) +
          parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
          parseFloat(item.StoneAmount ? item.StoneAmount : 0)
      )?.toFixed(2),
      160,
      y
    );
    NetCharges += parseFloat(
      parseFloat(parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt) +
        parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
        parseFloat(item.StoneAmount ? item.StoneAmount : 0)
    );
    doc.text(item.HallmarkAmount ? `${item.HallmarkAmount}` : "-", 175, y);
    HallmarkCharges += parseFloat(
      item.HallmarkAmount ? item.HallmarkAmount : 0
    );
    totalAmount =
      item.MRP !== 0 && item.MRP !== "" && item.MRP !== "0"
        ? parseFloat(item.MRP ? item.MRP : 0) +
            parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
            parseFloat(item.StoneAmount ? item.StoneAmount : 0) || 0
        : parseFloat(
            parseFloat(parseFloat(item.MetalRate) / 10) *
              parseFloat(item.NetWt) +
              parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
              parseFloat(item.StoneAmount ? item.StoneAmount : 0) || 0
          );
    Total += totalAmount;
    // doc.text(`${item.StoneAmount || "-"}`, 130, y);
    // doc.text(`${item.MetalRate || "-"}`, 145, y);
    // doc.text(`${item.Amount || "-"}`, 160, y);
    // doc.text(`${item.HallmarkAmount || "-"}`, 175, y);
    doc.text(`${totalAmount || "-"}`, 190, y);

    totalQuantity +=
      parseFloat(item.Quantity !== "undefined" ? item.Quantity : 0) || 0;
    totalGrossWt += parseFloat(item.GrossWt) || 0;
    totalNetWt += parseFloat(item.NetWt) || 0;
    // totalStoneAmount += parseFloat(item.StoneAmount) || 0;
    totalStoneAmount += OtherCharges;
    // totalNetAmount += parseFloat(item.NetAmount) || 0;
    totalNetAmount += NetCharges;
    // totalHallmarkCharges += parseFloat(item.HallmarkAmount) || 0;
    totalHallmarkCharges += HallmarkCharges;
    totalProductAmount += parseFloat(totalAmount) || 0;

    srNo++;
    y += 8;
  });

  doc.line(5, y - 3, 205, y - 3);

  doc.setFont("times", "bold");
  doc.text("Total", 10, y);
  doc.text(totalQuantity.toFixed(0), 85, y);
  doc.text(totalGrossWt.toFixed(3), 105, y);
  doc.text(totalNetWt.toFixed(3), 117, y);
  doc.text(totalStoneAmount?.toFixed(2), 130, y);
  doc.text(totalNetAmount?.toFixed(2), 160, y);
  doc.text(totalHallmarkCharges?.toFixed(2), 175, y);
  doc.text(totalProductAmount?.toFixed(2), 190, y);

  y += 10;

  // Payment Modes
  if (csData?.paymentMode) {
    const paymentModes = csData?.paymentMode.split(",");
    doc.setFontSize(9);
    doc.text("Payment Mode", 10, y);
    let yPaymentModes = y + 5;
    paymentModes.forEach((paymentMode) => {
      if (yPaymentModes > maxPageHeight - 10) {
        doc.addPage();
        yPaymentModes = 5;
      }
      const [mode, amount] = paymentMode.split(":");
      doc.text(mode, 10, yPaymentModes);
      doc.text(amount, 40, yPaymentModes);
      yPaymentModes += 5;
    });
    y = yPaymentModes + 10;
  }

  // Summary
  const totalSaleAmount = invoiceItems.reduce((total, product) => {
    return total + parseFloat((parseFloat(product.Amount) * 100) / 103 || 0);
  }, 0);

  const payableGst = totalSaleAmount * 0.03;

  if (csData?.Customer.currAddState === "Maharashtra") {
    doc.text(`Sales Amount:`, 155, y);
    doc.text(`${totalSaleAmount?.toFixed(2)}`, 185, y);
    doc.text(`R.O./Discount:`, 155, y + 5);
    doc.text(`${csData?.offer || 0}`, 185, y + 5);
    doc.text(`CGST 1.5%:`, 155, y + 10);
    // doc.text(`${(payableGst / 2)?.toFixed(2)}`, 185, y + 10);
    doc.text(`${(Number(csData?.GST) / 2 || 0)?.toFixed(2)}`, 185, y + 15);
    doc.text(`SGST 1.5%:`, 155, y + 15);
    // doc.text(`${(payableGst / 2)?.toFixed(2)}`, 185, y + 15);
    doc.text(`${(Number(csData?.GST) / 2 || 0)?.toFixed(2)}`, 185, y + 15);
  } else {
    doc.text(`Sales Amount:`, 155, y);
    doc.text(`${totalSaleAmount?.toFixed(2)}`, 185, y);
    doc.text(`R.O./Discount:`, 155, y + 5);
    doc.text(`${csData?.offer || 0}`, 185, y + 5);
    doc.text(`IGST 3%:`, 155, y + 10);
    // doc.text(`${payableGst?.toFixed(2)}`, 185, y + 10);
    doc.text(`${Number(csData?.GST)?.toFixed(2)}`, 185, y + 10);
  }

  doc.text(`Purchase Amount (-):`, 155, y + 15);
  doc.text(
    `${parseFloat(csData?.UrdPurchaseAmt || 0)?.toFixed(2)}`,
    185,
    y + 15
  );
  doc.text(`Received Amount:`, 155, y + 20);
  doc.text(
    `${parseFloat(csData?.ReceivedAmount || 0)?.toFixed(2)}`,
    185,
    y + 20
  );
  doc.text(`Balance Amount:`, 155, y + 25);
  // doc.text(
  //   `${(Number(csData?.TotalAmount||0) - Number(csData?.receivedAmt||0))?.toFixed(2)}`,
  //   185,
  //   y + 25
  // );
  doc.text(`${parseFloat(csData?.BalanceAmt || 0)?.toFixed(2)}`, 185, y + 25);
  doc.text(`Total:`, 155, y + 30);
  doc.text(`${Number(csData?.TotalAmount || 0).toFixed(2)}`, 185, y + 30);

  // Footer
  // doc.setFont("times", "bold");
  // doc.setFontSize(11);
  // doc.text("for TMJ Enterprises", 155, y + 45);
  // doc.setFont("times", "normal");
  // doc.setFontSize(10);
  // doc.text("Authorised Signatory", 160, y + 55);

  let footerY = doc.internal.pageSize.height - 50;
  doc.setFontSize(9);
  // doc.text("Raja Bazar, P.O. Jatni-752050, Khordha (Odisha)", 10, footerY);
  // doc.text("Phone Number: 0674-2492089 ", 10, footerY + 4);
  // doc.text("Mobile / Whatsapp: +91 7978114496 ", 10, footerY + 8);
  // doc.text("Customer Signature", 10, footerY);
  doc.setFont("times", "bold");
  doc.line(5, footerY - 4, 205, footerY - 4);
  doc.text("Terms And Conditions :- ", 10, footerY);
  doc.setFont("times", "normal");
  doc.text(
    `Note: - No Eway Bill is required to be Generated as the Goods covered under this Invoice are Exempted as per Serial No. 4/5 to the Annexure `,
    10,
    footerY + 5
  );
  doc.text(`to Rule 138(14) of the CGST Rules.`, 10, footerY + 9);
  doc.text(
    `Consumer can get the purity of the Hallmarked Jewellery / Artifacts verified from any of the BIS recognized A & H Center`,
    10,
    footerY + 13
  );
  doc.text(
    `List of BIS recognized A & H center along with address and contact details is available on the webiste "www.bis.gov.in"`,
    10,
    footerY + 17
  );
  doc.text(`Hallmark Charges is Rs 45 Per Piece`, 10, footerY + 21);
  doc.text(
    `This Bill includes Labour Charges, Hallmark Charges, Stone/Beads/Mina and other Charges `,
    10,
    footerY + 25
  );
  doc.setFont("times", "bold");
  doc.setFontSize(10);
  doc.text(`Receivers Signature`, 10, footerY + 42);
  doc.setFont("times", "normal");
  doc.setFontSize(7);
  doc.line(5, footerY + 27, 205, footerY + 27);

  // Save PDF
  doc.save(`Invoice-${csData?.invoiceNo}.pdf`);
};

// export default generateBillPDF;

export const generateBillInvocePDF123 = (csData, invoiceItems) => {
  const doc = new jsPDF({
    orientation: "portrait",
    format: "a4",
  });
  console.log(csData, "sjdshjdhsjhdjs");
  console.log(invoiceItems, "sjdshjdhsjhdjs");
  let Total = 0;
  doc.setDrawColor(0, 0, 0, 0.3);
  doc.setFontSize(12);
  doc.setFont("times");

  doc.setFontSize(18);
  doc.setTextColor(0, 0, 139);
  doc.setFont("times", "bold");
  doc.text("TAX INVOICE", 105, 20, { align: "center" });
  // if (csData?.billType === "false") {
  //   doc.text(`${csData?.orderType}`, 90, 47.5);
  // } else {
  //   doc.text(`${`billType`}`, 90, 47.5);
  // }
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.line(5, 44, 205, 44);
  doc.line(5, 290, 205, 290);
  doc.line(5, 44, 5, 290);
  doc.line(14, 88, 14, 193);
  doc.line(105, 88, 105, 193);
  doc.line(140, 88, 140, 193);
  doc.line(175, 88, 175, 193);
  doc.line(205, 44, 205, 290);
  // doc.line(5, 48, 205, 48);
  doc.setFont("times");

  const startY = 47.5;
  const headerY = 51;
  const maxPageHeight = doc.internal.pageSize.height - 20;
  let y = headerY;

  const renderAddress = (label, customer, y) => {
    // doc.line(5, y + 22, 115, y + 22);
    doc.text(label, 6, y);
    doc.setFont("times", "bold");
    doc.text(
      `${customer.FirstName || ""} ${customer.LastName || ""}`,
      6,
      y + 4
    );
    doc.setFont("times", "normal");
    doc.text(`${customer.CurrAddStreet || "add"}`, 6, y + 8);
    doc.text(
      `${customer.CurrAddState} & ${customer.CurrAddPincode}`,
      6,
      y + 22
    );
    doc.text(`GST No. - ${customer.GstNo || ""}`, 6, y + 26);
    doc.text(`Pan No. - ${customer.PanNo || ""}`, 6, y + 30);
    doc.text(`Mob No. - ${customer.Mobile || ""}`, 6, y + 34);
  };

  if (csData) {
    // Invoice Header
    doc.text(`${csData?.orderType || ""}`, 90, startY);

    // Consignee (Ship to)
    renderAddress("To ", csData?.Customer, y);
    doc.setTextColor(0, 0, 139);
    // renderAddress("Name ", csData?.Customer, y + 8);
    doc.setTextColor(0, 0, 0);
    // renderAddress("add ", csData?.Customer, y + 12);

    doc.text(`Invoice No - ${csData?.InvoiceNo || ""}`, 109, y);
    // doc.text(`Invoice Date - ${new Date(csData?.createdOn).toLocaleDateString("en-GB")}`, 120, y + 4);
    doc.text(`Invoice Date - ${csData?.InvoiceDate || ""}`, 109, y + 6);
    doc.text(`Terms - C.O.D`, 109, y + 10);
    doc.text(`Our GST No. - 27BCPPV7154N1ZI`, 109, y + 30);
    doc.text(`Pan No. - BCPPV7154N`, 109, y + 34);

    y += 16; // Adjust y position
    // Buyer (Bill to)
    // renderAddress("Buyer (Bill to)", csData?.Customer, y);
    doc.line(105, y - 23, 105, y + 21);
  }

  doc.line(5, y + 21, 205, y + 21);
  y += 26; // Adjust y position

  // Table Header
  doc.setFontSize(9);
  doc.text("Sr", 6, y);
  doc.text("No.", 6, y + 4);
  doc.text("Description of Goods", 42, y);
  doc.text("HSN CODE - 71131930", 42, y + 4);
  doc.text("HSN / SAC", 114, y);
  // doc.text("Pcs", 85, y);
  // doc.text("Purity", 95, y);
  doc.text("Gross Wgt.", 150, y);
  doc.text("In Grms.", 152, y + 4);
  // doc.text("Wt", 105, y + 3);
  // doc.text("Net", 117, y);
  // doc.text("Wt", 117, y + 3);
  // doc.text("Other", 130, y);
  // doc.text("Charges", 130, y + 3);
  // doc.text("Rate", 145, y);
  // doc.text("Amount", 160, y);
  // doc.text("Hallmark", 175, y);
  // doc.text("Charges", 175, y + 3);
  // doc.text("Total", 190, y);
  doc.text("Sale Value", 182, y);
  doc.text("In Rs.", 186, y + 4);
  doc.line(5, y + 5, 205, y + 5);

  y += 10;

  // Invoice Items
  let srNo = 1;
  let totalQuantity = 0;
  let totalGrossWt = 0;
  let totalNetWt = 0;
  let totalStoneAmount = 0;
  let totalNetAmount = 0;
  let totalHallmarkCharges = 0;
  let totalProductAmount = 0;

  doc.setFontSize(8);

  invoiceItems.forEach((item) => {
    let totalAmount = 0;
    if (y + 8 > maxPageHeight) {
      doc.addPage();
      y = 10;
    }
    let OtherCharges = 0;
    let NetCharges = 0;
    let HallmarkCharges = 0;
    const productName =
      item.ProductName.length > 15
        ? `${item.ProductName.substring(0, 15)}...`
        : item.ProductName;
    doc.text(srNo.toString(), 6, y);
    doc.text(`${productName || ""}`, 15, y);
    doc.text(`${item.HSNCode || "-"}`, 114, y);
    // doc.text(`${item.Quantity!=='undefined'?item.Quantity: "-"}`, 85, y);
    // doc.text(`${item.Purity || "-"}`, 95, y);
    doc.text(`${item.GrossWt || "-"}`, 150, y);
    // doc.text(`${item.NetWt || "-"}`, 117, y);
    if (item.MRP !== 0 && item.MRP !== "" && item.MRP !== "0") {
      // doc.text(`MRP -`, 130, y);
      // doc.text(`${parseFloat(item.MRP)?.toFixed(2)}`, 145, y);
      OtherCharges = Number(item.MRP);
    } else {
      // doc.text(item.MetalRate ? item.MetalRate : "-", 130, y);
      // doc.text(
      //     parseFloat(
      //         (parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt)
      //     )?.toFixed(2),
      //     145,
      //     y
      // );
      OtherCharges = Number(
        (parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt)
      );
    }

    // doc.text(
    //     parseFloat(
    //         parseFloat(parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt) +
    //         parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
    //         parseFloat(item.StoneAmount ? item.StoneAmount : 0)
    //     )?.toFixed(2),
    //     160,
    //     y
    // );
    NetCharges += parseFloat(
      parseFloat(parseFloat(item.MetalRate) / 10) * parseFloat(item.NetWt) +
        parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
        parseFloat(item.StoneAmount ? item.StoneAmount : 0)
    );
    // doc.text(item.HallmarkAmount ? `${item.HallmarkAmount}` : "-", 175, y);
    HallmarkCharges += parseFloat(
      item.HallmarkAmount ? item.HallmarkAmount : 0
    );
    totalAmount =
      item.MRP !== 0 && item.MRP !== "" && item.MRP !== "0"
        ? parseFloat(item.MRP ? item.MRP : 0) +
            parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
            parseFloat(item.StoneAmount ? item.StoneAmount : 0) || 0
        : parseFloat(
            parseFloat(parseFloat(item.MetalRate) / 10) *
              parseFloat(item.NetWt) +
              parseFloat(item.HallmarkAmount ? item.HallmarkAmount : 0) +
              parseFloat(item.StoneAmount ? item.StoneAmount : 0) || 0
          );
    Total += totalAmount;
    // doc.text(`${item.StoneAmount || "-"}`, 130, y);
    // doc.text(`${item.MetalRate || "-"}`, 145, y);
    // doc.text(`${item.Amount || "-"}`, 160, y);
    // doc.text(`${item.HallmarkAmount || "-"}`, 175, y);
    doc.text(`${totalAmount || "-"}`, 190, y);

    totalQuantity +=
      parseFloat(item.Quantity !== "undefined" ? item.Quantity : 0) || 0;
    totalGrossWt += parseFloat(item.GrossWt) || 0;
    totalNetWt += parseFloat(item.NetWt) || 0;
    // totalStoneAmount += parseFloat(item.StoneAmount) || 0;
    totalStoneAmount += OtherCharges;
    // totalNetAmount += parseFloat(item.NetAmount) || 0;
    totalNetAmount += NetCharges;
    // totalHallmarkCharges += parseFloat(item.HallmarkAmount) || 0;
    totalHallmarkCharges += HallmarkCharges;
    totalProductAmount += parseFloat(totalAmount) || 0;

    srNo++;
    y += 8;
  });

  doc.text("CGST", 15, y + 52);
  doc.text("SGST", 15, y + 56);
  doc.setFont("times", "bold");
  doc.text("IGST", 90, y + 60);
  doc.text("3.0%", 130, y + 60);
  doc.text("DISCOUNT", 90, y + 64);
  doc.text("R / d", 90, y + 68);
  // doc.line(5, y - 3, 205, y - 3);
  doc.setFont("times", "normal");

  // doc.setFont("times", "bold");
  // doc.text("Total", 10, y);
  // doc.text(totalQuantity.toFixed(0), 85, y);
  // doc.text(totalGrossWt.toFixed(3), 105, y);
  // doc.text(totalNetWt.toFixed(3), 117, y);
  // doc.text(totalStoneAmount?.toFixed(2), 130, y);
  // doc.text(totalNetAmount?.toFixed(2), 160, y);
  // doc.text(totalHallmarkCharges?.toFixed(2), 175, y);
  // doc.text(totalProductAmount?.toFixed(2), 190, y);

  y += 10;

  // Payment Modes
  if (csData?.paymentMode) {
    const paymentModes = csData?.paymentMode.split(",");
    doc.setFontSize(9);
    doc.text("Payment Mode", 10, y);
    let yPaymentModes = y + 5;
    paymentModes.forEach((paymentMode) => {
      if (yPaymentModes > maxPageHeight - 10) {
        doc.addPage();
        yPaymentModes = 5;
      }
      const [mode, amount] = paymentMode.split(":");
      doc.text(mode, 10, yPaymentModes);
      doc.text(amount, 40, yPaymentModes);
      yPaymentModes += 5;
    });
    y = yPaymentModes + 10;
  }

  // Summary
  const totalSaleAmount = invoiceItems.reduce((total, product) => {
    return (
      total + parseFloat((parseFloat(product.TotalAmount) * 100) / 103 || 0)
    );
  }, 0);

  const payableGst = totalSaleAmount * 0.03;

  // if (csData?.Customer.currAddState === "Maharashtra") {
  //   doc.text(`Sales Amount:`, 155, y);
  //   doc.text(`${totalSaleAmount?.toFixed(2)}`, 185, y);
  //   doc.text(`R.O./Discount:`, 155, y + 5);
  //   doc.text(`${csData?.offer || 0}`, 185, y + 5);
  //   doc.text(`CGST 1.5%:`, 155, y + 10);
  //   // doc.text(`${(payableGst / 2)?.toFixed(2)}`, 185, y + 10);
  //   doc.text(`${((Number(csData?.GST)/ 2||0))?.toFixed(2)}`, 185, y + 15);
  //   doc.text(`SGST 1.5%:`, 155, y + 15);
  //   // doc.text(`${(payableGst / 2)?.toFixed(2)}`, 185, y + 15);
  //   doc.text(`${((Number(csData?.GST)/ 2||0))?.toFixed(2)}`, 185, y + 15);
  // } else {
  //   doc.text(`Sales Amount:`, 155, y);
  //   doc.text(`${totalSaleAmount?.toFixed(2)}`, 185, y);
  //   doc.text(`R.O./Discount:`, 155, y + 5);
  //   doc.text(`${csData?.offer || 0}`, 185, y + 5);
  //   doc.text(`IGST 3%:`, 155, y + 10);
  //   // doc.text(`${payableGst?.toFixed(2)}`, 185, y + 10);
  //   doc.text(`${(Number(csData?.GST))?.toFixed(2)}`, 185, y + 10);
  // }

  // doc.text(`Purchase Amount (-):`, 155, y + 15);
  // doc.text(`${parseFloat(csData?.UrdPurchaseAmt || 0)?.toFixed(2)}`, 185, y + 15);
  // doc.text(`Received Amount:`, 155, y + 20);
  // doc.text(`${parseFloat(csData?.ReceivedAmount || 0)?.toFixed(2)}`, 185, y + 20);
  // doc.text(`Balance Amount:`, 155, y + 25);
  // // doc.text(
  // //   `${(Number(csData?.TotalAmount||0) - Number(csData?.receivedAmt||0))?.toFixed(2)}`,
  // //   185,
  // //   y + 25
  // // );
  // doc.text(`${parseFloat(csData?.BalanceAmt || 0)?.toFixed(2)}`, 185, y + 25);
  // doc.text(`Total:`, 155, y + 30);
  // doc.text(`${Number(csData?.TotalAmount||0).toFixed(2)}`, 185, y + 30);

  // Footer
  // doc.setFont("times", "bold");
  // doc.setFontSize(11);
  // doc.text("for TMJ Enterprises", 155, y + 45);
  // doc.setFont("times", "normal");
  // doc.setFontSize(10);
  // doc.text("Authorised Signatory", 160, y + 55);

  let footerY = doc.internal.pageSize.height - 50;
  doc.setFontSize(9);
  // doc.text("Raja Bazar, P.O. Jatni-752050, Khordha (Odisha)", 10, footerY);
  // doc.text("Phone Number: 0674-2492089 ", 10, footerY + 4);
  // doc.text("Mobile / Whatsapp: +91 7978114496 ", 10, footerY + 8);
  // doc.text("Customer Signature", 10, footerY);
  doc.setFont("times", "bold");
  doc.line(5, footerY - 60, 205, footerY - 60);
  doc.text("TOTAL", 90, footerY - 56);
  doc.text(csData.TotalAmount, 182, footerY - 56);

  doc.line(5, footerY - 54, 205, footerY - 54);
  doc.text("Amount Chargeable (in words): ", 7, footerY - 50);
  doc.text("Rs.", 7, footerY - 46);
  doc.line(5, footerY - 44, 205, footerY - 44);
  doc.text("Company's Bank details", 140, footerY - 40);
  doc.text("Bank Name : Indusind bank", 140, footerY - 36);
  doc.text("Branch : BKC Branch", 140, footerY - 32);
  doc.text("A/c No: 255024002400", 140, footerY - 28);
  doc.text("IFSC CODE : INDB0000342", 140, footerY - 24);
  doc.text(
    "Corporate Office : DIAGLITER 1003, 10th Floor, D Square, Dadabhai Road, Vile Parle (West), Mumbai - 400056",
    10,
    footerY
  );
  doc.text("Mo. No. 9152011005", 10, footerY + 4);
  doc.text("FOR DIAGLITER", 140, footerY + 18);
  doc.setFont("times", "normal");
  // doc.text(
  //     `Note: - No Eway Bill is required to be Generated as the Goods covered under this Invoice are Exempted as per Serial No. 4/5 to the Annexure `,
  //     10,
  //     footerY + 5
  // );
  // doc.text(`to Rule 138(14) of the CGST Rules.`, 10, footerY + 9);
  // doc.text(
  //     `Consumer can get the purity of the Hallmarked Jewellery / Artifacts verified from any of the BIS recognized A & H Center`,
  //     10,
  //     footerY + 13
  // );
  // doc.text(
  //     `List of BIS recognized A & H center along with address and contact details is available on the webiste "www.bis.gov.in"`,
  //     10,
  //     footerY + 17
  // );
  // doc.text(`Hallmark Charges is Rs 45 Per Piece`, 10, footerY + 21);
  // doc.text(
  //     `This Bill includes Labour Charges, Hallmark Charges, Stone/Beads/Mina and other Charges `,
  //     10,
  //     footerY + 25
  // );
  doc.setFont("times", "bold");
  doc.setFontSize(10);
  doc.text(`(SIGNATURE OF THE RECEIVER)`, 10, footerY + 40);
  doc.text(`PROPRIETOR / AUTHORISED SIGN`, 140, footerY + 40);
  doc.setFont("times", "normal");
  doc.setFontSize(7);
  // doc.line(5, footerY + 27, 205, footerY + 27);

  // Save PDF
  doc.save(`Invoice-${csData?.InvoiceNo}.pdf`);
};

export const generateBillInvocePDF = (
  csData,
  invoiceItems,
  allStonesmasterList
) => {
  generatenicegold(csData, invoiceItems, allStonesmasterList);
};

const generatenicegold = (csData, invoiceItems, allStonesmasterList) => {
  console.log("checking all stones ", allStonesmasterList);

  const doc = new jsPDF({
    orientation: "portrait", // Can also try "landscape" for more horizontal space
    format: "a4",
  });

  doc.setFontSize(18);
  doc.setTextColor(0, 0, 139);
  doc.setFont("times", "bold");
  doc.text("INVOICE", 105, 20, { align: "center" });

  // Get unique stone names/types from the allStonesmasterList
  const stoneTypes = [
    ...new Set(allStonesmasterList.map((stone) => stone.StoneName)),
  ];

  // Main table header (first row)
  const mainHeader = [
    { title: "Design", dataKey: "design", rowSpan: 2 },
    { title: "Particular", dataKey: "particular", rowSpan: 2 },
    { title: "Gross Wt", dataKey: "grossWt", rowSpan: 2 },
    { title: "Net Wt", dataKey: "netWt", rowSpan: 2 },
    ...stoneTypes.map((stoneName) => ({ title: stoneName, colSpan: 1 })),
    ...stoneTypes.map((stoneName) => ({ title: stoneName, colSpan: 1 })),
    // { title: "Stone Wt", dataKey: "stoneWt", colSpan: stoneTypes.length }, // Subheader for stone weights
    // { title: "Stone Amt", dataKey: "stoneAmt", colSpan: stoneTypes.length }, // Subheader for stone amounts
  ];

  // Subheader for stones under "Stone Wt" and "Stone Amt"
  const subHeader = [
    { title: "", colSpan: 4 }, // Empty columns for first 4 headers
    ...stoneTypes.map((stoneName) => ({ title: stoneName, colSpan: 1 })), // Stone names under "Stone Wt"
    ...stoneTypes.map((stoneName) => ({ title: stoneName, colSpan: 1 })), // Stone names under "Stone Amt"
  ];

  // Map the invoice items into rows
  const rows = invoiceItems.map((item) => {
    let row = [
      item.ItemCode || "", // Design
      item.ProductName || "", // Particular
      item.GrossWt || "0", // Gross Wt
      item.NetWt || "0", // Net Wt
    ];

    // Add the stone weight for each stone type
    stoneTypes.forEach((stoneName) => {
      const matchingStone = allStonesmasterList.find(
        (stone) => stone.StoneName === stoneName
      );
      row.push(matchingStone ? matchingStone.StoneWeight : "0"); // Stone Weight
    });

    // Add the stone amount for each stone type
    stoneTypes.forEach((stoneName) => {
      const matchingStone = allStonesmasterList.find(
        (stone) => stone.StoneName === stoneName
      );
      row.push(matchingStone ? matchingStone.StoneAmount : "0"); // Stone Amount
    });

    return row;
  });

  console.log("check rows ", rows);

  // Add table with dynamic subheader
  autoTable(doc, {
    head: [
      mainHeader.map((col) => col.title), // First row (main header)
      subHeader.map((col) => col.title), // Second row (subheader for stone types)
    ],
    body: rows,
    columnStyles: {
      0: { cellWidth: 25 }, // Design column width
      1: { cellWidth: 30 }, // Particular column width
      2: { cellWidth: 20 }, // Gross Wt column width
      3: { cellWidth: 20 }, // Net Wt column width
      // Dynamic stone width columns
      ...stoneTypes.reduce((acc, _, index) => {
        acc[4 + index] = { cellWidth: 15 }; // Dynamic stone weight column
        acc[4 + stoneTypes.length + index] = { cellWidth: 15 }; // Dynamic stone amount column
        return acc;
      }, {}),
    },
    styles: {
      fontSize: 10, // Adjust font size for readability
      textColor: "#000",
    },
    margin: { top: 30 }, // Adjust margin to avoid overlap with the title
    theme: "grid", // Add grid lines for better alignment visibility
  });

  // Save the PDF with a dynamic invoice number if available
  doc.save(`Invoice-${csData?.invoiceNo || "Default"}.pdf`);
};

const generateinvoicepdf6 = async (items, customer, mainitem) => {
  console.log("checking items", items);
  console.log("checking customer", customer);

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  console.log("mainitem", mainitem);

  const dummyData = generateDummyData();
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const marginTop = 80;
  const marginBottom = 40;
  const rowHeight = 10; // Initial row height
  const tableHeight = 100; // Fixed table height
  let currentY = marginTop;
  const invoicex = pageWidth - 60;
  const invoicey = 60;
  const customerx = pageWidth - 200;
  const customery = 60;
  const fotertotalx = pageWidth - 70;
  const fotertotaly = 180;

  const despx = pageWidth - 70;
  const despy = 250;

  const invoicenumber = `${mainitem.InvoiceNo}`;
  const invoicedate = `${mainitem.InvoiceDate}`;
  const firstname = `${customer.FirstName}`;
  const lastname = `${customer.LastName}`;
  const mobile = `${customer.Mobile}`;
  const address = `${customer.CurrAddStreet} ${customer.CurrAddTown} ${customer.CurrAddState}`;

  console.log("checkpagewidth  ", pageWidth);

  // Define the column positions
  const columnPositions = {
    sr: pageWidth - 200,
    productDetails: pageWidth - 185,
    // pcs: pageWidth-150,
    hsnCode: pageWidth - 125,
    purity: pageWidth - 100,
    // price: pageWidth - 90,
    qty: pageWidth - 60,
    amount: pageWidth - 40,
  };

  // Draw the table structure dynamically
  const drawTableStructure = () => {
    // Vertical Lines (for column separators)
    // doc.line(10, marginTop, 10, marginTop + tableHeight); // Left border
    Object.values(columnPositions).forEach((pos) => {
      doc.line(pos, marginTop, pos, marginTop + tableHeight); // Column separators
    });
    doc.line(
      pageWidth - 10,
      marginTop,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Right border
  };

  const drawTableHeader = () => {
    doc.setFontSize(10);
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header top line
    currentY += 5;

    // Draw the header text
    doc.text("Sr.", columnPositions.sr + 2, currentY);
    doc.text("Product Details", columnPositions.productDetails + 2, currentY);
    // doc.text('Pcs', columnPositions.pcs+2, currentY);
    doc.text("HSN Code", columnPositions.hsnCode + 2, currentY);
    doc.text("Purity", columnPositions.purity + 2, currentY);
    // doc.text('Gross Wt', columnPositions.grossWt+2, currentY);
    // doc.text('Net Wt', columnPositions.netWt+2, currentY);
    // doc.text("Metal Amt", columnPositions.price + 2, currentY);
    doc.text("Qty", columnPositions.qty + 2, currentY);
    // doc.text('Rate / gm', columnPositions.rate+2, currentY);
    doc.text("Total Amt", columnPositions.amount + 2, currentY);

    currentY += 5;
    doc.line(columnPositions.sr, currentY, pageWidth - 10, currentY); // Table header bottom line
    currentY += 5;

    doc.line(
      columnPositions.sr,
      marginTop + tableHeight,
      pageWidth - 10,
      marginTop + tableHeight
    ); // Table header top line
  };

  const totalAmount = Number(mainitem.TotalAmount) || 0;
  const gstAmount = Number(mainitem.GST) || 0;
  const receivedAmount = Number(mainitem.ReceivedAmount) || 0;

  const totalPrice = mainitem.InvoiceItem.reduce((sum, item) => {
    // Parse the price to a float and add to the sum
    return sum + parseFloat(item.Price);
  }, 0);

  const discountPrice = totalPrice - totalAmount;

  console.log("discountPrice", discountPrice);

  // Calculate CGST, SGST, total invoice amount, and balance amount
  const cgst = (totalAmount * 1.5) / 100; // CGST @1.5%
  const total = totalAmount + gstAmount; // Total Invoice Amount
  const bal = total - receivedAmount; // Balance Amount

  console.log("totalAmount", totalAmount);

  console.log("receivedAmount", receivedAmount);

  const AmtWithoutDiscount = totalAmount - receivedAmount;

  console.log("AmtWithoutDiscount", AmtWithoutDiscount);

  // Format amounts to two decimal places for better precision
  const formatAmount = (amount) => amount.toFixed(2);

  const drawFooter = () => {
    // Discount Amount
    doc.text(
      `Discount Amount : ${formatAmount(discountPrice)}`,
      fotertotalx,
      fotertotaly + 10
    );

    // Taxable Amount
    doc.text(
      `Taxable Amount : ${formatAmount(totalAmount)}`,
      fotertotalx,
      fotertotaly + 15
    );

    // CGST and SGST (assuming both are calculated similarly)
    doc.text(
      `CGST @ 1.5% : ${formatAmount(cgst)}`,
      fotertotalx,
      fotertotaly + 20
    );
    doc.text(
      `SGST @ 1.5% : ${formatAmount(cgst)}`,
      fotertotalx,
      fotertotaly + 25
    );

    // IGST (3% assumed)
    // doc.text(
    //   `IGST @ 3% : ${formatAmount(gstAmount)}`,
    //   fotertotalx,
    //   fotertotaly + 25
    // );

    // Total Invoice Amount
    doc.text(
      `Total Invoice Amount : ${formatAmount(total)}`,
      fotertotalx,
      fotertotaly + 30
    );

    // Amount Received
    doc.text(
      `Amount Received : ${formatAmount(receivedAmount)}`,
      fotertotalx,
      fotertotaly + 35
    );

    // Balance Amount (Handle negative balance if any)
    const balanceText =
      bal >= 0 ? formatAmount(bal) : `-${formatAmount(Math.abs(bal))}`;
    doc.text(`Balance Amount : ${balanceText}`, fotertotalx, fotertotaly + 40);

    const thankYouText = "Thank You For Your Business, God Bless Keep Buying";
    doc.setFontSize(13);

    // Calculate the text width to center it
    const textWidth = doc.getTextWidth(thankYouText);
    const centerX = (pageWidth - textWidth) / 2; // Calculate the x position for center alignment

    // Draw the centered text
    doc.text(thankYouText, centerX, fotertotaly + 50);
    doc.setFontSize(10);
    doc.text("Declaration :", customerx, fotertotaly + 55);
    const declarationText =
      "I declare that this invoice shows the actual price of the goods described and that all particulars are true and correct. I received ornament in good condition";
    const splitText = doc.splitTextToSize(declarationText, 80); // Adjust 180 to the width you want
    doc.setFontSize(10);
    doc.text(splitText, customerx, fotertotaly + 60);

    doc.setFontSize(10);
    doc.text(
      "For Mewar Jewellery House Pvt Ltd",
      fotertotalx,
      fotertotaly + 60
    );

    doc.text("Authorised Signature", fotertotalx, fotertotaly + 86);
    doc.text("Customer Signatory", customerx, fotertotaly + 86);

    doc.line(customerx, fotertotaly + 90, fotertotalx + 60, fotertotaly + 90);

    const ctext =
      "1st Floor, 1/1, 2nd cross Vasanthappa Thota Ganganagar Banglore-560032";
    const splitText1 = doc.splitTextToSize(ctext, 80); // Adjust 180 to the width you want
    doc.text(splitText1, customerx, fotertotaly + 95);
    const stext = "Contact Us : 080 23333409/080 41515409";
    const s1text = "Email: jewels@kevali.in";
    const s2text = "Instagram: kevali.in";
    const splitText2 = doc.splitTextToSize(stext, 80); // Adjust 180 to the width you want
    doc.text(stext, fotertotalx - 6, fotertotaly + 95);
    doc.text(s1text, fotertotalx - 6, fotertotaly + 100);
    doc.text(s2text, fotertotalx - 6, fotertotaly + 105);
  };

  const drawTableRows = () => {
    items.forEach((item, index) => {
      // Determine text lines and adjust currentY for each row
      const productDetailsLines = doc.splitTextToSize(
        item.ProductName,
        columnPositions.amount - columnPositions.productDetails - 5
      ); // Adjust width as needed
      const rowCount = Math.max(
        productDetailsLines.length,
        1 // To ensure there's at least one row
      );

      if (currentY + (rowCount + rowHeight) > pageHeight - marginBottom) {
        doc.addPage(); // Add a new page if needed
        currentY = marginTop;
        drawTableHeader();
        drawTableStructure();
      }

      // Draw row data
      doc.text(`${index + 1}`, columnPositions.sr + 2, currentY);
      productDetailsLines.forEach((line, lineIndex) => {
        doc.text(
          line,
          columnPositions.productDetails + 2,
          currentY + lineIndex * rowHeight
        );
      });
      // doc.text(item.Quantity || '1', columnPositions.pcs+2, currentY);
      doc.text("7113", columnPositions.hsnCode + 2, currentY);
      doc.text(item.Purity || "NA", columnPositions.purity + 2, currentY);
      // doc.text( item.Price || "NA", columnPositions.price + 2, currentY);
      doc.text(item.Quantity || "NA", columnPositions.qty + 2, currentY);
      doc.text(item.Price || "NA", columnPositions.amount + 2, currentY);

      // Update currentY based on the row count
      currentY += rowCount * rowHeight; // Adjust currentY based on the number of lines
    });
  };

  const getImageBase64 = (imagePath) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imagePath; // This path should point to the public folder image
      img.crossOrigin = "Anonymous"; // Ensure CORS issues don't block loading
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/jpeg"); // Convert to Base64
        resolve(dataURL);
      };
      img.onerror = (err) => reject(err);
    });
  };

  try {
    // Get the Base64 string of the image
    const imageBase64 = await getImageBase64("/images/pdfimages/7.png"); // Adjust path accordingly

    // Add the image to the PDF at specified coordinates (x, y, width, height)
    // const x = (pageWidth - 40) / 2;

    // doc.addImage(imageBase64, 'JPEG', x, 2, 40, 40);
    const imageWidth = 55;
    const imageX = (pageWidth - imageWidth) / 2; // Center horizontally
    const imageY = 3; // Adjust the y-coordinate as needed

    // Add the image to the PDF
    doc.addImage(imageBase64, "JPEG", imageX, imageY, imageWidth, 45);
  } catch (error) {
    console.error("Error loading image:", error);
  }

  const text = "TAX INVOICE";
  const textWidth = doc.getTextWidth(text); // Get the width of the text
  const textX = (pageWidth - textWidth) / 2; // Center horizontally
  const textY = 56; // Adjust the Y position as needed (below the image)

  // Add centered "TAX INVOICE" text
  doc.text(text, textX, textY);

  // Start generating the PDF
  // doc.text("TAX INVOICE", 90, 49);
  doc.setFontSize(10);
  doc.text("GSTIN :- 29AASCM4571D1Z2", invoicex, invoicey);
  doc.text("Invoice No :-", invoicex, invoicey + 5);
  doc.text(invoicenumber, invoicex + 20, invoicey + 5);
  // doc.text("Date :-", invoicex, invoicey + 5);
  doc.text(`Date :- ${invoicedate}`, invoicex, invoicey + 9);

  doc.text("Invoice To", customerx, customery);

  doc.text(
    `Customer Name : ${firstname} ${lastname}`,
    customerx,
    customery + 5
  );
  // doc.text(``, customerx + 28, customery + 5);
  doc.text(`Mobile No     : ${mobile}`, customerx, customery + 10);
  // doc.text(``, customerx + 28, customery + 10);
  doc.text(`Address       : ${address}`, customerx, customery + 15);
  // doc.text(``, customerx + 28, customery + 15);

  drawTableHeader();
  drawTableStructure();
  drawTableRows();

  // Add the footer to the last page
  drawFooter();

  // Open the PDF
  const pdfData = doc.output("datauristring");
  const newWindow = window.open();
  newWindow.document.write(
    `<iframe width='100%' height='100%' src='${pdfData}'></iframe>`
  );
};
